function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _create_super(Derived) {
  var hasNativeReflectConstruct = _is_native_reflect_construct();
  return function _createSuperInternal() {
    var Super = _get_prototype_of(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _get_prototype_of(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possible_constructor_return(this, result);
  };
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      ...EGUisMicroMessageFragment\n    }\n  }\n\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    schemaName\n    messageContent\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment UIPrimaryFloatingActionButtonFragment on UIPrimaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n    disabled\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment UISecondaryFloatingActionButtonFragment on UISecondaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment UIFloatingActionButtonFragment on UIFloatingActionButton {\n    __typename\n    accessibility\n\n    ... on UIPrimaryFloatingActionButton {\n      ...UIPrimaryFloatingActionButtonFragment\n    }\n\n    ... on UISecondaryFloatingActionButton {\n      ...UISecondaryFloatingActionButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment AllFilterSheetFooterFragment on ShoppingSortAndFilters {\n    footerLabel\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      accessibility\n    }\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterSheetFooterFragment on ShoppingSortAndFilterQuickFilter {\n    resultCountLabel\n    applyAction {\n      ...EGDSPrimaryButtonFragment\n    }\n    filterPill {\n      id\n    }\n  }\n\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSRemovablePillFragment on EGDSRemovablePill {\n    primary\n    accessibility\n    disabled\n    action {\n      accessibility\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSearchCriteriaFragment on ShoppingSearchCriteria {\n    selections {\n      id\n      value\n    }\n    booleans {\n      id\n      value\n    }\n    counts {\n      id\n      value\n    }\n    dates {\n      id\n      value {\n        day\n        month\n        year\n      }\n    }\n    ranges {\n      id\n      max\n      min\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment AppliedFilterFragment on ShoppingSortAndFilterAppliedFilter {\n    pill {\n      ...EGDSRemovablePillFragment\n    }\n    nextSearchCriteria {\n      ...ShoppingSearchCriteriaFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    disabled\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment FilterAppliedFragment on ShoppingAppliedFilter {\n    filter {\n      ...EGDSBasicRemovablePillFragment\n    }\n    nextSearchCriteria {\n      ...ShoppingSearchCriteriaFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsAppliedFiltersFragment on ShoppingSortAndFilters {\n    appliedFilters {\n      ...AppliedFilterFragment\n    }\n    filtersApplied {\n      ...FilterAppliedFragment\n    }\n    clearAll {\n      egdsElementId\n      ...EGDSButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFiltersCarouselFragment on ShoppingSortAndFilters {\n    carousel {\n      ...EGDSCarouselFragment\n    }\n    scrollEndAnalytics {\n      eventType\n      linkName\n      referrerId\n    }\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    accessibility\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment DropdownFieldFragment on ShoppingDropdownField {\n    __typename\n    primary\n    secondary\n    dropdownOptions: options {\n      accessibility\n      id\n      primary\n      value\n      defaultOption: default\n      selected\n      selectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      deselectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSignalReceiverFragment on SortAndFilterSignalReceiver {\n    signalId\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSignalEmitterFragment on SortAndFilterSignalEmitter {\n    signalId\n    condition\n    payload {\n      ...SortAndFilterSignalPayloadFragment\n    }\n  }\n\n  fragment SortAndFilterSignalPayloadFragment on SortAndFilterSignalPayload {\n    ...SortAndFilterBasicFilterPayloadFragment\n    ...SortAndFilterSelectedFilterPillPayloadFragment\n  }\n\n  fragment SortAndFilterBasicFilterPayloadFragment on SortAndFilterBasicFilterPayload {\n    filterId\n    type\n  }\n\n  fragment SortAndFilterSelectedFilterPillPayloadFragment on SortAndFilterSelectedFilterPillPayload {\n    deselectionSignalId\n    filter {\n      ...EGDSBasicRemovablePillPartialFragment\n    }\n    filterName {\n      ...SortAndFilterSignalDataSourceFragment\n    }\n  }\n\n  fragment EGDSBasicRemovablePillPartialFragment on EGDSBasicRemovablePill {\n    name\n    accessibility\n    id\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  fragment SortAndFilterSignalDataSourceFragment on SortAndFilterSignalDataSource {\n    ...EGDSPlainTextFragment\n    ...EGDSBasicLocalizedTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionStackedTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    selected\n    value\n    accessibility\n    disabled\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionStackedTileFieldFragment on ShoppingMultiSelectionStackedTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionStackedTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    secondary\n    selected\n    value\n    accessibility\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    icon {\n      ...IconFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionTileFieldFragment on ShoppingMultiSelectionTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ", "\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment MarkFragment on Mark {\n    description\n    id\n  }\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment UIGraphicFragment on UIGraphic {\n    ...MarkFragment\n  }\n\n  ", "\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    description\n    graphic {\n      ...UIGraphicFragment\n    }\n    primary\n    secondary\n    selected\n    value\n    disabled\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionFieldFragment on ShoppingMultiSelectionField {\n    __typename\n    primary\n    secondary\n    fieldId: id\n    expando {\n      collapseLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandLabel\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...MultiSelectionOptionFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment RangeFieldFragment on ShoppingRangeField {\n    primary\n    range {\n      ...ShoppingRangeFilterOptionFragment\n    }\n  }\n\n  fragment ShoppingRangeFilterOptionFragment on ShoppingRangeFilterOption {\n    characteristics {\n      labels {\n        label\n        value\n      }\n      max\n      maxLabel\n      min\n      minLabel\n      step\n      minStepDistance\n    }\n    id\n    minAccessibility\n    maxAccessibility\n    selected {\n      id\n      max\n      min\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment RangeTextInputFieldFragment on ShoppingRangeTextInputField {\n    numberFormat\n    fieldId: id\n    minValueInput {\n      ... on EGDSTextInputField {\n        egdsElementId\n        label\n        readOnly\n        value\n      }\n    }\n    maxValueInput {\n      ... on EGDSTextInputField {\n        egdsElementId\n        label\n        readOnly\n        value\n      }\n    }\n    rangeField: range {\n      ...ShoppingRangeTextInputFieldFilterOptionFragment\n    }\n    primary\n    secondary\n    lowerBoundAccessibility\n    upperBoundAccessibility\n    minValueAccessibility {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n        text\n      }\n    }\n    maxValueAccessibility {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n        text\n      }\n    }\n    minValueAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    maxValueAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  fragment ShoppingRangeTextInputFieldFilterOptionFragment on ShoppingRangeFilterOption {\n    characteristics {\n      max\n      maxLabel\n      min\n      minLabel\n      step\n    }\n    id\n    selected {\n      id\n      max\n      min\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment SelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    primary\n    secondary\n    selected\n    default\n    value\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment SelectionFieldFragment on ShoppingSelectionField {\n    __typename\n    primary\n    secondary\n    expando {\n      collapseLabel\n      expandLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...SelectionOptionFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment StepInputFieldFragment on ShoppingStepInputField {\n    __typename\n    primary\n    stepInputId: id\n    stepInput {\n      decreaseText\n      increaseText\n      label\n      max\n      min\n      step\n      subLabel\n      value\n      key\n      decreaseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      increaseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n    accessibility\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment MutexFieldFragment on ShoppingMutexField {\n    __typename\n    mutexId: id\n    primary\n    secondary\n    options {\n      __typename\n      mutexOption: option {\n        ...MultiSelectionFieldFragment\n        ...RangeFieldFragment\n        ...MultiSelectionStackedTileFieldFragment\n        ...MultiSelectionTileFieldFragment\n        ...StepInputFieldFragment\n        ...RangeTextInputFieldFragment\n      }\n      mutexValue: value {\n        ...SelectionOptionFieldFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSelectedFilterFragment on ShoppingSelectedFilter {\n    filter {\n      ...EGDSBasicRemovablePillFragment\n    }\n\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment SelectedFiltersFieldFragment on ShoppingSelectedFiltersField {\n    selectedFiltersFieldAccessiblity: accessibility {\n      ... on EGDSBasicLocalizedText {\n        egdsElementId\n        text\n      }\n      ... on EGDSCardinalLocalizedText {\n        egdsElementId\n        accessibilityText\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        egdsElementId\n        text\n      }\n    }\n    primary\n    secondary\n    selectedFiltersOrdering\n    shoppingSelectedFilters {\n      ...ShoppingSelectedFilterFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  fragment TextInputFieldFragment on ShoppingTextInputField {\n    __typename\n    id\n    primary\n    secondary\n    label\n    placeholder\n    selected\n    icon {\n      id\n      description\n    }\n    typeaheadInfo {\n      client\n      isDestination\n      lineOfBusiness\n      maxNumberOfResults\n      regionType\n      regionId\n      typeaheadFeatures\n      allowExactMatch\n      listTitle\n      categorize\n      dismissButtonText\n      domain\n      emptyResultsPlaceholder\n      typeaheadMultiSelect {\n        isMultiLocation\n        showPills\n        selectedItemHeading\n        clearAllText\n      }\n    }\n    autoSuggest {\n      uri {\n        relativePath\n        value\n      }\n      autoSuggestKeyValuePair {\n        key\n        value\n      }\n      header\n      payload\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    clearButtonAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    multiSelections {\n      text\n      value\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment SortFilterToolbarFragment on UIToolbar {\n    __typename\n    primary\n    actions {\n      primary {\n        ...EGDSTertiaryButtonFragment\n      }\n      secondaries {\n        ...EGDSTertiaryButtonFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterFieldFragment on ShoppingSortAndFilterQuickFilter {\n    ...QuickAccessFilterSheetFooterFragment\n    clearAll {\n      ...EGDSSecondaryButtonFragment\n    }\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n      ...RangeTextInputFieldFragment\n    }\n    filterPill {\n      ...EGDSPillFragment\n    }\n    resultCountLabel\n    toolbar {\n      ...SortFilterToolbarFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterMoreFiltersFragment on ShoppingSortAndFilterButtonTrigger {\n    container {\n      ... on ShoppingSortAndFilterDialogContainer {\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSectionFragment on ShoppingSortAndFilterSection {\n    __typename\n    id\n    title\n    subTitle\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n      ...RangeTextInputFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment ToggleButtonFieldFragment on EGDSStandardSwitch {\n    checked\n    checkedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    checkedDescription\n    checkedLabel\n    uncheckedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    uncheckedDescription\n    uncheckedLabel\n  }\n\n  ", "\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment ToggleFilterPillFieldFragment on ShoppingSortAndFilterToggleFilter {\n    filterPill {\n      ...EGDSPillFragment\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    __typename\n  }\n  ", "\n  ", "\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterBarFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    sortSections {\n      ...SortAndFilterSectionFragment\n    }\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n    quickAccessFilters {\n      ...QuickAccessFilterFieldFragment\n      ...QuickAccessFilterMoreFiltersFragment\n      ...ToggleFilterPillFieldFragment\n    }\n    ...ShoppingSortAndFiltersCarouselFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFiltersFragment on ShoppingSortAndFilters {\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...DropdownFieldFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortAndFiltersFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    sortSections {\n      ...SortAndFilterSectionFragment\n    }\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterDialogFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterPillFragment on ShoppingSortAndFilters {\n    quickAccessFilters {\n      ...ToggleFilterPillFieldFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  fragment TabSelectionFieldFragment on ShoppingTabSelectionField {\n    __typename\n    tabOptions: options {\n      __typename\n      accessibility\n      id\n      primary\n      secondary\n      value\n      selected\n      selectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject61() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortTabsFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...TabSelectionFieldFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject61 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject62() {
  var data = _tagged_template_literal(["\n  query LodgingUniversalSortAndFiltersQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $shoppingContext: ShoppingContextInput\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      shoppingContext: $shoppingContext\n    ) {\n      universalSortAndFilter {\n        ...SearchToolsFiltersFragment\n        ...SearchToolsSortFragment\n        ...SearchToolsSortAndFiltersFragment\n        ...SearchToolsFilterBarFragment\n        ...SearchToolsAppliedFiltersFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject62 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject63() {
  var data = _tagged_template_literal(["\n  query FilterSheetFooterQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $criteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n  ) {\n    propertySearch(context: $context, destination: $destination, criteria: $criteria, shoppingContext: $shoppingContext) {\n      universalSortAndFilter {\n        ...AllFilterSheetFooterFragment\n        quickAccessFilters {\n          ...QuickAccessFilterSheetFooterFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject63 = function _templateObject() {
    return data;
  };
  return data;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function (obj, key, value) {
  __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
  return value;
};
// src/components/sort-filters/sort-filters.tsx
import React61 from "react";
import { gql as gql57, useLazyQuery, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/all-filter-sheet-footer.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkParagraph } from "uitk-react-text";
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkButtonSize } from "uitk-react-button";
// ../internal/src/components/common/ui-floating-action-button/ui-primary-floating-action-button.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkNotificationBadge1 } from "uitk-react-badge";
import { UitkPrimaryButton } from "uitk-react-button";
// ../internal/src/utils/uis-messages-mapper.ts
var mapUisMicroMessage = function (uisPrimeMessages) {
  return uisPrimeMessages.map(function (uisPrimeMessage) {
    return {
      messageContent: JSON.parse(uisPrimeMessage.messageContent),
      schemaName: uisPrimeMessage.schemaName
    };
  });
};
// ../internal/src/components/common/client-side-analytics.ts
import { gql } from "@apollo/client";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/common/icon.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
// ../internal/src/__generated__/types.ts
var SortAndFiltersViewType = /* @__PURE__ */function (SortAndFiltersViewType3) {
  SortAndFiltersViewType3["APPLIED_FILTERS"] = "APPLIED_FILTERS";
  SortAndFiltersViewType3["FILTERS"] = "FILTERS";
  SortAndFiltersViewType3["FILTERS_PILLS"] = "FILTERS_PILLS";
  SortAndFiltersViewType3["FILTER_BAR"] = "FILTER_BAR";
  SortAndFiltersViewType3["FILTER_DIALOG"] = "FILTER_DIALOG";
  SortAndFiltersViewType3["SORT"] = "SORT";
  SortAndFiltersViewType3["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
  SortAndFiltersViewType3["SORT_TABS"] = "SORT_TABS";
  SortAndFiltersViewType3["USE_REWARDS"] = "USE_REWARDS";
  return SortAndFiltersViewType3;
}(SortAndFiltersViewType || {});
// ../internal/src/components/common/icon.tsx
var __Fragment = gql2(_templateObject1());
var _obj;
var iconSizeMap = (_obj = {}, _define_property(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */, UitkIconSize.EXTRA_SMALL), _define_property(_obj, "SMALL" /* SMALL */, UitkIconSize.SMALL), _define_property(_obj, "MEDIUM" /* MEDIUM */, UitkIconSize.MEDIUM), _define_property(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */, UitkIconSize.MEDIUM), _define_property(_obj, "LARGE" /* LARGE */, UitkIconSize.LARGE), _define_property(_obj, "XLARGE" /* XLARGE */, UitkIconSize.XLARGE), _obj);
var Icon = function (props) {
  var data = props.data;
  var id = data.id,
    title = data.title,
    description = data.description,
    size = data.size;
  var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
  return /* @__PURE__ */React.createElement(UitkIcon, {
    id: id,
    name: id,
    title: title !== null && title !== void 0 ? title : description,
    description: description,
    size: iconSize
  });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment;
// ../internal/src/components/common/ui-floating-action-button/ui-primary-floating-action-button.tsx
var __Fragment2 = gql3(_templateObject2(), clientSideAnalyticsFragment, Icon.fragment);
var UIPrimaryFloatingActionButton = function (props) {
  var data = props.data,
    onClick = props.onClick,
    isFullWidth = props.isFullWidth,
    size = props.size,
    triggerRef = props.triggerRef;
  var primary = data.primary,
    icon = data.icon,
    badge = data.badge,
    analytics = data.analytics,
    egdsElementId = data.egdsElementId,
    disabled = data.disabled;
  var track = useClickTracker();
  var handleClick = React2.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React2.createElement(UitkPrimaryButton, {
    isFullWidth: isFullWidth,
    onClick: handleClick,
    size: size,
    "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
    domRef: triggerRef,
    disabled: disabled
  }, badge && /* @__PURE__ */React2.createElement(UitkNotificationBadge1, {
    text: badge.toString()
  }), primary, icon && /* @__PURE__ */React2.createElement(Icon, {
    data: icon
  }));
};
UIPrimaryFloatingActionButton.displayName = "UIPrimaryFloatingActionButton";
UIPrimaryFloatingActionButton.fragment = __Fragment2;
// ../internal/src/components/common/ui-floating-action-button/ui-secondary-floating-action-button.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeNotification, UitkNotificationBadge1 as UitkNotificationBadge12 } from "uitk-react-badge";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var __Fragment3 = gql4(_templateObject3(), clientSideAnalyticsFragment, Icon.fragment);
var Badge = function (param) {
  var badge = param.badge,
    withUpdatedNotification = param.withUpdatedNotification;
  if (withUpdatedNotification) {
    return /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement(UitkLayoutPosition, {
      type: "relative",
      position: {
        right: "one",
        bottom: "half"
      }
    }, /* @__PURE__ */React3.createElement(UitkBadgeNotification, {
      count: badge.toString(),
      theme: "action",
      visible: true
    })));
  }
  return /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement(UitkNotificationBadge12, {
    text: badge.toString()
  }));
};
var UISecondaryFloatingActionButton = function (props) {
  var data = props.data,
    onClick = props.onClick,
    isFullWidth = props.isFullWidth,
    size = props.size,
    withUpdatedNotification = props.withUpdatedNotification,
    triggerRef = props.triggerRef;
  var primary = data.primary,
    icon = data.icon,
    badge = data.badge,
    analytics = data.analytics,
    egdsElementId = data.egdsElementId;
  var track = useClickTracker2();
  var handleClick = React3.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React3.createElement(UitkSecondaryButton, {
    isFullWidth: isFullWidth,
    onClick: handleClick,
    size: size,
    "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
    domRef: triggerRef
  }, /* @__PURE__ */React3.createElement(UitkLayoutFlex, {
    space: withUpdatedNotification && !!badge ? "six" : "two"
  }, !!badge && /* @__PURE__ */React3.createElement(Badge, {
    badge: badge,
    withUpdatedNotification: withUpdatedNotification
  }), icon && !badge && /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement(Icon, {
    data: icon
  })), /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement("div", null, primary))));
};
UISecondaryFloatingActionButton.displayName = "UISecondaryFloatingActionButton";
UISecondaryFloatingActionButton.fragment = __Fragment3;
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
var __Fragment4 = gql5(_templateObject4(), UIPrimaryFloatingActionButton.fragment, UISecondaryFloatingActionButton.fragment);
var UIFloatingActionButtonImplementationsMap = {
  UIPrimaryFloatingActionButton: UIPrimaryFloatingActionButton,
  UISecondaryFloatingActionButton: UISecondaryFloatingActionButton
};
var UIFloatingActionButton = function (param) {
  var onClick = param.onClick,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth,
    _param_size = param.size,
    size = _param_size === void 0 ? UitkButtonSize.MEDIUM : _param_size,
    data = param.data,
    withUpdatedNotification = param.withUpdatedNotification,
    triggerRef = param.triggerRef;
  var __typename = data.__typename;
  var Button = UIFloatingActionButtonImplementationsMap[__typename];
  if (Button) {
    return /* @__PURE__ */React4.createElement(Button, {
      onClick: onClick,
      isFullWidth: isFullWidth,
      size: size,
      data: data,
      withUpdatedNotification: withUpdatedNotification,
      triggerRef: triggerRef
    });
  }
  return null;
};
UIFloatingActionButton.displayName = "UIFloatingActionButton";
UIFloatingActionButton.fragment = __Fragment4;
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/all-filter-sheet-footer.tsx
var __Fragment5 = gql6(_templateObject5(), UIFloatingActionButton.fragment);
var AllFilterSheetFooter = function (param) {
  var data = param.data,
    viewType4 = param.viewType,
    onClick = param.onClick,
    footerDataLoading = param.footerDataLoading,
    _param_isDoneButtonFullWidth = param.isDoneButtonFullWidth,
    isDoneButtonFullWidth = _param_isDoneButtonFullWidth === void 0 ? false : _param_isDoneButtonFullWidth,
    _param_isWrapped = param.isWrapped,
    isWrapped = _param_isWrapped === void 0 ? true : _param_isWrapped;
  var footerLabel = data.footerLabel,
    containers = data.containers;
  var _containers_find;
  var applyAction = ((_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
    return container.view === viewType4;
  })) !== null && _containers_find !== void 0 ? _containers_find : {}).applyAction;
  var showResultsCount = footerLabel;
  if (!applyAction) {
    return null;
  }
  var buttonData = footerDataLoading ? _object_spread_props(_object_spread({}, applyAction), {
    disabled: true
  }) : applyAction;
  if (!isWrapped) {
    var FILTER_SHOW_PROPERTIES_TRACKING = {
      referrerId: "HOT.SR.FilterShowProperties.X.Viewed",
      linkName: "Zero property results in filter modal impression"
    };
    var isZeroPropertyCount = applyAction.__typename === "UIPrimaryFloatingActionButton" && applyAction.disabled;
    var Button = /* @__PURE__ */React5.createElement(UIFloatingActionButton, {
      data: buttonData,
      size: UitkButtonSize2.LARGE,
      onClick: onClick,
      isFullWidth: isDoneButtonFullWidth
    });
    return isZeroPropertyCount ? /* @__PURE__ */React5.createElement(IntersectionTracker, {
      referrerId: FILTER_SHOW_PROPERTIES_TRACKING.referrerId,
      linkName: FILTER_SHOW_PROPERTIES_TRACKING.linkName,
      trackOnce: true
    }, Button) : Button;
  }
  return /* @__PURE__ */React5.createElement(UitkSpacing, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    },
    border: ["blockstart"]
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlex2, {
    justifyContent: showResultsCount ? "space-between" : "end",
    alignItems: "center"
  }, showResultsCount && /* @__PURE__ */React5.createElement(UitkLayoutFlexItem2, null, footerDataLoading ? /* @__PURE__ */React5.createElement(UitkLineSkeleton, null) : /* @__PURE__ */React5.createElement(UitkParagraph, null, footerLabel)), /* @__PURE__ */React5.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React5.createElement(UIFloatingActionButton, {
    data: buttonData,
    onClick: onClick,
    withUpdatedNotification: true,
    isFullWidth: isDoneButtonFullWidth
  }))));
};
AllFilterSheetFooter.displayName = "AllFilterSheetFooter";
AllFilterSheetFooter.fragment = __Fragment5;
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
import React7 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSheetFooter } from "uitk-react-sheet";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph2 } from "uitk-react-text";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React6 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3, UitkFloatingFullWidthButton, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkScrim } from "uitk-react-scrim";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql as gql7 } from "@apollo/client";
var EGDSButtonFragment = gql7(_templateObject6(), clientSideAnalyticsFragment);
// ../internal/src/components/common/button/egds-primary-button.tsx
var __Fragment6 = gql8(_templateObject7(), EGDSButtonFragment);
var EGDSPrimaryButton = function (param) {
  var data = param.data,
    onClick = param.onClick,
    size = param.size,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth,
    _param_floating = param.floating,
    floating = _param_floating === void 0 ? false : _param_floating;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics,
    disabled = data.disabled;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
  var track = useClickTracker3();
  var handleClick = React6.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  var primaryButtonProps = {
    onClick: handleClick,
    id: id,
    isFullWidth: isFullWidth,
    disabled: disabled,
    size: size || UitkButtonSize3.LARGE
  };
  return floating ? /* @__PURE__ */React6.createElement(UitkScrim, {
    type: "fade-button"
  }, /* @__PURE__ */React6.createElement(UitkFloatingFullWidthButton, _object_spread({}, primaryButtonProps), primary)) : /* @__PURE__ */React6.createElement(UitkPrimaryButton2, _object_spread({}, primaryButtonProps), primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment6;
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
var __Fragment7 = gql9(_templateObject8(), EGDSPrimaryButton.fragment);
var QuickAccessFilterSheetFooter = function (param) {
  var data = param.data,
    onClick = param.onClick,
    footerDataLoading = param.footerDataLoading,
    isBexQuickFiltersEnabled = param.isBexQuickFiltersEnabled;
  var resultCountLabel = data.resultCountLabel,
    applyAction = data.applyAction;
  var showResultsCount = resultCountLabel;
  if ((applyAction === null || applyAction === void 0 ? void 0 : applyAction.__typename) !== "UIPrimaryButton") {
    return null;
  }
  var buttonData = footerDataLoading ? _object_spread_props(_object_spread({}, applyAction), {
    disabled: true
  }) : applyAction;
  var buttonProps = {
    data: buttonData,
    onClick: onClick,
    size: UitkButtonSize4.MEDIUM
  };
  if (isBexQuickFiltersEnabled) {
    return /* @__PURE__ */React7.createElement(UitkSheetFooter, null, /* @__PURE__ */React7.createElement(UitkSpacing2, {
      padding: {
        block: "three",
        inline: "two"
      }
    }, /* @__PURE__ */React7.createElement(UitkLayoutFlex3, null, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React7.createElement(EGDSPrimaryButton, _object_spread({}, buttonProps))))));
  }
  return /* @__PURE__ */React7.createElement(UitkSpacing2, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlex3, {
    justifyContent: showResultsCount ? "space-between" : "end",
    alignItems: "center"
  }, showResultsCount && /* @__PURE__ */React7.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem3, null, footerDataLoading ? /* @__PURE__ */React7.createElement(UitkLineSkeleton2, null) : /* @__PURE__ */React7.createElement(UitkParagraph2, null, resultCountLabel))), /* @__PURE__ */React7.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React7.createElement(EGDSPrimaryButton, _object_spread_props(_object_spread({}, buttonProps), {
    isFullWidth: false
  })))));
};
QuickAccessFilterSheetFooter.displayName = "QuickAccessFilterSheetFooter";
QuickAccessFilterSheetFooter.fragment = __Fragment7;
// ../internal/src/components/sort-filter/filter-bar-loading-skeleton.tsx
import React8 from "react";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var FilterBarLoadingSkeleton = function (param) {
  var filterBarSpacing = param.filterBarSpacing,
    _param_numPills = param.numPills,
    numPills = _param_numPills === void 0 ? 6 : _param_numPills;
  return /* @__PURE__ */React8.createElement(UitkSpacing3, _object_spread({}, filterBarSpacing), /* @__PURE__ */React8.createElement(UitkLayoutGrid, {
    autoRows: ["8x"],
    alignItems: "center"
  }, /* @__PURE__ */React8.createElement(UitkLayoutFlex4, {
    direction: "row",
    space: "two"
  }, Array.from({
    length: numPills
  }, function (_, i) {
    return /* @__PURE__ */React8.createElement(UitkLayoutFlexItem4, {
      key: i
    }, /* @__PURE__ */React8.createElement(UitkLineSkeleton3, {
      key: i,
      animation: true,
      type: "secondary"
    }));
  }))));
};
// ../internal/src/components/sort-filter/loading-skeleton-map.tsx
var loadingSkeletonMap = /* @__PURE__ */new Map();
loadingSkeletonMap.set("FILTER_BAR" /* FILTER_BAR */, FilterBarLoadingSkeleton);
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
import React13 from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
import React10 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/common/removable-pill/egds-removable-pill.tsx
import React9 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var __Fragment8 = gql10(_templateObject9(), clientSideAnalyticsFragment);
var EGDSRemovablePill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    disabled = param.disabled;
  var primary = data.primary,
    accessibility = data.accessibility,
    action = data.action;
  var clickTracker = useClickTracker4();
  var handleClick = function () {
    if (action === null || action === void 0 ? void 0 : action.analytics) {
      var _action_analytics = action.analytics,
        linkName = _action_analytics.linkName,
        referrerId = _action_analytics.referrerId,
        uisPrimeMessages = _action_analytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  };
  return /* @__PURE__ */React9.createElement(UitkRemovablePill, {
    id: primary,
    onClick: handleClick,
    altText: accessibility || "",
    a11yRemoveText: (action === null || action === void 0 ? void 0 : action.accessibility) || "",
    disabled: data.disabled || disabled
  }, primary);
};
EGDSRemovablePill.displayName = "EGDSRemovablePill";
EGDSRemovablePill.fragment = __Fragment8;
// ../internal/src/components/sort-filter/__private/__fragments/next-search-criteria-fragment.tsx
import { gql as gql11 } from "@apollo/client";
var NextSearchCriteriaFragment = gql11(_templateObject10());
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
var __Fragment9 = gql12(_templateObject11(), EGDSRemovablePill.fragment, NextSearchCriteriaFragment);
var AppliedFilter = function (param) {
  var data = param.data,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    disabled = param.disabled;
  var _nextSearchCriteria_selections;
  var pill = data.pill,
    nextSearchCriteria = data.nextSearchCriteria;
  if (pill.__typename !== "EGDSRemovablePill" || !((_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : _nextSearchCriteria_selections[0]) && !allowEmptySelections) {
    return null;
  }
  var handleClick = function () {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(nextSearchCriteria);
  };
  return /* @__PURE__ */React10.createElement(EGDSRemovablePill, {
    data: pill,
    onClick: handleClick,
    disabled: disabled
  });
};
AppliedFilter.displayName = "AppliedFilter";
AppliedFilter.fragment = __Fragment9;
// ../internal/src/components/sort-filter/__private/__fragments/filter-applied.tsx
import React12 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React11 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill as UitkRemovablePill2 } from "uitk-react-pill";
var __Fragment10 = gql13(_templateObject12(), Icon.fragment, clientSideAnalyticsFragment);
var EGDSBasicRemovablePill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    loading = param.loading;
  var id = data.id,
    primary = data.primary,
    accessibility = data.accessibility,
    removeAnalytics = data.removeAnalytics,
    name = data.name,
    disabled = data.disabled,
    icon = data.icon;
  var _ref;
  var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
  var iconDescription = (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.description : "";
  var clickTracker = useClickTracker5();
  var handleOnClick = function () {
    if (onClick) {
      onClick();
    }
    if (removeAnalytics) {
      var referrerId = removeAnalytics.referrerId,
        linkName = removeAnalytics.linkName,
        uisPrimeMessages = removeAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  return /* @__PURE__ */React11.createElement(UitkRemovablePill2, {
    id: title,
    onClick: handleOnClick,
    icon: iconDescription,
    a11yRemoveText: accessibility || "",
    disabled: disabled || loading
  }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment10;
// ../internal/src/components/sort-filter/__private/__fragments/filter-applied.tsx
var __Fragment11 = gql14(_templateObject13(), EGDSBasicRemovablePill.fragment, NextSearchCriteriaFragment);
var hasNoCriteria = function (nextSearchCriteria) {
  var _nextSearchCriteria_selections, _nextSearchCriteria_ranges;
  if (!nextSearchCriteria) {
    return true;
  }
  return !(((_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : _nextSearchCriteria_selections[0]) || ((_nextSearchCriteria_ranges = nextSearchCriteria.ranges) === null || _nextSearchCriteria_ranges === void 0 ? void 0 : _nextSearchCriteria_ranges[0]));
};
var FilterApplied = function (param) {
  var data = param.data,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    loading = param.loading,
    setDefaults = param.setDefaults;
  var filter = data.filter,
    nextSearchCriteria = data.nextSearchCriteria;
  React12.useEffect(function () {
    var _nextSearchCriteria_selections_, _nextSearchCriteria_selections;
    if ((nextSearchCriteria === null || nextSearchCriteria === void 0 ? void 0 : (_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : (_nextSearchCriteria_selections_ = _nextSearchCriteria_selections[0]) === null || _nextSearchCriteria_selections_ === void 0 ? void 0 : _nextSearchCriteria_selections_.id) === "neighborhood") {
      var _nextSearchCriteria_selections1;
      setDefaults({
        regionId: nextSearchCriteria === null || nextSearchCriteria === void 0 ? void 0 : (_nextSearchCriteria_selections1 = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections1 === void 0 ? void 0 : _nextSearchCriteria_selections1[0].value
      });
    }
  }, []);
  if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill" || hasNoCriteria(nextSearchCriteria) && !allowEmptySelections) {
    return null;
  }
  var handleClick = function () {
    if (onRemove && nextSearchCriteria) {
      onRemove(nextSearchCriteria);
    }
  };
  return /* @__PURE__ */React12.createElement(EGDSBasicRemovablePill, {
    data: filter,
    onClick: handleClick,
    loading: loading
  });
};
FilterApplied.displayName = "FilterApplied";
FilterApplied.fragment = __Fragment11;
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
var __Fragment12 = gql15(_templateObject14(), AppliedFilter.fragment, FilterApplied.fragment, EGDSButtonFragment);
var getFilters = function (filtersApplied, appliedFilters_deprecated) {
  if (filtersApplied) {
    return _to_consumable_array(filtersApplied);
  }
  if (appliedFilters_deprecated) {
    return _to_consumable_array(appliedFilters_deprecated);
  }
  return [];
};
var FilterComponent = function (param) {
  var key = param.key,
    filter = param.filter,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    loading = param.loading,
    setDefaults = param.setDefaults;
  if ("pill" in filter) {
    return /* @__PURE__ */React13.createElement(AppliedFilter, {
      key: key,
      data: filter,
      onRemove: onRemove,
      allowEmptySelections: allowEmptySelections,
      disabled: loading
    });
  }
  if ("filter" in filter) {
    return /* @__PURE__ */React13.createElement(FilterApplied, {
      key: key,
      data: filter,
      onRemove: onRemove,
      allowEmptySelections: allowEmptySelections,
      loading: loading,
      setDefaults: setDefaults
    });
  }
  return null;
};
var SearchToolsAppliedFilters = function (param) {
  var data = param.data,
    onEmptyResults = param.onEmptyResults,
    onRemoveAppliedFilter = param.onRemoveAppliedFilter,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    _param_wrapAppliedFilters = param.wrapAppliedFilters,
    wrapAppliedFilters = _param_wrapAppliedFilters === void 0 ? false : _param_wrapAppliedFilters,
    allowEmptySelectionsPills = param.allowEmptySelectionsPills,
    loading = param.loading,
    appliedFiltersSpacing = param.appliedFiltersSpacing;
  var _data_clearAll;
  var appliedFilters_deprecated = data.appliedFilters,
    clearAll = data.clearAll,
    filtersApplied = data.filtersApplied;
  var track = useClickTracker6();
  var clearElementId = clearAll === null || clearAll === void 0 ? void 0 : clearAll.egdsElementId;
  var filters = getFilters(filtersApplied, appliedFilters_deprecated);
  var _React13_useState = _sliced_to_array(React13.useState(void 0), 2),
    defaults = _React13_useState[0],
    setDefaults = _React13_useState[1];
  var handleClearAll = React13.useCallback(function () {
    var _data_clearAll;
    if ((_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics) {
      var _data_clearAll_analytics = data.clearAll.analytics,
        referrerId = _data_clearAll_analytics.referrerId,
        linkName = _data_clearAll_analytics.linkName;
      track(referrerId, linkName);
    }
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters(defaults);
  }, [(_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics, onRemoveAllAppliedFilters, track]);
  if (!(filters === null || filters === void 0 ? void 0 : filters.length)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React13.createElement(UitkSpacing4, _object_spread({}, appliedFiltersSpacing), /* @__PURE__ */React13.createElement(UitkScrollable, {
    direction: "horizontal"
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlex5, {
    wrap: wrapAppliedFilters ? "wrap" : "nowrap",
    space: wrapAppliedFilters ? "two" : void 0
  }, (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /* @__PURE__ */React13.createElement(React13.Fragment, null, filters.map(function (filter, index) {
    return /* @__PURE__ */React13.createElement(UitkLayoutFlexItem5, {
      shrink: 0,
      key: "applied-filter-".concat(index)
    }, /* @__PURE__ */React13.createElement(FilterComponent, {
      key: "applied-filter-".concat(index),
      filter: filter,
      onRemove: onRemoveAppliedFilter,
      allowEmptySelections: allowEmptySelectionsPills,
      loading: loading,
      setDefaults: setDefaults
    }));
  })), clearAll && /* @__PURE__ */React13.createElement(UitkLayoutFlexItem5, {
    shrink: 0
  }, /* @__PURE__ */React13.createElement(UitkSpacing4, {
    margin: {
      inlineend: "one"
    },
    padding: {
      inlinestart: "two",
      block: "two"
    }
  }, /* @__PURE__ */React13.createElement(UitkLink, {
    inline: true,
    noWrap: true
  }, /* @__PURE__ */React13.createElement("button", {
    type: "button",
    onClick: handleClearAll,
    disabled: loading,
    "data-test-id": clearElementId
  }, clearAll.primary)))))));
};
SearchToolsAppliedFilters.displayName = "SearchToolsAppliedFilters";
SearchToolsAppliedFilters.fragment = __Fragment12;
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
import React53 from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSTeamCarousel } from "@egds/react-universal-shopping";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { SignalEventsContextProvider } from "@shared-ui/signal-events-context";
import { PubSubEventManager } from "@shared-ui/signal-events-context_pub-sub-observer";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkPill as UitkPill3 } from "uitk-react-pill";
import { UitkSheet as UitkSheet3, UitkSheetTransition as UitkSheetTransition3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
// ../internal/src/utils/referrer-mapper.ts
var referrerMapper = function (referrerId, linkName) {
  var eventType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "click";
  return {
    schemaName: "referrer",
    messageContent: {
      referrerId: referrerId,
      linkName: linkName,
      eventType: eventType
    }
  };
};
// ../internal/src/components/common/carousel/carousel-fragment.ts
import { gql as gql16 } from "@apollo/client";
var EGDSCarouselFragment = gql16(_templateObject15());
var ShoppingSortAndFiltersCarouselFragment = gql16(_templateObject16(), EGDSCarouselFragment);
// ../internal/src/components/common/sticky-wrapper.tsx
import React14 from "react";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
import { UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkScrollable as UitkScrollable2 } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkSticky } from "uitk-react-sticky";
import { UitkViewRow } from "uitk-react-view";
var StickyWrapper = function (param) {
  var _obj;
  var children = param.children,
    isDialogOpen = param.isDialogOpen,
    _param_stickyForViewsize = param.stickyForViewsize,
    stickyForViewsize = _param_stickyForViewsize === void 0 ? (_obj = {}, _define_property(_obj, ViewSizes.SMALL, false), _define_property(_obj, ViewSizes.MEDIUM, false), _define_property(_obj, ViewSizes.LARGE, false), _define_property(_obj, ViewSizes.EXTRA_LARGE, false), _obj) : _param_stickyForViewsize,
    spacingStyling = param.spacingStyling,
    isDisabled = param.isDisabled;
  var _React14_useState = _sliced_to_array(React14.useState(false), 2),
    fixed = _React14_useState[0],
    setFixed = _React14_useState[1];
  var isStickyViewportWidth = useViewportMap(stickyForViewsize);
  var allSpacingStyling = {};
  if (spacingStyling) {
    allSpacingStyling = _object_spread({}, spacingStyling);
  }
  if (fixed) {
    allSpacingStyling = _object_spread({
      border: {
        small: ["blockend"],
        medium: ["blockend"],
        large: ["blockend"],
        extra_large: ["blockend"]
      }
    }, allSpacingStyling);
  }
  var horizontallyScrollableAndOptionallySpacedChildren = /* @__PURE__ */React14.createElement(UitkScrollable2, {
    direction: "horizontal"
  }, /* @__PURE__ */React14.createElement(UitkLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React14.createElement(UitkSpacing5, _object_spread({}, allSpacingStyling), children)));
  if (isDisabled) {
    return /* @__PURE__ */React14.createElement(UitkSpacing5, _object_spread({}, allSpacingStyling), children);
  }
  if (isStickyViewportWidth) {
    return /* @__PURE__ */React14.createElement(UitkSticky, {
      zIndex: isDialogOpen ? void 0 : 500,
      onFixed: setFixed
    }, fixed ? /* @__PURE__ */React14.createElement(UitkSpacing5, {
      padding: {
        inline: "unset"
      }
    }, /* @__PURE__ */React14.createElement(UitkViewRow, {
      layout: "fullwidth",
      canvasTheme: "primary"
    }, /* @__PURE__ */React14.createElement("div", {
      "data-testid": "sticky-content"
    }, horizontallyScrollableAndOptionallySpacedChildren))) : horizontallyScrollableAndOptionallySpacedChildren);
  }
  return horizontallyScrollableAndOptionallySpacedChildren;
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button-and-sheet.tsx
import React17 from "react";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button.tsx
import React15 from "react";
import { EGDSButtonSize, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
var AISearchButton = function (param) {
  var onClick = param.onClick,
    domRef = param.domRef;
  return /* @__PURE__ */React15.createElement(EGDSPrimaryButton2, {
    onClick: onClick,
    domRef: domRef,
    size: EGDSButtonSize.SMALL,
    style: {
      whiteSpace: "nowrap"
    }
  }, /* @__PURE__ */React15.createElement(EGDSIcon, {
    name: "cleanliness"
  }), "AI Search");
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-sheet-content.tsx
import React16 from "react";
import { EGDSActionListItem } from "@egds/react-core/action-list-item";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSTextInput } from "@egds/react-core/input";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
// ../internal/test/fixtures/ai-search/ai-search-suggestions.ts
var aiSearchSuggestions = [{
  destination: "Greenville - Spartanburg, South Carolina, United States of America",
  queries: ["Near Falls Park on the Reedy", "Close to Peace Center", "Around BMW Zentrum"],
  original_name: "Greenville_-_Spartanburg",
  id_corrupt: "fine",
  gaia_id: 6035267,
  short_name: "Greenville - Spartanburg",
  long_name: "Greenville - Spartanburg, South Carolina, United States of America"
}, {
  destination: "Vienna (and vicinity), Austria",
  queries: ["Near Sch\xF6nbrunn Palace", "Close to St. Stephen's Cathedral", "Around Belvedere Palace"],
  original_name: "Vienna",
  id_corrupt: "fine",
  gaia_id: 178316,
  short_name: "Vienna (and vicinity)",
  long_name: "Vienna (and vicinity), Austria"
}, {
  destination: "Alexandria, Virginia, United States of America",
  queries: ["Near Old Town Waterfront", "Close to George Washington's Mount Vernon", "Around Torpedo Factory Art Center"],
  original_name: "Alexandria",
  id_corrupt: "fine",
  gaia_id: 5980,
  short_name: "Alexandria",
  long_name: "Alexandria, Virginia, United States of America"
}, {
  destination: "Deadwood, South Dakota, United States of America",
  queries: ["Near Mount Moriah Cemetery", "Close to Adams Museum", "Around Saloon No. 10"],
  original_name: "Deadwood",
  id_corrupt: "fine",
  gaia_id: 6059490,
  short_name: "Deadwood",
  long_name: "Deadwood, South Dakota, United States of America"
}, {
  destination: "Los Angeles County, California, United States of America",
  queries: ["Near Griffith Observatory", "Close to Santa Monica Pier", "Around Hollywood Walk of Fame"],
  original_name: "Los_Angeles_County",
  id_corrupt: "fine",
  gaia_id: 6056560,
  short_name: "Los Angeles County",
  long_name: "Los Angeles County, California, United States of America"
}, {
  destination: "San Francisco (and vicinity), California, United States of America",
  queries: ["Near Golden Gate Bridge", "Close to Alcatraz Island", "Around Fisherman's Wharf"],
  original_name: "San_Francisco",
  id_corrupt: "fine",
  gaia_id: 178305,
  short_name: "San Francisco (and vicinity)",
  long_name: "San Francisco (and vicinity), California, United States of America"
}, {
  destination: "Newark (and vicinity), New Jersey, United States of America",
  queries: ["Near Branch Brook Park", "Close to Prudential Center", "Around Newark Museum"],
  original_name: "Newark",
  id_corrupt: "fine",
  gaia_id: 601760,
  short_name: "Newark (and vicinity)",
  long_name: "Newark (and vicinity), New Jersey, United States of America"
}, {
  destination: "Cherokee, North Carolina, United States of America",
  queries: ["Near Great Smoky Mountains National Park", "Close to Harrah's Cherokee Casino", "Around Museum of the Cherokee Indian"],
  original_name: "Cherokee",
  id_corrupt: "fine",
  gaia_id: 6058529,
  short_name: "Cherokee",
  long_name: "Cherokee, North Carolina, United States of America"
}, {
  destination: "Cape Canaveral, Florida, United States of America",
  queries: ["Near Kennedy Space Center Visitor Complex", "Close to Port Canaveral", "Around Exploration Tower"],
  original_name: "Cape_Canaveral",
  id_corrupt: "fine",
  gaia_id: 6484,
  short_name: "Cape Canaveral",
  long_name: "Cape Canaveral, Florida, United States of America"
}, {
  destination: "Aspen, Colorado, United States of America",
  queries: ["Near Maroon Bells", "Close to Aspen Mountain", "Around Aspen Art Museum"],
  original_name: "Aspen",
  id_corrupt: "fine",
  gaia_id: 423,
  short_name: "Aspen",
  long_name: "Aspen, Colorado, United States of America"
}, {
  destination: "Lake George, New York, United States of America",
  queries: ["near Lake George Beach", "close to Fort William Henry", "proximity to Million Dollar Beach"],
  original_name: "Lake_George",
  id_corrupt: "fine",
  gaia_id: 6055969,
  short_name: "Lake George",
  long_name: "Lake George, New York, United States of America"
}, {
  destination: "Phoenix (and vicinity), Arizona, United States of America",
  queries: ["near Desert Botanical Garden", "close to Camelback Mountain", "proximity to Heard Museum"],
  original_name: "Phoenix",
  id_corrupt: "fine",
  gaia_id: 178298,
  short_name: "Phoenix (and vicinity)",
  long_name: "Phoenix (and vicinity), Arizona, United States of America"
}, {
  destination: "Chicago (and vicinity), Illinois, United States of America",
  queries: ["near Millennium Park", "close to Navy Pier", "proximity to The Art Institute of Chicago"],
  original_name: "Chicago",
  id_corrupt: "fine",
  gaia_id: 178248,
  short_name: "Chicago (and vicinity)",
  long_name: "Chicago (and vicinity), Illinois, United States of America"
}, {
  destination: "Fredericksburg, Texas, United States of America",
  queries: ["near Main Street shopping", "close to Enchanted Rock State Natural Area", "proximity to National Museum of the Pacific War"],
  original_name: "Fredericksburg",
  id_corrupt: "fine",
  gaia_id: 6059096,
  short_name: "Fredericksburg",
  long_name: "Fredericksburg, Texas, United States of America"
}, {
  destination: "Honolulu, Hawaii, United States of America",
  queries: ["near Waikiki Beach", "close to Diamond Head State Monument", "proximity to Pearl Harbor National Memorial"],
  original_name: "Honolulu",
  id_corrupt: "fine",
  gaia_id: 1488,
  short_name: "Honolulu",
  long_name: "Honolulu, Hawaii, United States of America"
}, {
  destination: "Montana, United States of America",
  queries: ["near Glacier National Park", "close to Yellowstone National Park", "proximity to Big Sky Resort"],
  original_name: "Montana",
  id_corrupt: "fine",
  gaia_id: 228,
  short_name: "Montana",
  long_name: "Montana, United States of America"
}, {
  destination: "Aruba",
  queries: ["near Palm Beach", "close to Arikok National Park", "proximity to California Lighthouse"],
  original_name: "Aruba",
  id_corrupt: "fine",
  gaia_id: 9,
  short_name: "Aruba",
  long_name: "Aruba"
}, {
  destination: "Nantucket, Massachusetts, United States of America",
  queries: ["near Brant Point Light", "close to Sankaty Head Light", "proximity to Cisco Brewers"],
  original_name: "Nantucket",
  id_corrupt: "fine",
  gaia_id: 285,
  short_name: "Nantucket",
  long_name: "Nantucket, Massachusetts, United States of America"
}, {
  destination: "Roanoke, Virginia, United States of America",
  queries: ["near Mill Mountain Star and Park", "close to Taubman Museum of Art", "proximity to Blue Ridge Parkway"],
  original_name: "Roanoke",
  id_corrupt: "fine",
  gaia_id: 3020,
  short_name: "Roanoke",
  long_name: "Roanoke, Virginia, United States of America"
}, {
  destination: "Lexington (and vicinity), Kentucky, United States of America",
  queries: ["near Kentucky Horse Park", "close to Keeneland Racing Course", "proximity to Mary Todd Lincoln House"],
  original_name: "Lexington",
  id_corrupt: "fine",
  gaia_id: 603003,
  short_name: "Lexington (and vicinity)",
  long_name: "Lexington (and vicinity), Kentucky, United States of America"
}, {
  destination: "Branson, Missouri, United States of America",
  queries: ["near Titanic Museum Attraction", "close to Silver Dollar City", "around Table Rock Lake"],
  original_name: "Branson",
  id_corrupt: "fine",
  gaia_id: 6058734,
  short_name: "Branson",
  long_name: "Branson, Missouri, United States of America"
}, {
  destination: "Idaho, United States of America",
  queries: ["near Boise River Greenbelt", "close to Idaho Botanical Garden", "around Lake Coeur d'Alene"],
  original_name: "Idaho",
  id_corrupt: "fine",
  gaia_id: 214,
  short_name: "Idaho",
  long_name: "Idaho, United States of America"
}, {
  destination: "Illinois, United States of America",
  queries: ["near Millennium Park", "close to Navy Pier", "around Willis Tower"],
  original_name: "Illinois",
  id_corrupt: "fine",
  gaia_id: 215,
  short_name: "Illinois",
  long_name: "Illinois, United States of America"
}, {
  destination: "Omaha (and vicinity), Nebraska, United States of America",
  queries: ["near Henry Doorly Zoo and Aquarium", "close to Old Market", "around Bob Kerrey Pedestrian Bridge"],
  original_name: "Omaha",
  id_corrupt: "fine",
  gaia_id: 2670,
  short_name: "Omaha (and vicinity)",
  long_name: "Omaha (and vicinity), Nebraska, United States of America"
}, {
  destination: "Rochester, Minnesota, United States of America",
  queries: ["near Mayo Clinic", "close to Quarry Hill Nature Center", "around Silver Lake Park"],
  original_name: "Rochester",
  id_corrupt: "fine",
  gaia_id: 3041,
  short_name: "Rochester",
  long_name: "Rochester, Minnesota, United States of America"
}, {
  destination: "Little Rock, Arkansas, United States of America",
  queries: ["near Riverfront Park", "close to Little Rock Central High School National Historic Site", "around Pinnacle Mountain State Park"],
  original_name: "Little_Rock",
  id_corrupt: "fine",
  gaia_id: 602841,
  short_name: "Little Rock",
  long_name: "Little Rock, Arkansas, United States of America"
}, {
  destination: "Virginia, United States of America",
  queries: ["near Arlington National Cemetery", "close to Mount Vernon", "around Shenandoah National Park"],
  original_name: "Virginia",
  id_corrupt: "fine",
  gaia_id: 248,
  short_name: "Virginia",
  long_name: "Virginia, United States of America"
}, {
  destination: "St. Thomas, U.S. Virgin Islands",
  queries: ["near Magens Bay Beach", "close to Coral World Ocean Park", "around Charlotte Amalie"],
  original_name: "St_Thomas",
  id_corrupt: "fine",
  gaia_id: 6140138,
  short_name: "St. Thomas",
  long_name: "St. Thomas, U.S. Virgin Islands"
}, {
  destination: "Williamsport, Pennsylvania, United States of America",
  queries: ["near Little League Baseball International Headquarters", "close to Hiawatha Paddlewheel Riverboat", "around Susquehanna State Park"],
  original_name: "Williamsport",
  id_corrupt: "fine",
  gaia_id: 6057566,
  short_name: "Williamsport",
  long_name: "Williamsport, Pennsylvania, United States of America"
}, {
  destination: "Greenville, North Carolina, United States of America",
  queries: ["near River Park North", "close to Greenville Museum of Art", "around Eastern Carolina Village & Farm Museum"],
  original_name: "Greenville",
  id_corrupt: "fine",
  gaia_id: 2779,
  short_name: "Greenville",
  long_name: "Greenville, North Carolina, United States of America"
}, {
  destination: "Raleigh (and vicinity), North Carolina, United States of America",
  queries: ["near Research Triangle Park", "close to North Carolina Museum of Natural Sciences", "within walking distance of William B. Umstead State Park"],
  original_name: "Raleigh",
  id_corrupt: "fine",
  gaia_id: 178300,
  short_name: "Raleigh (and vicinity)",
  long_name: "Raleigh (and vicinity), North Carolina, United States of America"
}, {
  destination: "Kansas City (and vicinity), Missouri, United States of America",
  queries: ["near Country Club Plaza", "close to Nelson-Atkins Museum of Art", "within walking distance of Union Station"],
  original_name: "Kansas_City",
  id_corrupt: "fine",
  gaia_id: 178273,
  short_name: "Kansas City (and vicinity)",
  long_name: "Kansas City (and vicinity), Missouri, United States of America"
}, {
  destination: "Lubbock (and vicinity), Texas, United States of America",
  queries: ["near Buddy Holly Center", "close to National Ranching Heritage Center", "within walking distance of Texas Tech University"],
  original_name: "Lubbock",
  id_corrupt: "fine",
  gaia_id: 6131013,
  short_name: "Lubbock (and vicinity)",
  long_name: "Lubbock (and vicinity), Texas, United States of America"
}, {
  destination: "Jacksonville (and vicinity), Florida, United States of America",
  queries: ["near Jacksonville Beach", "close to Cummer Museum of Art and Gardens", "within walking distance of Friendship Fountain"],
  original_name: "Jacksonville",
  id_corrupt: "fine",
  gaia_id: 602997,
  short_name: "Jacksonville (and vicinity)",
  long_name: "Jacksonville (and vicinity), Florida, United States of America"
}, {
  destination: "Cape May - Wildwood, New Jersey, United States of America",
  queries: ["near Cape May Lighthouse", "close to Wildwood Boardwalk", "within walking distance of Sunset Beach"],
  original_name: "Cape_May_-_Wildwood",
  id_corrupt: "fine",
  gaia_id: 6056760,
  short_name: "Cape May - Wildwood",
  long_name: "Cape May - Wildwood, New Jersey, United States of America"
}, {
  destination: "Griffin, Georgia, United States of America",
  queries: ["near Griffin City Park", "close to Doc Holliday Museum", "within walking distance of Wyomia Tyus Olympic Park"],
  original_name: "Griffin",
  id_corrupt: "fine",
  gaia_id: 6058183,
  short_name: "Griffin",
  long_name: "Griffin, Georgia, United States of America"
}, {
  destination: "Newport, Rhode Island, United States of America",
  queries: ["near The Breakers", "close to Cliff Walk", "within walking distance of Newport Mansions"],
  original_name: "Newport",
  id_corrupt: "fine",
  gaia_id: 180037,
  short_name: "Newport",
  long_name: "Newport, Rhode Island, United States of America"
}, {
  destination: "Norfolk - Virginia Beach, Virginia, United States of America",
  queries: ["near Virginia Beach Boardwalk", "close to Norfolk Botanical Garden", "within walking distance of USS Wisconsin BB-64"],
  original_name: "Norfolk_-_Virginia_Beach",
  id_corrupt: "fine",
  gaia_id: 602904,
  short_name: "Norfolk - Virginia Beach",
  long_name: "Norfolk - Virginia Beach, Virginia, United States of America"
}, {
  destination: "Minneapolis - St. Paul (and vicinity), Minnesota, United States of America",
  queries: ["near Mall of America", "close to Minnehaha Park", "within walking distance of Como Park Zoo & Conservatory"],
  original_name: "Minneapolis_-_St_Paul",
  id_corrupt: "fine",
  gaia_id: 178287,
  short_name: "Minneapolis - St. Paul (and vicinity)",
  long_name: "Minneapolis - St. Paul (and vicinity), Minnesota, United States of America"
}, {
  destination: "Columbus (and vicinity), Ohio, United States of America",
  queries: ["near Ohio State University", "close to Franklin Park Conservatory and Botanical Gardens", "within walking distance of Columbus Museum of Art"],
  original_name: "Columbus",
  id_corrupt: "fine",
  gaia_id: 178251,
  short_name: "Columbus (and vicinity)",
  long_name: "Columbus (and vicinity), Ohio, United States of America"
}, {
  destination: "San Antonio (and vicinity), Texas, United States of America",
  queries: ["Near the Alamo", "Close to River Walk", "Around Tower of the Americas"],
  original_name: "San_Antonio",
  id_corrupt: "fine",
  gaia_id: 178303,
  short_name: "San Antonio (and vicinity)",
  long_name: "San Antonio (and vicinity), Texas, United States of America"
}, {
  destination: "Redding, California, United States of America",
  queries: ["Near Sundial Bridge", "Close to Turtle Bay Exploration Park", "Around Shasta State Historic Park"],
  original_name: "Redding",
  id_corrupt: "fine",
  gaia_id: 2962,
  short_name: "Redding",
  long_name: "Redding, California, United States of America"
}, {
  destination: "Poughkeepsie, New York, United States of America",
  queries: ["Near Walkway Over the Hudson", "Close to Frances Lehman Loeb Art Center", "Around Locust Grove Estate"],
  original_name: "Poughkeepsie",
  id_corrupt: "fine",
  gaia_id: 6056317,
  short_name: "Poughkeepsie",
  long_name: "Poughkeepsie, New York, United States of America"
}, {
  destination: "Palo Alto, California, United States of America",
  queries: ["Near Stanford University", "Close to The Dish Hike", "Around Gamble Garden"],
  original_name: "Palo_Alto",
  id_corrupt: "fine",
  gaia_id: 9355,
  short_name: "Palo Alto",
  long_name: "Palo Alto, California, United States of America"
}, {
  destination: "Monterey, California, United States of America",
  queries: ["Near Cannery Row", "Close to Monterey Bay Aquarium", "Around Fisherman's Wharf"],
  original_name: "Monterey",
  id_corrupt: "fine",
  gaia_id: 180045,
  short_name: "Monterey",
  long_name: "Monterey, California, United States of America"
}, {
  destination: "District of Columbia, United States of America",
  queries: ["Near National Mall", "Close to Lincoln Memorial", "Around Smithsonian National Museum of Natural History"],
  original_name: "District_Of_Columbia",
  id_corrupt: "fine",
  gaia_id: 210,
  short_name: "District of Columbia",
  long_name: "District of Columbia, United States of America"
}, {
  destination: "Greensboro (and vicinity), North Carolina, United States of America",
  queries: ["Near Greensboro Science Center", "Close to Tanger Family Bicentennial Garden", "Around Weatherspoon Art Museum"],
  original_name: "Greensboro",
  id_corrupt: "fine",
  gaia_id: 602968,
  short_name: "Greensboro (and vicinity)",
  long_name: "Greensboro (and vicinity), North Carolina, United States of America"
}, {
  destination: "Houston (and vicinity), Texas, United States of America",
  queries: ["Near Space Center Houston", "Close to Houston Museum of Natural Science", "Around Houston Zoo"],
  original_name: "Houston",
  id_corrupt: "fine",
  gaia_id: 178265,
  short_name: "Houston (and vicinity)",
  long_name: "Houston (and vicinity), Texas, United States of America"
}, {
  destination: "Toledo (and vicinity), Ohio, United States of America",
  queries: ["Near Toledo Museum of Art", "Close to Toledo Zoo", "Around Imagination Station"],
  original_name: "Toledo",
  id_corrupt: "fine",
  gaia_id: 602174,
  short_name: "Toledo (and vicinity)",
  long_name: "Toledo (and vicinity), Ohio, United States of America"
}, {
  destination: "South Padre Island, Texas, United States of America",
  queries: ["Near South Padre Island Dolphin Research & Sea Life Nature Center", "Close to Schlitterbahn Beach Waterpark", "Around Isla Blanca Park"],
  original_name: "South_Padre_Island",
  id_corrupt: "fine",
  gaia_id: 6046797,
  short_name: "South Padre Island",
  long_name: "South Padre Island, Texas, United States of America"
}, {
  destination: "Bar Harbor, Maine, United States of America",
  queries: ["near Acadia National Park", "close to Bar Island", "around Frenchman Bay"],
  original_name: "Bar_Harbor",
  id_corrupt: "fine",
  gaia_id: 561,
  short_name: "Bar Harbor",
  long_name: "Bar Harbor, Maine, United States of America"
}, {
  destination: "Wichita (and vicinity), Kansas, United States of America",
  queries: ["near Keeper of the Plains", "close to Sedgwick County Zoo", "around Old Cowtown Museum"],
  original_name: "Wichita",
  id_corrupt: "fine",
  gaia_id: 6058350,
  short_name: "Wichita (and vicinity)",
  long_name: "Wichita (and vicinity), Kansas, United States of America"
}, {
  destination: "Florence, Tuscany, Italy",
  queries: ["near Cathedral of Santa Maria del Fiore", "close to Ponte Vecchio", "around Uffizi Gallery"],
  original_name: "Florence",
  id_corrupt: "fine",
  gaia_id: 1222,
  short_name: "Florence",
  long_name: "Florence, Tuscany, Italy"
}, {
  destination: "Marin County, California, United States of America",
  queries: ["near Muir Woods National Monument", "close to Point Reyes National Seashore", "around Golden Gate National Recreation Area"],
  original_name: "Marin_County",
  id_corrupt: "fine",
  gaia_id: 6023567,
  short_name: "Marin County",
  long_name: "Marin County, California, United States of America"
}, {
  destination: "Daytona Beach, Florida, United States of America",
  queries: ["near Daytona International Speedway", "close to Daytona Beach Boardwalk and Pier", "around Ponce de Leon Inlet Lighthouse and Museum"],
  original_name: "Daytona_Beach",
  id_corrupt: "fine",
  gaia_id: 6023995,
  short_name: "Daytona Beach",
  long_name: "Daytona Beach, Florida, United States of America"
}, {
  destination: "Sarasota, Florida, United States of America",
  queries: ["near Siesta Key Beach", "close to Marie Selby Botanical Gardens", "around The Ringling"],
  original_name: "Sarasota",
  id_corrupt: "fine",
  gaia_id: 602719,
  short_name: "Sarasota",
  long_name: "Sarasota, Florida, United States of America"
}, {
  destination: "Red Bank - Tinton Falls, New Jersey, United States of America",
  queries: ["near Count Basie Theater", "close to Sandy Hook Gateway National Recreation Area", "around Twin Lights State Historic Site"],
  original_name: "Red_Bank_-_Tinton_Falls",
  id_corrupt: "fine",
  gaia_id: 6025618,
  short_name: "Red Bank - Tinton Falls",
  long_name: "Red Bank - Tinton Falls, New Jersey, United States of America"
}, {
  destination: "New Mexico, United States of America",
  queries: ["near White Sands National Park", "close to Carlsbad Caverns National Park", "around Taos Pueblo"],
  original_name: "New_Mexico",
  id_corrupt: "fine",
  gaia_id: 233,
  short_name: "New Mexico",
  long_name: "New Mexico, United States of America"
}, {
  destination: "Medellin (and vicinity), Antioquia, Colombia",
  queries: ["near Plaza Botero", "close to Parque Arvi", "around Pueblito Paisa"],
  original_name: "Medellin",
  id_corrupt: "fine",
  gaia_id: 2246,
  short_name: "Medellin (and vicinity)",
  long_name: "Medellin (and vicinity), Antioquia, Colombia"
}, {
  destination: "British Columbia, Canada",
  queries: ["near Stanley Park", "close to Capilano Suspension Bridge Park", "around Butchart Gardens"],
  original_name: "British_Columbia",
  id_corrupt: "fine",
  gaia_id: 11117,
  short_name: "British Columbia",
  long_name: "British Columbia, Canada"
}, {
  destination: "Durango, Colorado, United States of America",
  queries: ["near Durango and Silverton Narrow Gauge Railroad", "close to Animas River Trail", "around Fort Lewis College"],
  original_name: "Durango",
  id_corrupt: "fine",
  gaia_id: 180048,
  short_name: "Durango",
  long_name: "Durango, Colorado, United States of America"
}, {
  destination: "Aberdeen, Washington, United States of America",
  queries: ["near Kurt Cobain Memorial Park", "close to Grays Harbor Historical Seaport", "around Morrison Riverfront Park"],
  original_name: "Aberdeen",
  id_corrupt: "fine",
  gaia_id: 6054442,
  short_name: "Aberdeen",
  long_name: "Aberdeen, Washington, United States of America"
}, {
  destination: "Coronado, California, United States of America",
  queries: ["near Hotel del Coronado", "close to Coronado Beach", "around Coronado Ferry Landing"],
  original_name: "Coronado",
  id_corrupt: "fine",
  gaia_id: 5917,
  short_name: "Coronado",
  long_name: "Coronado, California, United States of America"
}, {
  destination: "New Braunfels, Texas, United States of America",
  queries: ["near Schlitterbahn Waterpark", "close to Gruene Historic District", "around Landa Park"],
  original_name: "New_Braunfels",
  id_corrupt: "fine",
  gaia_id: 6059109,
  short_name: "New Braunfels",
  long_name: "New Braunfels, Texas, United States of America"
}, {
  destination: "Ohio, United States of America",
  queries: ["near Rock and Roll Hall of Fame", "close to Cedar Point", "around Hocking Hills State Park"],
  original_name: "Ohio",
  id_corrupt: "fine",
  gaia_id: 237,
  short_name: "Ohio",
  long_name: "Ohio, United States of America"
}, {
  destination: "Fairfield, California, United States of America",
  queries: ["near Jelly Belly Factory", "close to Anheuser-Busch Brewery", "around Allan Witt Park"],
  original_name: "Fairfield",
  id_corrupt: "fine",
  gaia_id: 6055407,
  short_name: "Fairfield",
  long_name: "Fairfield, California, United States of America"
}, {
  destination: "Grand Rapids (and vicinity), Michigan, United States of America",
  queries: ["near Frederik Meijer Gardens & Sculpture Park", "close to Gerald R. Ford Museum", "around John Ball Zoo"],
  original_name: "Grand_Rapids",
  id_corrupt: "fine",
  gaia_id: 603005,
  short_name: "Grand Rapids (and vicinity)",
  long_name: "Grand Rapids (and vicinity), Michigan, United States of America"
}, {
  destination: "Niagara Falls, Ontario, Canada",
  queries: ["near Niagara Falls", "close to Clifton Hill", "around Table Rock Welcome Centre"],
  original_name: "Niagara_Falls",
  id_corrupt: "fine",
  gaia_id: 6023515,
  short_name: "Niagara Falls",
  long_name: "Niagara Falls, Ontario, Canada"
}, {
  destination: "Estes Park, Colorado, United States of America",
  queries: ["near Rocky Mountain National Park", "close to Estes Park Aerial Tramway", "around The Stanley Hotel"],
  original_name: "Estes_Park",
  id_corrupt: "fine",
  gaia_id: 7854,
  short_name: "Estes Park",
  long_name: "Estes Park, Colorado, United States of America"
}, {
  destination: "Punta Cana, La Altagracia, Dominican Republic",
  queries: ["near Bavaro Beach", "close to Dolphin Island", "around Scape Park at Cap Cana"],
  original_name: "Punta_Cana",
  id_corrupt: "fine",
  gaia_id: 601906,
  short_name: "Punta Cana",
  long_name: "Punta Cana, La Altagracia, Dominican Republic"
}, {
  destination: "Quintana Roo, Mexico",
  queries: ["near Tulum Ruins", "close to Xcaret Park", "around Playa del Carmen"],
  original_name: "Quintana_Roo",
  id_corrupt: "fine",
  gaia_id: 11186,
  short_name: "Quintana Roo",
  long_name: "Quintana Roo, Mexico"
}, {
  destination: "Paris (and vicinity), France",
  queries: ["near Eiffel Tower", "around Louvre Museum", "close to Notre-Dame Cathedral"],
  original_name: "Paris",
  id_corrupt: "fine",
  gaia_id: 179898,
  short_name: "Paris (and vicinity)",
  long_name: "Paris (and vicinity), France"
}, {
  destination: "Yellowstone National Park, Wyoming, United States of America",
  queries: ["close to Old Faithful Geyser", "around Grand Prismatic Spring", "near Yellowstone Falls"],
  original_name: "Yellowstone_National_Park",
  id_corrupt: "fine",
  gaia_id: 6347010,
  short_name: "Yellowstone National Park",
  long_name: "Yellowstone National Park, Wyoming, United States of America"
}, {
  destination: "Marquette, Michigan, United States of America",
  queries: ["close to Presque Isle Park", "around Black Rocks", "near Marquette Harbor Lighthouse"],
  original_name: "Marquette",
  id_corrupt: "fine",
  gaia_id: 2408,
  short_name: "Marquette",
  long_name: "Marquette, Michigan, United States of America"
}, {
  destination: "Mackinac Island, Michigan, United States of America",
  queries: ["near Mackinac Bridge", "close to Arch Rock", "around Fort Mackinac"],
  original_name: "Mackinac_Island",
  id_corrupt: "fine",
  gaia_id: 8308,
  short_name: "Mackinac Island",
  long_name: "Mackinac Island, Michigan, United States of America"
}, {
  destination: "Seattle (and vicinity), Washington, United States of America",
  queries: ["around Space Needle", "near Pike Place Market", "close to Chihuly Garden and Glass"],
  original_name: "Seattle",
  id_corrupt: "fine",
  gaia_id: 178307,
  short_name: "Seattle (and vicinity)",
  long_name: "Seattle (and vicinity), Washington, United States of America"
}, {
  destination: "Italy",
  queries: ["near Colosseum", "around Trevi Fountain", "close to Leaning Tower of Pisa"],
  original_name: "Italy",
  id_corrupt: "fine",
  gaia_id: 86,
  short_name: "Italy",
  long_name: "Italy"
}, {
  destination: "Newport Beach, California, United States of America",
  queries: ["around Balboa Pier", "close to Crystal Cove State Park", "near Fashion Island"],
  original_name: "Newport_Beach",
  id_corrupt: "fine",
  gaia_id: 8111,
  short_name: "Newport Beach",
  long_name: "Newport Beach, California, United States of America"
}, {
  destination: "Wisconsin Dells, Wisconsin, United States of America",
  queries: ["close to Noah's Ark Waterpark", "around Devil's Lake State Park", "near Mt. Olympus Water & Theme Park"],
  original_name: "Wisconsin_Dells",
  id_corrupt: "fine",
  gaia_id: 6059846,
  short_name: "Wisconsin Dells",
  long_name: "Wisconsin Dells, Wisconsin, United States of America"
}, {
  destination: "Prague (and vicinity), Czechia",
  queries: ["around Charles Bridge", "close to Prague Castle", "near Old Town Square"],
  original_name: "Prague",
  id_corrupt: "fine",
  gaia_id: 180014,
  short_name: "Prague (and vicinity)",
  long_name: "Prague (and vicinity), Czechia"
}, {
  destination: "Hilton Head Island, South Carolina, United States of America",
  queries: ["near Coligny Beach Park", "close to Harbour Town Lighthouse", "proximity to Shelter Cove Harbour & Marina"],
  original_name: "Hilton_Head_Island",
  id_corrupt: "fine",
  gaia_id: 601684,
  short_name: "Hilton Head Island",
  long_name: "Hilton Head Island, South Carolina, United States of America"
}, {
  destination: "McAllen, Texas, United States of America",
  queries: ["near Quinta Mazatlan", "close to McAllen Convention Center", "proximity to International Museum of Art & Science"],
  original_name: "Mcallen",
  id_corrupt: "fine",
  gaia_id: 2270,
  short_name: "McAllen",
  long_name: "McAllen, Texas, United States of America"
}, {
  destination: "New York, United States of America",
  queries: ["near Central Park", "close to Times Square", "proximity to Statue of Liberty"],
  original_name: "New_York",
  id_corrupt: "fine",
  gaia_id: 234,
  short_name: "New York",
  long_name: "New York, United States of America"
}, {
  destination: "Miami (and vicinity), Florida, United States of America",
  queries: ["near South Beach", "close to Wynwood Walls", "proximity to Vizcaya Museum and Gardens"],
  original_name: "Miami",
  id_corrupt: "fine",
  gaia_id: 178286,
  short_name: "Miami (and vicinity)",
  long_name: "Miami (and vicinity), Florida, United States of America"
}, {
  destination: "Sorrento, Campania, Italy",
  queries: ["near Piazza Tasso", "close to Marina Grande", "proximity to Villa Rufolo"],
  original_name: "Sorrento",
  id_corrupt: "fine",
  gaia_id: 9716,
  short_name: "Sorrento",
  long_name: "Sorrento, Campania, Italy"
}, {
  destination: "Portsmouth, New Hampshire, United States of America",
  queries: ["near Strawbery Banke Museum", "close to Prescott Park", "proximity to USS Albacore Museum"],
  original_name: "Portsmouth",
  id_corrupt: "fine",
  gaia_id: 6057414,
  short_name: "Portsmouth",
  long_name: "Portsmouth, New Hampshire, United States of America"
}, {
  destination: "Reno (and vicinity), Nevada, United States of America",
  queries: ["near Truckee River Walk", "close to National Automobile Museum", "proximity to Nevada Museum of Art"],
  original_name: "Reno",
  id_corrupt: "fine",
  gaia_id: 602688,
  short_name: "Reno (and vicinity)",
  long_name: "Reno (and vicinity), Nevada, United States of America"
}, {
  destination: "Nashville (and vicinity), Tennessee, United States of America",
  queries: ["near Grand Ole Opry", "close to Country Music Hall of Fame and Museum", "proximity to Ryman Auditorium"],
  original_name: "Nashville",
  id_corrupt: "fine",
  gaia_id: 178291,
  short_name: "Nashville (and vicinity)",
  long_name: "Nashville (and vicinity), Tennessee, United States of America"
}, {
  destination: "Provo, Utah, United States of America",
  queries: ["near Brigham Young University", "close to Utah Lake State Park", "proximity to Provo City Center Temple"],
  original_name: "Provo",
  id_corrupt: "fine",
  gaia_id: 602978,
  short_name: "Provo",
  long_name: "Provo, Utah, United States of America"
}, {
  destination: "Corpus Christi (and vicinity), Texas, United States of America",
  queries: ["near Padre Island National Seashore", "close to USS Lexington Museum on the Bay", "proximity to Texas State Aquarium"],
  original_name: "Corpus_Christi",
  id_corrupt: "fine",
  gaia_id: 915,
  short_name: "Corpus Christi (and vicinity)",
  long_name: "Corpus Christi (and vicinity), Texas, United States of America"
}, {
  destination: "Annapolis, Maryland, United States of America",
  queries: ["near United States Naval Academy", "close to Maryland State House", "proximity to Annapolis Harbor"],
  original_name: "Annapolis",
  id_corrupt: "fine",
  gaia_id: 6034082,
  short_name: "Annapolis",
  long_name: "Annapolis, Maryland, United States of America"
}, {
  destination: "Minnesota, United States of America",
  queries: ["near Mall of America", "close to Minnehaha Park", "proximity to Como Park Zoo & Conservatory"],
  original_name: "Minnesota",
  id_corrupt: "fine",
  gaia_id: 225,
  short_name: "Minnesota",
  long_name: "Minnesota, United States of America"
}, {
  destination: "Bend, Oregon, United States of America",
  queries: ["near Deschutes River Trail", "close to Pilot Butte State Scenic Viewpoint", "proximity to Drake Park"],
  original_name: "Bend",
  id_corrupt: "fine",
  gaia_id: 6051534,
  short_name: "Bend",
  long_name: "Bend, Oregon, United States of America"
}, {
  destination: "Akron, Ohio, United States of America",
  queries: ["near Stan Hywet Hall & Gardens", "close to Cuyahoga Valley National Park", "proximity to Akron Art Museum"],
  original_name: "Akron",
  id_corrupt: "fine",
  gaia_id: 602973,
  short_name: "Akron",
  long_name: "Akron, Ohio, United States of America"
}, {
  destination: "Cocoa Beach, Florida, United States of America",
  queries: ["near Cocoa Beach Pier", "close to Lori Wilson Park", "proximity to Kennedy Space Center Visitor Complex"],
  original_name: "Cocoa_Beach",
  id_corrupt: "fine",
  gaia_id: 6549,
  short_name: "Cocoa Beach",
  long_name: "Cocoa Beach, Florida, United States of America"
}, {
  destination: "Ogunquit - Wells, Maine, United States of America",
  queries: ["near Marginal Way", "close to Perkins Cove", "proximity to Ogunquit Beach"],
  original_name: "Ogunquit_-_Wells",
  id_corrupt: "fine",
  gaia_id: 6057322,
  short_name: "Ogunquit - Wells",
  long_name: "Ogunquit - Wells, Maine, United States of America"
}, {
  destination: "Springfield, Missouri, United States of America",
  queries: ["near Fantastic Caverns", "close to Nathanael Greene/Close Memorial Park", "proximity to Wonders of Wildlife Museum & Aquarium"],
  original_name: "Springfield",
  id_corrupt: "fine",
  gaia_id: 602962,
  short_name: "Springfield",
  long_name: "Springfield, Missouri, United States of America"
}, {
  destination: "Coeur d'Alene, Idaho, United States of America",
  queries: ["near Tubbs Hill Nature Trails", "close to Coeur d'Alene Resort Golf Course", "proximity to Museum of North Idaho"],
  original_name: "Coeur_D'Alene",
  id_corrupt: "fine",
  gaia_id: 6034019,
  short_name: "Coeur d'Alene",
  long_name: "Coeur d'Alene, Idaho, United States of America"
}, {
  destination: "Holland, Michigan, United States of America",
  queries: ["near Holland State Park", "close to Windmill Island Gardens", "proximity to Holland Harbor Light"],
  original_name: "Holland",
  id_corrupt: "fine",
  gaia_id: 6059199,
  short_name: "Holland",
  long_name: "Holland, Michigan, United States of America"
}, {
  destination: "Buena Vista, Colorado, United States of America",
  queries: ["near Arkansas River", "by Mount Princeton", "close to San Isabel National Forest"],
  original_name: "Buena_Vista",
  id_corrupt: "fine",
  gaia_id: 6056637,
  short_name: "Buena Vista",
  long_name: "Buena Vista, Colorado, United States of America"
}, {
  destination: "Oklahoma, United States of America",
  queries: ["near Oklahoma City National Memorial", "by Gathering Place", "close to Turner Falls"],
  original_name: "Oklahoma",
  id_corrupt: "fine",
  gaia_id: 238,
  short_name: "Oklahoma",
  long_name: "Oklahoma, United States of America"
}, {
  destination: "Playa del Carmen, Quintana Roo, Mexico",
  queries: ["near Fifth Avenue", "by Xcaret Park", "close to Mamitas Beach Club"],
  original_name: "Playa_Del_Carmen",
  id_corrupt: "fine",
  gaia_id: 601751,
  short_name: "Playa del Carmen",
  long_name: "Playa del Carmen, Quintana Roo, Mexico"
}, {
  destination: "Nassau, New Providence Island, Bahamas",
  queries: ["near Atlantis Paradise Island", "by Cable Beach", "close to Queen's Staircase"],
  original_name: "Nassau",
  id_corrupt: "fine",
  gaia_id: 601784,
  short_name: "Nassau",
  long_name: "Nassau, New Providence Island, Bahamas"
}, {
  destination: "Vero Beach, Florida, United States of America",
  queries: ["near McKee Botanical Garden", "by Vero Beach Museum of Art", "close to Riverside Theatre"],
  original_name: "Vero_Beach",
  id_corrupt: "fine",
  gaia_id: 6023660,
  short_name: "Vero Beach",
  long_name: "Vero Beach, Florida, United States of America"
}, {
  destination: "Balearic Islands, Spain",
  queries: ["near Palma Cathedral", "by Es Vedra", "close to Serra de Tramuntana"],
  original_name: "Balearic_Islands",
  id_corrupt: "fine",
  gaia_id: 6047891,
  short_name: "Balearic Islands",
  long_name: "Balearic Islands, Spain"
}, {
  destination: "Stockton (and vicinity), California, United States of America",
  queries: ["near Haggin Museum", "by University of the Pacific", "close to Lodi Wine Country"],
  original_name: "Stockton",
  id_corrupt: "fine",
  gaia_id: 602989,
  short_name: "Stockton (and vicinity)",
  long_name: "Stockton (and vicinity), California, United States of America"
}, {
  destination: "Naples, Florida, United States of America",
  queries: ["near Naples Pier", "by Delnor-Wiggins Pass State Park", "close to Fifth Avenue South"],
  original_name: "Naples",
  id_corrupt: "fine",
  gaia_id: 602724,
  short_name: "Naples",
  long_name: "Naples, Florida, United States of America"
}, {
  destination: "West Virginia, United States of America",
  queries: ["near New River Gorge Bridge", "by Seneca Rocks", "close to Blackwater Falls State Park"],
  original_name: "West_Virginia",
  id_corrupt: "fine",
  gaia_id: 250,
  short_name: "West Virginia",
  long_name: "West Virginia, United States of America"
}, {
  destination: "Kansas, United States of America",
  queries: ["near Strataca", "by Sedgwick County Zoo", "close to Monument Rocks"],
  original_name: "Kansas",
  id_corrupt: "fine",
  gaia_id: 218,
  short_name: "Kansas",
  long_name: "Kansas, United States of America"
}, {
  destination: "Sandusky, Ohio, United States of America",
  queries: ["near Cedar Point Amusement Park", "close to Sandusky Bay", "proximity to Kalahari Waterpark"],
  original_name: "Sandusky",
  id_corrupt: "fine",
  gaia_id: 6034855,
  short_name: "Sandusky",
  long_name: "Sandusky, Ohio, United States of America"
}, {
  destination: "Santa Clara, California, United States of America",
  queries: ["near Levi's Stadium", "close to California's Great America", "proximity to Santana Row"],
  original_name: "Santa_Clara",
  id_corrupt: "fine",
  gaia_id: 6172,
  short_name: "Santa Clara",
  long_name: "Santa Clara, California, United States of America"
}, {
  destination: "Laughlin, Nevada, United States of America",
  queries: ["near Colorado River", "close to Laughlin Labyrinths", "proximity to Davis Dam"],
  original_name: "Laughlin",
  id_corrupt: "fine",
  gaia_id: 10747,
  short_name: "Laughlin",
  long_name: "Laughlin, Nevada, United States of America"
}, {
  destination: "Bangor, Maine, United States of America",
  queries: ["near Stephen King's House", "close to Bangor City Forest", "proximity to Penobscot River"],
  original_name: "Bangor",
  id_corrupt: "fine",
  gaia_id: 6050918,
  short_name: "Bangor",
  long_name: "Bangor, Maine, United States of America"
}, {
  destination: "Grand County, Colorado, United States of America",
  queries: ["near Arches National Park", "close to Colorado River", "proximity to Rocky Mountain National Park"],
  original_name: "Grand_County",
  id_corrupt: "fine",
  gaia_id: 3000441228,
  short_name: "Grand County",
  long_name: "Grand County, Colorado, United States of America"
}, {
  destination: "Fort Worth (and vicinity), Texas, United States of America",
  queries: ["near Fort Worth Stockyards", "close to Sundance Square", "proximity to Kimbell Art Museum"],
  original_name: "Fort_Worth",
  id_corrupt: "fine",
  gaia_id: 178258,
  short_name: "Fort Worth (and vicinity)",
  long_name: "Fort Worth (and vicinity), Texas, United States of America"
}, {
  destination: "South Dakota, United States of America",
  queries: ["near Mount Rushmore National Memorial", "close to Badlands National Park", "proximity to Custer State Park"],
  original_name: "South_Dakota",
  id_corrupt: "fine",
  gaia_id: 243,
  short_name: "South Dakota",
  long_name: "South Dakota, United States of America"
}, {
  destination: "Gainesville, Florida, United States of America",
  queries: ["near University of Florida", "close to Paynes Prairie Preserve State Park", "proximity to Butterfly Rainforest"],
  original_name: "Gainesville",
  id_corrupt: "fine",
  gaia_id: 6048189,
  short_name: "Gainesville",
  long_name: "Gainesville, Florida, United States of America"
}, {
  destination: "Whitefish, Montana, United States of America",
  queries: ["near Whitefish Mountain Resort", "close to Glacier National Park", "proximity to Flathead Lake"],
  original_name: "Whitefish",
  id_corrupt: "fine",
  gaia_id: 1199,
  short_name: "Whitefish",
  long_name: "Whitefish, Montana, United States of America"
}, {
  destination: "Montreal (and vicinity), Quebec, Canada",
  queries: ["near Old Montreal", "close to Mont-Royal Park", "proximity to Notre-Dame Basilica of Montreal"],
  original_name: "Montreal",
  id_corrupt: "fine",
  gaia_id: 178288,
  short_name: "Montreal (and vicinity)",
  long_name: "Montreal (and vicinity), Quebec, Canada"
}, {
  destination: "Tacoma (and vicinity), Washington, United States of America",
  queries: ["near Point Defiance Park", "close to Museum of Glass", "around LeMay - America's Car Museum"],
  original_name: "Tacoma",
  id_corrupt: "fine",
  gaia_id: 6046853,
  short_name: "Tacoma (and vicinity)",
  long_name: "Tacoma (and vicinity), Washington, United States of America"
}, {
  destination: "Hartford, Connecticut, United States of America",
  queries: ["near Mark Twain House", "close to Wadsworth Atheneum Museum of Art", "around Bushnell Park"],
  original_name: "Hartford",
  id_corrupt: "fine",
  gaia_id: 180005,
  short_name: "Hartford",
  long_name: "Hartford, Connecticut, United States of America"
}, {
  destination: "Athens, Georgia, United States of America",
  queries: ["near University of Georgia", "close to State Botanical Garden of Georgia", "around Sanford Stadium"],
  original_name: "Athens",
  id_corrupt: "fine",
  gaia_id: 320,
  short_name: "Athens",
  long_name: "Athens, Georgia, United States of America"
}, {
  destination: "Syracuse, New York, United States of America",
  queries: ["near Destiny USA", "close to Rosamond Gifford Zoo", "around Erie Canal Museum"],
  original_name: "Syracuse",
  id_corrupt: "fine",
  gaia_id: 601764,
  short_name: "Syracuse",
  long_name: "Syracuse, New York, United States of America"
}, {
  destination: "Blacksburg, Virginia, United States of America",
  queries: ["near Virginia Tech", "close to Hahn Horticulture Garden", "around Lane Stadium"],
  original_name: "Blacksburg",
  id_corrupt: "fine",
  gaia_id: 6056941,
  short_name: "Blacksburg",
  long_name: "Blacksburg, Virginia, United States of America"
}, {
  destination: "Wenatchee - Lake Chelan, Washington, United States of America",
  queries: ["near Riverfront Park", "close to Ohme Gardens County Park", "around Lake Chelan"],
  original_name: "Wenatchee_-_Lake_Chelan",
  id_corrupt: "fine",
  gaia_id: 6054410,
  short_name: "Wenatchee - Lake Chelan",
  long_name: "Wenatchee - Lake Chelan, Washington, United States of America"
}, {
  destination: "Grand Canyon, Arizona, United States of America",
  queries: ["near Grand Canyon Village", "close to Mather Point", "around Bright Angel Trail"],
  original_name: "Grand_Canyon",
  id_corrupt: "fine",
  gaia_id: 6140738,
  short_name: "Grand Canyon",
  long_name: "Grand Canyon, Arizona, United States of America"
}, {
  destination: "Mazatl\xE1n, Sinaloa, Mexico",
  queries: ["near Malec\xF3n de Mazatl\xE1n", "close to Old Mazatl\xE1n", "around El Faro Lighthouse"],
  original_name: "Mazatlan",
  id_corrupt: "fine",
  gaia_id: 180011,
  short_name: "Mazatl\xE1n",
  long_name: "Mazatl\xE1n, Sinaloa, Mexico"
}, {
  destination: "Turks and Caicos",
  queries: ["near Grace Bay Beach", "close to Chalk Sound National Park", "around Conch Bar Cave"],
  original_name: "Turks_And_Caicos",
  id_corrupt: "fine",
  gaia_id: 184,
  short_name: "Turks and Caicos",
  long_name: "Turks and Caicos"
}, {
  destination: "Detroit (and vicinity), Michigan, United States of America",
  queries: ["near Detroit Institute of Arts", "close to Comerica Park", "around Belle Isle Park"],
  original_name: "Detroit",
  id_corrupt: "fine",
  gaia_id: 178255,
  short_name: "Detroit (and vicinity)",
  long_name: "Detroit (and vicinity), Michigan, United States of America"
}, {
  destination: "Washington County, Rhode Island, United States of America",
  queries: ["near Watch Hill Lighthouse", "close to Misquamicut State Beach", "around Point Judith Lighthouse"],
  original_name: "Washington_County",
  id_corrupt: "fine",
  gaia_id: 6057156,
  short_name: "Washington County",
  long_name: "Washington County, Rhode Island, United States of America"
}, {
  destination: "Lake Charles, Louisiana, United States of America",
  queries: ["near Prien Lake Park", "close to Mardi Gras Museum", "around USS Orleck Naval Museum"],
  original_name: "Lake_Charles",
  id_corrupt: "fine",
  gaia_id: 2029,
  short_name: "Lake Charles",
  long_name: "Lake Charles, Louisiana, United States of America"
}, {
  destination: "Istanbul, Istanbul, T\xFCrkiye",
  queries: ["near Hagia Sophia", "close to Galata Tower", "around Topkapi Palace"],
  original_name: "Istanbul",
  id_corrupt: "fine",
  gaia_id: 1639,
  short_name: "Istanbul",
  long_name: "Istanbul, Istanbul, T\xFCrkiye"
}, {
  destination: "Sacramento (and vicinity), California, United States of America",
  queries: ["near California State Capitol", "close to Old Sacramento Historic District", "around Crocker Art Museum"],
  original_name: "Sacramento",
  id_corrupt: "fine",
  gaia_id: 180049,
  short_name: "Sacramento (and vicinity)",
  long_name: "Sacramento (and vicinity), California, United States of America"
}, {
  destination: "West Yellowstone, Montana, United States of America",
  queries: ["near Yellowstone Historic Center", "close to Grizzly and Wolf Discovery Center", "around Yellowstone IMAX Theatre"],
  original_name: "West_Yellowstone",
  id_corrupt: "fine",
  gaia_id: 3846,
  short_name: "West Yellowstone",
  long_name: "West Yellowstone, Montana, United States of America"
}, {
  destination: "St. Augustine, Florida, United States of America",
  queries: ["near Castillo de San Marcos", "close to St. George Street", "around Lightner Museum"],
  original_name: "St_Augustine",
  id_corrupt: "fine",
  gaia_id: 6047864,
  short_name: "St. Augustine",
  long_name: "St. Augustine, Florida, United States of America"
}, {
  destination: "Palm Beach - West Palm Beach, Florida, United States of America",
  queries: ["near Henry Morrison Flagler Museum", "close to Worth Avenue", "around Norton Museum of Art"],
  original_name: "Palm_Beach_-_West_Palm_Beach",
  id_corrupt: "fine",
  gaia_id: 602278,
  short_name: "Palm Beach - West Palm Beach",
  long_name: "Palm Beach - West Palm Beach, Florida, United States of America"
}, {
  destination: "Ithaca, New York, United States of America",
  queries: ["near Buttermilk Falls State Park", "close to Cornell University", "around Ithaca Commons"],
  original_name: "Ithaca",
  id_corrupt: "fine",
  gaia_id: 6056124,
  short_name: "Ithaca",
  long_name: "Ithaca, New York, United States of America"
}, {
  destination: "Conroe, Texas, United States of America",
  queries: ["near Lake Conroe", "close to The Lone Star Monument and Historical Flag Park", "around 7 Acre Wood"],
  original_name: "Conroe",
  id_corrupt: "fine",
  gaia_id: 6134431,
  short_name: "Conroe",
  long_name: "Conroe, Texas, United States of America"
}, {
  destination: "Vail, Colorado, United States of America",
  queries: ["near Vail Ski Resort", "close to Betty Ford Alpine Gardens", "around Colorado Snowsports Museum and Hall of Fame"],
  original_name: "Vail",
  id_corrupt: "fine",
  gaia_id: 7053,
  short_name: "Vail",
  long_name: "Vail, Colorado, United States of America"
}, {
  destination: "New Orleans (and vicinity), Louisiana, United States of America",
  queries: ["near French Quarter", "close to Jackson Square", "proximity to Garden District"],
  original_name: "New_Orleans",
  id_corrupt: "fine",
  gaia_id: 178292,
  short_name: "New Orleans (and vicinity)",
  long_name: "New Orleans (and vicinity), Louisiana, United States of America"
}, {
  destination: "Southern Region, Iceland",
  queries: ["near Seljalandsfoss Waterfall", "close to Reynisfjara Black Sand Beach", "proximity to Skogafoss Waterfall"],
  original_name: "Southern_Region",
  id_corrupt: "fine",
  gaia_id: 6155242,
  short_name: "Southern Region",
  long_name: "Southern Region, Iceland"
}, {
  destination: "Traverse City, Michigan, United States of America",
  queries: ["near Sleeping Bear Dunes National Lakeshore", "close to Grand Traverse Bay", "proximity to Old Mission Peninsula"],
  original_name: "Traverse_City",
  id_corrupt: "fine",
  gaia_id: 3577,
  short_name: "Traverse City",
  long_name: "Traverse City, Michigan, United States of America"
}, {
  destination: "Singapore",
  queries: ["near Marina Bay Sands", "close to Gardens by the Bay", "proximity to Sentosa Island"],
  original_name: "Singapore",
  id_corrupt: "fine",
  gaia_id: 161,
  short_name: "Singapore",
  long_name: "Singapore"
}, {
  destination: "Geneva (and vicinity), Canton of Geneva, Switzerland",
  queries: ["near Jet d'Eau", "close to St. Pierre Cathedral", "proximity to United Nations Office at Geneva"],
  original_name: "Geneva",
  id_corrupt: "fine",
  gaia_id: 180003,
  short_name: "Geneva (and vicinity)",
  long_name: "Geneva (and vicinity), Canton of Geneva, Switzerland"
}, {
  destination: "Lisbon, Lisbon District, Portugal",
  queries: ["near Bel\xE9m Tower", "close to Jer\xF3nimos Monastery", "proximity to Alfama District"],
  original_name: "Lisbon",
  id_corrupt: "fine",
  gaia_id: 2080,
  short_name: "Lisbon",
  long_name: "Lisbon, Lisbon District, Portugal"
}, {
  destination: "Rehoboth Beach, Delaware, United States of America",
  queries: ["near Rehoboth Beach Boardwalk", "close to Cape Henlopen State Park", "proximity to Funland"],
  original_name: "Rehoboth_Beach",
  id_corrupt: "fine",
  gaia_id: 6055674,
  short_name: "Rehoboth Beach",
  long_name: "Rehoboth Beach, Delaware, United States of America"
}, {
  destination: "Kihei, Hawaii, United States of America",
  queries: ["near Wailea Beach", "close to Maalaea Bay", "proximity to Ahihi-Kinau Natural Area Reserve"],
  original_name: "Kihei",
  id_corrupt: "fine",
  gaia_id: 9304,
  short_name: "Kihei",
  long_name: "Kihei, Hawaii, United States of America"
}, {
  destination: "Venice (and vicinity), Veneto, Italy",
  queries: ["near St. Mark's Square", "close to Rialto Bridge", "proximity to Grand Canal"],
  original_name: "Venice",
  id_corrupt: "fine",
  gaia_id: 179981,
  short_name: "Venice (and vicinity)",
  long_name: "Venice (and vicinity), Veneto, Italy"
}, {
  destination: "Nevada, United States of America",
  queries: ["near Las Vegas Strip", "close to Hoover Dam", "proximity to Red Rock Canyon National Conservation Area"],
  original_name: "Nevada",
  id_corrupt: "fine",
  gaia_id: 230,
  short_name: "Nevada",
  long_name: "Nevada, United States of America"
}, {
  destination: "Manila (and vicinity), National Capital Region, Philippines",
  queries: ["near Rizal Park", "around Intramuros", "close to Mall of Asia"],
  original_name: "Manila",
  id_corrupt: "fine",
  gaia_id: 178282,
  short_name: "Manila (and vicinity)",
  long_name: "Manila (and vicinity), National Capital Region, Philippines"
}, {
  destination: "Richmond (and vicinity), Virginia, United States of America",
  queries: ["near Virginia State Capitol", "around Hollywood Cemetery", "close to Maymont"],
  original_name: "Richmond",
  id_corrupt: "fine",
  gaia_id: 601761,
  short_name: "Richmond (and vicinity)",
  long_name: "Richmond (and vicinity), Virginia, United States of America"
}, {
  destination: "Portland, Maine, United States of America",
  queries: ["near Portland Head Light", "around Old Port", "close to Casco Bay"],
  original_name: "Portland",
  id_corrupt: "fine",
  gaia_id: 181420,
  short_name: "Portland",
  long_name: "Portland, Maine, United States of America"
}, {
  destination: "Nebraska, United States of America",
  queries: ["near Henry Doorly Zoo and Aquarium", "around Chimney Rock National Historic Site", "close to Pioneer Village"],
  original_name: "Nebraska",
  id_corrupt: "fine",
  gaia_id: 229,
  short_name: "Nebraska",
  long_name: "Nebraska, United States of America"
}, {
  destination: "Anaheim, California, United States of America",
  queries: ["near Disneyland Park", "around Angel Stadium of Anaheim", "close to Downtown Disney District"],
  original_name: "Anaheim",
  id_corrupt: "fine",
  gaia_id: 5921,
  short_name: "Anaheim",
  long_name: "Anaheim, California, United States of America"
}, {
  destination: "Milan (and vicinity), Lombardy, Italy",
  queries: ["near Milan Cathedral", "around Sforza Castle", "close to Galleria Vittorio Emanuele II"],
  original_name: "Milan",
  id_corrupt: "fine",
  gaia_id: 180012,
  short_name: "Milan (and vicinity)",
  long_name: "Milan (and vicinity), Lombardy, Italy"
}, {
  destination: "Jersey City (and vicinity), New Jersey, United States of America",
  queries: ["near Liberty State Park", "around Ellis Island", "close to Colgate Clock"],
  original_name: "Jersey_City",
  id_corrupt: "fine",
  gaia_id: 6023404,
  short_name: "Jersey City (and vicinity)",
  long_name: "Jersey City (and vicinity), New Jersey, United States of America"
}, {
  destination: "Wilmington, North Carolina, United States of America",
  queries: ["near USS North Carolina", "around Airlie Gardens", "close to Bellamy Mansion Museum"],
  original_name: "Wilmington",
  id_corrupt: "fine",
  gaia_id: 1587,
  short_name: "Wilmington",
  long_name: "Wilmington, North Carolina, United States of America"
}, {
  destination: "Biloxi, Mississippi, United States of America",
  queries: ["near Beau Rivage Casino", "around Biloxi Lighthouse", "close to Keesler Air Force Base"],
  original_name: "Biloxi",
  id_corrupt: "fine",
  gaia_id: 603259,
  short_name: "Biloxi",
  long_name: "Biloxi, Mississippi, United States of America"
}, {
  destination: "Madison (and vicinity), Wisconsin, United States of America",
  queries: ["near Wisconsin State Capitol", "around Olbrich Botanical Gardens", "close to Henry Vilas Zoo"],
  original_name: "Madison",
  id_corrupt: "fine",
  gaia_id: 602704,
  short_name: "Madison (and vicinity)",
  long_name: "Madison (and vicinity), Wisconsin, United States of America"
}, {
  destination: "Ventura, California, United States of America",
  queries: ["near Ventura Pier", "close to San Buenaventura State Beach", "around Mission San Buenaventura"],
  original_name: "Ventura",
  id_corrupt: "fine",
  gaia_id: 6212,
  short_name: "Ventura",
  long_name: "Ventura, California, United States of America"
}, {
  destination: "Dublin (and vicinity), Ireland",
  queries: ["near Trinity College Dublin", "close to Guinness Storehouse", "around Dublin Castle"],
  original_name: "Dublin",
  id_corrupt: "fine",
  gaia_id: 178256,
  short_name: "Dublin (and vicinity)",
  long_name: "Dublin (and vicinity), Ireland"
}, {
  destination: "Alberta, Canada",
  queries: ["near Banff National Park", "close to Jasper National Park", "around Lake Louise"],
  original_name: "Alberta",
  id_corrupt: "fine",
  gaia_id: 11111,
  short_name: "Alberta",
  long_name: "Alberta, Canada"
}, {
  destination: "Central Vermont, Vermont, United States of America",
  queries: ["near Ben & Jerry's Factory", "close to Quechee Gorge", "around Church Street Marketplace"],
  original_name: "Central_Vermont",
  id_corrupt: "fine",
  gaia_id: 6057337,
  short_name: "Central Vermont",
  long_name: "Central Vermont, Vermont, United States of America"
}, {
  destination: "Port Richey, Florida, United States of America",
  queries: ["near Werner-Boyce Salt Springs State Park", "close to SunWest Park", "around Anclote River Park"],
  original_name: "Port_Richey",
  id_corrupt: "fine",
  gaia_id: 6048137,
  short_name: "Port Richey",
  long_name: "Port Richey, Florida, United States of America"
}, {
  destination: "Bakersfield (and vicinity), California, United States of America",
  queries: ["near Kern River Parkway Trail", "close to Buck Owens' Crystal Palace", "around California Living Museum"],
  original_name: "Bakersfield",
  id_corrupt: "fine",
  gaia_id: 546,
  short_name: "Bakersfield (and vicinity)",
  long_name: "Bakersfield (and vicinity), California, United States of America"
}, {
  destination: "Orlando (and vicinity), Florida, United States of America",
  queries: ["near Walt Disney World Resort", "close to Universal Orlando Resort", "around Lake Eola Park"],
  original_name: "Orlando",
  id_corrupt: "fine",
  gaia_id: 178294,
  short_name: "Orlando (and vicinity)",
  long_name: "Orlando (and vicinity), Florida, United States of America"
}, {
  destination: "Barcelona (and vicinity), Catalonia, Spain",
  queries: ["near Sagrada Familia", "close to Park G\xFCell", "around La Rambla"],
  original_name: "Barcelona",
  id_corrupt: "fine",
  gaia_id: 179992,
  short_name: "Barcelona (and vicinity)",
  long_name: "Barcelona (and vicinity), Catalonia, Spain"
}, {
  destination: "Eureka, California, United States of America",
  queries: ["near Redwood National and State Parks", "close to Sequoia Park Zoo", "around Humboldt Bay Maritime Museum"],
  original_name: "Eureka",
  id_corrupt: "fine",
  gaia_id: 287,
  short_name: "Eureka",
  long_name: "Eureka, California, United States of America"
}, {
  destination: "Ann Arbor, Michigan, United States of America",
  queries: ["near University of Michigan", "close to Matthaei Botanical Gardens", "around Michigan Stadium"],
  original_name: "Ann_Arbor",
  id_corrupt: "fine",
  gaia_id: 6059241,
  short_name: "Ann Arbor",
  long_name: "Ann Arbor, Michigan, United States of America"
}, {
  destination: "Mexico City (and vicinity), Mexico",
  queries: ["near Zocalo", "close to Chapultepec Castle", "around Palacio de Bellas Artes"],
  original_name: "Mexico_City",
  id_corrupt: "fine",
  gaia_id: 178285,
  short_name: "Mexico City (and vicinity)",
  long_name: "Mexico City (and vicinity), Mexico"
}, {
  destination: "Wyoming, United States of America",
  queries: ["near Yellowstone National Park", "around Grand Teton National Park", "close to Devils Tower National Monument"],
  original_name: "Wyoming",
  id_corrupt: "fine",
  gaia_id: 252,
  short_name: "Wyoming",
  long_name: "Wyoming, United States of America"
}, {
  destination: "Carlsbad, California, United States of America",
  queries: ["near Legoland California", "around Carlsbad State Beach", "close to Flower Fields at Carlsbad Ranch"],
  original_name: "Carlsbad",
  id_corrupt: "fine",
  gaia_id: 6056550,
  short_name: "Carlsbad",
  long_name: "Carlsbad, California, United States of America"
}, {
  destination: "Bozeman, Montana, United States of America",
  queries: ["near Museum of the Rockies", "close to Bridger Bowl Ski Area", "around Gallatin History Museum"],
  original_name: "Bozeman",
  id_corrupt: "fine",
  gaia_id: 757,
  short_name: "Bozeman",
  long_name: "Bozeman, Montana, United States of America"
}, {
  destination: "Albuquerque (and vicinity), New Mexico, United States of America",
  queries: ["near Petroglyph National Monument", "around Sandia Peak Tramway", "close to Albuquerque Biological Park"],
  original_name: "Albuquerque",
  id_corrupt: "fine",
  gaia_id: 602663,
  short_name: "Albuquerque (and vicinity)",
  long_name: "Albuquerque (and vicinity), New Mexico, United States of America"
}, {
  destination: "Hawaii Island, Hawaii, United States of America",
  queries: ["near Volcanoes National Park", "around Mauna Kea Observatories", "close to Akaka Falls State Park"],
  original_name: "Hawaii_Island",
  id_corrupt: "fine",
  gaia_id: 180074,
  short_name: "Hawaii Island",
  long_name: "Hawaii Island, Hawaii, United States of America"
}, {
  destination: "Riverside (and vicinity), California, United States of America",
  queries: ["near March Field Air Museum", "close to Mission Inn Museum", "around Riverside Art Museum"],
  original_name: "Riverside",
  id_corrupt: "fine",
  gaia_id: 6056021,
  short_name: "Riverside (and vicinity)",
  long_name: "Riverside (and vicinity), California, United States of America"
}, {
  destination: "Oceanside, California, United States of America",
  queries: ["close to Oceanside Pier", "around California Surf Museum", "near Guajome County Park"],
  original_name: "Oceanside",
  id_corrupt: "fine",
  gaia_id: 9154,
  short_name: "Oceanside",
  long_name: "Oceanside, California, United States of America"
}, {
  destination: "Jackson, Wyoming, United States of America",
  queries: ["near Grand Teton National Park", "around National Museum of Wildlife Art", "close to Snow King Mountain Resort"],
  original_name: "Jackson",
  id_corrupt: "fine",
  gaia_id: 180006,
  short_name: "Jackson",
  long_name: "Jackson, Wyoming, United States of America"
}, {
  destination: "Concord, California, United States of America",
  queries: ["near Six Flags Hurricane Harbor Concord", "around Markham Regional Arboretum", "close to Todos Santos Plaza"],
  original_name: "Concord",
  id_corrupt: "fine",
  gaia_id: 6056046,
  short_name: "Concord",
  long_name: "Concord, California, United States of America"
}, {
  destination: "Knoxville, Tennessee, United States of America",
  queries: ["near Great Smoky Mountains National Park", "close to Market Square", "proximity to Neyland Stadium"],
  original_name: "Knoxville",
  id_corrupt: "fine",
  gaia_id: 602977,
  short_name: "Knoxville",
  long_name: "Knoxville, Tennessee, United States of America"
}, {
  destination: "Reykjavik, Capital Region, Iceland",
  queries: ["near Hallgrimskirkja church", "close to Perlan", "proximity to Harpa Concert Hall"],
  original_name: "Reykjavik",
  id_corrupt: "fine",
  gaia_id: 6054688,
  short_name: "Reykjavik",
  long_name: "Reykjavik, Capital Region, Iceland"
}, {
  destination: "South Carolina, United States of America",
  queries: ["near historic Charleston", "close to Falls Park on the Reedy", "proximity to Myrtle Beach"],
  original_name: "South_Carolina",
  id_corrupt: "fine",
  gaia_id: 242,
  short_name: "South Carolina",
  long_name: "South Carolina, United States of America"
}, {
  destination: "Sydney (and vicinity), New South Wales, Australia",
  queries: ["near Sydney Opera House", "close to Bondi Beach", "proximity to Sydney Harbour Bridge"],
  original_name: "Sydney",
  id_corrupt: "fine",
  gaia_id: 178312,
  short_name: "Sydney (and vicinity)",
  long_name: "Sydney (and vicinity), New South Wales, Australia"
}, {
  destination: "Park City, Utah, United States of America",
  queries: ["near Park City Mountain", "close to Main Street", "proximity to Utah Olympic Park"],
  original_name: "Park_City",
  id_corrupt: "fine",
  gaia_id: 602285,
  short_name: "Park City",
  long_name: "Park City, Utah, United States of America"
}, {
  destination: "Brunswick, Georgia, United States of America",
  queries: ["near St. Simons Island", "close to Jekyll Island", "proximity to Hofwyl-Broadfield Plantation"],
  original_name: "Brunswick",
  id_corrupt: "fine",
  gaia_id: 6023716,
  short_name: "Brunswick",
  long_name: "Brunswick, Georgia, United States of America"
}, {
  destination: "Midland, Texas, United States of America",
  queries: ["near George W. Bush Childhood Home", "close to I-20 Wildlife Preserve", "proximity to Museum of the Southwest"],
  original_name: "Midland",
  id_corrupt: "fine",
  gaia_id: 6024016,
  short_name: "Midland",
  long_name: "Midland, Texas, United States of America"
}, {
  destination: "Amarillo (and vicinity), Texas, United States of America",
  queries: ["near Cadillac Ranch", "close to Palo Duro Canyon State Park", "proximity to Big Texan Steak Ranch"],
  original_name: "Amarillo",
  id_corrupt: "fine",
  gaia_id: 371,
  short_name: "Amarillo (and vicinity)",
  long_name: "Amarillo (and vicinity), Texas, United States of America"
}, {
  destination: "Modesto (and vicinity), California, United States of America",
  queries: ["near McHenry Mansion", "close to Gallo Center for the Arts", "proximity to Modesto Arch"],
  original_name: "Modesto",
  id_corrupt: "fine",
  gaia_id: 602990,
  short_name: "Modesto (and vicinity)",
  long_name: "Modesto (and vicinity), California, United States of America"
}, {
  destination: "Tri-Cities, Washington, United States of America",
  queries: ["near Columbia River", "close to Sacajawea State Park", "proximity to Howard Amon Park"],
  original_name: "Tri-Cities",
  id_corrupt: "fine",
  gaia_id: 6051514,
  short_name: "Tri-Cities",
  long_name: "Tri-Cities, Washington, United States of America"
}, {
  destination: "Cartagena (and vicinity), Bol\xEDvar, Colombia",
  queries: ["near Castillo San Felipe de Barajas", "close to Old Town Cartagena", "proximity to Bocagrande Beach"],
  original_name: "Cartagena",
  id_corrupt: "fine",
  gaia_id: 926,
  short_name: "Cartagena (and vicinity)",
  long_name: "Cartagena (and vicinity), Bol\xEDvar, Colombia"
}, {
  destination: "Parsippany, New Jersey, United States of America",
  queries: ["near Frelinghuysen Arboretum", "close to Knoll Country Club", "proximity to Morris Museum"],
  original_name: "Parsippany",
  id_corrupt: "fine",
  gaia_id: 603262,
  short_name: "Parsippany",
  long_name: "Parsippany, New Jersey, United States of America"
}, {
  destination: "South Bend, Indiana, United States of America",
  queries: ["near University of Notre Dame", "close to Studebaker National Museum", "proximity to Potawatomi Zoo"],
  original_name: "South_Bend",
  id_corrupt: "fine",
  gaia_id: 6023340,
  short_name: "South Bend",
  long_name: "South Bend, Indiana, United States of America"
}, {
  destination: "Salt Lake City (and vicinity), Utah, United States of America",
  queries: ["near Temple Square", "close to Red Butte Garden and Arboretum", "proximity to Utah State Capitol"],
  original_name: "Salt_Lake_City",
  id_corrupt: "fine",
  gaia_id: 178302,
  short_name: "Salt Lake City (and vicinity)",
  long_name: "Salt Lake City (and vicinity), Utah, United States of America"
}, {
  destination: "Oregon, United States of America",
  queries: ["near Columbia River Gorge National Scenic Area", "close to Cannon Beach", "proximity to Multnomah Falls"],
  original_name: "Oregon",
  id_corrupt: "fine",
  gaia_id: 239,
  short_name: "Oregon",
  long_name: "Oregon, United States of America"
}, {
  destination: "Pittsburgh (and vicinity), Pennsylvania, United States of America",
  queries: ["near Phipps Conservatory", "close to Duquesne Incline", "proximity to Andy Warhol Museum"],
  original_name: "Pittsburgh",
  id_corrupt: "fine",
  gaia_id: 601717,
  short_name: "Pittsburgh (and vicinity)",
  long_name: "Pittsburgh (and vicinity), Pennsylvania, United States of America"
}, {
  destination: "Lincoln (and vicinity), Nebraska, United States of America",
  queries: ["near University of Nebraska State Museum", "close to Sunken Gardens", "proximity to Pioneers Park Nature Center"],
  original_name: "Lincoln",
  id_corrupt: "fine",
  gaia_id: 602964,
  short_name: "Lincoln (and vicinity)",
  long_name: "Lincoln (and vicinity), Nebraska, United States of America"
}, {
  destination: "Buenos Aires (and vicinity), Argentina",
  queries: ["near Obelisco", "close to La Boca Neighborhood", "proximity to Puerto Madero Waterfront"],
  original_name: "Buenos_Aires",
  id_corrupt: "fine",
  gaia_id: 178242,
  short_name: "Buenos Aires (and vicinity)",
  long_name: "Buenos Aires (and vicinity), Argentina"
}, {
  destination: "London (and vicinity), England, United Kingdom",
  queries: ["near Buckingham Palace", "close to Tower of London", "proximity to Big Ben"],
  original_name: "London",
  id_corrupt: "fine",
  gaia_id: 178279,
  short_name: "London (and vicinity)",
  long_name: "London (and vicinity), England, United Kingdom"
}, {
  destination: "Myrtle Beach, South Carolina, United States of America",
  queries: ["near Broadway at the Beach", "close to Myrtle Beach Boardwalk", "proximity to SkyWheel Myrtle Beach"],
  original_name: "Myrtle_Beach",
  id_corrupt: "fine",
  gaia_id: 601685,
  short_name: "Myrtle Beach",
  long_name: "Myrtle Beach, South Carolina, United States of America"
}, {
  destination: "Vermont, United States of America",
  queries: ["near Ben & Jerry's Factory Tour", "close to Church Street Marketplace", "around Lake Champlain"],
  original_name: "Vermont",
  id_corrupt: "fine",
  gaia_id: 247,
  short_name: "Vermont",
  long_name: "Vermont, United States of America"
}, {
  destination: "Bermuda",
  queries: ["near Horseshoe Bay Beach", "close to Royal Naval Dockyard", "around Crystal Caves"],
  original_name: "Bermuda",
  id_corrupt: "fine",
  gaia_id: 20,
  short_name: "Bermuda",
  long_name: "Bermuda"
}, {
  destination: "Spokane (and vicinity), Washington, United States of America",
  queries: ["near Riverfront Park", "close to Manito Park", "around Centennial Trail"],
  original_name: "Spokane",
  id_corrupt: "fine",
  gaia_id: 602959,
  short_name: "Spokane (and vicinity)",
  long_name: "Spokane (and vicinity), Washington, United States of America"
}, {
  destination: "Kalamazoo, Michigan, United States of America",
  queries: ["near Air Zoo Aerospace & Science Museum", "close to Kalamazoo Valley Museum", "around Bell's Brewery"],
  original_name: "Kalamazoo",
  id_corrupt: "fine",
  gaia_id: 486,
  short_name: "Kalamazoo",
  long_name: "Kalamazoo, Michigan, United States of America"
}, {
  destination: "Tampa (and vicinity), Florida, United States of America",
  queries: ["near Busch Gardens Tampa Bay", "close to Ybor City", "around Tampa Riverwalk"],
  original_name: "Tampa",
  id_corrupt: "fine",
  gaia_id: 602996,
  short_name: "Tampa (and vicinity)",
  long_name: "Tampa (and vicinity), Florida, United States of America"
}, {
  destination: "Burlington, Vermont, United States of America",
  queries: ["near Waterfront Park", "close to ECHO Leahy Center for Lake Champlain", "around Church Street Marketplace"],
  original_name: "Burlington",
  id_corrupt: "fine",
  gaia_id: 601763,
  short_name: "Burlington",
  long_name: "Burlington, Vermont, United States of America"
}, {
  destination: "Edinburgh (and vicinity), Scotland, United Kingdom",
  queries: ["near Edinburgh Castle", "close to Royal Mile", "around Holyrood Palace"],
  original_name: "Edinburgh",
  id_corrupt: "fine",
  gaia_id: 6069845,
  short_name: "Edinburgh (and vicinity)",
  long_name: "Edinburgh (and vicinity), Scotland, United Kingdom"
}, {
  destination: "Qu\xE9bec City (and vicinity), Quebec, Canada",
  queries: ["near Old Quebec", "close to Citadelle of Quebec", "around Montmorency Falls Park"],
  original_name: "Quebec_City",
  id_corrupt: "fine",
  gaia_id: 180017,
  short_name: "Qu\xE9bec City (and vicinity)",
  long_name: "Qu\xE9bec City (and vicinity), Quebec, Canada"
}, {
  destination: "Puerto Rico",
  queries: ["near El Yunque National Forest", "close to Old San Juan", "around Flamenco Beach"],
  original_name: "Puerto_Rico",
  id_corrupt: "fine",
  gaia_id: 148,
  short_name: "Puerto Rico",
  long_name: "Puerto Rico"
}, {
  destination: "Champaign, Illinois, United States of America",
  queries: ["near University of Illinois Urbana-Champaign", "close to Krannert Art Museum", "around Meadowbrook Park"],
  original_name: "Champaign",
  id_corrupt: "fine",
  gaia_id: 6023715,
  short_name: "Champaign",
  long_name: "Champaign, Illinois, United States of America"
}, {
  destination: "Austin (and vicinity), Texas, United States of America",
  queries: ["Near Texas State Capitol", "Close to Barton Springs Pool", "Around South Congress Avenue"],
  original_name: "Austin",
  id_corrupt: "fine",
  gaia_id: 178234,
  short_name: "Austin (and vicinity)",
  long_name: "Austin (and vicinity), Texas, United States of America"
}, {
  destination: "Maryland, United States of America",
  queries: ["Near National Aquarium Baltimore", "Close to Inner Harbor", "Around United States Naval Academy"],
  original_name: "Maryland",
  id_corrupt: "fine",
  gaia_id: 222,
  short_name: "Maryland",
  long_name: "Maryland, United States of America"
}, {
  destination: "Positano, Campania, Italy",
  queries: ["Near Spiaggia Grande", "Close to Path of the Gods", "Around Positano Harbor"],
  original_name: "Positano",
  id_corrupt: "fine",
  gaia_id: 4330,
  short_name: "Positano",
  long_name: "Positano, Campania, Italy"
}, {
  destination: "Columbia, South Carolina, United States of America",
  queries: ["Near Riverbanks Zoo and Garden", "Close to South Carolina State House", "Around Congaree National Park"],
  original_name: "Columbia",
  id_corrupt: "fine",
  gaia_id: 764,
  short_name: "Columbia",
  long_name: "Columbia, South Carolina, United States of America"
}, {
  destination: "Saratoga Springs, New York, United States of America",
  queries: ["Near Saratoga Race Course", "Close to Congress Park", "Around SPAC - Saratoga Performing Arts Center"],
  original_name: "Saratoga_Springs",
  id_corrupt: "fine",
  gaia_id: 9775,
  short_name: "Saratoga Springs",
  long_name: "Saratoga Springs, New York, United States of America"
}, {
  destination: "Fort Wayne (and vicinity), Indiana, United States of America",
  queries: ["Near Fort Wayne Children's Zoo", "Close to Foellinger-Freimann Botanical Conservatory", "Around Fort Wayne Museum of Art"],
  original_name: "Fort_Wayne",
  id_corrupt: "fine",
  gaia_id: 603e3,
  short_name: "Fort Wayne (and vicinity)",
  long_name: "Fort Wayne (and vicinity), Indiana, United States of America"
}, {
  destination: "Point Pleasant - Toms River, New Jersey, United States of America",
  queries: ["Near Jenkinson's Boardwalk", "Close to Island Beach State Park", "Around Cattus Island County Park"],
  original_name: "Point_Pleasant_-_Toms_River",
  id_corrupt: "fine",
  gaia_id: 6085407,
  short_name: "Point Pleasant - Toms River",
  long_name: "Point Pleasant - Toms River, New Jersey, United States of America"
}, {
  destination: "Maine, United States of America",
  queries: ["Near Acadia National Park", "Close to Portland Head Light", "Around Old Port"],
  original_name: "Maine",
  id_corrupt: "fine",
  gaia_id: 221,
  short_name: "Maine",
  long_name: "Maine, United States of America"
}, {
  destination: "Taos, New Mexico, United States of America",
  queries: ["Near Taos Pueblo", "Close to Rio Grande Gorge Bridge", "Around Taos Plaza"],
  original_name: "Taos",
  id_corrupt: "fine",
  gaia_id: 602286,
  short_name: "Taos",
  long_name: "Taos, New Mexico, United States of America"
}, {
  destination: "Port Charlotte, Florida, United States of America",
  queries: ["Near Port Charlotte Beach Park", "Close to Peace River Wildlife Center", "Around Fishermen's Village"],
  original_name: "Port_Charlotte",
  id_corrupt: "fine",
  gaia_id: 6048101,
  short_name: "Port Charlotte",
  long_name: "Port Charlotte, Florida, United States of America"
}, {
  destination: "Gulf Shores, Alabama, United States of America",
  queries: ["near Gulf State Park", "close to The Wharf", "proximity to Orange Beach"],
  original_name: "Gulf_Shores",
  id_corrupt: "fine",
  gaia_id: 603078,
  short_name: "Gulf Shores",
  long_name: "Gulf Shores, Alabama, United States of America"
}, {
  destination: "Boise (and vicinity), Idaho, United States of America",
  queries: ["near Boise River Greenbelt", "close to Idaho State Capitol Building", "proximity to Julia Davis Park"],
  original_name: "Boise",
  id_corrupt: "fine",
  gaia_id: 602998,
  short_name: "Boise (and vicinity)",
  long_name: "Boise (and vicinity), Idaho, United States of America"
}, {
  destination: "Des Moines (and vicinity), Iowa, United States of America",
  queries: ["near Pappajohn Sculpture Park", "close to Iowa State Capitol Building", "proximity to Greater Des Moines Botanical Garden"],
  original_name: "Des_Moines",
  id_corrupt: "fine",
  gaia_id: 601690,
  short_name: "Des Moines (and vicinity)",
  long_name: "Des Moines (and vicinity), Iowa, United States of America"
}, {
  destination: "Boston (and vicinity), Massachusetts, United States of America",
  queries: ["near Fenway Park", "close to Freedom Trail", "proximity to Boston Common"],
  original_name: "Boston",
  id_corrupt: "fine",
  gaia_id: 178239,
  short_name: "Boston (and vicinity)",
  long_name: "Boston (and vicinity), Massachusetts, United States of America"
}, {
  destination: "Lansing, Michigan, United States of America",
  queries: ["near Michigan State Capitol", "close to Potter Park Zoo", "proximity to Cooley Law School Stadium"],
  original_name: "Lansing",
  id_corrupt: "fine",
  gaia_id: 603006,
  short_name: "Lansing",
  long_name: "Lansing, Michigan, United States of America"
}, {
  destination: "Louisiana, United States of America",
  queries: ["near French Quarter", "close to Bourbon Street", "proximity to Jackson Square"],
  original_name: "Louisiana",
  id_corrupt: "fine",
  gaia_id: 220,
  short_name: "Louisiana",
  long_name: "Louisiana, United States of America"
}, {
  destination: "White Plains, New York, United States of America",
  queries: ["near Kykuit", "close to Westchester County Center", "proximity to Empire City Casino"],
  original_name: "White_Plains",
  id_corrupt: "fine",
  gaia_id: 603214,
  short_name: "White Plains",
  long_name: "White Plains, New York, United States of America"
}, {
  destination: "Princeton, New Jersey, United States of America",
  queries: ["near Princeton University Art Museum", "close to Princeton Battlefield State Park", "proximity to Grounds For Sculpture"],
  original_name: "Princeton",
  id_corrupt: "fine",
  gaia_id: 603263,
  short_name: "Princeton",
  long_name: "Princeton, New Jersey, United States of America"
}, {
  destination: "Osaka (and vicinity), Osaka Prefecture, Japan",
  queries: ["near Osaka Castle", "close to Dotonbori", "proximity to Shinsaibashi Shopping Arcade"],
  original_name: "Osaka",
  id_corrupt: "fine",
  gaia_id: 179897,
  short_name: "Osaka (and vicinity)",
  long_name: "Osaka (and vicinity), Osaka Prefecture, Japan"
}, {
  destination: "Door County, Wisconsin, United States of America",
  queries: ["near Peninsula State Park", "close to Cave Point County Park", "proximity to Washington Island"],
  original_name: "Door_County",
  id_corrupt: "fine",
  gaia_id: 6059811,
  short_name: "Door County",
  long_name: "Door County, Wisconsin, United States of America"
}, {
  destination: "Tahoe City, California, United States of America",
  queries: ["near Lake Tahoe", "close to Tahoe City Golf Course", "proximity to Commons Beach Park"],
  original_name: "Tahoe_City",
  id_corrupt: "fine",
  gaia_id: 180041,
  short_name: "Tahoe City",
  long_name: "Tahoe City, California, United States of America"
}, {
  destination: "Colorado Springs (and vicinity), Colorado, United States of America",
  queries: ["near Garden of the Gods", "close to Pikes Peak", "proximity to Cheyenne Mountain Zoo"],
  original_name: "Colorado_Springs",
  id_corrupt: "fine",
  gaia_id: 602991,
  short_name: "Colorado Springs (and vicinity)",
  long_name: "Colorado Springs (and vicinity), Colorado, United States of America"
}, {
  destination: "Oakland (and vicinity), California, United States of America",
  queries: ["near Jack London Square", "close to Lake Merritt", "proximity to Redwood Regional Park"],
  original_name: "Oakland",
  id_corrupt: "fine",
  gaia_id: 601762,
  short_name: "Oakland (and vicinity)",
  long_name: "Oakland (and vicinity), California, United States of America"
}, {
  destination: "Fargo, North Dakota, United States of America",
  queries: ["near Red River Zoo", "close to Fargo Theatre", "proximity to Plains Art Museum"],
  original_name: "Fargo",
  id_corrupt: "fine",
  gaia_id: 6059376,
  short_name: "Fargo",
  long_name: "Fargo, North Dakota, United States of America"
}, {
  destination: "Denver (and vicinity), Colorado, United States of America",
  queries: ["near Red Rocks Park and Amphitheatre", "close to Denver Zoo", "proximity to Union Station"],
  original_name: "Denver",
  id_corrupt: "fine",
  gaia_id: 178254,
  short_name: "Denver (and vicinity)",
  long_name: "Denver (and vicinity), Colorado, United States of America"
}, {
  destination: "Islamorada, Florida, United States of America",
  queries: ["near Theater of the Sea", "close to Founders Park", "proximity to Anne's Beach"],
  original_name: "Islamorada",
  id_corrupt: "fine",
  gaia_id: 10768,
  short_name: "Islamorada",
  long_name: "Islamorada, Florida, United States of America"
}, {
  destination: "Fort Lee - Paramus, New Jersey, United States of America",
  queries: ["near Fort Lee Historic Park", "close to Saddle River County Park", "proximity to Van Saun County Park"],
  original_name: "Fort_Lee_-_Paramus",
  id_corrupt: "fine",
  gaia_id: 6023403,
  short_name: "Fort Lee - Paramus",
  long_name: "Fort Lee - Paramus, New Jersey, United States of America"
}, {
  destination: "Las Vegas (and vicinity), Nevada, United States of America",
  queries: ["near The Strip", "close to Red Rock Canyon National Conservation Area", "proximity to Fremont Street Experience"],
  original_name: "Las_Vegas",
  id_corrupt: "fine",
  gaia_id: 178276,
  short_name: "Las Vegas (and vicinity)",
  long_name: "Las Vegas (and vicinity), Nevada, United States of America"
}, {
  destination: "Boone, North Carolina, United States of America",
  queries: ["near Appalachian Ski Mtn.", "close to Moses H. Cone Memorial Park", "proximity to Tweetsie Railroad"],
  original_name: "Boone",
  id_corrupt: "fine",
  gaia_id: 6058523,
  short_name: "Boone",
  long_name: "Boone, North Carolina, United States of America"
}, {
  destination: "Milwaukee (and vicinity), Wisconsin, United States of America",
  queries: ["near Milwaukee Art Museum", "close to Harley-Davidson Museum", "proximity to Discovery World"],
  original_name: "Milwaukee",
  id_corrupt: "fine",
  gaia_id: 602647,
  short_name: "Milwaukee (and vicinity)",
  long_name: "Milwaukee (and vicinity), Wisconsin, United States of America"
}, {
  destination: "Arlington, Virginia, United States of America",
  queries: ["near Arlington National Cemetery", "close to Pentagon", "proximity to Arlington House, The Robert E. Lee Memorial"],
  original_name: "Arlington",
  id_corrupt: "fine",
  gaia_id: 6236,
  short_name: "Arlington",
  long_name: "Arlington, Virginia, United States of America"
}, {
  destination: "Santa Fe, New Mexico, United States of America",
  queries: ["near Loretto Chapel", "close to Canyon Road", "proximity to Georgia O'Keeffe Museum"],
  original_name: "Santa_Fe",
  id_corrupt: "fine",
  gaia_id: 180028,
  short_name: "Santa Fe",
  long_name: "Santa Fe, New Mexico, United States of America"
}, {
  destination: "Lancaster, Pennsylvania, United States of America",
  queries: ["near Dutch Wonderland", "close to Amish Farm and House", "proximity to Rock Ford Plantation"],
  original_name: "Lancaster",
  id_corrupt: "fine",
  gaia_id: 6057574,
  short_name: "Lancaster",
  long_name: "Lancaster, Pennsylvania, United States of America"
}, {
  destination: "San Diego, California, United States of America",
  queries: ["near USS Midway Museum", "close to Balboa Park", "proximity to Gaslamp Quarter"],
  original_name: "San_Diego",
  id_corrupt: "fine",
  gaia_id: 3073,
  short_name: "San Diego",
  long_name: "San Diego, California, United States of America"
}, {
  destination: "Cartersville, Georgia, United States of America",
  queries: ["near Etowah Indian Mounds", "close to Allatoona Pass Battlefield", "proximity to Tellus Science Museum"],
  original_name: "Cartersville",
  id_corrupt: "fine",
  gaia_id: 6058020,
  short_name: "Cartersville",
  long_name: "Cartersville, Georgia, United States of America"
}, {
  destination: "Massachusetts, United States of America",
  queries: ["near Fenway Park", "close to Freedom Trail", "proximity to Plymouth Rock"],
  original_name: "Massachusetts",
  id_corrupt: "fine",
  gaia_id: 223,
  short_name: "Massachusetts",
  long_name: "Massachusetts, United States of America"
}, {
  destination: "Kailua-Kona, Hawaii, United States of America",
  queries: ["near Hulihe\u2018e Palace", "close to Kamakahonu", "proximity to Kaloko-Honokohau National Historical Park"],
  original_name: "Kailua-Kona",
  id_corrupt: "fine",
  gaia_id: 1879,
  short_name: "Kailua-Kona",
  long_name: "Kailua-Kona, Hawaii, United States of America"
}, {
  destination: "Pensacola, Florida, United States of America",
  queries: ["near National Naval Aviation Museum", "close to Historic Pensacola Village", "proximity to Pensacola Beach"],
  original_name: "Pensacola",
  id_corrupt: "fine",
  gaia_id: 6023331,
  short_name: "Pensacola",
  long_name: "Pensacola, Florida, United States of America"
}, {
  destination: "Cleveland (and vicinity), Ohio, United States of America",
  queries: ["near Rock and Roll Hall of Fame", "close to West Side Market", "proximity to Cleveland Metroparks Zoo"],
  original_name: "Cleveland",
  id_corrupt: "fine",
  gaia_id: 178250,
  short_name: "Cleveland (and vicinity)",
  long_name: "Cleveland (and vicinity), Ohio, United States of America"
}, {
  destination: "San Luis Obispo, California, United States of America",
  queries: ["near Bubblegum Alley", "close to Mission San Luis Obispo de Tolosa", "proximity to Bishop Peak"],
  original_name: "San_Luis_Obispo",
  id_corrupt: "fine",
  gaia_id: 6046822,
  short_name: "San Luis Obispo",
  long_name: "San Luis Obispo, California, United States of America"
}, {
  destination: "College Park, Maryland, United States of America",
  queries: ["near University of Maryland", "close to Capital One Field at Maryland Stadium", "around College Park Aviation Museum"],
  original_name: "College_Park",
  id_corrupt: "fine",
  gaia_id: 6057494,
  short_name: "College Park",
  long_name: "College Park, Maryland, United States of America"
}, {
  destination: "San Diego County, California, United States of America",
  queries: ["by Balboa Park", "around San Diego Zoo", "near La Jolla Cove"],
  original_name: "San_Diego_County",
  id_corrupt: "fine",
  gaia_id: 178304,
  short_name: "San Diego County",
  long_name: "San Diego County, California, United States of America"
}, {
  destination: "Hawaii, United States of America",
  queries: ["close to Waikiki Beach", "around Pearl Harbor National Memorial", "near Haleakal\u0101 National Park"],
  original_name: "Hawaii",
  id_corrupt: "fine",
  gaia_id: 213,
  short_name: "Hawaii",
  long_name: "Hawaii, United States of America"
}, {
  destination: "Alaska, United States of America",
  queries: ["by Denali National Park and Preserve", "close to Kenai Fjords National Park", "around Mendenhall Glacier"],
  original_name: "Alaska",
  id_corrupt: "fine",
  gaia_id: 203,
  short_name: "Alaska",
  long_name: "Alaska, United States of America"
}, {
  destination: "North Carolina, United States of America",
  queries: ["near Biltmore Estate", "around Blue Ridge Mountains", "close to Wright Brothers National Memorial"],
  original_name: "North_Carolina",
  id_corrupt: "fine",
  gaia_id: 235,
  short_name: "North Carolina",
  long_name: "North Carolina, United States of America"
}, {
  destination: "Bethesda, Maryland, United States of America",
  queries: ["close to National Institutes of Health", "around Strathmore Music Center", "near Cabin John Regional Park"],
  original_name: "Bethesda",
  id_corrupt: "fine",
  gaia_id: 6057493,
  short_name: "Bethesda",
  long_name: "Bethesda, Maryland, United States of America"
}, {
  destination: "Kentucky, United States of America",
  queries: ["around Mammoth Cave National Park", "near Churchill Downs", "close to Kentucky Horse Park"],
  original_name: "Kentucky",
  id_corrupt: "fine",
  gaia_id: 219,
  short_name: "Kentucky",
  long_name: "Kentucky, United States of America"
}, {
  destination: "Ocean City, Maryland, United States of America",
  queries: ["near Ocean City Boardwalk", "around Assateague State Park", "close to Jolly Roger Amusement Park"],
  original_name: "Ocean_City",
  id_corrupt: "fine",
  gaia_id: 9151,
  short_name: "Ocean City",
  long_name: "Ocean City, Maryland, United States of America"
}, {
  destination: "Texas, United States of America",
  queries: ["by The Alamo", "near San Antonio River Walk", "around Space Center Houston"],
  original_name: "Texas",
  id_corrupt: "fine",
  gaia_id: 245,
  short_name: "Texas",
  long_name: "Texas, United States of America"
}, {
  destination: "Bowling Green, Kentucky, United States of America",
  queries: ["around Lost River Cave", "near National Corvette Museum", "close to Beech Bend Park"],
  original_name: "Bowling_Green",
  id_corrupt: "fine",
  gaia_id: 6059580,
  short_name: "Bowling Green",
  long_name: "Bowling Green, Kentucky, United States of America"
}, {
  destination: "Breckenridge, Colorado, United States of America",
  queries: ["near Breckenridge Ski Resort", "close to Main Street Breckenridge", "around Carter Park and Pavilion"],
  original_name: "Breckenridge",
  id_corrupt: "fine",
  gaia_id: 11926,
  short_name: "Breckenridge",
  long_name: "Breckenridge, Colorado, United States of America"
}, {
  destination: "Winston - Salem, North Carolina, United States of America",
  queries: ["near Old Salem Museums & Gardens", "close to Reynolda House Museum of American Art", "around BB&T Ballpark"],
  original_name: "Winston_-_Salem",
  id_corrupt: "fine",
  gaia_id: 602969,
  short_name: "Winston - Salem",
  long_name: "Winston - Salem, North Carolina, United States of America"
}, {
  destination: "Indianapolis (and vicinity), Indiana, United States of America",
  queries: ["near Indianapolis Motor Speedway", "close to Children's Museum of Indianapolis", "around Monument Circle"],
  original_name: "Indianapolis",
  id_corrupt: "fine",
  gaia_id: 178266,
  short_name: "Indianapolis (and vicinity)",
  long_name: "Indianapolis (and vicinity), Indiana, United States of America"
}, {
  destination: "Bellingham, Washington, United States of America",
  queries: ["near Fairhaven Historic District", "close to Whatcom Falls Park", "around Western Washington University"],
  original_name: "Bellingham",
  id_corrupt: "fine",
  gaia_id: 602922,
  short_name: "Bellingham",
  long_name: "Bellingham, Washington, United States of America"
}, {
  destination: "Irvine, California, United States of America",
  queries: ["near Orange County Great Park", "close to Irvine Spectrum Center", "around Bommer Canyon Trailhead"],
  original_name: "Irvine",
  id_corrupt: "fine",
  gaia_id: 7819,
  short_name: "Irvine",
  long_name: "Irvine, California, United States of America"
}, {
  destination: "Washington (and vicinity), District of Columbia, United States of America",
  queries: ["near National Mall", "close to United States Capitol", "around The White House"],
  original_name: "Washington",
  id_corrupt: "fine",
  gaia_id: 178318,
  short_name: "Washington (and vicinity)",
  long_name: "Washington (and vicinity), District of Columbia, United States of America"
}, {
  destination: "New Hampshire, United States of America",
  queries: ["near White Mountain National Forest", "close to Mount Washington", "around Strawbery Banke Museum"],
  original_name: "New_Hampshire",
  id_corrupt: "fine",
  gaia_id: 231,
  short_name: "New Hampshire",
  long_name: "New Hampshire, United States of America"
}, {
  destination: "Williamsburg, Virginia, United States of America",
  queries: ["near Colonial Williamsburg", "close to Busch Gardens Williamsburg", "around The College of William & Mary"],
  original_name: "Williamsburg",
  id_corrupt: "fine",
  gaia_id: 6296,
  short_name: "Williamsburg",
  long_name: "Williamsburg, Virginia, United States of America"
}, {
  destination: "Bentonville - Fayetteville, Arkansas, United States of America",
  queries: ["near Crystal Bridges Museum of American Art", "close to Fayetteville Downtown Square", "around Devil's Den State Park"],
  original_name: "Bentonville_-_Fayetteville",
  id_corrupt: "fine",
  gaia_id: 6025617,
  short_name: "Bentonville - Fayetteville",
  long_name: "Bentonville - Fayetteville, Arkansas, United States of America"
}, {
  destination: "Missoula, Montana, United States of America",
  queries: ["near University of Montana", "close to Missoula Art Museum", "around Caras Park"],
  original_name: "Missoula",
  id_corrupt: "fine",
  gaia_id: 180035,
  short_name: "Missoula",
  long_name: "Missoula, Montana, United States of America"
}, {
  destination: "Greece",
  queries: ["near Acropolis", "around Santorini Caldera", "close to Mykonos Windmills"],
  original_name: "Greece",
  id_corrupt: "fine",
  gaia_id: 67,
  short_name: "Greece",
  long_name: "Greece"
}, {
  destination: "Morehead City, North Carolina, United States of America",
  queries: ["by the waterfront", "near Fort Macon State Park", "around Atlantic Beach"],
  original_name: "Morehead_City",
  id_corrupt: "fine",
  gaia_id: 6058521,
  short_name: "Morehead City",
  long_name: "Morehead City, North Carolina, United States of America"
}, {
  destination: "Somerset, New Jersey, United States of America",
  queries: ["close to Duke Farms", "near Colonial Park", "around Somerset Patriot Ballpark"],
  original_name: "Somerset",
  id_corrupt: "fine",
  gaia_id: 603261,
  short_name: "Somerset",
  long_name: "Somerset, New Jersey, United States of America"
}, {
  destination: "Indiana, United States of America",
  queries: ["near Indianapolis Motor Speedway", "close to Indiana Dunes National Park", "around Children's Museum of Indianapolis"],
  original_name: "Indiana",
  id_corrupt: "fine",
  gaia_id: 216,
  short_name: "Indiana",
  long_name: "Indiana, United States of America"
}, {
  destination: "Orange County, California, United States of America",
  queries: ["close to Disneyland", "around Laguna Beach", "near Mission San Juan Capistrano"],
  original_name: "Orange_County",
  id_corrupt: "fine",
  gaia_id: 603224,
  short_name: "Orange County",
  long_name: "Orange County, California, United States of America"
}, {
  destination: "Munich (and vicinity), Bavaria, Germany",
  queries: ["near Marienplatz", "close to English Garden", "around Nymphenburg Palace"],
  original_name: "Munich",
  id_corrupt: "fine",
  gaia_id: 179896,
  short_name: "Munich (and vicinity)",
  long_name: "Munich (and vicinity), Bavaria, Germany"
}, {
  destination: "Waco, Texas, United States of America",
  queries: ["close to Magnolia Market at the Silos", "around Cameron Park Zoo", "near Waco Mammoth National Monument"],
  original_name: "Waco",
  id_corrupt: "fine",
  gaia_id: 286,
  short_name: "Waco",
  long_name: "Waco, Texas, United States of America"
}, {
  destination: "San Bernardino County, California, United States of America",
  queries: ["near Joshua Tree National Park", "close to Big Bear Lake", "around Calico Ghost Town"],
  original_name: "San_Bernardino_County",
  id_corrupt: "fine",
  gaia_id: 6055926,
  short_name: "San Bernardino County",
  long_name: "San Bernardino County, California, United States of America"
}, {
  destination: "Petoskey, Michigan, United States of America",
  queries: ["by Petoskey State Park", "close to Odawa Casino", "around Bay Harbor"],
  original_name: "Petoskey",
  id_corrupt: "fine",
  gaia_id: 6059162,
  short_name: "Petoskey",
  long_name: "Petoskey, Michigan, United States of America"
}, {
  destination: "Fort Lauderdale (and vicinity), Florida, United States of America",
  queries: ["near Fort Lauderdale Beach", "close to Las Olas Boulevard", "around Bonnet House Museum & Gardens"],
  original_name: "Fort_Lauderdale",
  id_corrupt: "fine",
  gaia_id: 601750,
  short_name: "Fort Lauderdale (and vicinity)",
  long_name: "Fort Lauderdale (and vicinity), Florida, United States of America"
}, {
  destination: "Key West, Florida, United States of America",
  queries: ["near Duval Street", "close to Mallory Square", "around Southernmost Point"],
  original_name: "Key_West",
  id_corrupt: "fine",
  gaia_id: 1187,
  short_name: "Key West",
  long_name: "Key West, Florida, United States of America"
}, {
  destination: "Huntsville (and vicinity), Alabama, United States of America",
  queries: ["near U.S. Space and Rocket Center", "close to Monte Sano State Park", "around Big Spring Park"],
  original_name: "Huntsville",
  id_corrupt: "fine",
  gaia_id: 602985,
  short_name: "Huntsville (and vicinity)",
  long_name: "Huntsville (and vicinity), Alabama, United States of America"
}, {
  destination: "Huntington Beach, California, United States of America",
  queries: ["near Huntington Beach Pier", "close to Bolsa Chica State Beach", "around Pacific City"],
  original_name: "Huntington_Beach",
  id_corrupt: "fine",
  gaia_id: 8165,
  short_name: "Huntington Beach",
  long_name: "Huntington Beach, California, United States of America"
}, {
  destination: "Birmingham (and vicinity), Alabama, United States of America",
  queries: ["near Birmingham Zoo", "close to Vulcan Park and Museum", "around Railroad Park"],
  original_name: "Birmingham",
  id_corrupt: "fine",
  gaia_id: 602981,
  short_name: "Birmingham (and vicinity)",
  long_name: "Birmingham (and vicinity), Alabama, United States of America"
}, {
  destination: "Galveston, Texas, United States of America",
  queries: ["near Pleasure Pier", "close to Moody Gardens", "around The Strand Historic District"],
  original_name: "Galveston",
  id_corrupt: "fine",
  gaia_id: 1341,
  short_name: "Galveston",
  long_name: "Galveston, Texas, United States of America"
}, {
  destination: "Mammoth Lakes, California, United States of America",
  queries: ["near Mammoth Mountain", "close to Devils Postpile National Monument", "around Convict Lake"],
  original_name: "Mammoth_Lakes",
  id_corrupt: "fine",
  gaia_id: 2363,
  short_name: "Mammoth Lakes",
  long_name: "Mammoth Lakes, California, United States of America"
}, {
  destination: "Prescott, Arizona, United States of America",
  queries: ["near Whiskey Row", "close to Watson Lake", "around Thumb Butte Park"],
  original_name: "Prescott",
  id_corrupt: "fine",
  gaia_id: 6054768,
  short_name: "Prescott",
  long_name: "Prescott, Arizona, United States of America"
}, {
  destination: "Fort Collins, Colorado, United States of America",
  queries: ["near Horsetooth Mountain Open Space", "close to Old Town Square", "around Cache la Poudre River"],
  original_name: "Fort_Collins",
  id_corrupt: "fine",
  gaia_id: 602992,
  short_name: "Fort Collins",
  long_name: "Fort Collins, Colorado, United States of America"
}, {
  destination: "Grayling, Michigan, United States of America",
  queries: ["near Hartwick Pines State Park", "close to AuSable River", "around Kirtland's Warbler Sanctuary"],
  original_name: "Grayling",
  id_corrupt: "fine",
  gaia_id: 6059176,
  short_name: "Grayling",
  long_name: "Grayling, Michigan, United States of America"
}, {
  destination: "Santa Cruz, California, United States of America",
  queries: ["near Santa Cruz Beach Boardwalk", "close to Natural Bridges State Beach", "around West Cliff Drive"],
  original_name: "Santa_Cruz",
  id_corrupt: "fine",
  gaia_id: 6666,
  short_name: "Santa Cruz",
  long_name: "Santa Cruz, California, United States of America"
}, {
  destination: "Tallahassee, Florida, United States of America",
  queries: ["Near Florida State Capitol", "Close to Florida State University", "Near Cascades Park"],
  original_name: "Tallahassee",
  id_corrupt: "fine",
  gaia_id: 6048214,
  short_name: "Tallahassee",
  long_name: "Tallahassee, Florida, United States of America"
}, {
  destination: "Kyoto (and vicinity), Kyoto Prefecture, Japan",
  queries: ["Close to Fushimi Inari Taisha Shrine", "Near Kinkaku-ji Temple", "Close to Arashiyama Bamboo Grove"],
  original_name: "Kyoto",
  id_corrupt: "fine",
  gaia_id: 6131486,
  short_name: "Kyoto (and vicinity)",
  long_name: "Kyoto (and vicinity), Kyoto Prefecture, Japan"
}, {
  destination: "North Dakota, United States of America",
  queries: ["Close to Theodore Roosevelt National Park", "Near Fargo Theatre", "Close to Scandinavian Heritage Park"],
  original_name: "North_Dakota",
  id_corrupt: "fine",
  gaia_id: 236,
  short_name: "North Dakota",
  long_name: "North Dakota, United States of America"
}, {
  destination: "Atlanta (and vicinity), Georgia, United States of America",
  queries: ["Near Centennial Olympic Park", "Close to Georgia Aquarium", "Near Martin Luther King Jr. National Historic Site"],
  original_name: "Atlanta",
  id_corrupt: "fine",
  gaia_id: 178232,
  short_name: "Atlanta (and vicinity)",
  long_name: "Atlanta (and vicinity), Georgia, United States of America"
}, {
  destination: "California, United States of America",
  queries: ["Close to Golden Gate Bridge", "Near Disneyland Resort", "Close to Hollywood Walk of Fame"],
  original_name: "California",
  id_corrupt: "fine",
  gaia_id: 206,
  short_name: "California",
  long_name: "California, United States of America"
}, {
  destination: "Stockholm (and vicinity), Stockholm County, Sweden",
  queries: ["Near Gamla Stan", "Close to Vasa Museum", "Near Skansen Open-Air Museum"],
  original_name: "Stockholm",
  id_corrupt: "fine",
  gaia_id: 178311,
  short_name: "Stockholm (and vicinity)",
  long_name: "Stockholm (and vicinity), Stockholm County, Sweden"
}, {
  destination: "Baton Rouge (and vicinity), Louisiana, United States of America",
  queries: ["Close to Louisiana State Capitol", "Near USS Kidd Veterans Memorial", "Close to Baton Rouge Zoo"],
  original_name: "Baton_Rouge",
  id_corrupt: "fine",
  gaia_id: 603004,
  short_name: "Baton Rouge (and vicinity)",
  long_name: "Baton Rouge (and vicinity), Louisiana, United States of America"
}, {
  destination: "Macon, Georgia, United States of America",
  queries: ["Near Ocmulgee Mounds National Historical Park", "Close to Tubman Museum", "Near Hay House"],
  original_name: "Macon",
  id_corrupt: "fine",
  gaia_id: 2236,
  short_name: "Macon",
  long_name: "Macon, Georgia, United States of America"
}, {
  destination: "Erie, Pennsylvania, United States of America",
  queries: ["Close to Presque Isle State Park", "Near Erie Maritime Museum", "Close to Splash Lagoon Indoor Water Park Resort"],
  original_name: "Erie",
  id_corrupt: "fine",
  gaia_id: 1160,
  short_name: "Erie",
  long_name: "Erie, Pennsylvania, United States of America"
}, {
  destination: "Topeka, Kansas, United States of America",
  queries: ["Near Kansas State Capitol Building", "Close to Combat Air Museum", "Near Gage Park"],
  original_name: "Topeka",
  id_corrupt: "fine",
  gaia_id: 6058365,
  short_name: "Topeka",
  long_name: "Topeka, Kansas, United States of America"
}, {
  destination: "Napa, California, United States of America",
  queries: ["near Napa Valley Wine Train", "close to Oxbow Public Market", "by Napa Riverfront"],
  original_name: "Napa",
  id_corrupt: "fine",
  gaia_id: 6141,
  short_name: "Napa",
  long_name: "Napa, California, United States of America"
}, {
  destination: "Lake Geneva, Wisconsin, United States of America",
  queries: ["near Geneva Lake Shore Path", "close to Riviera Beach", "by Big Foot Beach State Park"],
  original_name: "Lake_Geneva",
  id_corrupt: "fine",
  gaia_id: 6046584,
  short_name: "Lake Geneva",
  long_name: "Lake Geneva, Wisconsin, United States of America"
}, {
  destination: "Rome (and vicinity), Lazio, Italy",
  queries: ["near Colosseum", "close to Trevi Fountain", "by Vatican City"],
  original_name: "Rome",
  id_corrupt: "fine",
  gaia_id: 179899,
  short_name: "Rome (and vicinity)",
  long_name: "Rome (and vicinity), Lazio, Italy"
}, {
  destination: "Nice (and vicinity), Alpes-Maritimes, France",
  queries: ["near Promenade des Anglais", "close to Castle Hill", "by Old Town (Vieille Ville)"],
  original_name: "Nice",
  id_corrupt: "fine",
  gaia_id: 180102,
  short_name: "Nice (and vicinity)",
  long_name: "Nice (and vicinity), Alpes-Maritimes, France"
}, {
  destination: "Medford, Oregon, United States of America",
  queries: ["near Roxy Ann Peak", "close to Bear Creek Park", "by Prescott Park"],
  original_name: "Medford",
  id_corrupt: "fine",
  gaia_id: 602702,
  short_name: "Medford",
  long_name: "Medford, Oregon, United States of America"
}, {
  destination: "Lafayette, Louisiana, United States of America",
  queries: ["near Vermilionville", "close to Acadian Village", "by Girard Park"],
  original_name: "Lafayette",
  id_corrupt: "fine",
  gaia_id: 6047257,
  short_name: "Lafayette",
  long_name: "Lafayette, Louisiana, United States of America"
}, {
  destination: "Thomasville, Georgia, United States of America",
  queries: ["near Thomasville Rose Garden", "close to Pebble Hill Plantation", "by Lapham-Patterson House"],
  original_name: "Thomasville",
  id_corrupt: "fine",
  gaia_id: 6058119,
  short_name: "Thomasville",
  long_name: "Thomasville, Georgia, United States of America"
}, {
  destination: "Cedar Rapids - Iowa City, Iowa, United States of America",
  queries: ["near NewBo City Market", "close to Iowa Old Capitol Building", "by Brucemore"],
  original_name: "Cedar_Rapids_-_Iowa_City",
  id_corrupt: "fine",
  gaia_id: 602979,
  short_name: "Cedar Rapids - Iowa City",
  long_name: "Cedar Rapids - Iowa City, Iowa, United States of America"
}, {
  destination: "Bloomington, Indiana, United States of America",
  queries: ["near Indiana University Bloomington", "close to Monroe Lake", "by WonderLab Museum of Science, Health and Technology"],
  original_name: "Bloomington",
  id_corrupt: "fine",
  gaia_id: 6059776,
  short_name: "Bloomington",
  long_name: "Bloomington, Indiana, United States of America"
}, {
  destination: "Connecticut, United States of America",
  queries: ["near Mystic Seaport Museum", "close to Yale University", "by Mark Twain House"],
  original_name: "Connecticut",
  id_corrupt: "fine",
  gaia_id: 208,
  short_name: "Connecticut",
  long_name: "Connecticut, United States of America"
}, {
  destination: "Peoria, Illinois, United States of America",
  queries: ["near Peoria Riverfront", "close to Grand View Drive", "proximity to Peoria Zoo"],
  original_name: "Peoria",
  id_corrupt: "fine",
  gaia_id: 602999,
  short_name: "Peoria",
  long_name: "Peoria, Illinois, United States of America"
}, {
  destination: "Dallas (and vicinity), Texas, United States of America",
  queries: ["near Dealey Plaza", "close to Dallas Arboretum and Botanical Garden", "proximity to Reunion Tower"],
  original_name: "Dallas",
  id_corrupt: "fine",
  gaia_id: 178253,
  short_name: "Dallas (and vicinity)",
  long_name: "Dallas (and vicinity), Texas, United States of America"
}, {
  destination: "Worcester, Massachusetts, United States of America",
  queries: ["near Worcester Art Museum", "close to Bancroft Tower", "proximity to EcoTarium"],
  original_name: "Worcester",
  id_corrupt: "fine",
  gaia_id: 6023336,
  short_name: "Worcester",
  long_name: "Worcester, Massachusetts, United States of America"
}, {
  destination: "Boulder, Colorado, United States of America",
  queries: ["near Pearl Street Mall", "close to Chautauqua Park", "proximity to Flatirons"],
  original_name: "Boulder",
  id_corrupt: "fine",
  gaia_id: 6051762,
  short_name: "Boulder",
  long_name: "Boulder, Colorado, United States of America"
}, {
  destination: "Philadelphia (and vicinity), Pennsylvania, United States of America",
  queries: ["near Liberty Bell", "close to Reading Terminal Market", "proximity to Philadelphia Museum of Art"],
  original_name: "Philadelphia",
  id_corrupt: "fine",
  gaia_id: 178297,
  short_name: "Philadelphia (and vicinity)",
  long_name: "Philadelphia (and vicinity), Pennsylvania, United States of America"
}, {
  destination: "Benton Harbor, Michigan, United States of America",
  queries: ["near Silver Beach", "close to St. Joseph North Pier Lighthouse", "proximity to Sarett Nature Center"],
  original_name: "Benton_Harbor",
  id_corrupt: "fine",
  gaia_id: 6059188,
  short_name: "Benton Harbor",
  long_name: "Benton Harbor, Michigan, United States of America"
}, {
  destination: "Page, Arizona, United States of America",
  queries: ["near Horseshoe Bend", "close to Antelope Canyon", "proximity to Lake Powell"],
  original_name: "Page",
  id_corrupt: "fine",
  gaia_id: 2776,
  short_name: "Page",
  long_name: "Page, Arizona, United States of America"
}, {
  destination: "Auburn - Opelika, Alabama, United States of America",
  queries: ["near Chewacla State Park", "close to Jordan-Hare Stadium", "proximity to Jule Collins Smith Museum of Fine Art"],
  original_name: "Auburn_-_Opelika",
  id_corrupt: "fine",
  gaia_id: 6057712,
  short_name: "Auburn - Opelika",
  long_name: "Auburn - Opelika, Alabama, United States of America"
}, {
  destination: "Bangkok (and vicinity), Bangkok Province, Thailand",
  queries: ["near Grand Palace", "close to Wat Arun", "proximity to Chatuchak Weekend Market"],
  original_name: "Bangkok",
  id_corrupt: "fine",
  gaia_id: 178236,
  short_name: "Bangkok (and vicinity)",
  long_name: "Bangkok (and vicinity), Bangkok Province, Thailand"
}, {
  destination: "Bismarck, North Dakota, United States of America",
  queries: ["near North Dakota Heritage Center & State Museum", "close to Dakota Zoo", "proximity to Fort Abraham Lincoln State Park"],
  original_name: "Bismarck",
  id_corrupt: "fine",
  gaia_id: 6059380,
  short_name: "Bismarck",
  long_name: "Bismarck, North Dakota, United States of America"
}, {
  destination: "Mystic - New London, Connecticut, United States of America",
  queries: ["near Mystic Seaport Museum", "close to Ocean Beach Park", "around Fort Trumbull State Park"],
  original_name: "Mystic_-_New_London",
  id_corrupt: "fine",
  gaia_id: 602994,
  short_name: "Mystic - New London",
  long_name: "Mystic - New London, Connecticut, United States of America"
}, {
  destination: "El Paso (and vicinity), Texas, United States of America",
  queries: ["near El Paso Museum of Art", "close to Franklin Mountains State Park", "around Wyler Aerial Tramway"],
  original_name: "El_Paso",
  id_corrupt: "fine",
  gaia_id: 1129,
  short_name: "El Paso (and vicinity)",
  long_name: "El Paso (and vicinity), Texas, United States of America"
}, {
  destination: "Newburgh, New York, United States of America",
  queries: ["near Storm King Art Center", "close to Washington's Headquarters State Historic Site", "around Motorcyclepedia Museum"],
  original_name: "Newburgh",
  id_corrupt: "fine",
  gaia_id: 6023343,
  short_name: "Newburgh",
  long_name: "Newburgh, New York, United States of America"
}, {
  destination: "Harrisburg - Hershey, Pennsylvania, United States of America",
  queries: ["near Hersheypark", "close to Pennsylvania State Capitol", "around National Civil War Museum"],
  original_name: "Harrisburg_-_Hershey",
  id_corrupt: "fine",
  gaia_id: 602958,
  short_name: "Harrisburg - Hershey",
  long_name: "Harrisburg - Hershey, Pennsylvania, United States of America"
}, {
  destination: "Gatlinburg - Pigeon Forge, Tennessee, United States of America",
  queries: ["near Great Smoky Mountains National Park", "close to Dollywood", "around Ripley's Aquarium of the Smokies"],
  original_name: "Gatlinburg_-_Pigeon_Forge",
  id_corrupt: "fine",
  gaia_id: 601691,
  short_name: "Gatlinburg - Pigeon Forge",
  long_name: "Gatlinburg - Pigeon Forge, Tennessee, United States of America"
}, {
  destination: "Newport News, Virginia, United States of America",
  queries: ["near Mariners' Museum & Park", "close to Virginia Living Museum", "around Newport News Park"],
  original_name: "Newport_News",
  id_corrupt: "fine",
  gaia_id: 6056964,
  short_name: "Newport News",
  long_name: "Newport News, Virginia, United States of America"
}, {
  destination: "Fresno (and vicinity), California, United States of America",
  queries: ["near Forestiere Underground Gardens", "close to Shinzen Japanese Garden", "around Woodward Regional Park"],
  original_name: "Fresno",
  id_corrupt: "fine",
  gaia_id: 602988,
  short_name: "Fresno (and vicinity)",
  long_name: "Fresno (and vicinity), California, United States of America"
}, {
  destination: "Palm Springs, California, United States of America",
  queries: ["near Palm Springs Aerial Tramway", "close to Indian Canyons", "around Palm Springs Art Museum"],
  original_name: "Palm_Springs",
  id_corrupt: "fine",
  gaia_id: 180676,
  short_name: "Palm Springs",
  long_name: "Palm Springs, California, United States of America"
}, {
  destination: "Iowa, United States of America",
  queries: ["near Field of Dreams Movie Site", "close to Maquoketa Caves State Park", "around Grotto of the Redemption"],
  original_name: "Iowa",
  id_corrupt: "fine",
  gaia_id: 217,
  short_name: "Iowa",
  long_name: "Iowa, United States of America"
}, {
  destination: "Copenhagen (and vicinity), Hovedstaden, Denmark",
  queries: ["near Tivoli Gardens", "close to Nyhavn", "around The Little Mermaid"],
  original_name: "Copenhagen",
  id_corrupt: "fine",
  gaia_id: 178252,
  short_name: "Copenhagen (and vicinity)",
  long_name: "Copenhagen (and vicinity), Hovedstaden, Denmark"
}, {
  destination: "Mobile, Alabama, United States of America",
  queries: ["near USS Alabama Battleship Memorial Park", "close to Mobile Carnival Museum", "around Bienville Square"],
  original_name: "Mobile",
  id_corrupt: "fine",
  gaia_id: 602984,
  short_name: "Mobile",
  long_name: "Mobile, Alabama, United States of America"
}, {
  destination: "Madrid (and vicinity), Community of Madrid, Spain",
  queries: ["near Royal Palace of Madrid", "close to Prado National Museum", "around Puerta del Sol"],
  original_name: "Madrid",
  id_corrupt: "fine",
  gaia_id: 178281,
  short_name: "Madrid (and vicinity)",
  long_name: "Madrid (and vicinity), Community of Madrid, Spain"
}, {
  destination: "Arkansas, United States of America",
  queries: ["near Hot Springs National Park", "close to Crystal Bridges Museum of American Art", "around Buffalo National River"],
  original_name: "Arkansas",
  id_corrupt: "fine",
  gaia_id: 205,
  short_name: "Arkansas",
  long_name: "Arkansas, United States of America"
}, {
  destination: "Stamford, Connecticut, United States of America",
  queries: ["near Stamford Museum & Nature Center", "close to Cove Island Park", "around The Ferguson Library"],
  original_name: "Stamford",
  id_corrupt: "fine",
  gaia_id: 602523,
  short_name: "Stamford",
  long_name: "Stamford, Connecticut, United States of America"
}, {
  destination: "Moab, Utah, United States of America",
  queries: ["near Arches National Park", "close to Canyonlands National Park", "around Dead Horse Point State Park"],
  original_name: "Moab",
  id_corrupt: "fine",
  gaia_id: 6176216,
  short_name: "Moab",
  long_name: "Moab, Utah, United States of America"
}, {
  destination: "Montgomery, Alabama, United States of America",
  queries: ["near Civil Rights Memorial", "close to Montgomery Museum of Fine Arts", "around Alabama Shakespeare Festival"],
  original_name: "Montgomery",
  id_corrupt: "fine",
  gaia_id: 602983,
  short_name: "Montgomery",
  long_name: "Montgomery, Alabama, United States of America"
}, {
  destination: "Fort Walton Beach - Destin, Florida, United States of America",
  queries: ["near Destin Harbor Boardwalk", "close to Gulfarium Marine Adventure Park", "around Henderson Beach State Park"],
  original_name: "Fort_Walton_Beach_-_Destin",
  id_corrupt: "fine",
  gaia_id: 6023392,
  short_name: "Fort Walton Beach - Destin",
  long_name: "Fort Walton Beach - Destin, Florida, United States of America"
}, {
  destination: "Chattanooga, Tennessee, United States of America",
  queries: ["near Ruby Falls", "close to Tennessee Aquarium", "around Lookout Mountain"],
  original_name: "Chattanooga",
  id_corrupt: "fine",
  gaia_id: 827,
  short_name: "Chattanooga",
  long_name: "Chattanooga, Tennessee, United States of America"
}, {
  destination: "St. George, Utah, United States of America",
  queries: ["near St. George Temple", "close to Snow Canyon State Park", "around Red Hills Desert Garden"],
  original_name: "St_George",
  id_corrupt: "fine",
  gaia_id: 3142,
  short_name: "St. George",
  long_name: "St. George, Utah, United States of America"
}, {
  destination: "Duluth, Minnesota, United States of America",
  queries: ["near Aerial Lift Bridge", "close to Canal Park", "around Great Lakes Aquarium"],
  original_name: "Duluth",
  id_corrupt: "fine",
  gaia_id: 1029,
  short_name: "Duluth",
  long_name: "Duluth, Minnesota, United States of America"
}, {
  destination: "Pennsylvania, United States of America",
  queries: ["Near Liberty Bell", "Close to Hershey Park", "Around Philadelphia Museum of Art"],
  original_name: "Pennsylvania",
  id_corrupt: "fine",
  gaia_id: 240,
  short_name: "Pennsylvania",
  long_name: "Pennsylvania, United States of America"
}, {
  destination: "Cincinnati (and vicinity), Ohio, United States of America",
  queries: ["Near Cincinnati Zoo", "Close to Great American Ball Park", "Around Findlay Market"],
  original_name: "Cincinnati",
  id_corrupt: "fine",
  gaia_id: 178249,
  short_name: "Cincinnati (and vicinity)",
  long_name: "Cincinnati (and vicinity), Ohio, United States of America"
}, {
  destination: "Arizona, United States of America",
  queries: ["Near Grand Canyon", "Close to Antelope Canyon", "Around Sedona Red Rocks"],
  original_name: "Arizona",
  id_corrupt: "fine",
  gaia_id: 204,
  short_name: "Arizona",
  long_name: "Arizona, United States of America"
}, {
  destination: "Berlin, Germany",
  queries: ["Near Brandenburg Gate", "Close to Berlin Wall", "Around Museum Island"],
  original_name: "Berlin",
  id_corrupt: "fine",
  gaia_id: 536,
  short_name: "Berlin",
  long_name: "Berlin, Germany"
}, {
  destination: "Augusta, Georgia, United States of America",
  queries: ["Near Augusta National Golf Club", "Close to Riverwalk Augusta", "Around Phinizy Swamp Nature Park"],
  original_name: "Augusta",
  id_corrupt: "fine",
  gaia_id: 6034963,
  short_name: "Augusta",
  long_name: "Augusta, Georgia, United States of America"
}, {
  destination: "Victoria, British Columbia, Canada",
  queries: ["Near Butchart Gardens", "Close to Royal BC Museum", "Around Inner Harbour"],
  original_name: "Victoria",
  id_corrupt: "fine",
  gaia_id: 4138,
  short_name: "Victoria",
  long_name: "Victoria, British Columbia, Canada"
}, {
  destination: "Fort Myers, Florida, United States of America",
  queries: ["Near Edison and Ford Winter Estates", "Close to Fort Myers Beach", "Around J.N. Ding Darling National Wildlife Refuge"],
  original_name: "Fort_Myers",
  id_corrupt: "fine",
  gaia_id: 602729,
  short_name: "Fort Myers",
  long_name: "Fort Myers, Florida, United States of America"
}, {
  destination: "Mississippi, United States of America",
  queries: ["Near Gulf Islands National Seashore", "Close to Vicksburg National Military Park", "Around Beauvoir"],
  original_name: "Mississippi",
  id_corrupt: "fine",
  gaia_id: 226,
  short_name: "Mississippi",
  long_name: "Mississippi, United States of America"
}, {
  destination: "Mackinaw City, Michigan, United States of America",
  queries: ["Near Mackinac Bridge", "Close to Colonial Michilimackinac Park", "Around Old Mackinac Point Lighthouse"],
  original_name: "Mackinaw_City",
  id_corrupt: "fine",
  gaia_id: 9627,
  short_name: "Mackinaw City",
  long_name: "Mackinaw City, Michigan, United States of America"
}, {
  destination: "Tennessee, United States of America",
  queries: ["Near Graceland", "Close to Great Smoky Mountains National Park", "Around Country Music Hall of Fame"],
  original_name: "Tennessee",
  id_corrupt: "fine",
  gaia_id: 244,
  short_name: "Tennessee",
  long_name: "Tennessee, United States of America"
}, {
  destination: "Sedona, Arizona, United States of America",
  queries: ["near Cathedral Rock", "close to Bell Rock", "around Slide Rock State Park"],
  original_name: "Sedona",
  id_corrupt: "fine",
  gaia_id: 6054771,
  short_name: "Sedona",
  long_name: "Sedona, Arizona, United States of America"
}, {
  destination: "Lake Placid, New York, United States of America",
  queries: ["near Mirror Lake", "close to Whiteface Mountain", "around Olympic Center"],
  original_name: "Lake_Placid",
  id_corrupt: "fine",
  gaia_id: 6055989,
  short_name: "Lake Placid",
  long_name: "Lake Placid, New York, United States of America"
}, {
  destination: "Killeen, Texas, United States of America",
  queries: ["near Stillhouse Hollow Lake", "close to Vive Les Arts Theatre", "around Lions Club Park"],
  original_name: "Killeen",
  id_corrupt: "fine",
  gaia_id: 1585,
  short_name: "Killeen",
  long_name: "Killeen, Texas, United States of America"
}, {
  destination: "St. Louis (and vicinity), Missouri, United States of America",
  queries: ["near Gateway Arch", "close to Forest Park", "around Busch Stadium"],
  original_name: "St_Louis",
  id_corrupt: "fine",
  gaia_id: 178309,
  short_name: "St. Louis (and vicinity)",
  long_name: "St. Louis (and vicinity), Missouri, United States of America"
}, {
  destination: "Charlotte (and vicinity), North Carolina, United States of America",
  queries: ["near NASCAR Hall of Fame", "close to Freedom Park", "around Discovery Place"],
  original_name: "Charlotte",
  id_corrupt: "fine",
  gaia_id: 178247,
  short_name: "Charlotte (and vicinity)",
  long_name: "Charlotte (and vicinity), North Carolina, United States of America"
}, {
  destination: "Calgary (and vicinity), Alberta, Canada",
  queries: ["near Calgary Tower", "close to Prince's Island Park", "around Glenbow Museum"],
  original_name: "Calgary",
  id_corrupt: "fine",
  gaia_id: 178245,
  short_name: "Calgary (and vicinity)",
  long_name: "Calgary (and vicinity), Alberta, Canada"
}, {
  destination: "New Jersey, United States of America",
  queries: ["near Liberty State Park", "close to Cape May Lighthouse", "around Princeton University"],
  original_name: "New_Jersey",
  id_corrupt: "fine",
  gaia_id: 232,
  short_name: "New Jersey",
  long_name: "New Jersey, United States of America"
}, {
  destination: "Fayetteville (and vicinity), North Carolina, United States of America",
  queries: ["near Cape Fear Botanical Garden", "close to Airborne and Special Ops Museum", "around Cross Creek Mall"],
  original_name: "Fayetteville",
  id_corrupt: "fine",
  gaia_id: 6046693,
  short_name: "Fayetteville (and vicinity)",
  long_name: "Fayetteville (and vicinity), North Carolina, United States of America"
}, {
  destination: "Los Angeles (and vicinity), California, United States of America",
  queries: ["near Hollywood Walk of Fame", "close to Santa Monica Pier", "around Griffith Observatory"],
  original_name: "Los_Angeles",
  id_corrupt: "fine",
  gaia_id: 178280,
  short_name: "Los Angeles (and vicinity)",
  long_name: "Los Angeles (and vicinity), California, United States of America"
}, {
  destination: "Missouri, United States of America",
  queries: ["near Gateway Arch", "close to Forest Park", "around City Museum"],
  original_name: "Missouri",
  id_corrupt: "fine",
  gaia_id: 227,
  short_name: "Missouri",
  long_name: "Missouri, United States of America"
}, {
  destination: "Oklahoma City (and vicinity), Oklahoma, United States of America",
  queries: ["near Oklahoma City National Memorial", "around Myriad Botanical Gardens", "close to Bricktown Entertainment District"],
  original_name: "Oklahoma_City",
  id_corrupt: "fine",
  gaia_id: 602972,
  short_name: "Oklahoma City (and vicinity)",
  long_name: "Oklahoma City (and vicinity), Oklahoma, United States of America"
}, {
  destination: "Hot Springs, Arkansas, United States of America",
  queries: ["near Hot Springs National Park", "close to Bathhouse Row", "around Garvan Woodland Gardens"],
  original_name: "Hot_Springs",
  id_corrupt: "fine",
  gaia_id: 6058444,
  short_name: "Hot Springs",
  long_name: "Hot Springs, Arkansas, United States of America"
}, {
  destination: "Rapid City, South Dakota, United States of America",
  queries: ["near Mount Rushmore National Memorial", "close to Badlands National Park", "around Crazy Horse Memorial"],
  original_name: "Rapid_City",
  id_corrupt: "fine",
  gaia_id: 6059491,
  short_name: "Rapid City",
  long_name: "Rapid City, South Dakota, United States of America"
}, {
  destination: "Wisconsin, United States of America",
  queries: ["near Milwaukee Art Museum", "close to Lambeau Field", "around Wisconsin Dells"],
  original_name: "Wisconsin",
  id_corrupt: "fine",
  gaia_id: 251,
  short_name: "Wisconsin",
  long_name: "Wisconsin, United States of America"
}, {
  destination: "Guadalajara (and vicinity), Jalisco, Mexico",
  queries: ["near Guadalajara Cathedral", "close to Hospicio Caba\xF1as", "around Tlaquepaque"],
  original_name: "Guadalajara",
  id_corrupt: "fine",
  gaia_id: 1295,
  short_name: "Guadalajara (and vicinity)",
  long_name: "Guadalajara (and vicinity), Jalisco, Mexico"
}, {
  destination: "Cabo San Lucas, Baja California Sur, Mexico",
  queries: ["near El Arco", "close to Playa del Amor", "around Medano Beach"],
  original_name: "Cabo_San_Lucas",
  id_corrupt: "fine",
  gaia_id: 180032,
  short_name: "Cabo San Lucas",
  long_name: "Cabo San Lucas, Baja California Sur, Mexico"
}, {
  destination: "Dayton, Ohio, United States of America",
  queries: ["near National Museum of the US Air Force", "close to Carillon Historical Park", "around Dayton Art Institute"],
  original_name: "Dayton",
  id_corrupt: "fine",
  gaia_id: 602974,
  short_name: "Dayton",
  long_name: "Dayton, Ohio, United States of America"
}, {
  destination: "Florida, United States of America",
  queries: ["near Walt Disney World Resort", "close to South Beach", "around Everglades National Park"],
  original_name: "Florida",
  id_corrupt: "fine",
  gaia_id: 211,
  short_name: "Florida",
  long_name: "Florida, United States of America"
}, {
  destination: "Shreveport, Louisiana, United States of America",
  queries: ["near R.W. Norton Art Gallery", "close to Red River District", "around Caddo Lake State Park"],
  original_name: "Shreveport",
  id_corrupt: "fine",
  gaia_id: 602872,
  short_name: "Shreveport",
  long_name: "Shreveport, Louisiana, United States of America"
}, {
  destination: "Eugene, Oregon, United States of America",
  queries: ["Near University of Oregon", "Close to Willamette River", "Around 5th Street Public Market"],
  original_name: "Eugene",
  id_corrupt: "fine",
  gaia_id: 602875,
  short_name: "Eugene",
  long_name: "Eugene, Oregon, United States of America"
}, {
  destination: "Montego Bay, Saint James, Jamaica",
  queries: ["Near Doctor's Cave Beach", "Close to Rose Hall Great House", "Around Montego Bay Marine Park"],
  original_name: "Montego_Bay",
  id_corrupt: "fine",
  gaia_id: 180106,
  short_name: "Montego Bay",
  long_name: "Montego Bay, Saint James, Jamaica"
}, {
  destination: "Whistler, British Columbia, Canada",
  queries: ["Near Whistler Blackcomb", "Close to Lost Lake Park", "Around Whistler Village"],
  original_name: "Whistler",
  id_corrupt: "fine",
  gaia_id: 4115,
  short_name: "Whistler",
  long_name: "Whistler, British Columbia, Canada"
}, {
  destination: "Tuscaloosa, Alabama, United States of America",
  queries: ["Near University of Alabama", "Close to Bryant-Denny Stadium", "Around Tuscaloosa Riverwalk"],
  original_name: "Tuscaloosa",
  id_corrupt: "fine",
  gaia_id: 3390,
  short_name: "Tuscaloosa",
  long_name: "Tuscaloosa, Alabama, United States of America"
}, {
  destination: "Santa Barbara, California, United States of America",
  queries: ["Near Stearns Wharf", "Close to Santa Barbara Courthouse", "Around Lotusland"],
  original_name: "Santa_Barbara",
  id_corrupt: "fine",
  gaia_id: 602277,
  short_name: "Santa Barbara",
  long_name: "Santa Barbara, California, United States of America"
}, {
  destination: "Memphis (and vicinity), Tennessee, United States of America",
  queries: ["Near Graceland", "Close to Beale Street", "Around Shelby Farms Park"],
  original_name: "Memphis",
  id_corrupt: "fine",
  gaia_id: 178284,
  short_name: "Memphis (and vicinity)",
  long_name: "Memphis (and vicinity), Tennessee, United States of America"
}, {
  destination: "Lynchburg, Virginia, United States of America",
  queries: ["Near Thomas Jefferson's Poplar Forest", "Close to Lynchburg Museum", "Around Old City Cemetery"],
  original_name: "Lynchburg",
  id_corrupt: "fine",
  gaia_id: 2187,
  short_name: "Lynchburg",
  long_name: "Lynchburg, Virginia, United States of America"
}, {
  destination: "Savannah, Georgia, United States of America",
  queries: ["Near Forsyth Park", "Close to River Street", "Around Savannah Historic District"],
  original_name: "Savannah",
  id_corrupt: "fine",
  gaia_id: 6034190,
  short_name: "Savannah",
  long_name: "Savannah, Georgia, United States of America"
}, {
  destination: "San Simeon, California, United States of America",
  queries: ["Near Hearst Castle", "Close to Elephant Seal Rookery", "Around Piedras Blancas Light Station"],
  original_name: "San_Simeon",
  id_corrupt: "fine",
  gaia_id: 6055486,
  short_name: "San Simeon",
  long_name: "San Simeon, California, United States of America"
}, {
  destination: "Atlantic City (and vicinity), New Jersey, United States of America",
  queries: ["Near Atlantic City Boardwalk", "Close to Steel Pier", "Around Absecon Lighthouse"],
  original_name: "Atlantic_City",
  id_corrupt: "fine",
  gaia_id: 602179,
  short_name: "Atlantic City (and vicinity)",
  long_name: "Atlantic City (and vicinity), New Jersey, United States of America"
}, {
  destination: "San Bernardino (and vicinity), California, United States of America",
  queries: ["near San Bernardino National Forest", "close to Lake Arrowhead", "proximity to Big Bear Lake"],
  original_name: "San_Bernardino",
  id_corrupt: "fine",
  gaia_id: 6055931,
  short_name: "San Bernardino (and vicinity)",
  long_name: "San Bernardino (and vicinity), California, United States of America"
}, {
  destination: "Michigan, United States of America",
  queries: ["near Mackinac Bridge", "close to Sleeping Bear Dunes", "proximity to Pictured Rocks National Lakeshore"],
  original_name: "Michigan",
  id_corrupt: "fine",
  gaia_id: 224,
  short_name: "Michigan",
  long_name: "Michigan, United States of America"
}, {
  destination: "Kingston, New York, United States of America",
  queries: ["near Hudson River Maritime Museum", "close to Walkway Over the Hudson State Historic Park", "proximity to Catskill Park"],
  original_name: "Kingston",
  id_corrupt: "fine",
  gaia_id: 6056321,
  short_name: "Kingston",
  long_name: "Kingston, New York, United States of America"
}, {
  destination: "Green Bay, Wisconsin, United States of America",
  queries: ["near Lambeau Field", "close to Bay Beach Wildlife Sanctuary", "proximity to National Railroad Museum"],
  original_name: "Green_Bay",
  id_corrupt: "fine",
  gaia_id: 1374,
  short_name: "Green Bay",
  long_name: "Green Bay, Wisconsin, United States of America"
}, {
  destination: "Steamboat Springs, Colorado, United States of America",
  queries: ["near Steamboat Ski Resort", "close to Fish Creek Falls", "proximity to Yampa River Botanic Park"],
  original_name: "Steamboat_Springs",
  id_corrupt: "fine",
  gaia_id: 3087,
  short_name: "Steamboat Springs",
  long_name: "Steamboat Springs, Colorado, United States of America"
}, {
  destination: "La Crosse, Wisconsin, United States of America",
  queries: ["near Riverside Park", "close to Grandad Bluff", "proximity to Shrine of Our Lady of Guadalupe"],
  original_name: "La_Crosse",
  id_corrupt: "fine",
  gaia_id: 6023344,
  short_name: "La Crosse",
  long_name: "La Crosse, Wisconsin, United States of America"
}, {
  destination: "San Jose, California, United States of America",
  queries: ["near Winchester Mystery House", "close to Municipal Rose Garden", "proximity to Santana Row"],
  original_name: "San_Jose",
  id_corrupt: "fine",
  gaia_id: 602703,
  short_name: "San Jose",
  long_name: "San Jose, California, United States of America"
}, {
  destination: "Helen, Georgia, United States of America",
  queries: ["near Anna Ruby Falls", "close to Unicoi State Park", "proximity to Dukes Creek Falls Trail"],
  original_name: "Helen",
  id_corrupt: "fine",
  gaia_id: 6057994,
  short_name: "Helen",
  long_name: "Helen, Georgia, United States of America"
}, {
  destination: "Utah, United States of America",
  queries: ["near Arches National Park", "close to Bryce Canyon National Park", "proximity to Zion National Park"],
  original_name: "Utah",
  id_corrupt: "fine",
  gaia_id: 246,
  short_name: "Utah",
  long_name: "Utah, United States of America"
}, {
  destination: "Tulsa (and vicinity), Oklahoma, United States of America",
  queries: ["near Philbrook Museum of Art", "close to Gathering Place", "proximity to Turkey Mountain Park"],
  original_name: "Tulsa",
  id_corrupt: "fine",
  gaia_id: 602327,
  short_name: "Tulsa (and vicinity)",
  long_name: "Tulsa (and vicinity), Oklahoma, United States of America"
}, {
  destination: "Allentown, Pennsylvania, United States of America",
  queries: ["near Dorney Park & Wildwater Kingdom", "close to Coca-Cola Park", "around Allentown Art Museum"],
  original_name: "Allentown",
  id_corrupt: "fine",
  gaia_id: 602976,
  short_name: "Allentown",
  long_name: "Allentown, Pennsylvania, United States of America"
}, {
  destination: "Muskegon, Michigan, United States of America",
  queries: ["near USS LST 393", "close to Pere Marquette Park", "around Muskegon Museum of Art"],
  original_name: "Muskegon",
  id_corrupt: "fine",
  gaia_id: 2326,
  short_name: "Muskegon",
  long_name: "Muskegon, Michigan, United States of America"
}, {
  destination: "Gettysburg, Pennsylvania, United States of America",
  queries: ["near Gettysburg National Military Park", "close to Gettysburg Museum and Visitor Center", "around Devil's Den"],
  original_name: "Gettysburg",
  id_corrupt: "fine",
  gaia_id: 6057572,
  short_name: "Gettysburg",
  long_name: "Gettysburg, Pennsylvania, United States of America"
}, {
  destination: "Delaware, United States of America",
  queries: ["near Brandywine Creek State Park", "close to Winterthur Museum, Garden and Library", "around Hagley Museum and Library"],
  original_name: "Delaware",
  id_corrupt: "fine",
  gaia_id: 209,
  short_name: "Delaware",
  long_name: "Delaware, United States of America"
}, {
  destination: "Mount Laurel, New Jersey, United States of America",
  queries: ["near Laurel Acres Park", "close to Coco Key Water Resort", "around Garden State Discovery Museum"],
  original_name: "Mount_Laurel",
  id_corrupt: "fine",
  gaia_id: 6056714,
  short_name: "Mount Laurel",
  long_name: "Mount Laurel, New Jersey, United States of America"
}, {
  destination: "Tucson (and vicinity), Arizona, United States of America",
  queries: ["near Saguaro National Park", "close to Pima Air and Space Museum", "around Arizona-Sonora Desert Museum"],
  original_name: "Tucson",
  id_corrupt: "fine",
  gaia_id: 602986,
  short_name: "Tucson (and vicinity)",
  long_name: "Tucson (and vicinity), Arizona, United States of America"
}, {
  destination: "Anchorage (and vicinity), Alaska, United States of America",
  queries: ["near Tony Knowles Coastal Trail", "close to Alaska Native Heritage Center", "around Anchorage Museum"],
  original_name: "Anchorage",
  id_corrupt: "fine",
  gaia_id: 178230,
  short_name: "Anchorage (and vicinity)",
  long_name: "Anchorage (and vicinity), Alaska, United States of America"
}, {
  destination: "Glenwood Springs, Colorado, United States of America",
  queries: ["near Glenwood Caverns Adventure Park", "close to Hanging Lake Trail", "around Yampah Spa and Vapor Caves"],
  original_name: "Glenwood_Springs",
  id_corrupt: "fine",
  gaia_id: 6056762,
  short_name: "Glenwood Springs",
  long_name: "Glenwood Springs, Colorado, United States of America"
}, {
  destination: "Colorado, United States of America",
  queries: ["near Garden of the Gods", "close to Red Rocks Amphitheatre", "around Mesa Verde National Park"],
  original_name: "Colorado",
  id_corrupt: "fine",
  gaia_id: 207,
  short_name: "Colorado",
  long_name: "Colorado, United States of America"
}, {
  destination: "Grand Junction, Colorado, United States of America",
  queries: ["near Colorado National Monument", "close to Museum of the West", "around Grand Mesa National Forest"],
  original_name: "Grand_Junction",
  id_corrupt: "fine",
  gaia_id: 1331,
  short_name: "Grand Junction",
  long_name: "Grand Junction, Colorado, United States of America"
}, {
  destination: "Porto (and vicinity), Porto District, Portugal",
  queries: ["near Ribeira Square", "close to Livraria Lello", "proximity to Clerigos Tower"],
  original_name: "Porto",
  id_corrupt: "fine",
  gaia_id: 603077,
  short_name: "Porto (and vicinity)",
  long_name: "Porto (and vicinity), Porto District, Portugal"
}, {
  destination: "Panama City, Florida, United States of America",
  queries: ["near Shell Island", "close to St. Andrews State Park", "proximity to Pier Park"],
  original_name: "Panama_City",
  id_corrupt: "fine",
  gaia_id: 6023330,
  short_name: "Panama City",
  long_name: "Panama City, Florida, United States of America"
}, {
  destination: "Salem, Oregon, United States of America",
  queries: ["near Willamette Valley Vineyards", "close to Oregon State Capitol", "proximity to Riverfront Park"],
  original_name: "Salem",
  id_corrupt: "fine",
  gaia_id: 602975,
  short_name: "Salem",
  long_name: "Salem, Oregon, United States of America"
}, {
  destination: "Temecula, California, United States of America",
  queries: ["near Old Town Temecula Community Theater", "close to Wilson Creek Winery", "proximity to Temecula Valley Balloon & Wine Festival"],
  original_name: "Temecula",
  id_corrupt: "fine",
  gaia_id: 6034795,
  short_name: "Temecula",
  long_name: "Temecula, California, United States of America"
}, {
  destination: "Alabama, United States of America",
  queries: ["near Gulf State Park", "close to USS Alabama Battleship Memorial Park", "proximity to Birmingham Civil Rights Institute"],
  original_name: "Alabama",
  id_corrupt: "fine",
  gaia_id: 202,
  short_name: "Alabama",
  long_name: "Alabama, United States of America"
}, {
  destination: "Charlottesville, Virginia, United States of America",
  queries: ["near Monticello", "close to University of Virginia", "proximity to Carter Mountain Orchard"],
  original_name: "Charlottesville",
  id_corrupt: "fine",
  gaia_id: 6057012,
  short_name: "Charlottesville",
  long_name: "Charlottesville, Virginia, United States of America"
}, {
  destination: "Louisville (and vicinity), Kentucky, United States of America",
  queries: ["near Churchill Downs", "close to Louisville Mega Cavern", "proximity to Louisville Slugger Museum & Factory"],
  original_name: "Louisville",
  id_corrupt: "fine",
  gaia_id: 603002,
  short_name: "Louisville (and vicinity)",
  long_name: "Louisville (and vicinity), Kentucky, United States of America"
}, {
  destination: "Oregon Coast, Oregon, United States of America",
  queries: ["near Haystack Rock", "close to Cannon Beach", "proximity to Oregon Dunes National Recreation Area"],
  original_name: "Oregon_Coast",
  id_corrupt: "fine",
  gaia_id: 6051538,
  short_name: "Oregon Coast",
  long_name: "Oregon Coast, Oregon, United States of America"
}, {
  destination: "Baltimore (and vicinity), Maryland, United States of America",
  queries: ["near Inner Harbor", "close to National Aquarium", "proximity to Fort McHenry National Monument and Historic Shrine"],
  original_name: "Baltimore",
  id_corrupt: "fine",
  gaia_id: 178235,
  short_name: "Baltimore (and vicinity)",
  long_name: "Baltimore (and vicinity), Maryland, United States of America"
}, {
  destination: "United States of America",
  queries: ["near Statue of Liberty", "close to Grand Canyon", "proximity to Times Square"],
  original_name: "United_States_Of_America",
  id_corrupt: "fine",
  gaia_id: 201,
  short_name: "United States of America",
  long_name: "United States of America"
}, {
  destination: "Scranton, Pennsylvania, United States of America",
  queries: ["near Steamtown National Historic Site", "close to Lackawanna Coal Mine Tour", "by Nay Aug Park"],
  original_name: "Scranton",
  id_corrupt: "fine",
  gaia_id: 6023532,
  short_name: "Scranton",
  long_name: "Scranton, Pennsylvania, United States of America"
}, {
  destination: "New Haven, Connecticut, United States of America",
  queries: ["near Yale University", "close to New Haven Green", "by East Rock Park"],
  original_name: "New_Haven",
  id_corrupt: "fine",
  gaia_id: 180036,
  short_name: "New Haven",
  long_name: "New Haven, Connecticut, United States of America"
}, {
  destination: "Leesburg, Florida, United States of America",
  queries: ["near Venetian Gardens", "close to Lake Griffin State Park", "by Paquette's Historical Farmall Museum"],
  original_name: "Leesburg",
  id_corrupt: "fine",
  gaia_id: 6048231,
  short_name: "Leesburg",
  long_name: "Leesburg, Florida, United States of America"
}, {
  destination: "Georgetown, Colorado, United States of America",
  queries: ["near Georgetown Loop Railroad", "close to Guanella Pass", "by Hamill House Museum"],
  original_name: "Georgetown",
  id_corrupt: "fine",
  gaia_id: 6056756,
  short_name: "Georgetown",
  long_name: "Georgetown, Colorado, United States of America"
}, {
  destination: "Buffalo (and vicinity), New York, United States of America",
  queries: ["near Buffalo and Erie County Botanical Gardens", "close to Delaware Park", "by Buffalo City Hall"],
  original_name: "Buffalo",
  id_corrupt: "fine",
  gaia_id: 602674,
  short_name: "Buffalo (and vicinity)",
  long_name: "Buffalo (and vicinity), New York, United States of America"
}, {
  destination: "La Jolla, California, United States of America",
  queries: ["near La Jolla Cove", "close to Torrey Pines State Natural Reserve", "by Birch Aquarium at Scripps"],
  original_name: "La_Jolla",
  id_corrupt: "fine",
  gaia_id: 6126584,
  short_name: "La Jolla",
  long_name: "La Jolla, California, United States of America"
}, {
  destination: "Santa Rosa, California, United States of America",
  queries: ["near Safari West", "close to Luther Burbank Home and Gardens", "by Russian River Brewing Company"],
  original_name: "Santa_Rosa",
  id_corrupt: "fine",
  gaia_id: 3288,
  short_name: "Santa Rosa",
  long_name: "Santa Rosa, California, United States of America"
}, {
  destination: "Ocala, Florida, United States of America",
  queries: ["near Silver Springs State Park", "close to Ocala National Forest", "by Appleton Museum of Art"],
  original_name: "Ocala",
  id_corrupt: "fine",
  gaia_id: 6190293,
  short_name: "Ocala",
  long_name: "Ocala, Florida, United States of America"
}, {
  destination: "Tulum, Quintana Roo, Mexico",
  queries: ["near Tulum Archaeological Site", "close to Gran Cenote", "by Tulum Beach"],
  original_name: "Tulum",
  id_corrupt: "fine",
  gaia_id: 182189,
  short_name: "Tulum",
  long_name: "Tulum, Quintana Roo, Mexico"
}, {
  destination: "Tokyo (and vicinity), Tokyo Prefecture, Japan",
  queries: ["near Tokyo Disneyland", "close to Senso-ji Temple", "by Tokyo Tower"],
  original_name: "Tokyo",
  id_corrupt: "fine",
  gaia_id: 179900,
  short_name: "Tokyo (and vicinity)",
  long_name: "Tokyo (and vicinity), Tokyo Prefecture, Japan"
}, {
  destination: "Asheville, North Carolina, United States of America",
  queries: ["near Biltmore Estate", "close to Blue Ridge Parkway", "around Downtown Asheville"],
  original_name: "Asheville",
  id_corrupt: "fine",
  gaia_id: 6034866,
  short_name: "Asheville",
  long_name: "Asheville, North Carolina, United States of America"
}, {
  destination: "Cancun, Quintana Roo, Mexico",
  queries: ["near Chichen Itza", "close to Tulum Ruins", "around Playa Delfines"],
  original_name: "Cancun",
  id_corrupt: "fine",
  gaia_id: 935,
  short_name: "Cancun",
  long_name: "Cancun, Quintana Roo, Mexico"
}, {
  destination: "Toronto (and vicinity), Ontario, Canada",
  queries: ["near CN Tower", "close to Royal Ontario Museum", "around Distillery District"],
  original_name: "Toronto",
  id_corrupt: "fine",
  gaia_id: 178314,
  short_name: "Toronto (and vicinity)",
  long_name: "Toronto (and vicinity), Ontario, Canada"
}, {
  destination: "Laguna Beach, California, United States of America",
  queries: ["near Crystal Cove State Park", "close to Heisler Park", "around Main Beach"],
  original_name: "Laguna_Beach",
  id_corrupt: "fine",
  gaia_id: 8384,
  short_name: "Laguna Beach",
  long_name: "Laguna Beach, California, United States of America"
}, {
  destination: "Banff, Alberta, Canada",
  queries: ["near Lake Louise", "close to Banff Gondola", "around Bow Falls"],
  original_name: "Banff",
  id_corrupt: "fine",
  gaia_id: 10550,
  short_name: "Banff",
  long_name: "Banff, Alberta, Canada"
}, {
  destination: "Charleston, South Carolina, United States of America",
  queries: ["near Rainbow Row", "close to Waterfront Park", "around The Battery"],
  original_name: "Charleston",
  id_corrupt: "fine",
  gaia_id: 179997,
  short_name: "Charleston",
  long_name: "Charleston, South Carolina, United States of America"
}, {
  destination: "Iceland",
  queries: ["near Blue Lagoon", "close to Gullfoss Waterfall", "around Hallgrimskirkja Church"],
  original_name: "Iceland",
  id_corrupt: "fine",
  gaia_id: 79,
  short_name: "Iceland",
  long_name: "Iceland"
}, {
  destination: "Sioux Falls, South Dakota, United States of America",
  queries: ["near Falls Park", "close to St. Joseph Cathedral", "around SculptureWalk"],
  original_name: "Sioux_Falls",
  id_corrupt: "fine",
  gaia_id: 6059512,
  short_name: "Sioux Falls",
  long_name: "Sioux Falls, South Dakota, United States of America"
}, {
  destination: "Billings, Montana, United States of America",
  queries: ["near Pictograph Cave State Park", "close to Yellowstone River", "around Moss Mansion"],
  original_name: "Billings",
  id_corrupt: "fine",
  gaia_id: 583,
  short_name: "Billings",
  long_name: "Billings, Montana, United States of America"
}, {
  destination: "Stowe, Vermont, United States of America",
  queries: ["near Stowe Mountain Resort", "close to Ben & Jerry's Factory", "around Trapp Family Lodge"],
  original_name: "Stowe",
  id_corrupt: "fine",
  gaia_id: 6057386,
  short_name: "Stowe",
  long_name: "Stowe, Vermont, United States of America"
}, {
  destination: "State College, Pennsylvania, United States of America",
  queries: ["near Pennsylvania State University", "around Beaver Stadium", "close to Mount Nittany"],
  original_name: "State_College",
  id_corrupt: "fine",
  gaia_id: 6057571,
  short_name: "State College",
  long_name: "State College, Pennsylvania, United States of America"
}, {
  destination: "St. Petersburg - Clearwater (and vicinity), Florida, United States of America",
  queries: ["by Clearwater Beach", "around Sunken Gardens", "close to Dali Museum"],
  original_name: "St_Petersburg_-_Clearwater",
  id_corrupt: "fine",
  gaia_id: 178310,
  short_name: "St. Petersburg - Clearwater (and vicinity)",
  long_name: "St. Petersburg - Clearwater (and vicinity), Florida, United States of America"
}, {
  destination: "Chico, California, United States of America",
  queries: ["near Bidwell Park", "around Sierra Nevada Brewing Company", "close to The National Yo-Yo Museum"],
  original_name: "Chico",
  id_corrupt: "fine",
  gaia_id: 6055356,
  short_name: "Chico",
  long_name: "Chico, California, United States of America"
}, {
  destination: "Georgia, United States of America",
  queries: ["near Centennial Olympic Park", "around Savannah Historic District", "close to Forsyth Park"],
  original_name: "Georgia",
  id_corrupt: "fine",
  gaia_id: 212,
  short_name: "Georgia",
  long_name: "Georgia, United States of America"
}, {
  destination: "Tijuana (and vicinity), Baja California, Mexico",
  queries: ["near Avenida Revolucion", "around Tijuana Cultural Center", "close to Parque Morelos"],
  original_name: "Tijuana",
  id_corrupt: "fine",
  gaia_id: 3439,
  short_name: "Tijuana (and vicinity)",
  long_name: "Tijuana (and vicinity), Baja California, Mexico"
}, {
  destination: "Albany, New York, United States of America",
  queries: ["near New York State Capitol", "around The Egg", "close to Washington Park"],
  original_name: "Albany",
  id_corrupt: "fine",
  gaia_id: 603260,
  short_name: "Albany",
  long_name: "Albany, New York, United States of America"
}, {
  destination: "Providence, Rhode Island, United States of America",
  queries: ["near Brown University", "around WaterFire Providence", "close to Rhode Island State House"],
  original_name: "Providence",
  id_corrupt: "fine",
  gaia_id: 180015,
  short_name: "Providence",
  long_name: "Providence, Rhode Island, United States of America"
}, {
  destination: "Amsterdam (and vicinity), North Holland, Netherlands",
  queries: ["near Anne Frank House", "around Van Gogh Museum", "close to Dam Square"],
  original_name: "Amsterdam",
  id_corrupt: "fine",
  gaia_id: 178229,
  short_name: "Amsterdam (and vicinity)",
  long_name: "Amsterdam (and vicinity), North Holland, Netherlands"
}, {
  destination: "Vancouver (and vicinity), British Columbia, Canada",
  queries: ["near Stanley Park", "around Granville Island", "close to Capilano Suspension Bridge Park"],
  original_name: "Vancouver",
  id_corrupt: "fine",
  gaia_id: 178315,
  short_name: "Vancouver (and vicinity)",
  long_name: "Vancouver (and vicinity), British Columbia, Canada"
}, {
  destination: "Saginaw, Michigan, United States of America",
  queries: ["near The Dow Event Center", "around Children's Zoo at Celebration Square", "close to Japanese Cultural Center"],
  original_name: "Saginaw",
  id_corrupt: "fine",
  gaia_id: 6023389,
  short_name: "Saginaw",
  long_name: "Saginaw, Michigan, United States of America"
}, {
  destination: "Santorini, South Aegean, Greece",
  queries: ["near Oia Castle", "close to Red Beach", "around Fira Town"],
  original_name: "Santorini",
  id_corrupt: "fine",
  gaia_id: 177970,
  short_name: "Santorini",
  long_name: "Santorini, South Aegean, Greece"
}, {
  destination: "Seoul (and vicinity), South Korea",
  queries: ["near Gyeongbokgung Palace", "close to N Seoul Tower", "around Bukchon Hanok Village"],
  original_name: "Seoul",
  id_corrupt: "fine",
  gaia_id: 178308,
  short_name: "Seoul (and vicinity)",
  long_name: "Seoul (and vicinity), South Korea"
}, {
  destination: "Puerto Vallarta, Jalisco, Mexico",
  queries: ["near Malecon Boardwalk", "close to Los Muertos Beach", "around Zona Romantica"],
  original_name: "Puerto_Vallarta",
  id_corrupt: "fine",
  gaia_id: 180016,
  short_name: "Puerto Vallarta",
  long_name: "Puerto Vallarta, Jalisco, Mexico"
}];
var defaultSuggestions = ["free breakfast", "late check-in", "top rated hotels"];
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-sheet-content.tsx
var AISearchSheetContent = function (param) {
  var regionId = param.regionId,
    textInputLabel = param.textInputLabel,
    buttonAriaLabel = param.buttonAriaLabel,
    listTitle = param.listTitle,
    onMenuItemClick = param.onMenuItemClick,
    onTextInputChange = param.onTextInputChange,
    onSubmit = param.onSubmit;
  var _aiSearchSuggestions_find;
  var _React16_useState = _sliced_to_array(React16.useState(""), 2),
    textInputValue = _React16_useState[0],
    setTextInputValue = _React16_useState[1];
  var suggestions = regionId && ((_aiSearchSuggestions_find = aiSearchSuggestions.find(function (suggestion) {
    return suggestion.gaia_id === Number(regionId);
  })) === null || _aiSearchSuggestions_find === void 0 ? void 0 : _aiSearchSuggestions_find.queries) || defaultSuggestions;
  var handleTextInputChange = function (e) {
    onTextInputChange === null || onTextInputChange === void 0 ? void 0 : onTextInputChange();
    setTextInputValue(e.target.value);
  };
  var handleSubmit = function () {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(textInputValue);
    setTextInputValue("");
  };
  var handleKeyDown = function (e) {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex, {
    space: "two",
    alignItems: "center"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem, {
    grow: 1
  }, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSTextInput, {
    id: "aiSearch",
    label: textInputLabel,
    name: "aiSearchDemo",
    value: textInputValue,
    onChange: handleTextInputChange,
    onKeyDown: handleKeyDown,
    icon: "cleanliness"
  }))), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSPrimaryButton3, {
    size: EGDSButtonSize2.MEDIUM,
    onClick: handleSubmit,
    "aria-label": buttonAriaLabel
  }, /* @__PURE__ */React16.createElement(EGDSIcon2, {
    name: "search"
  }))))), /* @__PURE__ */React16.createElement(EGDSSpacing, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSHeading, {
    size: 7
  }, listTitle), /* @__PURE__ */React16.createElement(EGDSSpacing, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React16.createElement("div", null, suggestions.map(function (suggestion) {
    return /* @__PURE__ */React16.createElement(EGDSActionListItem, {
      key: suggestion,
      "aria-label": suggestion
    }, /* @__PURE__ */React16.createElement(EGDSLayoutFlex, {
      alignItems: "center",
      space: "two",
      onClick: function () {
        return onMenuItemClick === null || onMenuItemClick === void 0 ? void 0 : onMenuItemClick(suggestion);
      }
    }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSIcon2, {
      name: "search"
    }))), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSText, null, suggestion)))));
  }))))));
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button-and-sheet.tsx
var AISearchButtonAndSheet = function (param) {
  var regionId = param.regionId,
    dialogAriaLabel = param.dialogAriaLabel,
    onTriggerClick = param.onTriggerClick,
    onMenuItemClick = param.onMenuItemClick,
    onTextInputChange = param.onTextInputChange,
    onSubmit = param.onSubmit;
  var triggerRef = React17.useRef(null);
  var _useDialog = _sliced_to_array(useDialog("ai-search-dialog"), 3),
    isAISearchOpen = _useDialog[0],
    _useDialog_ = _useDialog[1],
    openAISearchDialog = _useDialog_.openDialog,
    AISearchDialogComponent = _useDialog[2];
  var handleTriggerClick = function () {
    onTriggerClick === null || onTriggerClick === void 0 ? void 0 : onTriggerClick();
    openAISearchDialog();
  };
  return /* @__PURE__ */React17.createElement(React17.Fragment, null, /* @__PURE__ */React17.createElement(AISearchButton, {
    onClick: handleTriggerClick,
    domRef: triggerRef
  }), /* @__PURE__ */React17.createElement(EGDSSheetTransition, {
    isVisible: isAISearchOpen
  }, /* @__PURE__ */React17.createElement(AISearchDialogComponent, null, /* @__PURE__ */React17.createElement(EGDSSheet, {
    type: "centered",
    triggerRef: triggerRef,
    isVisible: isAISearchOpen,
    centeredSheetSize: "small",
    ariaLabel: dialogAriaLabel
  }, /* @__PURE__ */React17.createElement(EGDSSheetContent, null, /* @__PURE__ */React17.createElement(AISearchSheetContent, {
    regionId: regionId,
    textInputLabel: "Search this box",
    buttonAriaLabel: "search",
    listTitle: "Try these",
    onMenuItemClick: onMenuItemClick,
    onTextInputChange: onTextInputChange,
    onSubmit: onSubmit
  }))))));
};
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
import React47 from "react";
import { gql as gql44 } from "@apollo/client";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/context/utils.ts
var updateSliderValueForMutex = function (field, action) {
  if ((field === null || field === void 0 ? void 0 : field.__typename) === "ShoppingMutexField") {
    var _field_options;
    var _field_options_map;
    return _object_spread_props(_object_spread({}, field), {
      options: (_field_options_map = (_field_options = field.options) === null || _field_options === void 0 ? void 0 : _field_options.map(function (option) {
        var mutexOption = option.mutexOption;
        if (mutexOption.__typename === "ShoppingRangeField") {
          var _mutexOption_range;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              range: ((_mutexOption_range = mutexOption.range) === null || _mutexOption_range === void 0 ? void 0 : _mutexOption_range.id) === action.id ? _object_spread_props(_object_spread({}, mutexOption.range), {
                selected: action.min !== -1 && action.max !== -1 ? _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: action.min,
                  max: action.max
                }) : _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: mutexOption.range.characteristics.min,
                  max: mutexOption.range.characteristics.max
                })
              }) : mutexOption.range
            })
          });
        }
        if (mutexOption.__typename === "ShoppingRangeTextInputField") {
          var _mutexOption_rangeField;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              rangeField: ((_mutexOption_rangeField = mutexOption.rangeField) === null || _mutexOption_rangeField === void 0 ? void 0 : _mutexOption_rangeField.id) === action.id ? _object_spread_props(_object_spread({}, mutexOption.rangeField), {
                selected: action.min !== -1 && action.max !== -1 ? _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: action.min,
                  max: action.max
                }) : _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: mutexOption.rangeField.characteristics.min,
                  max: mutexOption.rangeField.characteristics.max
                })
              }) : mutexOption.rangeField
            })
          });
        }
        return option;
      })) !== null && _field_options_map !== void 0 ? _field_options_map : null
    });
  }
  return field;
};
var resetSliderValueForMutex = function (field) {
  if ((field === null || field === void 0 ? void 0 : field.__typename) === "ShoppingMutexField") {
    var _field_options;
    var _field_options_map;
    return _object_spread_props(_object_spread({}, field), {
      options: (_field_options_map = (_field_options = field.options) === null || _field_options === void 0 ? void 0 : _field_options.map(function (option) {
        var mutexOption = option.mutexOption;
        if (mutexOption.__typename === "ShoppingRangeField") {
          var _mutexOption_range;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              range: ((_mutexOption_range = mutexOption.range) === null || _mutexOption_range === void 0 ? void 0 : _mutexOption_range.id) ? _object_spread_props(_object_spread({}, mutexOption.range), {
                selected: _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: mutexOption.range.characteristics.min,
                  max: mutexOption.range.characteristics.max
                })
              }) : null
            })
          });
        }
        if (mutexOption.__typename === "ShoppingRangeTextInputField") {
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              rangeField: _object_spread_props(_object_spread({}, mutexOption.rangeField), {
                selected: _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: mutexOption.rangeField.characteristics.min,
                  max: mutexOption.rangeField.characteristics.max
                })
              })
            })
          });
        }
        return option;
      })) !== null && _field_options_map !== void 0 ? _field_options_map : null
    });
  }
  return field;
};
var calculateQuickFilterFields = function (fields) {
  var clearQuickFilterFields = [];
  fields === null || fields === void 0 ? void 0 : fields.forEach(function (field) {
    switch (field.__typename) {
      case "ShoppingStepInputField":
        clearQuickFilterFields.push({
          key: "".concat(field.stepInputId)
        });
        break;
      case "ShoppingRangeField":
        clearQuickFilterFields.push({
          key: field.range.id
        });
        break;
      case "ShoppingMutexField":
        field.options.forEach(function (option) {
          if (option.mutexOption.range) {
            clearQuickFilterFields.push({
              key: "".concat(option.mutexOption.range.id)
            });
          }
          if (option.mutexOption.rangeField) {
            clearQuickFilterFields.push({
              key: "".concat(option.mutexOption.rangeField.id)
            });
          }
        });
        break;
      case "ShoppingRangeTextInputField":
        clearQuickFilterFields.push({
          key: field.fieldId
        });
        break;
      case "ShoppingMultiSelectionField":
      case "ShoppingSelectionField":
        field.options.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId,
            value: option.value
          });
        });
        break;
      case "ShoppingMultiSelectionTileField":
        field.multiOptions.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId,
            value: option.value
          });
        });
        break;
      case "ShoppingMultiSelectionStackedTileField":
        field.multiOptions.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId
          });
        });
        break;
      default:
    }
  });
  return clearQuickFilterFields;
};
// ../internal/src/components/common/button/egds-secondary-button.tsx
import React18 from "react";
import { gql as gql17 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
var __Fragment13 = gql17(_templateObject17(), EGDSButtonFragment);
var EGDSSecondaryButton = function (param) {
  var onClick = param.onClick,
    data = param.data;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_secondary_button";
  var track = useClickTracker7();
  var handleClick = React18.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React18.createElement(UitkSecondaryButton2, {
    id: id,
    onClick: handleClick
  }, primary);
};
EGDSSecondaryButton.displayName = "EGDSSecondaryButton";
EGDSSecondaryButton.fragment = __Fragment13;
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React19 from "react";
import { gql as gql18 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
var __Fragment14 = gql18(_templateObject18(), EGDSButtonFragment);
var EGDSTertiaryButton = function (param) {
  var onClick = param.onClick,
    isFullWidth = param.isFullWidth,
    size = param.size,
    data = param.data,
    isDisabled = param.isDisabled;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    disabled = data.disabled,
    accessibility = data.accessibility,
    analytics = data.analytics,
    icon = data.icon;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
  var track = useClickTracker8();
  var disableState = isDisabled || disabled;
  var handleClick = React19.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React19.createElement(UitkTertiaryButton, {
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
    id: id,
    "data-test-id": id,
    onClick: handleClick,
    disabled: disableState,
    isFullWidth: isFullWidth,
    size: size
  }, icon && /* @__PURE__ */React19.createElement(UitkIcon2, {
    name: icon.id
  }), primary);
};
EGDSTertiaryButton.displayName = "EGDSTertiaryButton";
EGDSTertiaryButton.fragment = __Fragment14;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React22 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React20, { useRef } from "react";
import { gql as gql19 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback } from "uitk-react-form";
import { UitkPill } from "uitk-react-pill";
import { liveAnnounce } from "uitk-react-utils";
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment15 = gql19(_templateObject19(), clientSideAnalyticsFragment, Icon.fragment);
var EGDSBasicPill = function (props) {
  var data = props.data,
    onChange = props.onChange,
    triggerPill = props.triggerPill,
    onClick = props.onClick,
    active = props.active;
  var accessibility = data.accessibility,
    name = data.name,
    primary = data.primary,
    selected = data.selected,
    value = data.value,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    selectedText = data.selectedText;
  var clickTracker = useClickTracker9();
  var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
  var _React20_useState = _sliced_to_array(React20.useState(selected), 2),
    checked = _React20_useState[0],
    setCheckState = _React20_useState[1];
  var pillRef = useRef(false);
  var onPillSelectText = selectedText || primary;
  var handleOnChange = useFormCallback(id, function (event) {
    var _event_currentTarget = event.currentTarget,
      newSelection = _event_currentTarget.checked;
    setCheckState(newSelection);
    if (!pillRef.current) {
      pillRef.current = true;
    }
    if (onChange) {
      onChange(event);
    }
    if (selectAnalytics && newSelection) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
      return event;
    }
    if (deselectAnalytics && !newSelection) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId,
        uisPrimeMessages1 = deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    return event;
  });
  var handleOnClick = function () {
    if (onClick) {
      onClick();
    }
  };
  React20.useEffect(function () {
    if (pillRef.current) {
      liveAnnounce(accessibility !== null && accessibility !== void 0 ? accessibility : void 0);
    }
  }, [accessibility, pillRef.current]);
  React20.useEffect(function () {
    setCheckState(selected);
  }, [selected]);
  return /* @__PURE__ */React20.createElement(UitkPill, {
    checked: checked,
    active: active,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: id,
    name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
    onChange: handleOnChange,
    value: value !== null && value !== void 0 ? value : "",
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    triggerPill: triggerPill,
    onClick: handleOnClick
  }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = _object_spread_props(_object_spread({}, __Fragment15), {
  __typename: "EGDSBasicPill"
});
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React21 from "react";
import { gql as gql20 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback2 } from "uitk-react-form";
import { UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkPill as UitkPill2 } from "uitk-react-pill";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment16 = gql20(_templateObject20(), clientSideAnalyticsFragment, Icon.fragment);
var EGDSBasicTriggerPill = function (props) {
  var data = props.data,
    onChange = props.onChange,
    triggerPill = props.triggerPill,
    onClick = props.onClick,
    domRef = props.domRef,
    active = props.active;
  var id = data.id,
    primary = data.primary,
    selected = data.selected,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    accessibility = data.accessibility;
  var clickTracker = useClickTracker10();
  var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
  var _React21_useState = _sliced_to_array(React21.useState(active || selected), 2),
    checked = _React21_useState[0],
    check = _React21_useState[1];
  React21.useEffect(function () {
    check(active !== null && active !== void 0 ? active : false);
  }, [active]);
  var handleOnClick = useFormCallback2(name, function (event) {
    check(!checked);
    if (onChange) {
      onChange(event);
    }
    if (onClick) {
      onClick();
    }
    if (selectAnalytics && checked) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
      return event;
    }
    if (deselectAnalytics && !checked) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId,
        uisPrimeMessages1 = deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    return event;
  });
  return /* @__PURE__ */React21.createElement(UitkLayoutFlexItem7, {
    shrink: 0
  }, /* @__PURE__ */React21.createElement(UitkPill2, {
    checked: checked,
    active: checked,
    selected: selected,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: name,
    name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
    triggerPill: triggerPill,
    onClick: handleOnClick,
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    domRef: domRef
  }, primary));
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPillFragment";
EGDSBasicTriggerPill.fragment = __Fragment16;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment17 = gql21(_templateObject21(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function (props) {
  var data = props.data;
  switch (data.__typename) {
    case "EGDSBasicPill":
      return /* @__PURE__ */React22.createElement(EGDSBasicPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicTriggerPill":
      return /* @__PURE__ */React22.createElement(EGDSBasicTriggerPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React22.createElement(EGDSBasicRemovablePill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    default:
      return null;
  }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = __Fragment17;
// ../internal/src/components/sort-filter/custom-event-types.ts
var SortAndFiltersCustomEventTypes = /* @__PURE__ */function (SortAndFiltersCustomEventTypes2) {
  SortAndFiltersCustomEventTypes2["CLEAR"] = "clear";
  SortAndFiltersCustomEventTypes2["RESTORE"] = "restore";
  SortAndFiltersCustomEventTypes2["CLEAR_QUICK_FILTERS"] = "clear_quick_filters";
  SortAndFiltersCustomEventTypes2["CLEAR_FILTERS_APPLIED"] = "clear_filters_applied";
  return SortAndFiltersCustomEventTypes2;
}(SortAndFiltersCustomEventTypes || {});
// ../internal/src/components/sort-filter/quick-access-filter-wrappers.tsx
import React23 from "react";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetTransition } from "uitk-react-sheet";
// ../internal/src/components/sort-filter/__private/__fragments/hooks/use-window-size.tsx
import { useEffect, useState } from "react";
var useWindowSize = function () {
  var isClientSide = typeof window === "object";
  var _useState = _sliced_to_array(useState(isClientSide ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {}), 2),
    windowSize = _useState[0],
    setWindowSize = _useState[1];
  var handleWindowResize = function () {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  useEffect(function () {
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return windowSize;
};
// ../internal/src/components/sort-filter/quick-access-filter-wrappers.tsx
var QuickAccessFilterSheetWrapper = function (_param) {
  var children = _param.children,
    DialogComponent = _param.DialogComponent,
    sheetProps = _object_without_properties(_param, ["children", "DialogComponent"]);
  var _triggerRef_current;
  var triggerRef = sheetProps.triggerRef,
    isVisible = sheetProps.isVisible,
    onDismiss = sheetProps.onDismiss,
    lastQuickfilter = sheetProps.lastQuickfilter,
    isCenteredSheet = sheetProps.isCenteredSheet,
    isBottomSheet = sheetProps.isBottomSheet;
  var isSmallViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.SMALL;
  var isMediumViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.MEDIUM;
  var _useWindowSize = useWindowSize(),
    tmp = _useWindowSize.height,
    windowHeight = tmp === void 0 ? 0 : tmp;
  var _triggerRef_current_getBoundingClientRect;
  var _ref = (_triggerRef_current_getBoundingClientRect = triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.getBoundingClientRect()) !== null && _triggerRef_current_getBoundingClientRect !== void 0 ? _triggerRef_current_getBoundingClientRect : {},
    tmp1 = _ref.bottom,
    triggerBottom = tmp1 === void 0 ? 0 : tmp1;
  var maxHeight = Math.max(windowHeight - triggerBottom - 160, 0);
  var popoverSheetProps = {
    position: {
      inline: isMediumViewSize && lastQuickfilter ? "trailing" : "leading",
      block: "trailing"
    },
    liveAnnounceString: "Popover Sheet has opened",
    type: "popover",
    width: 400,
    applyBlockStartMargin: true,
    autoFocus: true,
    autoPosition: false,
    triggerRef: triggerRef,
    isVisible: isVisible,
    onDismiss: onDismiss,
    maxHeight: maxHeight
  };
  var bottomSheetProps = {
    liveAnnounceString: "Bottom has opened",
    type: "bottom",
    isVisible: isVisible,
    triggerRef: triggerRef,
    fullWidth: isMediumViewSize
  };
  var centeredSheetProps = {
    liveAnnounceString: "Centered has opened",
    type: "centered",
    centeredSheetSize: "small",
    isVisible: isVisible,
    triggerRef: triggerRef
  };
  if (isSmallViewSize || isBottomSheet) {
    return /* @__PURE__ */React23.createElement(UitkSheetTransition, {
      isVisible: isVisible
    }, /* @__PURE__ */React23.createElement(DialogComponent, null, /* @__PURE__ */React23.createElement(UitkSheet, _object_spread({}, bottomSheetProps), children)));
  }
  if (isCenteredSheet) {
    return /* @__PURE__ */React23.createElement(UitkSheetTransition, {
      isVisible: isVisible
    }, /* @__PURE__ */React23.createElement(DialogComponent, null, /* @__PURE__ */React23.createElement(UitkSheet, _object_spread({}, centeredSheetProps), children)));
  }
  return /* @__PURE__ */React23.createElement(UitkSheetTransition, {
    isVisible: isVisible
  }, /* @__PURE__ */React23.createElement(UitkSheet, _object_spread({}, popoverSheetProps), children));
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
import React24, { useMemo } from "react";
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-reducer.tsx
var fieldStateReducer = function (state, action) {
  switch (action.type) {
    case "RESET_STATE" /* RESET_STATE_FOR_MUTEX */:
      {
        var field = resetSliderValueForMutex(state.field);
        return _object_spread_props(_object_spread({}, state), {
          field: field
        });
      }
    case "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */:
      {
        var field1 = updateSliderValueForMutex(state.field, action);
        return _object_spread_props(_object_spread({}, state), {
          field: field1
        });
      }
    default:
      return state;
  }
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
var FieldStateContext = React24.createContext({
  state: {}
});
var FieldStateProvider = function (param) {
  var children = param.children,
    field = param.field;
  var _React24_useReducer = _sliced_to_array(React24.useReducer(fieldStateReducer, {
      field: field
    }), 2),
    state = _React24_useReducer[0],
    dispatch = _React24_useReducer[1];
  var fieldStateContext = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /* @__PURE__ */React24.createElement(FieldStateContext.Provider, {
    value: fieldStateContext
  }, children);
};
var useFieldStateContext = function () {
  return React24.useContext(FieldStateContext);
};
// ../internal/src/components/sort-filter/__private/__fragments/dropdown-field.tsx
import React25 from "react";
import { gql as gql22 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback3 } from "uitk-react-form";
import { UitkSelect } from "uitk-react-input";
import { UitkHeading } from "uitk-react-text";
var __Fragment18 = gql22(_templateObject22(), clientSideAnalyticsFragment);
var DropdownField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    onKeyPress = param.onKeyPress,
    onClick = param.onClick,
    resetFilters = param.resetFilters,
    hasNoSectionTitle = param.hasNoSectionTitle;
  var _data_dropdownOptions_find;
  var primary = data.primary,
    secondary = data.secondary,
    dropdownOptions = data.dropdownOptions;
  var _ref;
  var label = (_ref = primary !== null && primary !== void 0 ? primary : secondary) !== null && _ref !== void 0 ? _ref : "";
  var _dropdownOptions_;
  var _ref1 = (_dropdownOptions_ = dropdownOptions[0]) !== null && _dropdownOptions_ !== void 0 ? _dropdownOptions_ : {
      id: ""
    },
    id = _ref1.id,
    firstValue = _ref1.value;
  var defaultValue = Array.isArray(data.dropdownOptions) ? (_data_dropdownOptions_find = data.dropdownOptions.find(function (option) {
    return option.selected;
  })) === null || _data_dropdownOptions_find === void 0 ? void 0 : _data_dropdownOptions_find.value : firstValue;
  var _React25_useState = _sliced_to_array(React25.useState(defaultValue), 2),
    selectedFieldValue = _React25_useState[0],
    setSelectedFieldValue = _React25_useState[1];
  var clickTracker = useClickTracker11();
  var handleChange = useFormCallback3(id, function (event) {
    var selectedOption = dropdownOptions.find(function (value) {
      return value.value === event.currentTarget.value;
    });
    var deselectedOption = dropdownOptions.find(function (value) {
      return value.value === selectedFieldValue;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
      var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics,
        referrerId = _deselectedOption_deselectAnalytics.referrerId,
        linkName = _deselectedOption_deselectAnalytics.linkName,
        uisPrimeMessages = _deselectedOption_deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
      var _selectedOption_selectAnalytics = selectedOption.selectAnalytics,
        referrerId1 = _selectedOption_selectAnalytics.referrerId,
        linkName1 = _selectedOption_selectAnalytics.linkName,
        uisPrimeMessages1 = _selectedOption_selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    setSelectedFieldValue(event.currentTarget.value);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleOnClick = function () {
    var field = {
      name: id
    };
    onClick === null || onClick === void 0 ? void 0 : onClick(field);
  };
  var handleKeyPress = function () {
    onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress();
  };
  React25.useEffect(function () {
    setSelectedFieldValue(defaultValue);
  }, [defaultValue]);
  React25.useEffect(function () {
    if (resetFilters) {
      setSelectedFieldValue(firstValue);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React25.createElement(React25.Fragment, null, hasNoSectionTitle && /* @__PURE__ */React25.createElement(UitkHeading, {
    className: "is-visually-hidden",
    tag: "h4"
  }, label), /* @__PURE__ */React25.createElement(UitkSelect, {
    id: "sort-filter-dropdown-".concat(id),
    value: selectedFieldValue,
    defaultValue: selectedFieldValue,
    name: id,
    label: label,
    emptyState: false,
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    onClick: handleOnClick
  }, dropdownOptions.map(function (param, optionIndex) {
    var primaryOption = param.primary,
      selected = param.selected,
      value = param.value;
    return /* @__PURE__ */React25.createElement("option", {
      key: optionIndex,
      value: value,
      "aria-selected": selected,
      "data-opt-id": value
    }, primaryOption);
  })));
};
DropdownField.displayName = "DropdownField";
DropdownField.fragment = _object_spread_props(_object_spread({}, __Fragment18), {
  __typename: "ShoppingDropdownField"
});
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
import React28 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkParagraph as UitkParagraph3 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field-option.tsx
import React27, { useState as useState2 } from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonToggle } from "uitk-react-button-toggle";
import { useFormCallback as useFormCallback4 } from "uitk-react-form";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
// ../internal/src/components/sort-filter/__private/__fragments/signals/state-utils.ts
var selectedFiltersStateReducer = function (state, action) {
  if (action.type === "SortAndFilterClearAllFilters" /* CLEAR */) {
    return _object_spread_props(_object_spread({}, state), {
      selectedFilters: [],
      isFirstSelectedFilter: false
    });
  }
  if (action.type === "SortAndFilterClearFilterById" /* CLEAR_BY_ID */) {
    var selectedFilters = state.selectedFilters.filter(function (param) {
      var filter = param.filter;
      if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
        return true;
      }
      return filter.id !== action.payload.id;
    });
    return _object_spread_props(_object_spread({}, state), {
      selectedFilters: selectedFilters,
      isFirstSelectedFilter: false
    });
  }
  var payload = action.payload;
  switch (payload.__typename) {
    case "SortAndFilterSelectedFilterPillPayload" /* SELECTED_PILL */:
      {
        var deselectionSignalId = payload.deselectionSignalId,
          filter = payload.filter,
          filterNameResolved = payload.filterNameResolved;
        if (filter.__typename !== "EGDSBasicRemovablePill") {
          return state;
        }
        var filterId = filter.id;
        var selectedFilters1 = state.selectedFilters;
        var filterPillExists = selectedFilters1.some(function (selectedFilter) {
          var _selectedFilter_filter;
          if (((_selectedFilter_filter = selectedFilter.filter) === null || _selectedFilter_filter === void 0 ? void 0 : _selectedFilter_filter.__typename) !== "EGDSBasicRemovablePill") {
            return false;
          }
          return selectedFilter.filter.id === filterId;
        });
        if (filterPillExists) {
          var updatedSelectedFilters = selectedFilters1.map(function (selectedFilter) {
            var filterPill = selectedFilter.filter;
            if ((filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) !== "EGDSBasicRemovablePill") {
              return selectedFilter;
            }
            if (filterPill.id === filterId) {
              return _object_spread_props(_object_spread({}, selectedFilter), {
                filter: _object_spread_props(_object_spread({}, filterPill), {
                  primary: filterNameResolved !== null && filterNameResolved !== void 0 ? filterNameResolved : "",
                  removeAnalytics: filter.removeAnalytics
                })
              });
            }
            return selectedFilter;
          });
          return _object_spread_props(_object_spread({}, state), {
            selectedFilters: updatedSelectedFilters,
            isFirstSelectedFilter: false
          });
        }
        var newFilter = {
          __typename: "ShoppingSelectedFilter",
          filter: _object_spread_props(_object_spread({}, filter), {
            primary: filterNameResolved !== null && filterNameResolved !== void 0 ? filterNameResolved : "",
            removeAnalytics: filter.removeAnalytics,
            disabled: false,
            icon: null
          }),
          emitters: [{
            __typename: "SortAndFilterSignalEmitter",
            signalId: deselectionSignalId !== null && deselectionSignalId !== void 0 ? deselectionSignalId : "",
            condition: "UNSELECTED" /* UNSELECTED */,
            payload: {
              __typename: "SortAndFilterBasicFilterPayload" /* BASIC */,
              filterId: filterId !== null && filterId !== void 0 ? filterId : "",
              type: "REMOVE" /* REMOVE */
            }
          }]
        };
        return _object_spread_props(_object_spread({}, state), {
          isFirstSelectedFilter: selectedFilters1.length === 0,
          selectedFilters: _to_consumable_array(selectedFilters1).concat([newFilter])
        });
      }
    case "SortAndFilterBasicFilterPayload" /* BASIC */:
      {
        switch (payload.type) {
          case "REMOVE" /* REMOVE */:
            return _object_spread_props(_object_spread({}, state), {
              isFirstSelectedFilter: false,
              selectedFilters: state.selectedFilters.filter(function (param) {
                var filter = param.filter;
                if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
                  return true;
                }
                return filter.id !== payload.filterId;
              })
            });
          default:
            return state;
        }
      }
    default:
      return state;
  }
};
var resolveDataValue = function (source, options) {
  switch (source) {
    case "selected.min" /* RANGE_MIN */:
      var _options_rangeOptions;
      return "".concat((_options_rangeOptions = options.rangeOptions) === null || _options_rangeOptions === void 0 ? void 0 : _options_rangeOptions.nextMin);
    case "selected.max" /* RANGE_MAX */:
      var _options_rangeOptions1;
      return "".concat((_options_rangeOptions1 = options.rangeOptions) === null || _options_rangeOptions1 === void 0 ? void 0 : _options_rangeOptions1.nextMax);
    case "stepInput.value" /* STEP_VALUE */:
      var _options_stepInputOptions;
      return "".concat((_options_stepInputOptions = options.stepInputOptions) === null || _options_stepInputOptions === void 0 ? void 0 : _options_stepInputOptions.nextValue);
    case "selected" /* TYPEAHEAD_SELECTED */:
      var _options_typeaheadOptions;
      return "".concat((_options_typeaheadOptions = options.typeaheadOptions) === null || _options_typeaheadOptions === void 0 ? void 0 : _options_typeaheadOptions.selection);
    default:
      return "";
  }
};
var resolveFilterName = function (filterName, options) {
  switch (filterName.__typename) {
    case "EGDSPlainText" /* PLAIN_TEXT */:
      return filterName.text;
    case "EGDSBasicLocalizedText" /* BASIC_LOCALIZED_TEXT */:
      {
        var template = filterName.template,
          models = filterName.models;
        return models.reduce(function (resolvedTemplate, param) {
          var key = param.key,
            source = param.source;
          var value = resolveDataValue(source, options);
          return resolvedTemplate.replace("{".concat(key, "}"), value);
        }, template);
      }
    default:
      return "";
  }
};
var buildPayload = function (payload, condition) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _options_selectionOptions;
  var guardClause = true;
  switch (condition) {
    case "SELECTED" /* SELECTED */:
      if (options.selectionOptions) {
        guardClause = options.selectionOptions.prevChecked;
      } else if (options.typeaheadOptions) {
        guardClause = options.typeaheadOptions.selection === void 0;
      }
      break;
    case "UNSELECTED" /* UNSELECTED */:
      guardClause = false;
      if (options.selectionOptions) {
        guardClause = !options.selectionOptions.prevChecked;
      }
      if (options.typeaheadOptions) {
        guardClause = options.typeaheadOptions.selection !== void 0;
      }
      break;
    case "DEFAULT_TO_NON_DEFAULT" /* DEFAULT_TO_NON_DEFAULT */:
      if (options.rangeOptions) {
        var _options_rangeOptions = options.rangeOptions,
          prevMin = _options_rangeOptions.prevMin,
          nextMin = _options_rangeOptions.nextMin,
          defaultMin = _options_rangeOptions.defaultMin,
          prevMax = _options_rangeOptions.prevMax,
          nextMax = _options_rangeOptions.nextMax,
          defaultMax = _options_rangeOptions.defaultMax;
        guardClause = prevMin !== defaultMin || prevMax !== defaultMax || nextMin === defaultMin && nextMax === defaultMax;
      } else if (options.stepInputOptions) {
        var _options_stepInputOptions = options.stepInputOptions,
          prevValue = _options_stepInputOptions.prevValue,
          defaultValue = _options_stepInputOptions.defaultValue;
        guardClause = prevValue !== defaultValue;
      }
      break;
    case "NON_DEFAULT_TO_NON_DEFAULT" /* NON_DEFAULT_TO_NON_DEFAULT */:
      if (options.rangeOptions) {
        var _options_rangeOptions1 = options.rangeOptions,
          prevMin1 = _options_rangeOptions1.prevMin,
          nextMin1 = _options_rangeOptions1.nextMin,
          defaultMin1 = _options_rangeOptions1.defaultMin,
          prevMax1 = _options_rangeOptions1.prevMax,
          nextMax1 = _options_rangeOptions1.nextMax,
          defaultMax1 = _options_rangeOptions1.defaultMax;
        guardClause = prevMin1 === defaultMin1 && prevMax1 === defaultMax1 || nextMin1 === defaultMin1 && nextMax1 === defaultMax1;
      } else if (options.stepInputOptions) {
        var _options_stepInputOptions1 = options.stepInputOptions,
          prevValue1 = _options_stepInputOptions1.prevValue,
          nextValue = _options_stepInputOptions1.nextValue,
          defaultValue1 = _options_stepInputOptions1.defaultValue;
        guardClause = prevValue1 === defaultValue1 || nextValue === defaultValue1;
      }
      break;
    case "NON_DEFAULT_TO_DEFAULT" /* NON_DEFAULT_TO_DEFAULT */:
      if (options.rangeOptions) {
        var _options_rangeOptions2 = options.rangeOptions,
          nextMin2 = _options_rangeOptions2.nextMin,
          defaultMin2 = _options_rangeOptions2.defaultMin,
          nextMax2 = _options_rangeOptions2.nextMax,
          defaultMax2 = _options_rangeOptions2.defaultMax;
        guardClause = nextMin2 !== defaultMin2 || nextMax2 !== defaultMax2;
      } else if (options.stepInputOptions) {
        var _options_stepInputOptions2 = options.stepInputOptions,
          nextValue1 = _options_stepInputOptions2.nextValue,
          defaultValue2 = _options_stepInputOptions2.defaultValue;
        guardClause = nextValue1 !== defaultValue2;
      }
      break;
    default:
      guardClause = true;
  }
  if (guardClause) {
    return null;
  }
  if (payload.__typename === "SortAndFilterSelectedFilterPillPayload" /* SELECTED_PILL */) {
    var filterNameResolved = resolveFilterName(payload.filterName, options);
    if (payload.filter.__typename === "EGDSBasicRemovablePill" && payload.filter.removeAnalytics) {
      var newReferrerId = payload.filter.removeAnalytics.referrerId;
      if (options.rangeOptions) {
        var _options_rangeOptions3 = options.rangeOptions,
          analyticsMin = _options_rangeOptions3.analyticsMin,
          analyticsMax = _options_rangeOptions3.analyticsMax;
        var minMaxValues = "".concat(analyticsMin, ",").concat(analyticsMax);
        newReferrerId = "".concat(newReferrerId, ".").concat(minMaxValues);
      } else if (options.stepInputOptions) {
        var nextValue2 = options.stepInputOptions.nextValue;
        newReferrerId = "".concat(newReferrerId, ".").concat(nextValue2);
      } else if (options.typeaheadOptions) {
        var selection = options.typeaheadOptions.selection;
        newReferrerId = "".concat(newReferrerId, ".").concat(selection);
      }
      return _object_spread_props(_object_spread({}, payload), {
        filter: _object_spread_props(_object_spread({}, payload.filter), {
          removeAnalytics: _object_spread_props(_object_spread({}, payload.filter.removeAnalytics), {
            referrerId: newReferrerId
          })
        }),
        filterNameResolved: filterNameResolved
      });
    }
    return _object_spread_props(_object_spread({}, payload), {
      filterNameResolved: filterNameResolved
    });
  }
  return _object_spread_props(_object_spread({}, payload), {
    prevChecked: (_options_selectionOptions = options.selectionOptions) === null || _options_selectionOptions === void 0 ? void 0 : _options_selectionOptions.prevChecked
  });
};
// ../internal/src/components/sort-filter/__private/__fragments/hooks/use-signal-emitter.tsx
import { useCallback } from "react";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
var useSignalEmitter = function () {
  var publishSignal = useSignalPublisher().publishSignal;
  return useCallback(function (emitters, options) {
    emitters.forEach(function (param) {
      var signalId = param.signalId,
        condition = param.condition,
        payload = param.payload;
      var newPayload = buildPayload(payload, condition, options);
      if (newPayload) {
        publishSignal({
          type: signalId,
          payload: newPayload
        });
      }
    });
  }, [publishSignal]);
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/signal-subscriber.tsx
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
var SignalSubscriber = function (param) {
  var subscription = param.subscription;
  useSignalSubscriber(subscription);
  return null;
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
import { gql as gql25 } from "@apollo/client";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql23 } from "@apollo/client";
var TemplateModelFragment = gql23(_templateObject23());
var EGDSBasicLocalizedTextFragment = gql23(_templateObject24(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql23(_templateObject25(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql23(_templateObject26(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql23(_templateObject27(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/common/egds-text/egds-plain-text.tsx
import React26 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment = gql24(_templateObject28());
var EGDSPlainText = function (param) {
  var data = param.data;
  return /* @__PURE__ */React26.createElement(UitkText, null, data.text);
};
EGDSPlainText.fragment = fragment;
EGDSPlainText.displayName = "EGDSParagraph";
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
var ReceiverFragment = gql25(_templateObject29());
var EmitterFragment = gql25(_templateObject30(), clientSideAnalyticsFragment, EGDSPlainText.fragment, EGDSBasicLocalizedTextFragment, EGDSBasicRemovablePill.fragment);
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field-option.tsx
var __Fragment19 = gql26(_templateObject31(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment, Icon.fragment);
var MultiSelectionStackedTileFieldOptionSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */) {
          switch (payload.type) {
            case "REMOVE" /* REMOVE */:
              setChecked(false);
              break;
            case "OPTION" /* OPTION */:
              setChecked(!payload.prevChecked);
              break;
            default:
          }
        }
      }
    };
    return /* @__PURE__ */React27.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MultiSelectionStackedTileFieldOption = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters;
  var fieldId = data.fieldId,
    primary = data.primary,
    selected = data.selected,
    value = data.value,
    icon = data.icon,
    accessibility = data.accessibility,
    disabled = data.disabled,
    __typename = data.__typename,
    receivers = data.receivers,
    emitters = data.emitters;
  var _useState2 = _sliced_to_array(useState2(selected), 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var track = useClickTracker12();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback4(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    if (emitters) {
      var selectionOptions = {
        prevChecked: checked
      };
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        selectionOptions: selectionOptions
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  React27.useEffect(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, receivers && /* @__PURE__ */React27.createElement(MultiSelectionStackedTileFieldOptionSubscriptions, {
    receivers: receivers,
    setChecked: setChecked
  }), /* @__PURE__ */React27.createElement(UitkButtonToggle, _object_spread_props(_object_spread({
    key: "".concat(fieldId, "-").concat(value),
    name: fieldId,
    id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
    value: value,
    checked: checked,
    disabled: disabled
  }, icon ? {
    icon: icon === null || icon === void 0 ? void 0 : icon.id
  } : {}), {
    labelText: primary,
    altText: accessibility || "",
    iconSize: UitkIconSize2.EXTRA_SMALL,
    onChange: handleChange
  })));
};
MultiSelectionStackedTileFieldOption.displayName = "MultiSelectionStackedTileFieldOption";
MultiSelectionStackedTileFieldOption.fragment = __Fragment19;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
var __Fragment20 = gql27(_templateObject32(), MultiSelectionStackedTileFieldOption.fragment);
var MultiSelectionStackedTileField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters;
  var multiOptions = data.multiOptions,
    primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React28.createElement("fieldset", null, /* @__PURE__ */React28.createElement("legend", null, primary && /* @__PURE__ */React28.createElement(UitkSpacing6, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React28.createElement(UitkHeading2, {
    tag: "h4",
    size: 7
  }, primary))), secondary && /* @__PURE__ */React28.createElement(UitkParagraph3, null, secondary), multiOptions && /* @__PURE__ */React28.createElement(UitkSpacing6, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React28.createElement(UitkButtonToggleGroup, {
    wrapButtons: true
  }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function (option, i) {
    return (
      /**
      * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
      */ /* @__PURE__ */
      React28.createElement(MultiSelectionStackedTileFieldOption, {
        resetFilters: resetFilters,
        data: option,
        key: "".concat(i, "-").concat(option.selected),
        onSelectedField: onSelectedField
      })
    );
  }))));
};
MultiSelectionStackedTileField.displayName = "MultiSelectionStackedTileField";
MultiSelectionStackedTileField.fragment = _object_spread_props(_object_spread({}, __Fragment20), {
  __typename: "ShoppingMultiSelectionStackedTileField"
});
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
import React30 from "react";
import { gql as gql29 } from "@apollo/client";
import { UitkButtonToggleGroup as UitkButtonToggleGroup2 } from "uitk-react-button-toggle";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkParagraph as UitkParagraph4 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field-option.tsx
import React29, { useState as useState3 } from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonToggle as UitkButtonToggle2 } from "uitk-react-button-toggle";
import { useFormCallback as useFormCallback5 } from "uitk-react-form";
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
var __Fragment21 = gql28(_templateObject33(), clientSideAnalyticsFragment, Icon.fragment, ReceiverFragment, EmitterFragment);
var MultiSelectionTileFieldOptionSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked;
  return /* @__PURE__ */React29.createElement(React29.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */) {
          switch (payload.type) {
            case "REMOVE" /* REMOVE */:
              setChecked(false);
              break;
            case "OPTION" /* OPTION */:
              setChecked(!payload.prevChecked);
              break;
            default:
          }
        }
      }
    };
    return /* @__PURE__ */React29.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MultiSelectionTileFieldOption = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    selected = data.selected,
    value = data.value,
    icon = data.icon,
    accessibility = data.accessibility,
    disabled = data.disabled,
    __typename = data.__typename,
    emitters = data.emitters,
    receivers = data.receivers;
  var _useState3 = _sliced_to_array(useState3(selected), 2),
    checked = _useState3[0],
    setChecked = _useState3[1];
  var track = useClickTracker13();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback5(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var selectionOptions = {
      prevChecked: checked
    };
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        selectionOptions: selectionOptions
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  React29.useEffect(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React29.createElement(React29.Fragment, null, receivers && /* @__PURE__ */React29.createElement(MultiSelectionTileFieldOptionSubscriptions, {
    receivers: receivers,
    setChecked: setChecked
  }), /* @__PURE__ */React29.createElement(UitkButtonToggle2, _object_spread_props(_object_spread({
    key: "".concat(fieldId, "-").concat(value),
    name: fieldId,
    id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
    value: value,
    checked: checked,
    disabled: disabled
  }, icon ? {
    icon: icon === null || icon === void 0 ? void 0 : icon.id
  } : {}), {
    labelText: primary,
    subLabelText: secondary || "",
    altText: accessibility || "",
    iconSize: UitkIconSize3.EXTRA_SMALL,
    onChange: handleChange,
    stacked: true
  })));
};
MultiSelectionTileFieldOption.displayName = "MultiSelectionTileFieldOption";
MultiSelectionTileFieldOption.fragment = __Fragment21;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
var __Fragment22 = gql29(_templateObject34(), MultiSelectionTileFieldOption.fragment);
var MultiSelectionTileField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters;
  var multiOptions = data.multiOptions,
    primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React30.createElement("fieldset", null, /* @__PURE__ */React30.createElement("legend", null, primary && /* @__PURE__ */React30.createElement(UitkSpacing7, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React30.createElement(UitkHeading3, {
    tag: "h4",
    size: 7
  }, primary))), secondary && /* @__PURE__ */React30.createElement(UitkParagraph4, null, secondary), multiOptions && /* @__PURE__ */React30.createElement(UitkSpacing7, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React30.createElement(UitkButtonToggleGroup2, {
    wrapButtons: true
  }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function (option, i) {
    return (
      /**
      * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
      */ /* @__PURE__ */
      React30.createElement(MultiSelectionTileFieldOption, {
        data: option,
        key: "".concat(i, "-").concat(option.selected),
        onSelectedField: onSelectedField,
        resetFilters: resetFilters
      })
    );
  }))));
};
MultiSelectionTileField.displayName = "MultiSelectionTileField";
MultiSelectionTileField.fragment = _object_spread_props(_object_spread({}, __Fragment22), {
  __typename: "ShoppingMultiSelectionTileField"
});
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
import React34 from "react";
import { gql as gql33 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
import React33, { useEffect as useEffect2, useState as useState4 } from "react";
import { gql as gql32 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
import { useFormCallback as useFormCallback6 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function (value, handler, inputType) {
  var event = new CustomEvent("change");
  var input = document.createElement("input");
  if (inputType) {
    input.type = inputType;
  }
  input.value = value;
  var changeListener = function (inputEvent) {
    handler(inputEvent);
  };
  input.addEventListener("change", changeListener);
  input.dispatchEvent(event);
  input.removeEventListener("change", changeListener);
};
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React32 from "react";
import { gql as gql31 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic/mark.tsx
import React31 from "react";
import { gql as gql30 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment2 = gql30(_templateObject35());
var Mark = function (param) {
  var data = param.data,
    className = param.className;
  return /* @__PURE__ */React31.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id
  });
};
Mark.displayName = "Mark";
Mark.fragment = _object_spread_props(_object_spread({}, fragment2), {
  __typename: "Mark"
});
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
var fragment3 = gql31(_templateObject36(), Mark.fragment);
var UIGraphic = function (param) {
  var data = param.data,
    markOptions = param.markOptions;
  switch (data.__typename) {
    case "Mark":
      return /* @__PURE__ */React32.createElement(Mark, _object_spread({
        data: data
      }, markOptions));
    default:
      return null;
  }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment3;
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
var __Fragment23 = gql32(_templateObject37(), clientSideAnalyticsFragment, UIGraphic.fragment, ReceiverFragment, EmitterFragment);
var MultiSelectionOptionFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked,
    setTriggerInputChange = param.setTriggerInputChange;
  return /* @__PURE__ */React33.createElement(React33.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */) {
          switch (payload.type) {
            case "REMOVE" /* REMOVE */:
              setChecked(false);
              setTriggerInputChange(true);
              break;
            case "OPTION" /* OPTION */:
              setChecked(!payload.prevChecked);
              break;
            default:
          }
        }
      }
    };
    return /* @__PURE__ */React33.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MultiSelectionOptionField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    ignoreSignals = param.ignoreSignals,
    domRef = param.domRef;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    selected = data.selected,
    value = data.value,
    description = data.description,
    emitters = data.emitters,
    receivers = data.receivers,
    disabled = data.disabled,
    graphic = data.graphic,
    accessibility = data.accessibility;
  var _useState4 = _sliced_to_array(useState4(selected), 2),
    checked = _useState4[0],
    setChecked = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(false), 2),
    triggerInputChange = _useState41[0],
    setTriggerInputChange = _useState41[1];
  var inputFieldWithSelectionFormCallback = useFormCallback6(fieldId, function (event) {
    return event;
  });
  var uniqueFieldId = React33.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var emitSignal = useSignalEmitter();
  var track = useClickTracker14();
  var handleChange = useFormCallback6(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var selectionOptions = {
      prevChecked: checked
    };
    if (emitters && !ignoreSignals) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        selectionOptions: selectionOptions
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  useEffect2(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  useEffect2(function () {
    setChecked(selected);
  }, [selected]);
  useEffect2(function () {
    if (triggerInputChange) {
      triggerInputChangeEvent(value, inputFieldWithSelectionFormCallback, "checkbox" /* CHECKBOX */);
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  return /* @__PURE__ */React33.createElement(React33.Fragment, null, receivers && /* @__PURE__ */React33.createElement(MultiSelectionOptionFieldSubscriptions, {
    receivers: receivers,
    setChecked: setChecked,
    setTriggerInputChange: setTriggerInputChange
  }), /* @__PURE__ */React33.createElement(UitkLayoutFlex6, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React33.createElement(UitkSpacing8, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React33.createElement(UitkLayoutFlexItem8, {
    grow: 1
  }, /* @__PURE__ */React33.createElement("div", null, /* @__PURE__ */React33.createElement(UitkCheckbox, {
    id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
    name: fieldId,
    value: value,
    checked: checked,
    description: description !== null && description !== void 0 ? description : "",
    onChange: handleChange,
    disabled: disabled,
    a11yLabel: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    domRef: domRef
  }, graphic && /* @__PURE__ */React33.createElement(UIGraphic, {
    data: graphic
  }), " ", primary)))), secondary && /* @__PURE__ */React33.createElement(UitkLayoutFlexItem8, {
    shrink: 0
  }, /* @__PURE__ */React33.createElement(UitkText2, null, secondary))));
};
MultiSelectionOptionField.displayName = "MultiSelectionOptionField";
MultiSelectionOptionField.fragment = __Fragment23;
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
var __Fragment24 = gql33(_templateObject38(), clientSideAnalyticsFragment, MultiSelectionOptionField.fragment);
var MultiSelectionField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    ignoreSignals = param.ignoreSignals;
  var _data_options, _data_options1, _data_options2;
  var primary = data.primary,
    secondary = data.secondary,
    expando = data.expando,
    options = data.options,
    fieldId = data.fieldId;
  var firstUnexpandedOptionRef = React34.useRef(null);
  var _expando_threshold, _ref;
  var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
  var unexpandedOptions = expandoThreshold ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold) : null;
  var getExpandoIsVisibleState = function () {
    return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function (option) {
      return option.selected;
    })));
  };
  var _React34_useState = _sliced_to_array(React34.useState(getExpandoIsVisibleState()), 2),
    expandoIsVisible = _React34_useState[0],
    setExpandoIsVisible = _React34_useState[1];
  var track = useClickTracker15();
  var handleClick = React34.useCallback(function () {
    setExpandoIsVisible(!expandoIsVisible);
    if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
      var _expando_expandAnalytics = expando.expandAnalytics,
        referrerId = _expando_expandAnalytics.referrerId,
        linkName = _expando_expandAnalytics.linkName,
        uisPrimeMessages = _expando_expandAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
      var _expando_collapseAnalytics = expando.collapseAnalytics,
        referrerId1 = _expando_collapseAnalytics.referrerId,
        linkName1 = _expando_collapseAnalytics.linkName,
        uisPrimeMessages1 = _expando_collapseAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
  }, [setExpandoIsVisible, expandoIsVisible]);
  if (!((_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.length)) {
    return null;
  }
  var Base = (expando === null || expando === void 0 ? void 0 : expando.threshold) && ((_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.length) > expando.threshold ? UitkExpandoPeek : React34.Fragment;
  var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
  var expandoProps = (expando === null || expando === void 0 ? void 0 : expando.threshold) && ((_data_options2 = data.options) === null || _data_options2 === void 0 ? void 0 : _data_options2.length) > expando.threshold ? {
    collapseLabel: expando.collapseLabel,
    expandLabel: expando.expandLabel,
    collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
    expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
    items: expandoThreshold,
    isVisible: expandoIsVisible,
    hideScrim: true,
    handleClick: handleClick,
    revealRef: firstUnexpandedOptionRef
  } : {};
  return /* @__PURE__ */React34.createElement("fieldset", {
    "data-stid": fieldId
  }, secondary ? /* @__PURE__ */React34.createElement(React34.Fragment, null, /* @__PURE__ */React34.createElement("legend", {
    className: "is-visually-hidden"
  }, primary), /* @__PURE__ */React34.createElement(UitkSpacing9, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React34.createElement(UitkLayoutFlex7, {
    space: "two"
  }, primary && /* @__PURE__ */React34.createElement(UitkLayoutFlexItem9, {
    grow: 1
  }, /* @__PURE__ */React34.createElement(UitkHeading4, {
    tag: "h4",
    size: 7
  }, primary)), secondary && /* @__PURE__ */React34.createElement(UitkLayoutFlexItem9, {
    shrink: 0
  }, /* @__PURE__ */React34.createElement(UitkHeading4, {
    tag: "h4",
    size: 7
  }, secondary))))) : /* @__PURE__ */React34.createElement("legend", null, primary && /* @__PURE__ */React34.createElement(UitkHeading4, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React34.createElement(Experiment, {
    name: "VrBex_Clawback_Filter_Modal_Display_Optimizations"
  }, /* @__PURE__ */React34.createElement(ExperimentControl, null, /* @__PURE__ */React34.createElement(Base, _object_spread({}, expandoProps), options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    var isFirstUnexpandedOption = optionIndex === expandoThreshold;
    return /* @__PURE__ */React34.createElement(UitkLayoutGridItem, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value)
    }, /* @__PURE__ */React34.createElement(MultiSelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      data: option,
      resetFilters: resetFilters,
      onSelectedField: onSelectedField,
      ignoreSignals: ignoreSignals,
      domRef: isFirstUnexpandedOption ? firstUnexpandedOptionRef : void 0
    }));
  }))), /* @__PURE__ */React34.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React34.createElement(Base, _object_spread({}, expandoProps), /* @__PURE__ */React34.createElement(UitkLayoutGrid2, {
    columns: options && (options === null || options === void 0 ? void 0 : options.length) >= 2 ? 2 : 1,
    alignContent: "start",
    alignItems: "start"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    var isFirstUnexpandedOption = optionIndex === expandoThreshold;
    return /* @__PURE__ */React34.createElement(UitkLayoutGridItem, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value)
    }, /* @__PURE__ */React34.createElement(MultiSelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      data: option,
      resetFilters: resetFilters,
      onSelectedField: onSelectedField,
      ignoreSignals: ignoreSignals,
      domRef: isFirstUnexpandedOption ? firstUnexpandedOptionRef : void 0
    }));
  })))), /* @__PURE__ */React34.createElement(ExperimentVariant, {
    bucket: 2
  }, /* @__PURE__ */React34.createElement(Base, _object_spread({}, expandoProps), /* @__PURE__ */React34.createElement(UitkLayoutGrid2, {
    columns: options && (options === null || options === void 0 ? void 0 : options.length) >= 2 ? 2 : 1,
    alignContent: "start",
    alignItems: "start"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    var isFirstUnexpandedOption = optionIndex === expandoThreshold;
    return /* @__PURE__ */React34.createElement(UitkLayoutGridItem, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value)
    }, /* @__PURE__ */React34.createElement(MultiSelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      data: option,
      resetFilters: resetFilters,
      onSelectedField: onSelectedField,
      ignoreSignals: ignoreSignals,
      domRef: isFirstUnexpandedOption ? firstUnexpandedOptionRef : void 0
    }));
  }))))));
};
MultiSelectionField.displayName = "MultiSelectionField";
MultiSelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment24), {
  __typename: "ShoppingMultiSelectionField"
});
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
import React40 from "react";
import { gql as gql39 } from "@apollo/client";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { useFormCallback as useFormCallback8 } from "uitk-react-form";
import { UitkRadioButtonGroup as UitkRadioButtonGroup2 } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/range-field.tsx
import React35, { useEffect as useEffect3, useState as useState5 } from "react";
import { gql as gql34 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkSlider } from "uitk-react-slider";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
var __Fragment25 = gql34(_templateObject39(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var RangeFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React35.createElement(React35.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */ && payload.type === "REMOVE" /* REMOVE */) {
          onSignalCallback();
        }
      }
    };
    return /* @__PURE__ */React35.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var RangeField = function (param) {
  var data = param.data,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    _param_shouldFireSignalOnMount = param.shouldFireSignalOnMount,
    shouldFireSignalOnMount = _param_shouldFireSignalOnMount === void 0 ? false : _param_shouldFireSignalOnMount;
  var primary = data.primary,
    range = data.range;
  var _ref = range || {},
    selected = _ref.selected,
    characteristics = _ref.characteristics,
    _ref_id = _ref.id,
    id = _ref_id === void 0 ? "" : _ref_id,
    emitters = _ref.emitters,
    receivers = _ref.receivers,
    minAccessibility = _ref.minAccessibility,
    maxAccessibility = _ref.maxAccessibility;
  var _ref1 = characteristics || {},
    _ref_min = _ref1.min,
    min = _ref_min === void 0 ? 0 : _ref_min,
    _ref_max = _ref1.max,
    max = _ref_max === void 0 ? 0 : _ref_max,
    step = _ref1.step;
  var _ref2 = selected || {},
    initialMin = _ref2.min,
    initialMax = _ref2.max;
  var _useState5 = _sliced_to_array(useState5(initialMin), 2),
    currentMin = _useState5[0],
    setMin = _useState5[1];
  var _useState51 = _sliced_to_array(useState5(initialMax), 2),
    currentMax = _useState51[0],
    setMax = _useState51[1];
  var _useState52 = _sliced_to_array(useState5(false), 2),
    triggerInputChange = _useState52[0],
    setTriggerInputChange = _useState52[1];
  var track = useClickTracker16();
  var unboundedPriceRangeValue = -1;
  var emitSignal = useSignalEmitter();
  var onSignalCallback = React35.useCallback(function () {
    setMin(min);
    setMax(max);
    setTriggerInputChange(true);
  }, [min, max]);
  var formatValue = function (number) {
    var _characteristics_labels;
    var currentLabel = characteristics === null || characteristics === void 0 ? void 0 : (_characteristics_labels = characteristics.labels) === null || _characteristics_labels === void 0 ? void 0 : _characteristics_labels.find(function (param) {
      var value = param.value;
      return value === number;
    });
    var _currentLabel_label;
    return (_currentLabel_label = currentLabel === null || currentLabel === void 0 ? void 0 : currentLabel.label) !== null && _currentLabel_label !== void 0 ? _currentLabel_label : "";
  };
  var handleSliderChange = function (lowerValue, upperValue) {
    var safeLowerValue = upperValue ? lowerValue : min;
    var safeUpperValue = upperValue || lowerValue;
    var rangeOptions = {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      defaultMax: formatValue(max),
      defaultMin: formatValue(min),
      nextMax: formatValue(safeUpperValue),
      nextMin: formatValue(safeLowerValue),
      prevMax: formatValue(currentMax),
      prevMin: formatValue(currentMin)
    };
    var minDistanceBetweenHandles = step && (characteristics === null || characteristics === void 0 ? void 0 : characteristics.minStepDistance) ? step * characteristics.minStepDistance : 0;
    if (minDistanceBetweenHandles === 0 || typeof upperValue === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
          rangeOptions: rangeOptions
        });
      }
      setMin(safeLowerValue);
      setMax(safeUpperValue);
    }
  };
  var handleSliderAfterChange = function (lowerValue, upperValue, event) {
    var safeLowerValue = upperValue ? lowerValue : min;
    var safeUpperValue = upperValue || lowerValue;
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (currentMin === (selected === null || selected === void 0 ? void 0 : selected.min) && currentMax === (selected === null || selected === void 0 ? void 0 : selected.max)) {
      return;
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    var sliderEvent = event;
    if (sliderEvent) {
      sliderEvent.target.checked = !isRangeSetToDefault;
    }
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      }, sliderEvent);
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      }, sliderEvent);
    }
    if (range === null || range === void 0 ? void 0 : range.analytics) {
      track("".concat(range.analytics.referrerId).concat(!isRangeSetToDefault, ".").concat(safeLowerValue, ",").concat(safeUpperValue), range.analytics.linkName, void 0, mapUisMicroMessage(range.analytics.uisPrimeMessages));
    }
  };
  useEffect3(function () {
    if (resetFilters) {
      setMin(min);
      setMax(max);
    }
  }, [resetFilters]);
  useEffect3(function () {
    if (initialMin === min) {
      setMin(min);
    }
    if (initialMax === max) {
      setMax(max);
    }
  }, [initialMin, initialMax]);
  useEffect3(function () {
    if (triggerInputChange) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  useEffect3(function () {
    if (shouldFireSignalOnMount) {
      var rangeOptions = {
        analyticsMax: max,
        analyticsMin: min,
        defaultMax: formatValue(max),
        defaultMin: formatValue(min),
        nextMax: formatValue(selected === null || selected === void 0 ? void 0 : selected.max),
        nextMin: formatValue(selected === null || selected === void 0 ? void 0 : selected.min),
        prevMax: formatValue(currentMax),
        prevMin: formatValue(currentMin)
      };
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        rangeOptions: rangeOptions
      });
    }
  }, [shouldFireSignalOnMount]);
  if (!range) {
    return null;
  }
  return /* @__PURE__ */React35.createElement(React35.Fragment, null, /* @__PURE__ */React35.createElement(RangeFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React35.createElement(UitkSpacing10, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React35.createElement("div", null, /* @__PURE__ */React35.createElement("fieldset", null, /* @__PURE__ */React35.createElement("legend", null, /* @__PURE__ */React35.createElement(UitkHeading5, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React35.createElement(UitkSpacing10, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React35.createElement("div", null, /* @__PURE__ */React35.createElement(UitkSlider, {
    id: id,
    key: "".concat(id, "-shopping-range-field"),
    name: id,
    type: "dual",
    min: min,
    max: max,
    step: step,
    handleChange: handleSliderChange,
    handleAfterChange: handleSliderAfterChange,
    lowerValue: currentMin,
    upperValue: currentMax,
    formatValueForDisplay: formatValue,
    formatSecondaryValueForDisplay: formatValue,
    gap: 0,
    primaryLabel: minAccessibility !== null && minAccessibility !== void 0 ? minAccessibility : void 0,
    secondaryLabel: maxAccessibility !== null && maxAccessibility !== void 0 ? maxAccessibility : void 0
  })))))));
};
RangeField.displayName = "RangeField";
RangeField.fragment = _object_spread_props(_object_spread({}, __Fragment25), {
  __typename: "ShoppingRangeField"
});
// ../internal/src/components/sort-filter/__private/__fragments/range-text-input-field.tsx
import React36, { useEffect as useEffect4, useState as useState6 } from "react";
import { gql as gql35 } from "@apollo/client";
import { SliderTextInputs } from "@egds/react-lodging";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
import numberFormatter from "number-formatter";
var __Fragment26 = gql35(_templateObject40(), clientSideAnalyticsFragment, EmitterFragment, ReceiverFragment);
var RangeTextInputFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React36.createElement(React36.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */ && payload.type === "REMOVE" /* REMOVE */) {
          onSignalCallback();
        }
      }
    };
    return /* @__PURE__ */React36.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var RangeTextInputField = function (param) {
  var data = param.data,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    shouldFireSignalOnMount = param.shouldFireSignalOnMount,
    type = param.type;
  var primary = data.primary,
    fieldId = data.fieldId,
    minValueInput = data.minValueInput,
    maxValueInput = data.maxValueInput,
    rangeField = data.rangeField,
    minValueAccessibility = data.minValueAccessibility,
    maxValueAccessibility = data.maxValueAccessibility,
    lowerBoundAccessibility = data.lowerBoundAccessibility,
    upperBoundAccessibility = data.upperBoundAccessibility,
    numberFormat = data.numberFormat,
    minValueAnalytics = data.minValueAnalytics,
    maxValueAnalytics = data.maxValueAnalytics;
  var selected = rangeField.selected,
    characteristics = rangeField.characteristics,
    _rangeField_id = rangeField.id,
    id = _rangeField_id === void 0 ? "" : _rangeField_id,
    emitters = rangeField.emitters,
    receivers = rangeField.receivers;
  var min = characteristics.min,
    max = characteristics.max,
    step = characteristics.step,
    minLabel = characteristics.minLabel,
    maxLabel = characteristics.maxLabel;
  var _useState6 = _sliced_to_array(useState6(false), 2),
    filterPillRemoved = _useState6[0],
    setFilterPillRemoved = _useState6[1];
  var _useState61 = _sliced_to_array(useState6(false), 2),
    triggerInputChange = _useState61[0],
    setTriggerInputChange = _useState61[1];
  var unboundedPriceRangeValue = -1;
  var minDistanceBetweenHandles = step || 0;
  var track = useClickTracker17();
  var emitSignal = useSignalEmitter();
  var onSignalCallback = React36.useCallback(function () {
    setFilterPillRemoved(true);
    setTriggerInputChange(true);
  }, []);
  var _useExperiment = useExperiment("Flexible_Max_Price_Text_Input"),
    flexibleMaxExposure = _useExperiment.exposure;
  var formatValue = function (input) {
    if (input === min) {
      return minLabel;
    }
    if (input === max) {
      return maxLabel;
    }
    if (numberFormat) {
      return numberFormatter(numberFormat, input);
    }
    return input;
  };
  var initialRangeOptions = {
    analyticsMin: min,
    analyticsMax: max,
    defaultMin: formatValue(min),
    defaultMax: formatValue(max),
    nextMin: formatValue(selected === null || selected === void 0 ? void 0 : selected.min),
    nextMax: formatValue(selected === null || selected === void 0 ? void 0 : selected.max),
    prevMin: formatValue(min),
    prevMax: formatValue(max)
  };
  var handleMinChange = function (event, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
          rangeOptions: rangeOptions
        });
      }
    }
    if (minValueAnalytics) {
      track("".concat(minValueAnalytics.referrerId, ".").concat(lower, ".").concat(upper), minValueAnalytics.linkName);
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
    return event;
  };
  var handleMaxChange = function (event, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
          rangeOptions: rangeOptions
        });
      }
    }
    if (maxValueAnalytics) {
      track("".concat(maxValueAnalytics.referrerId, ".").concat(lower, ".").concat(upper), maxValueAnalytics.linkName);
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
    return event;
  };
  var handleRangeSelectionChange = React36.useCallback(function (lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
          rangeOptions: rangeOptions
        });
      }
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
  }, [rangeField, onSelectedField]);
  var handleRangeAfterChange = function (e, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (safeLowerValue === (selected === null || selected === void 0 ? void 0 : selected.min) && safeUpperValue === (selected === null || selected === void 0 ? void 0 : selected.max)) {
      return;
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (rangeField === null || rangeField === void 0 ? void 0 : rangeField.analytics) {
      track("".concat(rangeField.analytics.referrerId).concat(!isRangeSetToDefault, ".").concat(safeLowerValue, ",").concat(safeUpperValue), rangeField.analytics.linkName, void 0, mapUisMicroMessage(rangeField.analytics.uisPrimeMessages));
    }
  };
  useEffect4(function () {
    if (shouldFireSignalOnMount) {
      var rangeOptions = _object_spread({}, initialRangeOptions);
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        rangeOptions: rangeOptions
      });
    }
  }, [shouldFireSignalOnMount]);
  useEffect4(function () {
    if (triggerInputChange) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  if ((minValueAccessibility === null || minValueAccessibility === void 0 ? void 0 : minValueAccessibility.__typename) !== "EGDSBasicLocalizedText" || (maxValueAccessibility === null || maxValueAccessibility === void 0 ? void 0 : maxValueAccessibility.__typename) !== "EGDSBasicLocalizedText") {
    return null;
  }
  var _minValueAccessibility_models, _maxValueAccessibility_models;
  return /* @__PURE__ */React36.createElement(React36.Fragment, null, /* @__PURE__ */React36.createElement(RangeTextInputFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React36.createElement("fieldset", {
    "data-testid": fieldId
  }, primary && /* @__PURE__ */React36.createElement(UitkSpacing11, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React36.createElement("legend", null, /* @__PURE__ */React36.createElement(UitkHeading6, {
    tag: "h4",
    size: 7
  }, primary))), /* @__PURE__ */React36.createElement(SliderTextInputs, {
    onRangeChange: handleRangeSelectionChange,
    onRangeAfterChange: handleRangeAfterChange,
    onMinChange: handleMinChange,
    onMaxChange: handleMaxChange,
    fieldId: fieldId !== null && fieldId !== void 0 ? fieldId : "",
    minValueInput: minValueInput,
    maxValueInput: maxValueInput,
    range: rangeField,
    minValueAccessibility: _object_spread_props(_object_spread({}, minValueAccessibility), {
      models: _to_consumable_array((_minValueAccessibility_models = minValueAccessibility === null || minValueAccessibility === void 0 ? void 0 : minValueAccessibility.models) !== null && _minValueAccessibility_models !== void 0 ? _minValueAccessibility_models : [])
    }),
    maxValueAccessibility: _object_spread_props(_object_spread({}, maxValueAccessibility), {
      models: _to_consumable_array((_maxValueAccessibility_models = maxValueAccessibility === null || maxValueAccessibility === void 0 ? void 0 : maxValueAccessibility.models) !== null && _maxValueAccessibility_models !== void 0 ? _maxValueAccessibility_models : [])
    }),
    lowerBoundAccessibility: lowerBoundAccessibility !== null && lowerBoundAccessibility !== void 0 ? lowerBoundAccessibility : "",
    upperBoundAccessibility: upperBoundAccessibility !== null && upperBoundAccessibility !== void 0 ? upperBoundAccessibility : "",
    numberFormat: numberFormat !== null && numberFormat !== void 0 ? numberFormat : "",
    resetFilters: filterPillRemoved || resetFilters,
    type: type !== null && type !== void 0 ? type : primary,
    allowUserMax: flexibleMaxExposure.bucket === 1
  })));
};
RangeTextInputField.displayName = "RangeTextInputField";
RangeTextInputField.fragment = _object_spread_props(_object_spread({}, __Fragment26), {
  __typename: "ShoppingRangeTextInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
import React38 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek as UitkExpandoPeek2 } from "uitk-react-expando";
import { useFormCallback as useFormCallback7 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/selection-option-field.tsx
import React37 from "react";
import { gql as gql36 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkRadioButton } from "uitk-react-radio-button";
import { UitkText as UitkText3 } from "uitk-react-text";
var __Fragment27 = gql36(_templateObject41(), clientSideAnalyticsFragment);
var SelectionOptionField = function (param) {
  var data = param.data;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    disabled = data.disabled,
    value = data.value;
  var uniqueFieldId = React37.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  return /* @__PURE__ */React37.createElement(UitkLayoutFlex8, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React37.createElement(UitkLayoutFlexItem10, {
    grow: 1
  }, /* @__PURE__ */React37.createElement("div", null, /* @__PURE__ */React37.createElement(UitkRadioButton, {
    name: fieldId,
    disabled: disabled,
    id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
    value: value
  }, primary))), secondary && /* @__PURE__ */React37.createElement(UitkLayoutFlexItem10, {
    shrink: 0
  }, /* @__PURE__ */React37.createElement(UitkText3, null, secondary)));
};
SelectionOptionField.displayName = "SelectionOptionField";
SelectionOptionField.fragment = __Fragment27;
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
var __Fragment28 = gql37(_templateObject42(), clientSideAnalyticsFragment, SelectionOptionField.fragment);
var SelectionFieldSubscriptions = function (param) {
  var options = param.options,
    setSelectedFieldValue = param.setSelectedFieldValue;
  var _options_find;
  var defaultValue = Array.isArray(options) ? (_options_find = options.find(function (option) {
    return option.selected;
  })) === null || _options_find === void 0 ? void 0 : _options_find.value : "";
  var receivers = options === null || options === void 0 ? void 0 : options.map(function (option) {
    var _option_receivers;
    return (_option_receivers = option.receivers) !== null && _option_receivers !== void 0 ? _option_receivers : [];
  }).flat();
  return /* @__PURE__ */React38.createElement(React38.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        switch (payload.type) {
          case "OPTION" /* OPTION */:
            setSelectedFieldValue(payload.filterId);
            break;
          case "REMOVE" /* REMOVE */:
            setSelectedFieldValue(defaultValue);
            break;
          default:
        }
      }
    };
    return /* @__PURE__ */React38.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var SelectionField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters;
  var _options_find, _options_;
  var primary = data.primary,
    secondary = data.secondary,
    expando = data.expando,
    options = data.options;
  var _expando_threshold, _ref;
  var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
  var unexpandedOptions = expandoThreshold ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold) : null;
  var getExpandoIsVisibleState = function () {
    return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function (option) {
      return option.selected;
    })));
  };
  var defaultValue = Array.isArray(options) ? (_options_find = options.find(function (option) {
    return option.selected;
  })) === null || _options_find === void 0 ? void 0 : _options_find.value : "";
  var _React38_useState = _sliced_to_array(React38.useState(defaultValue), 2),
    selectedFieldValue = _React38_useState[0],
    setSelectedFieldValue = _React38_useState[1];
  var _React38_useState1 = _sliced_to_array(React38.useState(getExpandoIsVisibleState()), 2),
    expandoIsVisible = _React38_useState1[0],
    setExpandoIsVisible = _React38_useState1[1];
  var emitSignal = useSignalEmitter();
  var track = useClickTracker18();
  var fieldId = (options === null || options === void 0 ? void 0 : options.length) && options[0] ? options[0].fieldId : "";
  var handleChange = useFormCallback7(fieldId, function (event) {
    var _data_options, _data_options1;
    var deselectedOption = (_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.find(function (option) {
      return option.value === selectedFieldValue;
    });
    var selectedOption = (_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.find(function (option) {
      return option.value === event.currentTarget.value;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
      var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics,
        referrerId = _deselectedOption_deselectAnalytics.referrerId,
        linkName = _deselectedOption_deselectAnalytics.linkName,
        uisPrimeMessages = _deselectedOption_deselectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
      var _selectedOption_selectAnalytics = selectedOption.selectAnalytics,
        referrerId1 = _selectedOption_selectAnalytics.referrerId,
        linkName1 = _selectedOption_selectAnalytics.linkName,
        uisPrimeMessages1 = _selectedOption_selectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var _deselectedOption_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_deselectedOption_emitters = deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.emitters) !== null && _deselectedOption_emitters !== void 0 ? _deselectedOption_emitters : [], {
      selectionOptions: {
        prevChecked: (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.selected) || true
      }
    });
    var _selectedOption_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_selectedOption_emitters = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.emitters) !== null && _selectedOption_emitters !== void 0 ? _selectedOption_emitters : [], {
      selectionOptions: {
        prevChecked: false
      }
    });
    setSelectedFieldValue(event.currentTarget.value);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleClick = React38.useCallback(function () {
    setExpandoIsVisible(!expandoIsVisible);
    if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
      var _expando_expandAnalytics = expando.expandAnalytics,
        referrerId = _expando_expandAnalytics.referrerId,
        linkName = _expando_expandAnalytics.linkName,
        uisPrimeMessages = _expando_expandAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
      var _expando_collapseAnalytics = expando.collapseAnalytics,
        referrerId1 = _expando_collapseAnalytics.referrerId,
        linkName1 = _expando_collapseAnalytics.linkName,
        uisPrimeMessages1 = _expando_collapseAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
  }, [setExpandoIsVisible, expandoIsVisible]);
  React38.useEffect(function () {
    setSelectedFieldValue(defaultValue);
  }, [defaultValue]);
  React38.useEffect(function () {
    var _options_find;
    var defaultOptionValue = options === null || options === void 0 ? void 0 : (_options_find = options.find(function (option) {
      return option.default;
    })) === null || _options_find === void 0 ? void 0 : _options_find.value;
    if (resetFilters) {
      setSelectedFieldValue(defaultOptionValue);
    }
  }, [resetFilters]);
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }
  var Base = (expando === null || expando === void 0 ? void 0 : expando.threshold) && (options === null || options === void 0 ? void 0 : options.length) > expando.threshold ? UitkExpandoPeek2 : React38.Fragment;
  var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
  var expandoProps = (expando === null || expando === void 0 ? void 0 : expando.threshold) && (options === null || options === void 0 ? void 0 : options.length) > expando.threshold ? {
    collapseLabel: expando.collapseLabel,
    expandLabel: expando.expandLabel,
    collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
    expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
    items: expandoThreshold,
    isVisible: expandoIsVisible,
    hideScrim: true,
    handleClick: handleClick
  } : {};
  return /* @__PURE__ */React38.createElement(React38.Fragment, null, options && /* @__PURE__ */React38.createElement(SelectionFieldSubscriptions, {
    options: options,
    setSelectedFieldValue: setSelectedFieldValue
  }), /* @__PURE__ */React38.createElement("fieldset", null, /* @__PURE__ */React38.createElement(UitkSpacing12, {
    margin: {
      blockend: "two"
    }
  }, secondary ? /* @__PURE__ */React38.createElement(React38.Fragment, null, /* @__PURE__ */React38.createElement("legend", {
    className: "is-visually-hidden"
  }, primary), /* @__PURE__ */React38.createElement(UitkLayoutFlex9, {
    space: "two"
  }, primary && /* @__PURE__ */React38.createElement(UitkLayoutFlexItem11, {
    grow: 1
  }, /* @__PURE__ */React38.createElement(UitkHeading7, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React38.createElement(UitkLayoutFlexItem11, {
    shrink: 0
  }, /* @__PURE__ */React38.createElement(UitkHeading7, {
    tag: "h4",
    size: 7
  }, secondary)))) : /* @__PURE__ */React38.createElement("legend", null, primary && /* @__PURE__ */React38.createElement(UitkHeading7, {
    tag: "h4",
    size: 7
  }, primary))), options && /* @__PURE__ */React38.createElement(UitkRadioButtonGroup, {
    key: selectedFieldValue,
    group: ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.fieldId) || "",
    selected: selectedFieldValue,
    onChange: handleChange,
    defaultChecked: true
  }, /* @__PURE__ */React38.createElement(Base, _object_spread({}, expandoProps), options.map(function (option, optionIndex) {
    return /* @__PURE__ */React38.createElement(SelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      data: option
    });
  })))));
};
SelectionField.displayName = "SelectionField";
SelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment28), {
  __typename: "ShoppingSelectionField"
});
// ../internal/src/components/sort-filter/__private/__fragments/step-input-field.tsx
import React39, { useEffect as useEffect5, useState as useState7 } from "react";
import { gql as gql38 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkStepInput } from "uitk-react-step-input";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
var __Fragment29 = gql38(_templateObject43(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var StepInputFieldSubscriptions = function (param) {
  var defaultMin = param.defaultMin,
    receivers = param.receivers,
    setCounter = param.setCounter,
    setTriggerInputChange = param.setTriggerInputChange;
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */ && payload.type === "REMOVE" /* REMOVE */) {
          setCounter(defaultMin);
          setTriggerInputChange(true);
        }
      }
    };
    return /* @__PURE__ */React39.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var StepInputField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    onStepInputChange = param.onStepInputChange;
  var primary = data.primary,
    stepInput = data.stepInput,
    stepInputId = data.stepInputId,
    emitters = data.emitters,
    receivers = data.receivers,
    accessibility = data.accessibility;
  var decreaseText = stepInput.decreaseText,
    increaseText = stepInput.increaseText,
    max = stepInput.max,
    min = stepInput.min,
    label = stepInput.label,
    step = stepInput.step,
    subLabel = stepInput.subLabel,
    value = stepInput.value,
    increaseAnalytics = stepInput.increaseAnalytics,
    decreaseAnalytics = stepInput.decreaseAnalytics;
  var defaultProps = UitkStepInput.defaultProps;
  var tmp = defaultProps.min,
    defaultPropsMin = tmp === void 0 ? 0 : tmp;
  var defaultMin = min !== null && min !== void 0 ? min : defaultPropsMin;
  var _useState7 = _sliced_to_array(useState7(value), 2),
    counter = _useState7[0],
    setCounter = _useState7[1];
  var _useState71 = _sliced_to_array(useState7(false), 2),
    triggerInputChange = _useState71[0],
    setTriggerInputChange = _useState71[1];
  var track = useClickTracker19();
  var emitSignal = useSignalEmitter();
  useEffect5(function () {
    if (resetFilters) {
      setCounter(defaultMin);
    }
  }, [resetFilters]);
  useEffect5(function () {
    if (triggerInputChange) {
      onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", counter);
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  var handleStepInputChange = function (e) {
    var newValue = Number(e.target.value);
    if (increaseAnalytics && newValue > counter) {
      var linkName = increaseAnalytics.linkName,
        referrerId = increaseAnalytics.referrerId,
        uisPrimeMessages = increaseAnalytics.uisPrimeMessages;
      track("".concat(referrerId, ".").concat(newValue !== value), linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (decreaseAnalytics && newValue < counter) {
      var linkName1 = decreaseAnalytics.linkName,
        referrerId1 = decreaseAnalytics.referrerId,
        uisPrimeMessages1 = decreaseAnalytics.uisPrimeMessages;
      track("".concat(referrerId1, ".").concat(newValue !== value), linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var stepInputOptions = {
      prevValue: counter,
      nextValue: newValue,
      defaultValue: defaultMin
    };
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters, {
        stepInputOptions: stepInputOptions
      });
    }
    setCounter(newValue);
    onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", newValue);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
  };
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, receivers && /* @__PURE__ */React39.createElement(StepInputFieldSubscriptions, {
    defaultMin: defaultMin,
    receivers: receivers,
    setCounter: setCounter,
    setTriggerInputChange: setTriggerInputChange
  }), /* @__PURE__ */React39.createElement(UitkHeading8, {
    tag: "h4",
    size: 7
  }, primary), /* @__PURE__ */React39.createElement("fieldset", null, /* @__PURE__ */React39.createElement("legend", {
    className: "is-visually-hidden"
  }, accessibility), /* @__PURE__ */React39.createElement(UitkStepInput, {
    decrementText: decreaseText !== null && decreaseText !== void 0 ? decreaseText : "",
    incrementText: increaseText !== null && increaseText !== void 0 ? increaseText : "",
    max: max !== null && max !== void 0 ? max : defaultProps.max,
    min: defaultMin,
    label: label,
    onChange: handleStepInputChange,
    value: counter,
    step: step || defaultProps.step,
    description: subLabel !== null && subLabel !== void 0 ? subLabel : ""
  })));
};
StepInputField.displayName = "StepInputField";
StepInputField.fragment = _object_spread_props(_object_spread({}, __Fragment29), {
  __typename: "ShoppingStepInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
var __Fragment30 = gql39(_templateObject44(), MultiSelectionField.fragment, RangeField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, SelectionOptionField.fragment, RangeTextInputField.fragment, ReceiverFragment, EmitterFragment);
var validFieldComponents = [DropdownField, MultiSelectionField, RangeField, SelectionField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, RangeTextInputField];
var MutexFieldSubscriptions = function (param) {
  var options = param.options,
    setSelectedFieldValue = param.setSelectedFieldValue;
  var defaultValue = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.selected;
  });
  var mutexValueReceivers = options === null || options === void 0 ? void 0 : options.map(function (option) {
    var _option_mutexValue_receivers;
    return (_option_mutexValue_receivers = option.mutexValue.receivers) !== null && _option_mutexValue_receivers !== void 0 ? _option_mutexValue_receivers : [];
  }).flat();
  return /* @__PURE__ */React40.createElement(React40.Fragment, null, mutexValueReceivers === null || mutexValueReceivers === void 0 ? void 0 : mutexValueReceivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */ && payload.type === "REMOVE" /* REMOVE */) {
          setSelectedFieldValue(defaultValue);
        }
      }
    };
    return /* @__PURE__ */React40.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MutexField = function (props) {
  var data = props.data,
    onFieldClick = props.onFieldClick,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onStepInputChange = props.onStepInputChange,
    onSelectedField = props.onSelectedField,
    resetFilters = props.resetFilters,
    type = props.type,
    isDatedSearch = props.isDatedSearch;
  var _useFieldStateContext = useFieldStateContext(),
    dispatch = _useFieldStateContext.dispatch,
    state = _useFieldStateContext.state;
  var mutexStateData = state.field.__typename === data.__typename ? state.field : data;
  var initSignalOnMount = mutexStateData.primary !== null || mutexStateData.secondary !== null;
  var primary = mutexStateData.primary,
    options = mutexStateData.options,
    mutexId = mutexStateData.mutexId;
  var defaultValue = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.selected;
  });
  var defaultResetOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.default;
  });
  var _React40_useState = _sliced_to_array(React40.useState(defaultValue), 2),
    selectedFieldValue = _React40_useState[0],
    setSelectedFieldValue = _React40_useState[1];
  var fieldId = mutexId || "";
  var track = useClickTracker20();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback8(fieldId, function (event) {
    var deselectedOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
      return option.mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
    });
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
      return option.mutexValue.value === event.currentTarget.value;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.deselectAnalytics) {
      var _deselectedOption_mutexValue_deselectAnalytics = deselectedOption.mutexValue.deselectAnalytics,
        referrerId = _deselectedOption_mutexValue_deselectAnalytics.referrerId,
        linkName = _deselectedOption_mutexValue_deselectAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.selectAnalytics) {
      var _selectedOption_mutexValue_selectAnalytics = selectedOption.mutexValue.selectAnalytics,
        referrerId1 = _selectedOption_mutexValue_selectAnalytics.referrerId,
        linkName1 = _selectedOption_mutexValue_selectAnalytics.linkName;
      track(referrerId1, linkName1);
    }
    var deselectedOptionEmittedSignalValue = {
      prevChecked: (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.selected) || true
    };
    var _deselectedOption_mutexValue_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_deselectedOption_mutexValue_emitters = deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.emitters) !== null && _deselectedOption_mutexValue_emitters !== void 0 ? _deselectedOption_mutexValue_emitters : [], {
      selectionOptions: deselectedOptionEmittedSignalValue
    });
    var selectedOptionEmittedSignalValue = {
      prevChecked: false
    };
    var _selectedOption_mutexValue_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_selectedOption_mutexValue_emitters = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.emitters) !== null && _selectedOption_mutexValue_emitters !== void 0 ? _selectedOption_mutexValue_emitters : [], {
      selectionOptions: selectedOptionEmittedSignalValue
    });
    setSelectedFieldValue(selectedOption);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleRangeSelectionChange = function (selected) {
    var id = selected.id,
      min = selected.min,
      max = selected.max;
    dispatch({
      type: "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */,
      id: id,
      min: min,
      max: max
    });
    onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange(selected);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
  };
  var _useExperiment2 = useExperiment2("Vrbex_NEW_Price_withTextEntry"),
    newPriceSliderExposure = _useExperiment2.exposure,
    newPriceSliderExperiment = _useExperiment2.logExperiment;
  React40.useEffect(function () {
    if (newPriceSliderExposure) {
      newPriceSliderExperiment(newPriceSliderExposure);
    }
  }, [newPriceSliderExposure, newPriceSliderExperiment]);
  var _useExperiment21 = useExperiment2("VrBex_Default_Pricing_Filter"),
    defaultPricingExposure = _useExperiment21.exposure,
    defaultPricingExperiment = _useExperiment21.logExperiment;
  React40.useEffect(function () {
    if (defaultPricingExposure && isDatedSearch) {
      defaultPricingExperiment(defaultPricingExposure);
    }
  }, [defaultPricingExposure, defaultPricingExperiment, isDatedSearch]);
  React40.useEffect(function () {
    if (resetFilters) {
      dispatch({
        type: "RESET_STATE" /* RESET_STATE_FOR_MUTEX */
      });
      if (defaultPricingExposure.bucket === 1) {
        setSelectedFieldValue(defaultResetOption);
      } else {
        setSelectedFieldValue(defaultValue);
      }
    }
  }, [resetFilters]);
  if (!options) {
    return null;
  }
  return /* @__PURE__ */React40.createElement(React40.Fragment, null, options && /* @__PURE__ */React40.createElement(MutexFieldSubscriptions, {
    options: options,
    setSelectedFieldValue: setSelectedFieldValue
  }), /* @__PURE__ */React40.createElement("fieldset", {
    "data-testid": fieldId
  }, /* @__PURE__ */React40.createElement("legend", null, primary && /* @__PURE__ */React40.createElement(UitkSpacing13, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React40.createElement(UitkHeading9, {
    "data-testid": primary,
    tag: "h4",
    size: 7
  }, primary))), options && /* @__PURE__ */React40.createElement(UitkRadioButtonGroup2, {
    selected: selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value,
    key: defaultPricingExposure.bucket === 1 ? selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value : "",
    "data-testid": fieldId,
    onChange: handleChange,
    group: fieldId,
    legendLabel: " ",
    defaultChecked: true
  }, options.map(function (mutexOption, mutexOptionIndex) {
    return /* @__PURE__ */React40.createElement(SelectionOptionField, {
      key: "option-".concat(mutexOption.mutexValue.primary, "-").concat(mutexOptionIndex),
      data: mutexOption.mutexValue
    });
  })), options.map(function (param, optionIndex) {
    var mutexOption = param.mutexOption,
      mutexValue = param.mutexValue;
    var Field = validFieldComponents.find(function (component) {
      return component.fragment.__typename === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexOption.__typename);
    });
    var isSelected = mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
    if (!Field || !isSelected) {
      return null;
    }
    switch (mutexOption.__typename) {
      case RangeField.fragment.__typename:
      case RangeTextInputField.fragment.__typename:
        return /* @__PURE__ */React40.createElement(Field, {
          key: "field-section-".concat(optionIndex),
          data: mutexOption,
          onSelectedField: onSelectedField,
          onRangeSelectionChange: handleRangeSelectionChange,
          resetFilters: resetFilters,
          type: primary !== null && primary !== void 0 ? primary : type,
          shouldFireSignalOnMount: initSignalOnMount
        });
      default:
        return /* @__PURE__ */React40.createElement(Field, {
          key: "field-section-".concat(optionIndex),
          data: mutexOption,
          onClick: onFieldClick,
          onSelectedField: onSelectedField,
          resetFilters: resetFilters,
          onStepInputChange: onStepInputChange
        });
    }
  })));
};
MutexField.displayName = "MutexField";
MutexField.fragment = _object_spread_props(_object_spread({}, __Fragment30), {
  __typename: "ShoppingMutexField"
});
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
import React42, { useEffect as useEffect6, useReducer } from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkPillContainer } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkParagraph as UitkParagraph5 } from "uitk-react-text";
import { Level, liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
// ../internal/src/utils/sort-by-selected-fields-ordering.ts
var sortBySelectedFieldsOrdering = function (originalArray, sortingArray) {
  var sortingMap = new Map(sortingArray.map(function (item, index) {
    return [item, index];
  }));
  var shoppingSelectedFilters = JSON.parse(JSON.stringify(originalArray));
  return shoppingSelectedFilters.sort(function (previousFilter, currentFilter) {
    var _previousFilter_filter, _currentFilter_filter;
    if (((_previousFilter_filter = previousFilter.filter) === null || _previousFilter_filter === void 0 ? void 0 : _previousFilter_filter.__typename) === "EGDSBasicRemovablePill" && previousFilter.filter.id && ((_currentFilter_filter = currentFilter.filter) === null || _currentFilter_filter === void 0 ? void 0 : _currentFilter_filter.__typename) === "EGDSBasicRemovablePill" && currentFilter.filter.id) {
      var previousIndex = sortingMap.get(previousFilter.filter.id);
      var currentIndex = sortingMap.get(currentFilter.filter.id);
      if (previousIndex === void 0 && currentIndex === void 0) {
        return 0;
      }
      if (previousIndex === void 0) {
        return 1;
      }
      if (currentIndex === void 0) {
        return -1;
      }
      return previousIndex - currentIndex;
    }
    return 0;
  });
};
// ../internal/src/components/sort-filter/__private/__fragments/selected-filter.tsx
import React41 from "react";
import { gql as gql40 } from "@apollo/client";
var __Fragment31 = gql40(_templateObject45(), EmitterFragment, EGDSBasicRemovablePill.fragment);
var SelectedFilter = function (param) {
  var data = param.data,
    onRemoveFilterPill = param.onRemoveFilterPill;
  var filter = data.filter,
    emitters = data.emitters;
  var emitSignal = useSignalEmitter();
  if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
    return null;
  }
  var id = filter.id,
    primary = filter.primary,
    name = filter.name,
    accessibility = filter.accessibility;
  if (!id || !primary || !name || !accessibility) {
    return null;
  }
  var handleClick = function () {
    onRemoveFilterPill === null || onRemoveFilterPill === void 0 ? void 0 : onRemoveFilterPill(id);
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {});
    }
  };
  return /* @__PURE__ */React41.createElement(EGDSBasicRemovablePill, {
    data: filter,
    onClick: handleClick
  });
};
SelectedFilter.displayName = "SelectedFilter";
SelectedFilter.fragment = __Fragment31;
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
var __Fragment32 = gql41(_templateObject46(), SelectedFilter.fragment, ReceiverFragment);
var SelectedFiltersFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    dispatch = param.dispatch;
  return /* @__PURE__ */React42.createElement(React42.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: dispatch
    };
    return /* @__PURE__ */React42.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var SelectedFiltersField = function (param) {
  var data = param.data,
    resetFilters = param.resetFilters,
    focusNextElement = param.focusNextElement;
  var selectedFiltersFieldAccessiblity = data.selectedFiltersFieldAccessiblity,
    primary = data.primary,
    secondary = data.secondary,
    shoppingSelectedFilters = data.shoppingSelectedFilters,
    receivers = data.receivers,
    selectedFiltersOrdering = data.selectedFiltersOrdering;
  var _useReducer = _sliced_to_array(useReducer(selectedFiltersStateReducer, {
      selectedFilters: _to_consumable_array(shoppingSelectedFilters !== null && shoppingSelectedFilters !== void 0 ? shoppingSelectedFilters : []),
      isFirstSelectedFilter: false
    }), 2),
    _useReducer_ = _useReducer[0],
    selectedFilters = _useReducer_.selectedFilters,
    isFirstSelectedFilter = _useReducer_.isFirstSelectedFilter,
    dispatch = _useReducer[1];
  var ariaLabel = (selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.__typename) === "EGDSCardinalLocalizedText" ? selectedFiltersFieldAccessiblity.accessibilityText : selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.text;
  var liveAnnounceRef = React42.useRef(null);
  useEffect6(function () {
    if (resetFilters) {
      dispatch({
        type: "SortAndFilterClearAllFilters" /* CLEAR */,
        payload: {}
      });
    }
  }, [resetFilters]);
  useEffect6(function () {
    if (isFirstSelectedFilter) {
      liveAnnounce2("A list of your filter selections have been added. Check headings menu to review.", Level.POLITE, "is-visually-hidden", liveAnnounceRef, "selected-filter-field-live");
    }
  }, [isFirstSelectedFilter]);
  var orderedSelectedFilterList = selectedFiltersOrdering ? sortBySelectedFieldsOrdering(selectedFilters, selectedFiltersOrdering) : selectedFilters;
  if (!(orderedSelectedFilterList === null || orderedSelectedFilterList === void 0 ? void 0 : orderedSelectedFilterList.length)) {
    return receivers ? /* @__PURE__ */React42.createElement(SelectedFiltersFieldSubscriptions, {
      receivers: receivers,
      dispatch: dispatch
    }) : null;
  }
  var removeFilterPill = function (id) {
    var _lastOrderedSelectedFilter_filter;
    var lastOrderedSelectedFilter = orderedSelectedFilterList[orderedSelectedFilterList.length - 1];
    var isLastFilterPill = (lastOrderedSelectedFilter === null || lastOrderedSelectedFilter === void 0 ? void 0 : (_lastOrderedSelectedFilter_filter = lastOrderedSelectedFilter.filter) === null || _lastOrderedSelectedFilter_filter === void 0 ? void 0 : _lastOrderedSelectedFilter_filter.__typename) === "EGDSBasicRemovablePill" && lastOrderedSelectedFilter.filter.id === id;
    if (isLastFilterPill) {
      focusNextElement === null || focusNextElement === void 0 ? void 0 : focusNextElement();
    }
    dispatch({
      type: "SortAndFilterClearFilterById" /* CLEAR_BY_ID */,
      payload: {
        id: id
      }
    });
  };
  return /* @__PURE__ */React42.createElement(React42.Fragment, null, receivers && /* @__PURE__ */React42.createElement(SelectedFiltersFieldSubscriptions, {
    receivers: receivers,
    dispatch: dispatch
  }), /* @__PURE__ */React42.createElement("fieldset", {
    "data-testid": "selected-filter-field",
    ref: liveAnnounceRef
  }, /* @__PURE__ */React42.createElement("legend", null, primary && /* @__PURE__ */React42.createElement(UitkHeading10, {
    tag: "h4",
    size: 7,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : ""
  }, primary)), secondary && /* @__PURE__ */React42.createElement(UitkParagraph5, null, secondary), /* @__PURE__ */React42.createElement(UitkSpacing14, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React42.createElement(UitkPillContainer, {
    wrap: true
  }, orderedSelectedFilterList.map(function (selectedFilter, index) {
    return /* @__PURE__ */React42.createElement(SelectedFilter, {
      key: "selected-filter-".concat(index),
      data: selectedFilter,
      onRemoveFilterPill: removeFilterPill
    });
  })))));
};
SelectedFiltersField.displayName = "SelectedFiltersField";
SelectedFiltersField.fragment = _object_spread_props(_object_spread({}, __Fragment32), {
  __typename: "ShoppingSelectedFiltersField"
});
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
import React45 from "react";
import { gql as gql42 } from "@apollo/client";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { UitkTextInput } from "uitk-react-input";
import { UitkHeading as UitkHeading11 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-multi-typeahead.tsx
import React43 from "react";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { ESSAdapter as ESSAdapter2, UitkTypeahead } from "uitk-react-typeahead";
// ../internal/src/utils/universal-cruise-ess-adapter.ts
import { ESSAdapter } from "uitk-react-typeahead";
var MAX_RESULTS_SHIP_EMPTY_TERM = 25;
var MAX_RESULTS_PORT_EMPTY_TERM = 25;
var NUM_TOP_POPULAR_DEPARTURE_PORTS = 25;
var departurePortsCategoryName = "TOP_POPULAR_DEPARTURE_PORTS";
var getIcon = function (domainId) {
  switch (domainId) {
    case "CRUISE_SHIP" /* CRUISE_SHIP */:
      return "lob_cruise";
    default:
      return "place";
  }
};
var getDeeplink = function (result) {
  switch (result.domainId) {
    case "CRUISE_PORT" /* CRUISE_PORT */:
      var _result_metadata;
      return (result === null || result === void 0 ? void 0 : (_result_metadata = result.metadata) === null || _result_metadata === void 0 ? void 0 : _result_metadata.portDeepLink) || "";
    default:
      return result.ids.id;
  }
};
var getSubtext = function (result) {
  switch (result.domainId) {
    case "CRUISE_SHIP" /* CRUISE_SHIP */:
      var _result_metadata;
      return ((_result_metadata = result.metadata) === null || _result_metadata === void 0 ? void 0 : _result_metadata.cruiseLineName) || "";
    case "CRUISE_PORT" /* CRUISE_PORT */:
      return result.names.secondaryDisplayName || "";
    default:
      return "";
  }
};
var generateNewResults = function (newResults, result) {
  var _result_metadata;
  var primaryText = result.domainId === "CRUISE_PORT" /* CRUISE_PORT */ ? result.names.primaryDisplayName : result.names.displayName;
  var subtext = getSubtext(result);
  var deeplink = getDeeplink(result);
  var newResult = {
    data: {
      type: (_result_metadata = result.metadata) === null || _result_metadata === void 0 ? void 0 : _result_metadata.type,
      value: deeplink
    },
    icon: getIcon(result.domainId),
    name: primaryText || "",
    subtext: subtext,
    title: primaryText || "",
    value: primaryText || ""
  };
  newResults.push(newResult);
  if (newResults.length === NUM_TOP_POPULAR_DEPARTURE_PORTS && result.domainId === "CRUISE_PORT" /* CRUISE_PORT */) {
    newResults.forEach(function (res) {
      res.data.type = departurePortsCategoryName;
    });
  }
  return newResults;
};
var UniversalCruiseESSAdapter = /*#__PURE__*/function (ESSAdapter) {
  "use strict";

  _inherits(UniversalCruiseESSAdapter, ESSAdapter);
  var _super = _create_super(UniversalCruiseESSAdapter);
  function UniversalCruiseESSAdapter(config) {
    _class_call_check(this, UniversalCruiseESSAdapter);
    var _this;
    _this = _super.call(this, config);
    __publicField(_assert_this_initialized(_this), "config");
    __publicField(_assert_this_initialized(_this), "ESSCategories");
    /**
    * Used to set typeahead categories for categorization of results
    */
    __publicField(_assert_this_initialized(_this), "setTypeaheadCategories", function () {
      var _this_config_essCategories;
      _this.ESSCategories = {};
      (_this_config_essCategories = _this.config.essCategories) === null || _this_config_essCategories === void 0 ? void 0 : _this_config_essCategories.forEach(function (category) {
        _this.ESSCategories[category.key] = category.value;
      });
      if (_this.config.header && _this.config.domainId === "CRUISE_PORT" /* CRUISE_PORT */) {
        _this.ESSCategories[departurePortsCategoryName] = _this.config.header;
      }
    });
    /**
    * Constructs URL for typeahead suggest service
    * @param query
    */
    __publicField(_assert_this_initialized(_this), "constructURL", function (query) {
      var baseURL = "".concat(_this.config.domain, "/api/v2/suggest");
      var _$config = {
        domainId: _this.config.domainId,
        lob: _this.config.lob,
        maxResults: _this.getMaxResults(query),
        siteid: _this.config.siteId,
        locale: _this.config.locale
      };
      var URLParams = function (params) {
        return Object.entries(params).map(function (param) {
          var _param = _sliced_to_array(param, 2),
            key = _param[0],
            val = _param[1];
          return "".concat(key, "=").concat(encodeURIComponent(val));
        }).join("&");
      };
      return "".concat(baseURL, "?query=").concat(query, "&").concat(URLParams(_$config));
    });
    /**
    * Used to fetch the typeahead results from the suggest service
    * @param term
    */
    __publicField(_assert_this_initialized(_this), "fetchResponse", function (term) {
      if (term) {
        if (_this.config.typeaheadLogger) {
          _this.config.typeaheadLogger.logTypeaheadRequest(term);
        }
      }
      return fetch(_this.constructURL(term), {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(_this.config.requestBody)
      }).then(function (response) {
        if (_this.config.typeaheadLogger) {
          _this.config.typeaheadLogger.logResponse(response);
        }
        return response.json();
      });
    });
    /**
    * Returns maximum results for the typeahead component
    * @param query
    */
    __publicField(_assert_this_initialized(_this), "getMaxResults", function (query) {
      if (!query) {
        if (_this.config.domainId === "CRUISE_SHIP" /* CRUISE_SHIP */) {
          return MAX_RESULTS_SHIP_EMPTY_TERM;
        }
        if (_this.config.domainId === "CRUISE_PORT" /* CRUISE_PORT */) {
          return MAX_RESULTS_PORT_EMPTY_TERM;
        }
      }
      return _this.config.maxResults;
    });
    /**
    * Accepts the suggest api response and adapts it to typeahead results
    * @param results
    */ // eslint-disable-next-line class-methods-use-this
    __publicField(_assert_this_initialized(_this), "adaptResponseToTypeaheadResults", function (results) {
      var adapt = function (json) {
        var _json_suggestions_reduce, _json_suggestions;
        return (_json_suggestions = json.suggestions) === null || _json_suggestions === void 0 ? void 0 : (_json_suggestions_reduce = _json_suggestions.reduce) === null || _json_suggestions_reduce === void 0 ? void 0 : _json_suggestions_reduce.call(_json_suggestions, generateNewResults, []);
      };
      return adapt(results);
    });
    _this.config = config;
    return _this;
  }
  return UniversalCruiseESSAdapter;
}(ESSAdapter);
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-multi-typeahead.tsx
var DEFAULT_CRUISE_ADAPTER_VALUES = {
  lob: "CRUISES",
  maxResults: 25,
  regionType: 2047
};
var getAutoSuggestKeyValuePairMap = function (autoSuggestKeyValuePair) {
  return (autoSuggestKeyValuePair === null || autoSuggestKeyValuePair === void 0 ? void 0 : autoSuggestKeyValuePair.reduce(function (prev, next) {
    var newPrev = prev;
    newPrev[next.key] = next.value;
    return newPrev;
  }, {})) || {};
};
var TextInputFieldMultiTypeahead = function (props) {
  var onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange2 = props.onSelectionChange,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    multiSelections = props.multiSelections,
    id = props.id,
    typeaheadInfo = props.typeaheadInfo,
    typeaheadAdapter = props.typeaheadAdapter,
    autoSuggest = props.autoSuggest,
    analytics = props.analytics,
    typeaheadLogger = props.typeaheadLogger,
    resetFilters = props.resetFilters;
  var context = useBexApi().context;
  var _ref = typeaheadInfo || {},
    client = _ref.client,
    isDestination = _ref.isDestination,
    lineOfBusiness = _ref.lineOfBusiness,
    maxNumberOfResults = _ref.maxNumberOfResults,
    regionType = _ref.regionType,
    typeaheadFeatures = _ref.typeaheadFeatures,
    categorize = _ref.categorize,
    allowExactMatch = _ref.allowExactMatch,
    dismissButtonText = _ref.dismissButtonText,
    listTitle = _ref.listTitle,
    typeaheadMultiSelect = _ref.typeaheadMultiSelect,
    emptyResultsPlaceholder = _ref.emptyResultsPlaceholder;
  var _ref1 = typeaheadMultiSelect || {},
    isMultiLocation = _ref1.isMultiLocation,
    showPills = _ref1.showPills,
    selectedItemHeading = _ref1.selectedItemHeading,
    clearAllText = _ref1.clearAllText;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
  var _ref2 = identity || {},
    guid = _ref2.duaid;
  var defaultMaxNumberOfResults2 = 10;
  var isCruiseLOB = (lineOfBusiness === null || lineOfBusiness === void 0 ? void 0 : lineOfBusiness.toLowerCase()) === "cruises";
  var autoSuggestKeyValuePairMap = getAutoSuggestKeyValuePairMap(autoSuggest === null || autoSuggest === void 0 ? void 0 : autoSuggest.autoSuggestKeyValuePair);
  var _typeaheadInfo_client, _typeaheadInfo_isDestination, _typeaheadInfo_typeaheadFeatures, _autoSuggestKeyValuePairMap_lob, _parseInt, _typeaheadInfo_regionType;
  var essAdapter = isCruiseLOB && autoSuggest ? new UniversalCruiseESSAdapter({
    client: (_typeaheadInfo_client = typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : typeaheadInfo.client) !== null && _typeaheadInfo_client !== void 0 ? _typeaheadInfo_client : "",
    dest: (_typeaheadInfo_isDestination = typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : typeaheadInfo.isDestination) !== null && _typeaheadInfo_isDestination !== void 0 ? _typeaheadInfo_isDestination : false,
    domain: (typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : typeaheadInfo.domain) || "",
    domainId: autoSuggestKeyValuePairMap.domainId || "",
    expuserid: expuserid,
    features: (_typeaheadInfo_typeaheadFeatures = typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : typeaheadInfo.typeaheadFeatures) !== null && _typeaheadInfo_typeaheadFeatures !== void 0 ? _typeaheadInfo_typeaheadFeatures : "",
    guid: guid,
    lob: (_autoSuggestKeyValuePairMap_lob = autoSuggestKeyValuePairMap.lob) !== null && _autoSuggestKeyValuePairMap_lob !== void 0 ? _autoSuggestKeyValuePairMap_lob : DEFAULT_CRUISE_ADAPTER_VALUES.lob,
    locale: autoSuggestKeyValuePairMap.locale || locale,
    maxResults: (_parseInt = parseInt(autoSuggestKeyValuePairMap.maxResults || "", 10)) !== null && _parseInt !== void 0 ? _parseInt : DEFAULT_CRUISE_ADAPTER_VALUES.maxResults,
    personalize: false,
    regionType: (_typeaheadInfo_regionType = typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : typeaheadInfo.regionType) !== null && _typeaheadInfo_regionType !== void 0 ? _typeaheadInfo_regionType : DEFAULT_CRUISE_ADAPTER_VALUES.regionType,
    requestBody: JSON.parse(autoSuggest.payload || ""),
    siteId: parseInt(autoSuggestKeyValuePairMap.siteid || "", 10) || siteId,
    typeaheadLogger: typeaheadLogger,
    header: autoSuggest.header
  }) : typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter2({
    client: client !== null && client !== void 0 ? client : "",
    domain: "https://www.expedia.com/",
    dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
    expuserid: expuserid,
    features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
    guid: guid,
    lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
    locale: locale,
    maxResults: maxNumberOfResults || defaultMaxNumberOfResults2,
    regionType: regionType || 128,
    siteId: siteId,
    typeaheadLogger: typeaheadLogger
  });
  var currentMultiSelection = React43.useMemo(function () {
    return multiSelections ? multiSelections.map(function (item) {
      return {
        term: item.text,
        data: {
          value: item.value
        }
      };
    }) : [];
  }, [multiSelections]);
  var _React43_useState = _sliced_to_array(React43.useState(currentMultiSelection), 2),
    selection = _React43_useState[0],
    setSelection = _React43_useState[1];
  React43.useEffect(function () {
    setSelection(resetFilters ? [] : currentMultiSelection);
  }, [currentMultiSelection, resetFilters]);
  var track = useClickTracker21();
  var handleUpdate = function (typeaheadSelection) {
    var isNewSelectionRepeated = selection.find(function (item) {
      return item === typeaheadSelection;
    });
    if (!isNewSelectionRepeated && typeaheadSelection.data) {
      setSelection(function (prevSelection) {
        return _to_consumable_array(prevSelection).concat([typeaheadSelection]);
      });
      onSelectionChange2 === null || onSelectionChange2 === void 0 ? void 0 : onSelectionChange2(typeaheadSelection, id);
    }
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
  };
  var handleRemove = function (selectedIndex) {
    if (selection.length > 0) {
      setSelection(selection.filter(function (_, i) {
        return i !== selectedIndex;
      }));
      var selectedSelection = selection[selectedIndex];
      if (selectedSelection) {
        onMultiSelectItemRemove === null || onMultiSelectItemRemove === void 0 ? void 0 : onMultiSelectItemRemove(selectedSelection, id);
      }
    }
  };
  var handleClear = function () {
    setSelection([]);
    onMultiSelectClearAll === null || onMultiSelectClearAll === void 0 ? void 0 : onMultiSelectClearAll(id);
    onSelectionChange2 === null || onSelectionChange2 === void 0 ? void 0 : onSelectionChange2({
      term: "",
      data: {}
    }, id);
  };
  var handleDismiss = function (renderType) {
    onMultiSelectClose === null || onMultiSelectClose === void 0 ? void 0 : onMultiSelectClose(renderType, id, selection);
  };
  var _ref3, _icon_id;
  return /* @__PURE__ */React43.createElement(UitkSpacing15, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React43.createElement("div", null, /* @__PURE__ */React43.createElement(UitkTypeahead, {
    stid: id,
    id: id,
    name: id,
    value: selection.map(function (item) {
      return item.term;
    }),
    label: (_ref3 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref3 !== void 0 ? _ref3 : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    adapter: essAdapter,
    onUpdate: handleUpdate,
    onItemRemove: isMultiLocation ? handleRemove : void 0,
    handleClear: handleClear,
    onDismiss: isMultiLocation ? handleDismiss : void 0,
    isMulti: isMultiLocation !== null && isMultiLocation !== void 0 ? isMultiLocation : false,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
    clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
    dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
    showPills: showPills,
    hasClearButton: true,
    typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : ""
  })));
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-typeahead.tsx
import React44 from "react";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { ESSAdapter as ESSAdapter3, UitkTypeahead as UitkTypeahead2 } from "uitk-react-typeahead";
var TextInputFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React44.createElement(React44.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (param, i) {
    var signalId = param.signalId;
    var subscription = {
      query: {
        type: signalId
      },
      onSignal: function (param) {
        var payload = param.payload;
        if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */) {
          switch (payload.type) {
            case "REMOVE" /* REMOVE */:
              onSignalCallback();
              break;
            default:
          }
        }
      }
    };
    return /* @__PURE__ */React44.createElement(SignalSubscriber, {
      subscription: subscription,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var TextInputFieldTypeahead = function (props) {
  var onSelectionChange2 = props.onSelectionChange,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    selected = props.selected,
    id = props.id,
    typeaheadInfo = props.typeaheadInfo,
    typeaheadAdapter = props.typeaheadAdapter,
    analytics = props.analytics,
    typeaheadLogger = props.typeaheadLogger,
    clearButtonAnalytics = props.clearButtonAnalytics,
    resetFilters = props.resetFilters,
    emitters = props.emitters,
    receivers = props.receivers;
  var emitSignal = useSignalEmitter();
  var context = useBexApi2().context;
  var track = useClickTracker22();
  var _React44_useState = _sliced_to_array(React44.useState(selected), 2),
    selection = _React44_useState[0],
    setSelection = _React44_useState[1];
  var onSignalCallback = React44.useCallback(function () {
    setSelection("");
    onSelectionChange2 === null || onSelectionChange2 === void 0 ? void 0 : onSelectionChange2({
      term: "",
      data: {}
    }, id);
  }, []);
  React44.useEffect(function () {
    setSelection(resetFilters ? "" : selected);
  }, [selected, resetFilters]);
  var _ref = typeaheadInfo || {},
    client = _ref.client,
    isDestination = _ref.isDestination,
    lineOfBusiness = _ref.lineOfBusiness,
    maxNumberOfResults = _ref.maxNumberOfResults,
    regionType = _ref.regionType,
    regionId = _ref.regionId,
    typeaheadFeatures = _ref.typeaheadFeatures,
    categorize = _ref.categorize,
    allowExactMatch = _ref.allowExactMatch,
    listTitle = _ref.listTitle;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
  var _ref1 = identity || {},
    guid = _ref1.duaid;
  var defaultMaxNumberOfResults2 = 10;
  var essAdapter = typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter3({
    client: client !== null && client !== void 0 ? client : "",
    domain: "https://www.expedia.com/",
    dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
    expuserid: expuserid,
    features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
    guid: guid,
    lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
    locale: locale,
    maxResults: maxNumberOfResults || defaultMaxNumberOfResults2,
    regionType: regionType || 128,
    siteId: siteId,
    typeaheadLogger: typeaheadLogger,
    regionId: regionId !== null && regionId !== void 0 ? regionId : ""
  });
  var handleUpdate = function (typeaheadSelection) {
    var typeaheadOptions = {
      selection: typeaheadSelection.term
    };
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
      typeaheadOptions: typeaheadOptions
    });
    setSelection(typeaheadSelection.term);
    onSelectionChange2 === null || onSelectionChange2 === void 0 ? void 0 : onSelectionChange2(typeaheadSelection, id);
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
  };
  var handleClear = function () {
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
      typeaheadOptions: {}
    });
    setSelection("");
    onSelectionChange2 === null || onSelectionChange2 === void 0 ? void 0 : onSelectionChange2({
      term: "",
      data: {}
    }, id);
    if (clearButtonAnalytics) {
      var referrerId = clearButtonAnalytics.referrerId,
        linkName = clearButtonAnalytics.linkName;
      track(referrerId, linkName);
    }
  };
  var _ref2, _icon_id;
  return /* @__PURE__ */React44.createElement(React44.Fragment, null, receivers && /* @__PURE__ */React44.createElement(TextInputFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React44.createElement(UitkTypeahead2, {
    id: id,
    name: id,
    value: selection !== null && selection !== void 0 ? selection : "",
    label: (_ref2 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref2 !== void 0 ? _ref2 : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    adapter: essAdapter,
    onUpdate: handleUpdate,
    handleClear: handleClear,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    hasClearButton: true
  }));
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
var __Fragment33 = gql42(_templateObject47(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var TextInputField = function (props) {
  var _typeaheadInfo_typeaheadMultiSelect, _typeaheadInfo_typeaheadMultiSelect1;
  var data = props.data,
    onKeyDown = props.onKeyDown,
    onDone = props.onDone,
    resetFilters = props.resetFilters;
  var primary = data.primary,
    label = data.label,
    placeholder = data.placeholder,
    icon = data.icon,
    selected = data.selected,
    id = data.id,
    typeaheadInfo = data.typeaheadInfo,
    analytics = data.analytics;
  var _React45_useState = _sliced_to_array(React45.useState(selected !== null && selected !== void 0 ? selected : ""), 2),
    value = _React45_useState[0],
    setValue = _React45_useState[1];
  var track = useClickTracker23();
  React45.useEffect(function () {
    setValue(resetFilters ? "" : selected || "");
  }, [selected, resetFilters]);
  var handleChange = function (event) {
    setValue(event.target.value);
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  var handleKeyDown = function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      var inputElement = event.target;
      setValue(inputElement.value);
      if (onKeyDown) {
        onKeyDown({
          name: id,
          value: inputElement.value
        }, event);
      }
      if (analytics) {
        var referrerId = analytics.referrerId,
          linkName = analytics.linkName,
          uisPrimeMessages = analytics.uisPrimeMessages;
        track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
      }
    }
  };
  var handleBlur = function (event) {
    event.preventDefault();
    setValue(event.target.value);
    if (onDone) {
      onDone({
        name: id,
        value: event.target.value
      }, event);
    }
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  var _icon_id;
  return /* @__PURE__ */React45.createElement(React45.Fragment, null, primary && /* @__PURE__ */React45.createElement(UitkHeading11, {
    tag: "h4",
    size: 7
  }, primary), !typeaheadInfo && /* @__PURE__ */React45.createElement(UitkTextInput, {
    label: label !== null && label !== void 0 ? label : "",
    id: id,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  }), typeaheadInfo && !((_typeaheadInfo_typeaheadMultiSelect = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect.isMultiLocation) && /* @__PURE__ */React45.createElement(TextInputFieldTypeahead, _object_spread({}, data, props)), (typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : (_typeaheadInfo_typeaheadMultiSelect1 = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect1 === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect1.isMultiLocation) && /* @__PURE__ */React45.createElement(TextInputFieldMultiTypeahead, _object_spread({}, data, props)));
};
TextInputField.displayName = "TextInputField";
TextInputField.fragment = _object_spread_props(_object_spread({}, __Fragment33), {
  __typename: "ShoppingTextInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/toolbar.tsx
import React46 from "react";
import { gql as gql43 } from "@apollo/client";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { UitkToolbar } from "uitk-react-toolbar";
var __Fragment34 = gql43(_templateObject48(), EGDSTertiaryButton.fragment);
var Toolbar = function (props) {
  var data = props.data,
    onCloseButtonClick = props.onCloseButtonClick,
    onClearAllButtonClick = props.onClearAllButtonClick;
  var actions = data.actions,
    primary = data.primary;
  var close = actions.primary,
    secondaries = actions.secondaries;
  var track = useClickTracker24();
  var _actions_primary_egdsElementId;
  var id = (_actions_primary_egdsElementId = actions.primary.egdsElementId) !== null && _actions_primary_egdsElementId !== void 0 ? _actions_primary_egdsElementId : "";
  var _close_accessibility;
  var closeAccessibility = (_close_accessibility = close.accessibility) !== null && _close_accessibility !== void 0 ? _close_accessibility : "";
  var handleCloseButton = React46.useCallback(function () {
    if (actions.primary.analytics) {
      var _actions_primary_analytics = actions.primary.analytics,
        referrerId = _actions_primary_analytics.referrerId,
        linkName = _actions_primary_analytics.linkName;
      track(referrerId, linkName);
    }
    onCloseButtonClick === null || onCloseButtonClick === void 0 ? void 0 : onCloseButtonClick();
  }, [actions.primary.analytics, onCloseButtonClick, track]);
  if (!primary || !Array.isArray(secondaries) || secondaries.length === 0) {
    return null;
  }
  var _secondaries = _sliced_to_array(secondaries, 1),
    clearAll = _secondaries[0];
  return /* @__PURE__ */React46.createElement(UitkToolbar, {
    toolbarTitle: primary,
    navigationContent: onCloseButtonClick ? {
      onClick: handleCloseButton,
      navIconLabel: closeAccessibility,
      navButtonId: id
    } : void 0,
    toolbarActionContent: clearAll && /* @__PURE__ */React46.createElement(EGDSTertiaryButton, {
      data: clearAll,
      onClick: onClearAllButtonClick
    })
  });
};
Toolbar.displayName = "Toolbar";
Toolbar.fragment = __Fragment34;
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
var __Fragment35 = gql44(_templateObject49(), EGDSPill.fragment, Toolbar.fragment, EGDSSecondaryButton.fragment, DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment, QuickAccessFilterSheetFooter.fragment, RangeTextInputField.fragment);
var validFieldComponents2 = [DropdownField, MultiSelectionField, RangeField, SelectionField, TextInputField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, MutexField, SelectedFiltersField, RangeTextInputField];
var QuickAccessFilterField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSubmit = param.onSubmit,
    onFieldClick = param.onFieldClick,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onStepInputChange = param.onStepInputChange,
    onSelectedField = param.onSelectedField,
    handleClearButtonClick = param.handleClearButtonClick,
    loading = param.loading,
    isSheetVisible = param.isSheetVisible,
    onSheetToggle = param.onSheetToggle,
    sheetIndex = param.sheetIndex,
    onSheetDismiss = param.onSheetDismiss,
    footerDataLoading = param.footerDataLoading,
    lastQuickFilter = param.lastQuickFilter,
    bexQuickFiltersExposure = param.bexQuickFiltersExposure,
    isDatedSearch = param.isDatedSearch,
    quickFilterCarouselButtonExposure = param.quickFilterCarouselButtonExposure,
    quickFiltersVrboArrowExposure = param.quickFiltersVrboArrowExposure,
    setCloseButtonClicked = param.setCloseButtonClicked,
    closeButtonClicked = param.closeButtonClicked,
    shouldDisplayToolbarForQuickAccessFilters = param.shouldDisplayToolbarForQuickAccessFilters,
    xLOBLodgingMwebExposure = param.xLOBLodgingMwebExposure,
    xLOBQAFExposure = param.xLOBQAFExposure;
  var filterPill = data.filterPill,
    resultCountLabel = data.resultCountLabel,
    applyAction = data.applyAction,
    fields = data.fields,
    toolbar = data.toolbar;
  var _React47_useState = _sliced_to_array(React47.useState(false), 2),
    resetFilters = _React47_useState[0],
    setResetFilters = _React47_useState[1];
  var domRef = React47.useRef(null);
  var isSmallViewSize = useMediaQueries2({
    viewSizes: defaultViewSizes2
  }) === defaultViewSizes2.SMALL;
  var isMediumViewSize = useMediaQueries2({
    viewSizes: defaultViewSizes2
  }) === defaultViewSizes2.MEDIUM;
  var _React47_useState1 = _sliced_to_array(React47.useState([]), 2),
    quickAccessFields = _React47_useState1[0],
    setQuickAccessFields = _React47_useState1[1];
  var _useDialog2 = _sliced_to_array(useDialog2("shopping-sort-and-filter-quick-filter-dialog-".concat(sheetIndex)), 3),
    isOpen = _useDialog2[0],
    _useDialog2_ = _useDialog2[1],
    openDialog = _useDialog2_.openDialog,
    closeDialog = _useDialog2_.closeDialog,
    DialogComponent = _useDialog2[2];
  var isBexQuickFiltersEnabled = (bexQuickFiltersExposure === null || bexQuickFiltersExposure === void 0 ? void 0 : bexQuickFiltersExposure.bucket) === 1;
  var _useExperiment3 = useExperiment3("Filter_Removal_Phase_1_VrBex"),
    filterRemovalP1Exposure = _useExperiment3.exposure,
    filterRemovalP1ExperimentLogger = _useExperiment3.logExperiment;
  var _React47_useState2 = _sliced_to_array(React47.useState(true), 2),
    doneButtonClicked = _React47_useState2[0],
    setDoneButtonClicked = _React47_useState2[1];
  var isXLOBMwebEnabled = (xLOBLodgingMwebExposure === null || xLOBLodgingMwebExposure === void 0 ? void 0 : xLOBLodgingMwebExposure.bucket) === 1;
  var useBottomSheetForTablet = isXLOBMwebEnabled && isMediumViewSize;
  React47.useEffect(function () {
    if (data.__typename === "ShoppingSortAndFilterQuickFilter") {
      var returnQuickFilterFields = calculateQuickFilterFields(data.fields);
      setQuickAccessFields(returnQuickFilterFields);
    }
  }, [data.__typename, data.fields]);
  React47.useEffect(function () {
    if (resetFilters) {
      setResetFilters(false);
    }
    if (!isSheetVisible) {
      onSheetDismiss === null || onSheetDismiss === void 0 ? void 0 : onSheetDismiss({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
  }, [resetFilters, isSheetVisible]);
  React47.useEffect(function () {
    if (!isOpen && isSheetVisible) {
      onSheetToggle(sheetIndex, filterPill === null || filterPill === void 0 ? void 0 : filterPill.id);
    }
    if (!isOpen && !closeButtonClicked && !doneButtonClicked) {
      if (((quickFilterCarouselButtonExposure === null || quickFilterCarouselButtonExposure === void 0 ? void 0 : quickFilterCarouselButtonExposure.bucket) === 1 || (quickFiltersVrboArrowExposure === null || quickFiltersVrboArrowExposure === void 0 ? void 0 : quickFiltersVrboArrowExposure.bucket) === 1) && (isSmallViewSize || useBottomSheetForTablet)) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      }
      return;
    }
    setCloseButtonClicked === null || setCloseButtonClicked === void 0 ? void 0 : setCloseButtonClicked(false);
    setDoneButtonClicked(false);
  }, [isOpen]);
  if ((filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) !== "EGDSBasicTriggerPill") {
    return null;
  }
  var filterPillData = _object_spread_props(_object_spread({}, filterPill), {
    disabled: loading !== null && loading !== void 0 ? loading : false
  });
  var toolbarPrimary = toolbar === null || toolbar === void 0 ? void 0 : toolbar.primary;
  var toolbarSecondaries = toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions.secondaries;
  var _ref = _sliced_to_array(toolbarSecondaries !== null && toolbarSecondaries !== void 0 ? toolbarSecondaries : [], 1),
    clearAll = _ref[0];
  var clearButtonClick = function () {
    setResetFilters(true);
    handleClearButtonClick === null || handleClearButtonClick === void 0 ? void 0 : handleClearButtonClick(quickAccessFields);
  };
  var toggleSheet = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      openDialog();
    }
    onSheetToggle(sheetIndex, filterPill.id);
    var fieldsExceptSortAndPrice = data.fields.filter(function (field) {
      return field.__typename !== "ShoppingMutexField" && field.__typename !== "ShoppingSelectionField";
    });
    if (fieldsExceptSortAndPrice.length !== 0 && !isSheetVisible) {
      filterRemovalP1ExperimentLogger(filterRemovalP1Exposure);
    }
  };
  var handleSubmit = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      closeDialog();
      setDoneButtonClicked(true);
    }
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    onSheetToggle(sheetIndex, filterPill.id);
  };
  var closeSheet = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      closeDialog();
      setCloseButtonClicked === null || setCloseButtonClicked === void 0 ? void 0 : setCloseButtonClicked(true);
    }
    onSheetToggle(sheetIndex, filterPill.id);
  };
  var hasSupportedFields = fields.some(function (param) {
    var __typename = param.__typename;
    return validFieldComponents2.find(function (param) {
      var fragment5 = param.fragment;
      return fragment5.__typename === __typename;
    });
  });
  if (!hasSupportedFields) {
    return null;
  }
  var quickAccessFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilterQuickFilter",
    resultCountLabel: resultCountLabel,
    applyAction: applyAction,
    filterPill: {
      __typename: "EGDSBasicTriggerPill",
      id: filterPillData.id
    }
  };
  var QuickAccessFilterContent = /* @__PURE__ */React47.createElement(React47.Fragment, null, shouldDisplayToolbarForQuickAccessFilters || isSmallViewSize ? toolbar && /* @__PURE__ */React47.createElement(Toolbar, {
    onClearAllButtonClick: clearButtonClick,
    onCloseButtonClick: closeSheet,
    data: toolbar
  }) : /* @__PURE__ */React47.createElement(UitkSpacing16, {
    padding: {
      small: "four",
      medium: {
        inlinestart: "six",
        blockstart: "six",
        inlineend: "six",
        blockend: "two"
      }
    }
  }, /* @__PURE__ */React47.createElement(UitkLayoutFlex10, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React47.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */React47.createElement(UitkHeading12, {
    tag: "h2",
    size: 6
  }, toolbarPrimary)), /* @__PURE__ */React47.createElement(UitkLayoutFlexItem12, null, clearAll && /* @__PURE__ */React47.createElement(EGDSTertiaryButton, {
    data: clearAll,
    onClick: clearButtonClick
  })))), /* @__PURE__ */React47.createElement(UitkSpacing16, {
    padding: {
      medium: {
        blockstart: "unset",
        blockend: "one",
        inlinestart: "six",
        inlineend: "six"
      }
    }
  }, /* @__PURE__ */React47.createElement(UitkSheetContent, {
    padded: false
  }, /* @__PURE__ */React47.createElement(UitkSpacing16, {
    padding: {
      small: {
        inline: isSmallViewSize ? "three" : "unset"
      }
    }
  }, /* @__PURE__ */React47.createElement("div", null, fields.map(function (field, fieldIndex) {
    var __typename = field.__typename;
    var Field = validFieldComponents2.find(function (component) {
      return component.fragment.__typename === __typename;
    });
    var fieldSectionMargin = isXLOBMwebEnabled ? {
      block: "two"
    } : {
      blockstart: "six"
    };
    if (!Field) {
      return null;
    }
    return /* @__PURE__ */React47.createElement(UitkSpacing16, {
      margin: fieldSectionMargin,
      key: "field-section-".concat(fieldIndex)
    }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(FieldStateProvider, {
      field: field
    }, __typename === RangeField.fragment.__typename && /* @__PURE__ */React47.createElement(Field, {
      data: field,
      onSelectedField: onSelectedField,
      onRangeSelectionChange: onRangeSelectionChange,
      resetFilters: resetFilters
    }), __typename !== TextInputField.fragment.__typename && __typename !== RangeField.fragment.__typename && /* @__PURE__ */React47.createElement(Field, {
      data: field,
      onClick: onFieldClick,
      onSelectedField: onSelectedField,
      keepSectionExpanded: keepSectionExpanded,
      resetFilters: resetFilters,
      onStepInputChange: onStepInputChange,
      type: toolbarPrimary,
      onRangeSelectionChange: onRangeSelectionChange,
      isDatedSearch: isDatedSearch
    }))));
  }))))));
  return /* @__PURE__ */React47.createElement(React47.Fragment, null, /* @__PURE__ */React47.createElement(EGDSPill, {
    data: filterPillData,
    onClick: toggleSheet,
    active: isSheetVisible,
    triggerPill: true,
    domRef: domRef
  }), /* @__PURE__ */React47.createElement(QuickAccessFilterSheetWrapper, {
    DialogComponent: DialogComponent,
    triggerRef: domRef,
    isVisible: isSheetVisible,
    onDismiss: toggleSheet,
    lastQuickfilter: lastQuickFilter,
    isBottomSheet: useBottomSheetForTablet
  }, /* @__PURE__ */React47.createElement(React47.Fragment, null, QuickAccessFilterContent, /* @__PURE__ */React47.createElement(QuickAccessFilterSheetFooter, {
    data: quickAccessFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    onClick: handleSubmit,
    isBexQuickFiltersEnabled: isSmallViewSize && (xLOBLodgingMwebExposure === null || xLOBLodgingMwebExposure === void 0 ? void 0 : xLOBLodgingMwebExposure.bucket) === 1 || useBottomSheetForTablet || isSmallViewSize && (xLOBQAFExposure === null || xLOBQAFExposure === void 0 ? void 0 : xLOBQAFExposure.bucket) === 1
  }))));
};
QuickAccessFilterField.displayName = "QuickAccessFilterField";
QuickAccessFilterField.fragment = _object_spread_props(_object_spread({}, __Fragment35), {
  __typename: "ShoppingSortAndFilterQuickFilter"
});
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-more-filters.tsx
import React48 from "react";
import { gql as gql45 } from "@apollo/client";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkButtonSize as UitkButtonSize5, UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet2, UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
var __Fragment36 = gql45(_templateObject50(), UIFloatingActionButton.fragment, Toolbar.fragment);
var QuickAccessFilterMoreFilters = function (param) {
  var data = param.data,
    onOpenDialog = param.onOpenDialog,
    onClearFilters = param.onClearFilters,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    onSubmit = param.onSubmit,
    setFiltersActive = param.setFiltersActive,
    setResetFilters = param.setResetFilters,
    setSubmitButtonClicked = param.setSubmitButtonClicked,
    filterSections = param.filterSections,
    loading = param.loading;
  var _useDialog3 = _sliced_to_array(useDialog3("quick-access-filters-more-filters"), 3),
    isDialogOpen = _useDialog3[0],
    _useDialog3_ = _useDialog3[1],
    openDialog = _useDialog3_.openDialog,
    closeDialog = _useDialog3_.closeDialog,
    DialogComponent = _useDialog3[2];
  var _data_container = data.container,
    toolbar = _data_container.toolbar,
    revealAction = _data_container.revealAction,
    applyAction = _data_container.applyAction;
  var track = useClickTracker25();
  var isUISecondaryFloatingActionButton = (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton";
  var handleTriggerClick = React48.useCallback(function () {
    onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
    openDialog();
    if (isUISecondaryFloatingActionButton && (revealAction === null || revealAction === void 0 ? void 0 : revealAction.analytics)) {
      var _revealAction_analytics = revealAction.analytics,
        referrerId = _revealAction_analytics.referrerId,
        linkName = _revealAction_analytics.linkName;
      track(referrerId, linkName);
    }
  }, [openDialog, onOpenDialog]);
  var handleSubmitClick = React48.useCallback(function () {
    setSubmitButtonClicked(true);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React48.useCallback(function () {
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "restore" /* RESTORE */,
      value: {}
    });
    setResetFilters(false);
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React48.useCallback(function () {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear" /* CLEAR */,
      value: {}
    });
    setResetFilters(true);
    setFiltersActive(false);
  }, [onRemoveAllAppliedFilters, onClearFilters]);
  if (!isUISecondaryFloatingActionButton || !applyAction || !filterSections) {
    return null;
  }
  var _revealAction_egdsElementId;
  return /* @__PURE__ */React48.createElement(React48.Fragment, null, /* @__PURE__ */React48.createElement(UitkLayoutFlexItem13, {
    shrink: 0
  }, /* @__PURE__ */React48.createElement(UitkSecondaryButton3, {
    size: UitkButtonSize5.SMALL,
    disabled: loading,
    onClick: handleTriggerClick,
    "data-test-id": (_revealAction_egdsElementId = revealAction.egdsElementId) !== null && _revealAction_egdsElementId !== void 0 ? _revealAction_egdsElementId : ""
  }, revealAction.primary)), /* @__PURE__ */React48.createElement(UitkSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React48.createElement(DialogComponent, null, /* @__PURE__ */React48.createElement(UitkSheet2, {
    type: "full",
    isVisible: true,
    returnFocusOnClose: true,
    triggerRef: null
  }, toolbar && /* @__PURE__ */React48.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React48.createElement(UitkDialogContent, {
    zeroPadding: true
  }, /* @__PURE__ */React48.createElement(UitkSpacing17, {
    padding: {
      inline: "six"
    }
  }, filterSections)), applyAction && /* @__PURE__ */React48.createElement(UitkSpacing17, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    },
    border: ["blockstart"]
  }, /* @__PURE__ */React48.createElement(UitkLayoutFlex11, {
    justifyContent: "end",
    alignItems: "center"
  }, /* @__PURE__ */React48.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */React48.createElement(UIFloatingActionButton, {
    data: applyAction,
    onClick: handleSubmitClick,
    withUpdatedNotification: true,
    isFullWidth: true
  }))))))));
};
QuickAccessFilterMoreFilters.displayName = "QuickAccessFilterMoreFilters";
QuickAccessFilterMoreFilters.fragment = __Fragment36;
// ../internal/src/components/sort-filter/__private/__fragments/section.tsx
import React49 from "react";
import { gql as gql46 } from "@apollo/client";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { UitkSpacing as UitkSpacing18, UitkSpacingHr } from "uitk-react-spacing";
import { UitkHeading as UitkHeading13 } from "uitk-react-text";
var __Fragment37 = gql46(_templateObject51(), DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment, RangeTextInputField.fragment);
var validFieldComponents3 = [DropdownField, MultiSelectionField, RangeField, SelectionField, TextInputField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, MutexField, SelectedFiltersField, RangeTextInputField];
var SortAndFilterSection = function (props) {
  var data = props.data,
    keepSectionExpanded = props.keepSectionExpanded,
    onFieldClick = props.onFieldClick,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange2 = props.onSelectionChange,
    typeaheadAdapters = props.typeaheadAdapters,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onStepInputChange = props.onStepInputChange,
    onSelectedField = props.onSelectedField,
    useUnsetMargin = props.useUnsetMargin,
    useUnsetTopBorder = props.useUnsetTopBorder,
    resetFilters = props.resetFilters,
    typeaheadLogger = props.typeaheadLogger,
    isQuickFilters = props.isQuickFilters,
    onDone = props.onDone,
    onKeyDown = props.onKeyDown,
    isDatedSearch = props.isDatedSearch,
    currentView = props.currentView;
  var fields = data.fields,
    subTitle = data.subTitle,
    title = data.title,
    id = data.id;
  var containerRef = React49.useRef(null);
  var hasSupportedFields = fields.some(function (param) {
    var __typename = param.__typename;
    return validFieldComponents3.find(function (param) {
      var fragment5 = param.fragment;
      return fragment5.__typename === __typename;
    });
  });
  if (!hasSupportedFields && fields.length > 0) {
    return null;
  }
  var isFilterSectionInputType = fields.some(function (param) {
    var __typename = param.__typename;
    return __typename === "ShoppingTextInputField";
  });
  var borderedSpacingProps = {
    border: isFilterSectionInputType ? ["blockend", "blockstart"] : [],
    padding: isFilterSectionInputType ? {
      block: "six"
    } : {},
    margin: !useUnsetMargin ? {
      blockstart: "six"
    } : {
      blockstart: "unset"
    }
  };
  var noTopBorderSpacingProps = {
    border: isFilterSectionInputType ? ["blockend"] : [],
    padding: isFilterSectionInputType ? {
      blockstart: "four",
      blockend: "six"
    } : {},
    margin: isFilterSectionInputType ? {
      blockstart: "unset"
    } : {
      blockstart: "six"
    }
  };
  var fieldSpacingProps = {
    margin: isFilterSectionInputType && fields.length === 1 ? {
      blockstart: "two"
    } : {
      blockstart: "six"
    }
  };
  var spacingProps = useUnsetTopBorder ? noTopBorderSpacingProps : borderedSpacingProps;
  var focusNextElement = function () {
    var _containerRef_current;
    var focusableElements = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var currentElement = document.activeElement;
    if (focusableElements && _instanceof(currentElement, HTMLElement)) {
      var index = _to_consumable_array(focusableElements).indexOf(currentElement);
      if (index > -1) {
        var _focusableElements_;
        var nextElement = (_focusableElements_ = focusableElements[index + 1]) !== null && _focusableElements_ !== void 0 ? _focusableElements_ : focusableElements[0];
        nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
      }
    }
  };
  var ignoreSignals = currentView !== "FILTER_BAR" /* FILTER_BAR */ && currentView !== "FILTER_DIALOG" /* FILTER_DIALOG */;
  return /* @__PURE__ */React49.createElement(UitkSpacing18, _object_spread({}, spacingProps), /* @__PURE__ */React49.createElement("div", {
    "data-test-id": id,
    ref: containerRef
  }, title && /* @__PURE__ */React49.createElement(UitkHeading13, {
    tag: "h3",
    size: 5
  }, title), /* @__PURE__ */React49.createElement(UitkHeading13, {
    tag: "h4",
    size: 6
  }, subTitle), fields.map(function (field, fieldIndex) {
    var __typename = (field || {}).__typename;
    var typeaheadAdapter = field.__typename === "ShoppingTextInputField" ? typeaheadAdapters === null || typeaheadAdapters === void 0 ? void 0 : typeaheadAdapters.get(field.id) : void 0;
    var Field = validFieldComponents3.find(function (component) {
      return component.fragment.__typename === __typename;
    });
    if (!Field) {
      return null;
    }
    return /* @__PURE__ */React49.createElement(UitkSpacing18, _object_spread_props(_object_spread({}, fieldSpacingProps), {
      key: fieldIndex
    }), /* @__PURE__ */React49.createElement("div", null, /* @__PURE__ */React49.createElement(FieldStateProvider, {
      field: field
    }, /* @__PURE__ */React49.createElement("div", null, __typename === TextInputField.fragment.__typename && /* @__PURE__ */React49.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      typeaheadAdapter: typeaheadAdapter,
      onMultiSelectClose: onMultiSelectClose,
      onMultiSelectItemRemove: onMultiSelectItemRemove,
      onMultiSelectClearAll: onMultiSelectClearAll,
      onSelectionChange: onSelectionChange2,
      typeaheadLogger: typeaheadLogger,
      onKeyDown: onKeyDown,
      onDone: onDone,
      resetFilters: resetFilters
    }), __typename === RangeField.fragment.__typename && /* @__PURE__ */React49.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      onSelectedField: onSelectedField,
      onRangeSelectionChange: onRangeSelectionChange,
      resetFilters: resetFilters
    }), __typename !== TextInputField.fragment.__typename && __typename !== RangeField.fragment.__typename && /* @__PURE__ */React49.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      onClick: onFieldClick,
      onSelectedField: onSelectedField,
      keepSectionExpanded: keepSectionExpanded,
      resetFilters: resetFilters,
      onStepInputChange: onStepInputChange,
      onRangeSelectionChange: onRangeSelectionChange,
      hasNoSectionTitle: !title,
      focusNextElement: focusNextElement,
      isDatedSearch: isDatedSearch,
      ignoreSignals: ignoreSignals
    })), /* @__PURE__ */React49.createElement(Experiment2, {
      name: "VrBex_Clawback_Filter_Modal_Display_Optimizations"
    }, /* @__PURE__ */React49.createElement(ExperimentControl2, null), /* @__PURE__ */React49.createElement(ExperimentVariant2, {
      bucket: 1
    }, isQuickFilters || fieldIndex === 0 || fieldIndex === fields.length - 1 || field.__typename === "ShoppingStepInputField" ? /* @__PURE__ */React49.createElement(React49.Fragment, null, " ") : /* @__PURE__ */React49.createElement(UitkSpacingHr, null)), /* @__PURE__ */React49.createElement(ExperimentVariant2, {
      bucket: 2
    }, isQuickFilters || fieldIndex === 0 || fieldIndex === fields.length - 1 || field.__typename === "ShoppingStepInputField" ? /* @__PURE__ */React49.createElement(React49.Fragment, null, " ") : /* @__PURE__ */React49.createElement(UitkSpacingHr, null))))));
  })));
};
SortAndFilterSection.displayName = "SortAndFilterSection";
SortAndFilterSection.fragment = __Fragment37;
// ../internal/src/components/sort-filter/__private/__fragments/toggle-button-field.tsx
import React51, { useCallback as useCallback2, useContext, useEffect as useEffect7 } from "react";
import { gql as gql47 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { CompareAdaptExContext } from "@shared-ui/retail-compare-providers";
import { UitkCard } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
// ../../../../node_modules/.pnpm/tslib@2.3.1/node_modules/tslib/tslib.es6.js
var extendStatics = function extendStatics1(d, b) {
  extendStatics = Object.setPrototypeOf || _instanceof({
    __proto__: []
  }, Array) && function (d2, b2) {
    d2.__proto__ = b2;
  } || function (d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
// ../../../../node_modules/.pnpm/uitk-react-switch@11.3.30_@egds+tokens-web@5.8.5_react@17.0.2_tslib@2.3.1_uitk-react-foundati_wrkvmmuqci4remeszyuuod2ssq/node_modules/uitk-react-switch/dist/uitk-switch.esm.js
import * as React50 from "react";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { classNames, UitkContextWrapper } from "uitk-react-utils";
// ../../../../node_modules/.pnpm/uitk-react-switch@11.3.30_@egds+tokens-web@5.8.5_react@17.0.2_tslib@2.3.1_uitk-react-foundati_wrkvmmuqci4remeszyuuod2ssq/node_modules/uitk-react-switch/dist/uitk-switch.css
var uitk_switch_default = {};
// ../../../../node_modules/.pnpm/uitk-react-switch@11.3.30_@egds+tokens-web@5.8.5_react@17.0.2_tslib@2.3.1_uitk-react-foundati_wrkvmmuqci4remeszyuuod2ssq/node_modules/uitk-react-switch/dist/uitk-switch.esm.js
var getClassNameList = classNames.bind(uitk_switch_default);
var UitkSwitch = /** @class */function (_super) {
  __extends(UitkSwitch2, _super);
  function UitkSwitch2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkSwitch2.prototype.render = function () {
    var _a;
    var _b = this.props,
      a11yLabel = _b.a11yLabel,
      checked = _b.checked,
      children = _b.children,
      className = _b.className,
      disabled = _b.disabled,
      description = _b.description,
      errorMessage = _b.errorMessage,
      id = _b.id,
      label = _b.label,
      labelClassName = _b.labelClassName,
      name = _b.name,
      onChange = _b.onChange,
      required = _b.required,
      switchPosition = _b.switchPosition,
      _c = _b.theme,
      theme = _c === void 0 ? "standard" : _c,
      value = _b.value;
    var baseCssClass = "uitk-switch";
    var wrapperClassNames = getClassNameList(baseCssClass, className, "".concat(baseCssClass, "-theme-").concat(theme), "".concat(baseCssClass, "-position-").concat(switchPosition), {
      "is-disabled": disabled
    });
    var labelCssClassNames = getClassNameList("uitk-switch-label", (_a = {}, _a[labelClassName] = Boolean(labelClassName), _a["is-required"] = required, _a));
    var inputClassNames = getClassNameList("".concat(baseCssClass, "-input"), {
      checked: checked
    });
    var controlClassNames = getClassNameList("".concat(baseCssClass, "-control"));
    var handleClassNames = getClassNameList("".concat(baseCssClass, "-control-handle"));
    var contentClassNames = getClassNameList("".concat(baseCssClass, "-content"));
    var labelContentClassNames = getClassNameList("".concat(baseCssClass, "-label-content"));
    var descriptionClassNames = getClassNameList("".concat(baseCssClass, "-description"));
    var errorClassNames = getClassNameList("".concat(baseCssClass, "-error"));
    var contents = label || children;
    var a11yContent = a11yLabel !== null && a11yLabel !== void 0 ? a11yLabel : contents === null || contents === void 0 ? void 0 : contents.toString();
    var a11yFullLabel = description ? "".concat(a11yContent, " ").concat(description) : a11yContent;
    return React50.createElement(UitkContextWrapper, null, function (context, data) {
      return React50.createElement("div", {
        className: wrapperClassNames
      }, React50.createElement("input", {
        type: "checkbox",
        name: name || id,
        id: id,
        checked: checked,
        className: inputClassNames,
        onChange: onChange,
        value: value,
        "aria-invalid": errorMessage ? true : void 0,
        disabled: disabled,
        "aria-required": required,
        "aria-label": a11yFullLabel
      }), React50.createElement("div", {
        "aria-hidden": "true",
        className: controlClassNames
      }, React50.createElement("div", {
        className: handleClassNames
      }, React50.createElement(UitkIcon3, {
        name: checked ? "check" : "close"
      }))), React50.createElement("div", {
        className: contentClassNames
      }, React50.createElement("label", {
        className: labelCssClassNames,
        htmlFor: id
      }, React50.createElement("span", {
        className: labelContentClassNames
      }, contents, required && (data === null || data === void 0 ? void 0 : data.hasRequiredFieldIndicator) && React50.createElement("span", {
        className: "uitk-switch-required-asterisk",
        "aria-hidden": "true"
      }, " ", "*")), description && React50.createElement("p", {
        className: descriptionClassNames
      }, description)), errorMessage && React50.createElement("p", {
        className: errorClassNames
      }, errorMessage)));
    });
  };
  UitkSwitch2.displayName = "UitkSwitch";
  UitkSwitch2.defaultProps = {
    checked: false,
    switchPosition: "leading"
  };
  return UitkSwitch2;
}(React50.Component);
// ../internal/src/components/sort-filter/__private/__fragments/toggle-button-field.tsx
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment4 = gql47(_templateObject52(), clientSideAnalyticsFragment);
var ToggleButtonField = function (param) {
  var data = param.data,
    placement = param.placement,
    _param_inlinePadding = param.inlinePadding,
    inlinePadding = _param_inlinePadding === void 0 ? "four" : _param_inlinePadding;
  var track = useClickTracker26();
  var _useContext = _sliced_to_array(useContext(CompareAdaptExContext), 2),
    state = _useContext[0],
    setState = _useContext[1];
  var checked = data.checked,
    checkedAnalytics = data.checkedAnalytics,
    checkedDescription = data.checkedDescription,
    checkedLabel = data.checkedLabel,
    uncheckedAnalytics = data.uncheckedAnalytics,
    uncheckedDescription = data.uncheckedDescription,
    uncheckedLabel = data.uncheckedLabel;
  useEffect7(function () {
    var toggleStateFromLocalStorage = typeof localStorage === "undefined" ? null : localStorage.getItem("toggleState") === String(true);
    setState(_object_spread_props(_object_spread({}, state), {
      enabled: toggleStateFromLocalStorage || checked
    }));
  }, []);
  var handleToggle = useCallback2(function () {
    var enabled = !state.enabled;
    var _ref;
    var _ref1 = (_ref = enabled ? checkedAnalytics : uncheckedAnalytics) !== null && _ref !== void 0 ? _ref : {},
      referrerId = _ref1.referrerId,
      linkName = _ref1.linkName,
      uisPrimeMessages = _ref1.uisPrimeMessages;
    setState(_object_spread_props(_object_spread({}, state), {
      enabled: enabled
    }));
    if (referrerId && linkName) {
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages !== null && uisPrimeMessages !== void 0 ? uisPrimeMessages : []));
    }
  }, [state, setState]);
  var description = state.enabled ? checkedDescription : uncheckedDescription;
  var label = state.enabled ? checkedLabel : uncheckedLabel;
  var isModal = placement === "MODAL";
  var toggle = /* @__PURE__ */React51.createElement(UitkSwitch, {
    id: "compare-toggle-filter",
    switchPosition: "trailing",
    checked: state.enabled,
    onChange: handleToggle,
    description: isModal && description || void 0,
    a11yLabel: label
  }, placement === "INLINE" ? /* @__PURE__ */React51.createElement(UitkText4, {
    whiteSpace: "nowrap",
    inline: true
  }, label) : label);
  if (isModal) {
    return /* @__PURE__ */React51.createElement(UitkSpacing19, {
      padding: {
        blockstart: "six",
        inline: inlinePadding
      }
    }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(UitkSpacing19, {
      padding: {
        blockend: "six"
      },
      border: ["blockend"]
    }, toggle)));
  }
  if (placement === "SIDEBAR") {
    return /* @__PURE__ */React51.createElement(UitkSpacing19, {
      margin: {
        blockstart: "six"
      }
    }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(UitkCard, {
      padded: true,
      border: true
    }, /* @__PURE__ */React51.createElement(UitkLayoutFlex12, null, /* @__PURE__ */React51.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */React51.createElement(UitkSwitch, {
      id: "compare-toggle-filter",
      switchPosition: "trailing",
      checked: state.enabled,
      onChange: handleToggle
    }, label))))));
  }
  return toggle;
};
ToggleButtonField.displayName = "CompareToggleField";
ToggleButtonField.fragment = fragment4;
// ../internal/src/components/sort-filter/__private/__fragments/toggle-filter-pill-field.tsx
import React52 from "react";
import { gql as gql48 } from "@apollo/client";
var __Fragment38 = gql48(_templateObject53(), clientSideAnalyticsFragment, EGDSPill.fragment);
var ToggleFilterPillField = function (param) {
  var loading = param.loading,
    handleOnClick = param.handleOnClick,
    data = param.data;
  var filterPill = data.filterPill;
  var isRemovablePill = (filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) === "EGDSBasicRemovablePill";
  var isBasicPill = (filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) === "EGDSBasicPill";
  if (filterPill === null || !isRemovablePill && !isBasicPill) {
    return null;
  }
  if (isBasicPill) {
    return /* @__PURE__ */React52.createElement(EGDSPill, {
      data: filterPill
    });
  }
  if (isRemovablePill) {
    return /* @__PURE__ */React52.createElement(EGDSBasicRemovablePill, {
      data: filterPill,
      loading: loading,
      onClick: handleOnClick
    });
  }
  return null;
};
ToggleFilterPillField.displayName = "ToggleFilterPillField";
ToggleFilterPillField.fragment = _object_spread_props(_object_spread({}, __Fragment38), {
  __typename: "ShoppingSortAndFilterToggleFilter"
});
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
var __Fragment39 = gql49(_templateObject54(), Toolbar.fragment, SortAndFilterSection.fragment, ToggleButtonField.fragment, UIFloatingActionButton.fragment, QuickAccessFilterField.fragment, AllFilterSheetFooter.fragment, QuickAccessFilterMoreFilters.fragment, ShoppingSortAndFiltersCarouselFragment, ToggleFilterPillField.fragment);
var viewType = "FILTER_BAR" /* FILTER_BAR */;
var SearchToolsFilterBar = function (param) {
  var data = param.data,
    onOpenDialog = param.onOpenDialog,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectionChange2 = param.onSelectionChange,
    onStepInputChange = param.onStepInputChange,
    onSubmit = param.onSubmit,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    onClearFilters = param.onClearFilters,
    loading = param.loading,
    footerDataLoading = param.footerDataLoading,
    onFieldClick = param.onFieldClick,
    isDatedSearch = param.isDatedSearch,
    stickyForViewsize = param.stickyFilterBarByViewsize,
    spacingStyling = param.filterBarSpacing,
    carouselEdgeItemsPadding = param.carouselEdgeItemsPadding,
    currentView = param.currentView,
    keepSectionExpanded = param.keepSectionExpanded,
    regionId = param.regionId;
  var _toolbarData_actions, _toolbarData_actions_secondaries_, _toolbarData_actions1, _revealAction_icon, _carousel_nextButton, _carousel_previousButton;
  var __typename = data.__typename,
    containers = data.containers,
    filterSections = data.filterSections,
    quickAccessFilters = data.quickAccessFilters,
    footerLabel = data.footerLabel,
    sortSections = data.sortSections,
    carousel = data.carousel,
    scrollEndAnalytics = data.scrollEndAnalytics,
    toggleButton = data.toggleButton;
  var _ref = (containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.view === viewType;
    })) || {},
    toolbarData = _ref.toolbar,
    revealAction = _ref.revealAction,
    applyAction = _ref.applyAction;
  var sortAndFilterSections = sortSections && filterSections && _to_consumable_array(sortSections).concat(_to_consumable_array(filterSections));
  var _useDialog4 = _sliced_to_array(useDialog4("".concat(__typename, "-").concat(viewType)), 3),
    isOpen = _useDialog4[0],
    _useDialog4_ = _useDialog4[1],
    openDialog = _useDialog4_.openDialog,
    closeDialog = _useDialog4_.closeDialog,
    DialogComponent = _useDialog4[2];
  var isSmallViewSize = useMediaQueries3({
    viewSizes: defaultViewSizes3
  }) === defaultViewSizes3.SMALL;
  var isMediumViewSize = useMediaQueries3({
    viewSizes: defaultViewSizes3
  }) === defaultViewSizes3.MEDIUM;
  var _React53_useState = _sliced_to_array(React53.useState(toolbarData), 2),
    toolbar = _React53_useState[0],
    setToolbar = _React53_useState[1];
  var _React53_useState1 = _sliced_to_array(React53.useState(false), 2),
    resetFilters = _React53_useState1[0],
    setResetFilters = _React53_useState1[1];
  var _React53_useState2 = _sliced_to_array(React53.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : (_toolbarData_actions_secondaries_ = _toolbarData_actions1.secondaries[0]) === null || _toolbarData_actions_secondaries_ === void 0 ? void 0 : _toolbarData_actions_secondaries_.disabled)), 2),
    filtersActive = _React53_useState2[0],
    setFiltersActive = _React53_useState2[1];
  var _React53_useState3 = _sliced_to_array(React53.useState(true), 2),
    submitButtonClicked = _React53_useState3[0],
    setSubmitButtonClicked = _React53_useState3[1];
  var _quickAccessFilters_map;
  var _React53_useState4 = _sliced_to_array(React53.useState((_quickAccessFilters_map = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function () {
      return false;
    })) !== null && _quickAccessFilters_map !== void 0 ? _quickAccessFilters_map : []), 2),
    isSheetVisibleList = _React53_useState4[0],
    setIsSheetVisibleList = _React53_useState4[1];
  var _React53_useState5 = _sliced_to_array(React53.useState(false), 2),
    isMoreFiltersButtonVisible = _React53_useState5[0],
    setIsMoreFiltersButtonVisible = _React53_useState5[1];
  var trackClick = useClickTracker27();
  var track = useClickstreamAnalytics().track;
  var isUISecondaryFloatingActionButton = (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton";
  var context = useBexApi3().context;
  var _useExperiment4 = useExperiment4(context.device.type === "MOBILE_PHONE" ? "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_mweb" : "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_web"),
    bexQuickFiltersExposure = _useExperiment4.exposure;
  var _useExperiment41 = useExperiment4("Quick_Filters_MVP_xLOB_Flights_Activities_Web"),
    xLOBQAFExposure = _useExperiment41.exposure;
  var _useExperiment42 = useExperiment4("Quick_Filters_xLOB_Lodging_mWeb_Retest"),
    xLOBLodgingMwebExposure = _useExperiment42.exposure;
  var _useExperiment43 = useExperiment4("Quick_Filter_Carousel_Buttons_Native_VrBex"),
    quickFilterCarouselButtonExposure = _useExperiment43.exposure;
  var _useExperiment44 = useExperiment4("Quick_Filters_VrBex_Arrow_Buttons"),
    quickFiltersVrboArrowExposure = _useExperiment44.exposure;
  var _useExperiment45 = useExperiment4("Filter_Removal_Phase_1_VrBex"),
    filterRemovalP1Exposure = _useExperiment45.exposure,
    filterRemovalP1ExperimentLogger = _useExperiment45.logExperiment;
  var _useExperiment46 = useExperiment4("Split_View_Side_by_side_BEXG_H"),
    bexSplitViewExposure = _useExperiment46.exposure;
  var _React53_useState6 = _sliced_to_array(React53.useState(true), 2),
    closeButtonClicked = _React53_useState6[0],
    setCloseButtonClicked = _React53_useState6[1];
  var shouldDisplayToolbarForQuickAccessFilters = xLOBQAFExposure.bucket === 1 && isSmallViewSize || xLOBLodgingMwebExposure.bucket === 1 && (isSmallViewSize || isMediumViewSize);
  var _useExperiment47 = useExperiment4("AI_Search_MVP_Web"),
    aISearchExposure = _useExperiment47.exposure;
  var shouldDisplayAISearch = aISearchExposure.bucket === 1;
  React53.useEffect(function () {
    var _toolbar_actions_secondaries;
    if (!toolbar) {
      return;
    }
    setToolbar(_object_spread_props(_object_spread({}, toolbar), {
      actions: {
        __typename: "UIToolbarActions",
        primary: _object_spread({}, toolbar.actions.primary),
        secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: !filtersActive && resetFilters
          });
        })) || []
      }
    }));
  }, [filtersActive, resetFilters]);
  React53.useEffect(function () {
    return setIsMoreFiltersButtonVisible(isSmallViewSize);
  }, [isSmallViewSize]);
  React53.useEffect(function () {
    if (!isOpen && !closeButtonClicked && !submitButtonClicked) {
      if (quickFilterCarouselButtonExposure.bucket === 1) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      }
      return;
    }
    if (!isOpen && !submitButtonClicked) {
      onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
      setResetFilters(false);
    }
    if (isOpen) {
      filterRemovalP1ExperimentLogger(filterRemovalP1Exposure);
    }
    setSubmitButtonClicked(false);
    setCloseButtonClicked(false);
  }, [isOpen]);
  var handleTriggerClick = React53.useCallback(function () {
    onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
    openDialog();
    if (isUISecondaryFloatingActionButton && (revealAction === null || revealAction === void 0 ? void 0 : revealAction.analytics)) {
      var _revealAction_analytics = revealAction.analytics,
        referrerId = _revealAction_analytics.referrerId,
        linkName = _revealAction_analytics.linkName;
      trackClick(referrerId, linkName);
    }
  }, [openDialog, onOpenDialog]);
  var handleSubmitClick = React53.useCallback(function () {
    setSubmitButtonClicked(true);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    setResetFilters(false);
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React53.useCallback(function () {
    setCloseButtonClicked(true);
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "restore" /* RESTORE */,
      value: {}
    });
    setResetFilters(false);
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React53.useCallback(function () {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear" /* CLEAR */,
      value: {}
    });
    setResetFilters(true);
    setFiltersActive(false);
  }, [onRemoveAllAppliedFilters, onClearFilters]);
  var handleQuickAccessFiltersClearButtonClick = React53.useCallback(function (quickAccessFilterFieldsData) {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters(quickAccessFilterFieldsData);
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear_quick_filters" /* CLEAR_QUICK_FILTERS */,
      value: quickAccessFilterFieldsData
    });
    setFiltersActive(false);
  }, [onRemoveAllAppliedFilters, onClearFilters]);
  var onSelectedField = React53.useCallback(function () {
    setToolbar(toolbarData);
    setResetFilters(false);
    setFiltersActive(true);
  }, [toolbarData]);
  var handleSheetToggle = function (index) {
    var newIsSheetVisibleList = isSheetVisibleList.map(function (isSheetVisible, sheetIndex) {
      if (sheetIndex === index) {
        return !isSheetVisible;
      }
      return false;
    });
    setIsSheetVisibleList(newIsSheetVisibleList);
  };
  var handleCarouselNextButtonClick = function () {
    var _carousel_nextButton;
    if (carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : _carousel_nextButton.analytics) {
      var _carousel_nextButton_analytics = carousel.nextButton.analytics,
        referrerId = _carousel_nextButton_analytics.referrerId,
        linkName = _carousel_nextButton_analytics.linkName;
      trackClick(referrerId, linkName);
    }
    setIsSheetVisibleList(isSheetVisibleList.map(function () {
      return false;
    }));
  };
  var handleCarouselPrevButtonClick = function () {
    var _carousel_previousButton;
    if (carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : _carousel_previousButton.analytics) {
      var _carousel_previousButton_analytics = carousel.previousButton.analytics,
        referrerId = _carousel_previousButton_analytics.referrerId,
        linkName = _carousel_previousButton_analytics.linkName;
      trackClick(referrerId, linkName);
    }
    setIsSheetVisibleList(isSheetVisibleList.map(function () {
      return false;
    }));
  };
  var handleCarouselScrollEnd = function () {
    if (scrollEndAnalytics) {
      var referrerId = scrollEndAnalytics.referrerId,
        linkName = scrollEndAnalytics.linkName;
      track(ITrackType.EVENT, {
        data: referrerMapper(referrerId, linkName, "impression")
      });
    }
  };
  var isInlineToggle = useExperiment4("Property_Compare_on_VRBO_xVector_Web", false).exposure.bucket === 2;
  if (!(sortAndFilterSections === null || sortAndFilterSections === void 0 ? void 0 : sortAndFilterSections.length) || !revealAction || !applyAction || !isUISecondaryFloatingActionButton) {
    return null;
  }
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  var mappedFilterSections = /* @__PURE__ */React53.createElement("div", null, sortAndFilterSections.map(function (section, index) {
    return /* @__PURE__ */React53.createElement(SortAndFilterSection, {
      key: "sort-section-".concat(index),
      onSelectedField: onSelectedField,
      resetFilters: resetFilters,
      data: section,
      onRangeSelectionChange: onRangeSelectionChange,
      onStepInputChange: onStepInputChange,
      onSelectionChange: onSelectionChange2,
      onFieldClick: onFieldClick,
      isDatedSearch: isDatedSearch,
      currentView: currentView,
      keepSectionExpanded: keepSectionExpanded
    });
  }));
  var primaryPillContent = "";
  if ((xLOBQAFExposure.bucket === 1 || xLOBLodgingMwebExposure.bucket === 1) && (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton" && isSmallViewSize) {
    if (revealAction.badge && revealAction.badge > 0) {
      primaryPillContent = "(".concat(revealAction.badge, ")");
    }
  } else {
    primaryPillContent = revealAction === null || revealAction === void 0 ? void 0 : revealAction.primary;
  }
  var aiSearchButtonAndSheet = shouldDisplayAISearch && /* @__PURE__ */React53.createElement(AISearchButtonAndSheet, {
    regionId: regionId,
    dialogAriaLabel: "AI search dialog"
  });
  var primaryPill = /* @__PURE__ */React53.createElement(UitkPill3, {
    id: "all-filters-pill",
    active: isOpen,
    icon: (_revealAction_icon = revealAction.icon) === null || _revealAction_icon === void 0 ? void 0 : _revealAction_icon.id,
    onClick: handleTriggerClick,
    selected: Boolean(revealAction.badge),
    onSubmit: handleSubmitClick,
    disabled: loading,
    triggerPill: true
  }, primaryPillContent);
  var filters = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function (quickAccessFilter, index) {
    var lastQuickfilter = index === quickAccessFilters.length - 1;
    switch (quickAccessFilter.__typename) {
      case "ShoppingSortAndFilterQuickFilter":
        return /* @__PURE__ */React53.createElement(QuickAccessFilterField, {
          key: "quick-access-".concat(index),
          data: quickAccessFilter,
          onFieldClick: onSelectedField,
          onRangeSelectionChange: onRangeSelectionChange,
          onStepInputChange: onStepInputChange,
          handleClearButtonClick: handleQuickAccessFiltersClearButtonClick,
          onSubmit: onSubmit,
          loading: loading,
          isSheetVisible: isSheetVisibleList[index] || false,
          onSheetToggle: handleSheetToggle,
          sheetIndex: index,
          lastQuickFilter: lastQuickfilter,
          onSheetDismiss: onClearFilters,
          footerDataLoading: footerDataLoading,
          bexQuickFiltersExposure: bexQuickFiltersExposure,
          quickFiltersVrboArrowExposure: quickFiltersVrboArrowExposure,
          quickFilterCarouselButtonExposure: quickFilterCarouselButtonExposure,
          isDatedSearch: isDatedSearch,
          closeButtonClicked: closeButtonClicked,
          setCloseButtonClicked: setCloseButtonClicked,
          shouldDisplayToolbarForQuickAccessFilters: shouldDisplayToolbarForQuickAccessFilters,
          bexSplitViewExposure: bexSplitViewExposure,
          xLOBLodgingMwebExposure: xLOBLodgingMwebExposure,
          xLOBQAFExposure: xLOBQAFExposure,
          keepSectionExpanded: keepSectionExpanded,
          isQuickFilters: true
        });
      case "ShoppingSortAndFilterButtonTrigger":
        if (!isMoreFiltersButtonVisible) {
          return null;
        }
        return /* @__PURE__ */React53.createElement(QuickAccessFilterMoreFilters, {
          data: quickAccessFilter,
          filterSections: mappedFilterSections,
          onOpenDialog: onOpenDialog,
          onClearFilters: onClearFilters,
          onSubmit: onSubmit,
          onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
          setFiltersActive: setFiltersActive,
          setResetFilters: setResetFilters,
          setSubmitButtonClicked: setSubmitButtonClicked,
          loading: loading
        });
      case "ShoppingSortAndFilterToggleFilter":
        return /* @__PURE__ */React53.createElement(ToggleFilterPillField, {
          data: quickAccessFilter,
          loading: loading
        });
      default:
        return null;
    }
  });
  var _carousel_nextButton_accessibility, _carousel_previousButton_accessibility;
  var carouselProps = {
    itemsVisible: {
      sm: "auto",
      md: "auto",
      lg: "auto",
      xl: "auto"
    },
    buttonText: {
      nextButton: (_carousel_nextButton_accessibility = carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : _carousel_nextButton.accessibility) !== null && _carousel_nextButton_accessibility !== void 0 ? _carousel_nextButton_accessibility : "",
      prevButton: (_carousel_previousButton_accessibility = carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : _carousel_previousButton.accessibility) !== null && _carousel_previousButton_accessibility !== void 0 ? _carousel_previousButton_accessibility : ""
    },
    pagingInset: true,
    hideNavOnScrollEnd: true,
    onNextButtonClick: handleCarouselNextButtonClick,
    onPrevButtonClick: handleCarouselPrevButtonClick,
    onScrollEnd: handleCarouselScrollEnd,
    edgeItemsPadding: isSmallViewSize ? carouselEdgeItemsPadding : "unset",
    isPopoverOpenList: [isOpen].concat(_to_consumable_array(isSheetVisibleList))
  };
  var inlineToggle = isInlineToggle && toggleButton ? /* @__PURE__ */React53.createElement(ToggleButtonField, {
    data: toggleButton,
    placement: "INLINE"
  }) : null;
  return /* @__PURE__ */React53.createElement(SignalEventsContextProvider, {
    eventManager: PubSubEventManager
  }, /* @__PURE__ */React53.createElement(StickyWrapper, {
    isDialogOpen: isOpen,
    stickyForViewsize: stickyForViewsize,
    spacingStyling: spacingStyling,
    isDisabled: bexSplitViewExposure.bucket === 1 || xLOBQAFExposure.bucket === 1 && !isSmallViewSize
  }, carousel ? /* @__PURE__ */React53.createElement(EGDSTeamCarousel, _object_spread({}, carouselProps), aiSearchButtonAndSheet, primaryPill, filters, inlineToggle) : /* @__PURE__ */React53.createElement(UitkLayoutFlex13, {
    wrap: "nowrap"
  }, aiSearchButtonAndSheet, /* @__PURE__ */React53.createElement(UitkLayoutFlexItem15, {
    shrink: 0
  }, primaryPill), filters, inlineToggle && /* @__PURE__ */React53.createElement(UitkSpacing20, {
    margin: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React53.createElement(UitkLayoutFlexItem15, {
    alignSelf: "center"
  }, /* @__PURE__ */React53.createElement("div", null, inlineToggle))))), /* @__PURE__ */React53.createElement(UitkSheetTransition3, {
    isVisible: isOpen
  }, /* @__PURE__ */React53.createElement(DialogComponent, null, /* @__PURE__ */React53.createElement(UitkSheet3, {
    type: isSmallViewSize ? "full" : "centered",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: null
  }, toolbar && /* @__PURE__ */React53.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React53.createElement(UitkDialogContent2, {
    zeroPadding: true
  }, !isInlineToggle && toggleButton && /* @__PURE__ */React53.createElement(ToggleButtonField, {
    data: toggleButton,
    placement: "MODAL",
    inlinePadding: "six"
  }), /* @__PURE__ */React53.createElement(UitkSpacing20, {
    padding: {
      inline: "six"
    }
  }, mappedFilterSections)), /* @__PURE__ */React53.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType,
    onClick: handleSubmitClick,
    isDoneButtonFullWidth: (bexQuickFiltersExposure === null || bexQuickFiltersExposure === void 0 ? void 0 : bexQuickFiltersExposure.bucket) === 1,
    isWrapped: true
  })))));
};
SearchToolsFilterBar.displayName = "SearchToolsFilterBar";
SearchToolsFilterBar.fragment = __Fragment39;
// ../internal/src/components/sort-filter/search-tools-filters.tsx
import React54 from "react";
import { gql as gql50 } from "@apollo/client";
var __Fragment40 = gql50(_templateObject55(), ToggleButtonField.fragment, SortAndFilterSection.fragment);
var SearchToolsFilters = function (props) {
  var data = props.data,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange2 = props.onSelectionChange,
    typeaheadAdapters = props.typeaheadAdapters,
    onRangeSelectionChange = props.onRangeSelectionChange,
    useUnsetMargin = props.useUnsetMargin,
    useUnsetTopBorder = props.useUnsetTopBorder,
    onEmptyResults = props.onEmptyResults,
    keepSectionExpanded = props.keepSectionExpanded,
    typeaheadLogger = props.typeaheadLogger,
    onKeyDown = props.onKeyDown,
    currentView = props.currentView;
  var filterSections = data.filterSections,
    toggleButton = data.toggleButton;
  if (!Array.isArray(filterSections)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React54.createElement(React54.Fragment, null, toggleButton && /* @__PURE__ */React54.createElement(ToggleButtonField, {
    data: toggleButton,
    placement: "SIDEBAR"
  }), filterSections.map(function (section, index) {
    return /* @__PURE__ */React54.createElement(SortAndFilterSection, {
      key: "filter-section-".concat(index),
      data: section,
      typeaheadAdapters: typeaheadAdapters,
      onMultiSelectClose: onMultiSelectClose,
      onMultiSelectItemRemove: onMultiSelectItemRemove,
      onMultiSelectClearAll: onMultiSelectClearAll,
      onSelectionChange: onSelectionChange2,
      onRangeSelectionChange: onRangeSelectionChange,
      useUnsetMargin: useUnsetMargin,
      useUnsetTopBorder: useUnsetTopBorder,
      keepSectionExpanded: keepSectionExpanded,
      typeaheadLogger: typeaheadLogger,
      onKeyDown: onKeyDown,
      currentView: currentView
    });
  }));
};
SearchToolsFilters.displayName = "SearchToolsFilters";
SearchToolsFilters.fragment = __Fragment40;
// ../internal/src/components/sort-filter/search-tools-sort.tsx
import React55 from "react";
import { gql as gql51 } from "@apollo/client";
var __Fragment41 = gql51(_templateObject56(), DropdownField.fragment);
var SearchToolsSort = function (param) {
  var data = param.data,
    onKeyPress = param.onKeyPress,
    onClick = param.onClick,
    onEmptyResults = param.onEmptyResults;
  var sortSections = data.sortSections;
  if (!Array.isArray(sortSections)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React55.createElement(React55.Fragment, null, sortSections.map(function (section) {
    return section.fields.map(function (field, index) {
      if (!(field.__typename === DropdownField.fragment.__typename)) {
        return null;
      }
      return /* @__PURE__ */React55.createElement("div", {
        "data-test-id": section.id,
        key: index
      }, /* @__PURE__ */React55.createElement(DropdownField, {
        key: "sort-field-".concat(index),
        data: field,
        onKeyPress: onKeyPress,
        onClick: onClick
      }));
    });
  }));
};
SearchToolsSort.displayName = "SearchToolsSort";
SearchToolsSort.fragment = __Fragment41;
// ../internal/src/components/sort-filter/search-tools-sort-and-filter.tsx
import React56 from "react";
import { gql as gql52 } from "@apollo/client";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { defaultViewSizes as defaultViewSizes4, useMediaQueries as useMediaQueries4 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent3 } from "uitk-react-dialog";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkScrim as UitkScrim2, UitkScrimType } from "uitk-react-scrim";
import { UitkSheet as UitkSheet4, UitkSheetTransition as UitkSheetTransition4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
var __Fragment42 = gql52(_templateObject57(), AllFilterSheetFooter.fragment, ToggleButtonField.fragment, SortAndFilterSection.fragment, Toolbar.fragment, UIFloatingActionButton.fragment);
var viewType2 = "SORT_AND_FILTERS" /* SORT_AND_FILTERS */;
var SearchToolsSortAndFilter = function (props) {
  var data = props.data,
    onEmptyResults = props.onEmptyResults,
    onFieldClick = props.onFieldClick,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSubmit = props.onSubmit,
    onOpenDialog = props.onOpenDialog,
    onClearFilters = props.onClearFilters,
    typeaheadAdapters = props.typeaheadAdapters,
    onSelectionChange2 = props.onSelectionChange,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters,
    keepSectionExpanded = props.keepSectionExpanded,
    onStepInputChange = props.onStepInputChange,
    withExtraMarginBlockEnd = props.withExtraMarginBlockEnd,
    withUpdatedNotification = props.withUpdatedNotification,
    onKeyDown = props.onKeyDown,
    onDone = props.onDone,
    footerDataLoading = props.footerDataLoading,
    currentView = props.currentView;
  var _ref = data || {},
    __typename = _ref.__typename,
    sortSections = _ref.sortSections,
    filterSections = _ref.filterSections,
    legacySections = _ref.sections,
    containers = _ref.containers,
    footerLabel = _ref.footerLabel,
    toggleButton = _ref.toggleButton;
  var _ref1 = (containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.view === viewType2;
    })) || {},
    toolbarData = _ref1.toolbar,
    revealAction = _ref1.revealAction,
    applyAction = _ref1.applyAction;
  var combinedSections = [sortSections, filterSections, legacySections];
  var isSmallViewSize = useMediaQueries4({
    viewSizes: defaultViewSizes4
  }) === defaultViewSizes4.SMALL;
  var _useDialog5 = _sliced_to_array(useDialog5("".concat(__typename, "-").concat(viewType2)), 3),
    isDialogOpen = _useDialog5[0],
    dialogActions = _useDialog5[1],
    DialogComponent = _useDialog5[2];
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var _React56_useState = _sliced_to_array(React56.useState(toolbarData), 2),
    toolbar = _React56_useState[0],
    setToolbar = _React56_useState[1];
  var _React56_useState1 = _sliced_to_array(React56.useState(false), 2),
    resetFilters = _React56_useState1[0],
    setResetFilters = _React56_useState1[1];
  var triggerRef = React56.useRef(null);
  var handleTriggerClick = React56.useCallback(function () {
    if (onOpenDialog) {
      onOpenDialog();
    }
    setResetFilters(false);
    setToolbar(toolbarData);
    openDialog();
  }, [onOpenDialog, openDialog, toolbarData]);
  var handleSubmitClick = React56.useCallback(function () {
    if (onSubmit) {
      onSubmit();
    }
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React56.useCallback(function () {
    if (onClearFilters) {
      onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React56.useCallback(function () {
    var _toolbar_actions_secondaries;
    if (onRemoveAllAppliedFilters) {
      onRemoveAllAppliedFilters();
    }
    if (onClearFilters) {
      onClearFilters({
        name: "clear" /* CLEAR */,
        value: {}
      });
    }
    setResetFilters(true);
    var toolBarAttributes = _object_spread_props(_object_spread({}, toolbar), {
      actions: _object_spread_props(_object_spread({}, toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions), {
        secondaries: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: true
          });
        })
      })
    });
    setToolbar(toolBarAttributes);
  }, [onRemoveAllAppliedFilters]);
  var onSelectedField = React56.useCallback(function () {
    setToolbar(toolbarData);
    setResetFilters(false);
  }, [toolbarData]);
  var hasSections = combinedSections.some(function (sections) {
    return Array.isArray(sections) && sections.length > 0;
  });
  if (!hasSections || !revealAction || !applyAction) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  return /* @__PURE__ */React56.createElement(React56.Fragment, null, /* @__PURE__ */React56.createElement(UIFloatingActionButton, {
    data: revealAction,
    isFullWidth: true,
    onClick: handleTriggerClick,
    withUpdatedNotification: withUpdatedNotification,
    triggerRef: triggerRef
  }), /* @__PURE__ */React56.createElement(UitkSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React56.createElement(DialogComponent, null, /* @__PURE__ */React56.createElement(UitkSheet4, {
    type: isSmallViewSize ? "full" : "centered",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React56.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React56.createElement(UitkDialogContent3, {
    zeroPadding: true
  }, toggleButton && /* @__PURE__ */React56.createElement(ToggleButtonField, {
    data: toggleButton,
    placement: "MODAL"
  }), /* @__PURE__ */React56.createElement(UitkSpacing21, {
    padding: {
      blockend: "twelve",
      inline: "four"
    },
    margin: {
      blockend: withExtraMarginBlockEnd ? "twelve" : "three"
    }
  }, /* @__PURE__ */React56.createElement("div", {
    "data-test-id": "sort-filter-drawer"
  }, combinedSections.map(function (sections) {
    if (!Array.isArray(sections)) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React56.createElement(SortAndFilterSection, {
        key: "sort-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onFieldClick: onFieldClick,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange2,
        onSelectedField: onSelectedField,
        onRangeSelectionChange: onRangeSelectionChange,
        onStepInputChange: onStepInputChange,
        keepSectionExpanded: keepSectionExpanded,
        resetFilters: resetFilters,
        onKeyDown: onKeyDown,
        onDone: onDone,
        currentView: currentView
      });
    });
  })))), /* @__PURE__ */React56.createElement(UitkLayoutPosition2, {
    position: {
      zindex: "layer1"
    }
  }, /* @__PURE__ */React56.createElement(UitkScrim2, {
    type: UitkScrimType.BUTTON
  }, /* @__PURE__ */React56.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType2,
    onClick: handleSubmitClick,
    isDoneButtonFullWidth: true,
    isWrapped: false
  })))))));
};
SearchToolsSortAndFilter.displayName = "SearchToolsSortAndFilter";
SearchToolsSortAndFilter.fragment = __Fragment42;
// ../internal/src/components/sort-filter/search-tools-filter-dialog.tsx
import React57 from "react";
import { gql as gql53 } from "@apollo/client";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkBadgeNotification as UitkBadgeNotification2 } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize6, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkScrim as UitkScrim3, UitkScrimType as UitkScrimType2 } from "uitk-react-scrim";
import { UitkSheet as UitkSheet5, UitkSheetTransition as UitkSheetTransition5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
var __Fragment43 = gql53(_templateObject58(), AllFilterSheetFooter.fragment, SortAndFilterSection.fragment, Toolbar.fragment, UIFloatingActionButton.fragment);
var viewType3 = "FILTER_DIALOG" /* FILTER_DIALOG */;
var SearchToolsFilterDialog = function (props) {
  var _toolbarData_actions, _toolbarData_actions_secondaries_, _toolbarData_actions1;
  var data = props.data,
    onEmptyResults = props.onEmptyResults,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSubmit = props.onSubmit,
    onOpenDialog = props.onOpenDialog,
    onClearFilters = props.onClearFilters,
    typeaheadAdapters = props.typeaheadAdapters,
    onSelectionChange2 = props.onSelectionChange,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters,
    keepSectionExpanded = props.keepSectionExpanded,
    footerDataLoading = props.footerDataLoading,
    currentView = props.currentView;
  var __typename = data.__typename,
    containers = data.containers,
    filterSections = data.filterSections,
    legacySections = data.sections,
    footerLabel = data.footerLabel;
  var _ref = (containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.view === viewType3;
    })) || {},
    toolbarData = _ref.toolbar,
    revealAction = _ref.revealAction,
    applyAction = _ref.applyAction;
  var combinedSections = [filterSections, legacySections];
  var _useDialog6 = _sliced_to_array(useDialog6("".concat(__typename, "-").concat(viewType3)), 3),
    isOpen = _useDialog6[0],
    dialogActions = _useDialog6[1],
    DialogComponent = _useDialog6[2];
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var _React57_useState = _sliced_to_array(React57.useState(toolbarData), 2),
    toolbar = _React57_useState[0],
    setToolbar = _React57_useState[1];
  var _React57_useState1 = _sliced_to_array(React57.useState(false), 2),
    resetFilters = _React57_useState1[0],
    setResetFilters = _React57_useState1[1];
  var _React57_useState2 = _sliced_to_array(React57.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : (_toolbarData_actions_secondaries_ = _toolbarData_actions1.secondaries[0]) === null || _toolbarData_actions_secondaries_ === void 0 ? void 0 : _toolbarData_actions_secondaries_.disabled)), 2),
    filtersActive = _React57_useState2[0],
    setFiltersActive = _React57_useState2[1];
  var _React57_useState3 = _sliced_to_array(React57.useState(true), 2),
    submitButtonClicked = _React57_useState3[0],
    setSubmitButtonClicked = _React57_useState3[1];
  var triggerRef = React57.useRef(null);
  React57.useEffect(function () {
    var _toolbar_actions_secondaries;
    if (!toolbar) {
      return;
    }
    setToolbar(_object_spread_props(_object_spread({}, toolbar), {
      actions: {
        __typename: "UIToolbarActions",
        primary: _object_spread({}, toolbar.actions.primary),
        secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: !filtersActive && resetFilters
          });
        })) || []
      }
    }));
  }, [filtersActive, resetFilters]);
  React57.useEffect(function () {
    if (!isOpen && !submitButtonClicked) {
      onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
      setResetFilters(false);
    }
    setSubmitButtonClicked(false);
  }, [isOpen, submitButtonClicked]);
  var track = useClickTracker28();
  var handleTriggerClick = React57.useCallback(function () {
    var _revealAction_analytics;
    if (onOpenDialog) {
      onOpenDialog();
    }
    if (revealAction && revealAction.__typename === "UISecondaryFloatingActionButton" && ((_revealAction_analytics = revealAction.analytics) === null || _revealAction_analytics === void 0 ? void 0 : _revealAction_analytics.__typename) === "ClientSideAnalytics") {
      var _revealAction_analytics1 = revealAction.analytics,
        referrerId = _revealAction_analytics1.referrerId,
        linkName = _revealAction_analytics1.linkName;
      track(referrerId, linkName);
    }
    openDialog();
  }, [openDialog, onOpenDialog, revealAction, track]);
  var handleSubmitClick = React57.useCallback(function () {
    setSubmitButtonClicked(true);
    if (onSubmit) {
      onSubmit();
    }
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React57.useCallback(function () {
    if (onClearFilters) {
      onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
    setResetFilters(false);
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React57.useCallback(function () {
    if (onRemoveAllAppliedFilters) {
      onRemoveAllAppliedFilters();
    }
    if (onClearFilters) {
      onClearFilters({
        name: "clear" /* CLEAR */,
        value: {}
      });
    }
    setResetFilters(true);
    setFiltersActive(false);
  }, [onRemoveAllAppliedFilters]);
  var onSelectedField = React57.useCallback(function () {
    setToolbar(toolbarData);
    setResetFilters(false);
    setFiltersActive(true);
  }, [toolbarData]);
  var hasSections = combinedSections.some(function (sections) {
    return Array.isArray(sections) && sections.length > 0;
  });
  if (!hasSections || !revealAction || !applyAction) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  if (revealAction.__typename !== "UISecondaryFloatingActionButton") {
    return null;
  }
  var badge = revealAction.badge,
    icon = revealAction.icon,
    primary = revealAction.primary;
  var btnContent = /* @__PURE__ */React57.createElement(React57.Fragment, null, !!badge && /* @__PURE__ */React57.createElement(UitkLayoutFlexItem16, null, /* @__PURE__ */React57.createElement(UitkLayoutPosition3, {
    type: "relative",
    position: {
      right: "two",
      bottom: "half"
    }
  }, /* @__PURE__ */React57.createElement(UitkBadgeNotification2, {
    count: badge.toString(),
    theme: "action",
    visible: true
  }))), icon && !badge && /* @__PURE__ */React57.createElement(UitkLayoutFlexItem16, null, /* @__PURE__ */React57.createElement(Icon, {
    data: icon
  })), /* @__PURE__ */React57.createElement(UitkLayoutFlexItem16, null, /* @__PURE__ */React57.createElement("div", null, primary)));
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  return /* @__PURE__ */React57.createElement(Viewport, null, /* @__PURE__ */React57.createElement(ViewSmall, null, /* @__PURE__ */React57.createElement(React57.Fragment, null, /* @__PURE__ */React57.createElement(UitkTertiaryButton3, {
    isFullWidth: true,
    onClick: handleTriggerClick,
    size: UitkButtonSize6.MEDIUM,
    domRef: triggerRef
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlex14, {
    direction: "column",
    alignItems: "center"
  }, btnContent)), /* @__PURE__ */React57.createElement(UitkSheetTransition5, {
    isVisible: isOpen
  }, /* @__PURE__ */React57.createElement(DialogComponent, null, /* @__PURE__ */React57.createElement(UitkSheet5, {
    type: "full",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React57.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React57.createElement(UitkDialogContent4, {
    zeroPadding: true
  }, /* @__PURE__ */React57.createElement(UitkSpacing22, {
    padding: {
      blockend: "twelve",
      inline: "four"
    },
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React57.createElement("div", null, combinedSections.map(function (sections) {
    if (!Array.isArray(sections) || sections.length === 0) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React57.createElement(SortAndFilterSection, {
        key: "filter-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange2,
        onSelectedField: onSelectedField,
        onRangeSelectionChange: onRangeSelectionChange,
        keepSectionExpanded: keepSectionExpanded,
        useUnsetTopBorder: true,
        resetFilters: resetFilters,
        currentView: currentView
      });
    });
  })))), /* @__PURE__ */React57.createElement(UitkLayoutPosition3, {
    position: {
      zindex: "layer1"
    }
  }, /* @__PURE__ */React57.createElement(UitkScrim3, {
    type: UitkScrimType2.BUTTON
  }, /* @__PURE__ */React57.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType3,
    onClick: handleSubmitClick,
    isDoneButtonFullWidth: true,
    isWrapped: false
  })))))))), /* @__PURE__ */React57.createElement(ViewMedium, null, /* @__PURE__ */React57.createElement(React57.Fragment, null, /* @__PURE__ */React57.createElement(UitkTertiaryButton3, {
    isFullWidth: true,
    onClick: handleTriggerClick,
    size: UitkButtonSize6.MEDIUM,
    domRef: triggerRef
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlex14, {
    space: badge ? "four" : "two"
  }, btnContent)), /* @__PURE__ */React57.createElement(UitkSheetTransition5, {
    isVisible: isOpen
  }, /* @__PURE__ */React57.createElement(DialogComponent, null, /* @__PURE__ */React57.createElement(UitkSheet5, {
    type: "centered",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React57.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React57.createElement(UitkDialogContent4, {
    zeroPadding: true
  }, /* @__PURE__ */React57.createElement(UitkSpacing22, {
    padding: {
      blockend: "twelve",
      inline: "four"
    },
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React57.createElement("div", null, combinedSections.map(function (sections) {
    if (!Array.isArray(sections) || sections.length === 0) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React57.createElement(SortAndFilterSection, {
        key: "filter-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange2,
        onSelectedField: onSelectedField,
        onRangeSelectionChange: onRangeSelectionChange,
        keepSectionExpanded: keepSectionExpanded,
        useUnsetTopBorder: true,
        resetFilters: resetFilters,
        currentView: currentView
      });
    });
  })))), /* @__PURE__ */React57.createElement(UitkLayoutPosition3, {
    position: {
      zindex: "layer1"
    }
  }, /* @__PURE__ */React57.createElement(UitkScrim3, {
    type: UitkScrimType2.BUTTON
  }, /* @__PURE__ */React57.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType3,
    onClick: handleSubmitClick,
    isDoneButtonFullWidth: true,
    isWrapped: false
  })))))))));
};
SearchToolsFilterDialog.displayName = "SearchToolsFilterDialog";
SearchToolsFilterDialog.fragment = __Fragment43;
// ../internal/src/components/sort-filter/search-tools-filter-pill.tsx
import React58 from "react";
import { gql as gql54 } from "@apollo/client";
import { UitkPillContainer as UitkPillContainer2 } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
var __Fragment44 = gql54(_templateObject59(), ToggleFilterPillField.fragment);
var filterPillpadding = {
  block: "half"
};
var SearchToolsFilterPill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    onEmptyResults = param.onEmptyResults;
  var quickAccessFilters = data.quickAccessFilters;
  if (!quickAccessFilters) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React58.createElement(UitkPillContainer2, null, quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function (filterPill, index) {
    var fieldID = "filter-pill-".concat(index);
    if (filterPill.__typename !== ToggleFilterPillField.fragment.__typename) {
      return null;
    }
    return /* @__PURE__ */React58.createElement(UitkSpacing23, {
      key: fieldID,
      padding: filterPillpadding
    }, /* @__PURE__ */React58.createElement("div", {
      "data-stid": fieldID
    }, /* @__PURE__ */React58.createElement(ToggleFilterPillField, {
      data: filterPill
    })));
  }));
};
SearchToolsFilterPill.displayName = "SearchToolsFilterPill";
SearchToolsFilterPill.fragment = __Fragment44;
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
import React60 from "react";
import { gql as gql56 } from "@apollo/client";
// ../internal/src/components/sort-filter/__private/__fragments/tab-selection-field.tsx
import React59, { useCallback as useCallback3, useEffect as useEffect8, useRef as useRef2, useState as useState8 } from "react";
import { gql as gql55 } from "@apollo/client";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback9 } from "uitk-react-form";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkHeading as UitkHeading14, UitkText as UitkText5 } from "uitk-react-text";
var __Fragment45 = gql55(_templateObject60(), clientSideAnalyticsFragment);
var useDidUpdateEffect = function (fn, deps) {
  var didMount = useRef2(false);
  useEffect8(function () {
    if (didMount.current) {
      return fn();
    }
    didMount.current = true;
  }, deps);
};
var TabSelectionField = function (param) {
  var data = param.data;
  var _tabOptions_currentTabIndex;
  var track = useClickTracker29();
  var tabOptions = data.tabOptions;
  var defaultIndex = (tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.findIndex(function (option) {
    return option.selected;
  })) || 0;
  var _useState8 = _sliced_to_array(useState8(defaultIndex), 2),
    currentTabIndex = _useState8[0],
    setCurrentTabIndex = _useState8[1];
  var _tabOptions_currentTabIndex_id;
  var tabSelectionFormCallback = useFormCallback9((_tabOptions_currentTabIndex_id = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.id) !== null && _tabOptions_currentTabIndex_id !== void 0 ? _tabOptions_currentTabIndex_id : "", function (event) {
    return event;
  });
  var handleTabSelect = useCallback3(function (selectedTabIndex) {
    var _tabOptions_selectedTabIndex;
    var selectAnalytics = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_selectedTabIndex = tabOptions[selectedTabIndex]) === null || _tabOptions_selectedTabIndex === void 0 ? void 0 : _tabOptions_selectedTabIndex.selectAnalytics;
    if (selectAnalytics) {
      var referrerId = selectAnalytics.referrerId,
        linkName = selectAnalytics.linkName,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    setCurrentTabIndex(selectedTabIndex);
  }, [tabOptions, track]);
  useEffect8(function () {
    setCurrentTabIndex(defaultIndex);
  }, [defaultIndex]);
  useDidUpdateEffect(function () {
    var _tabOptions_currentTabIndex;
    var _tabOptions_currentTabIndex_value;
    var fieldValue = (_tabOptions_currentTabIndex_value = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.value) !== null && _tabOptions_currentTabIndex_value !== void 0 ? _tabOptions_currentTabIndex_value : "";
    triggerInputChangeEvent(fieldValue, tabSelectionFormCallback);
  }, [currentTabIndex]);
  if (!(tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.length)) {
    return null;
  }
  return /* @__PURE__ */React59.createElement(UitkTabs, {
    selectedTab: currentTabIndex,
    onTabSelect: handleTabSelect,
    tabsType: UitkTabsType.EQUAL_WIDTH
  }, tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.map(function (option, index) {
    var accessibility = option.accessibility,
      id = option.id,
      primary = option.primary,
      secondary = option.secondary,
      value = option.value;
    var tabID = "".concat(id, "-").concat(value, "-").concat(index);
    return /* @__PURE__ */React59.createElement(UitkTab, {
      name: primary,
      id: id,
      key: tabID,
      targetURI: "#",
      tabLinkAttr: {
        id: tabID,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
      }
    }, /* @__PURE__ */React59.createElement(UitkSpacing24, {
      padding: {
        inline: "four",
        blockstart: "one"
      }
    }, /* @__PURE__ */React59.createElement("div", null, secondary && /* @__PURE__ */React59.createElement(React59.Fragment, null, /* @__PURE__ */React59.createElement(UitkHeading14, {
      size: 6,
      tag: "h3"
    }, primary), /* @__PURE__ */React59.createElement(UitkText5, {
      size: 200,
      spacing: "two"
    }, secondary)))));
  }));
};
TabSelectionField.displayName = "TabSelectionField";
TabSelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment45), {
  __typename: "ShoppingTabSelectionField"
});
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
var __Fragment46 = gql56(_templateObject61(), TabSelectionField.fragment);
var SearchToolsSortTabs = function (param) {
  var data = param.data,
    onEmptyResults = param.onEmptyResults;
  var sortSections = data.sortSections;
  if (!sortSections) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React60.createElement(React60.Fragment, null, sortSections.map(function (section) {
    return section.fields.map(function (field, index) {
      if (field.__typename !== TabSelectionField.fragment.__typename) {
        return null;
      }
      return /* @__PURE__ */React60.createElement("div", {
        "data-test-id": section.id,
        key: index
      }, /* @__PURE__ */React60.createElement(TabSelectionField, {
        key: "tabs-field-".concat(index),
        data: field
      }));
    });
  }));
};
SearchToolsSortTabs.displayName = "SearchToolsSortTabs";
SearchToolsSortTabs.fragment = __Fragment46;
var _obj1;
// ../internal/src/components/sort-filter/search-tools-sort-and-filters-views.tsx
var sortAndFiltersViewMap = (_obj1 = {}, _define_property(_obj1, "FILTERS" /* FILTERS */, SearchToolsFilters), _define_property(_obj1, "SORT" /* SORT */, SearchToolsSort), _define_property(_obj1, "SORT_AND_FILTERS" /* SORT_AND_FILTERS */, SearchToolsSortAndFilter), _define_property(_obj1, "APPLIED_FILTERS" /* APPLIED_FILTERS */, SearchToolsAppliedFilters), _define_property(_obj1, "FILTER_BAR" /* FILTER_BAR */, SearchToolsFilterBar), _define_property(_obj1, "FILTER_DIALOG" /* FILTER_DIALOG */, SearchToolsFilterDialog), _define_property(_obj1, "FILTERS_PILLS" /* FILTERS_PILLS */, SearchToolsFilterPill), _define_property(_obj1, "SORT_TABS" /* SORT_TABS */, SearchToolsSortTabs),
// the use rewards component was removed due to a PR revert
// this declaration is needed to pass build tests
// this will need to be updated once we have a use rewards component
_define_property(_obj1, "USE_REWARDS" /* USE_REWARDS */, SearchToolsSortTabs), _obj1);
// src/components/sort-filters/sort-filters.tsx
import { ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
import { UitkForm } from "uitk-react-form";
// src/components/sort-filters/utils/error-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
  SEARCH_TOOLS_LODGING_SORT_AND_FILTER_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "SORT_AND_FILTER_QUERY_ERROR"),
  SEARCH_TOOLS_LODGING_SORT_AND_FILTER_QUERY_NO_DATA: new SystemEvent(SystemEventLevel.INFO, "SORT_AND_FILTER_NO_DATA"),
  SEARCH_TOOLS_LODGING_FILTER_SHEET_FOOTER_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "FILTER_SHEET_FOOTER_QUERY_ERROR"),
  SEARCH_TOOLS_LODGING_FILTER_SHEET_FOOTER_QUERY_NO_DATA: new SystemEvent(SystemEventLevel.INFO, "FILTER_SHEET_FOOTER_NO_DATA")
};
// src/components/sort-filters/utils/merge-filter-sheet-footer-data.ts
var mergeFilterSheetFooterData = function (data, filterSheetFooterData) {
  var propertySearch = data.propertySearch;
  var universalSortAndFilter = propertySearch.universalSortAndFilter;
  var containers = universalSortAndFilter.containers,
    quickAccessFilters = universalSortAndFilter.quickAccessFilters;
  var _filterSheetFooterData_propertySearch_universalSortAndFilter = filterSheetFooterData.propertySearch.universalSortAndFilter,
    filterSheetFooterLabel = _filterSheetFooterData_propertySearch_universalSortAndFilter.footerLabel,
    filterSheetFooterContainers = _filterSheetFooterData_propertySearch_universalSortAndFilter.containers,
    filterSheetFooterQuickAccessFilters = _filterSheetFooterData_propertySearch_universalSortAndFilter.quickAccessFilters;
  var _containers_map, _quickAccessFilters_map;
  var newData = _object_spread_props(_object_spread({}, data), {
    propertySearch: _object_spread_props(_object_spread({}, propertySearch), {
      universalSortAndFilter: _object_spread_props(_object_spread({}, universalSortAndFilter), {
        footerLabel: filterSheetFooterLabel,
        containers: (_containers_map = containers === null || containers === void 0 ? void 0 : containers.map(function (container) {
          var newContainer = filterSheetFooterContainers === null || filterSheetFooterContainers === void 0 ? void 0 : filterSheetFooterContainers.find(function (lightweightContainer) {
            return lightweightContainer.view === container.view;
          });
          return _object_spread({}, container, newContainer);
        })) !== null && _containers_map !== void 0 ? _containers_map : null,
        quickAccessFilters: (_quickAccessFilters_map = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function (quickAccessFilter) {
          var newQuickAccessFilter = filterSheetFooterQuickAccessFilters === null || filterSheetFooterQuickAccessFilters === void 0 ? void 0 : filterSheetFooterQuickAccessFilters.find(function (lightweightQuickAccessFilter) {
            var _lightweightQuickAccessFilter_filterPill, _quickAccessFilter_filterPill;
            return lightweightQuickAccessFilter.__typename === "ShoppingSortAndFilterQuickFilter" && quickAccessFilter.__typename === "ShoppingSortAndFilterQuickFilter" && ((_lightweightQuickAccessFilter_filterPill = lightweightQuickAccessFilter.filterPill) === null || _lightweightQuickAccessFilter_filterPill === void 0 ? void 0 : _lightweightQuickAccessFilter_filterPill.id) === ((_quickAccessFilter_filterPill = quickAccessFilter.filterPill) === null || _quickAccessFilter_filterPill === void 0 ? void 0 : _quickAccessFilter_filterPill.id);
          });
          if ((newQuickAccessFilter === null || newQuickAccessFilter === void 0 ? void 0 : newQuickAccessFilter.__typename) !== "ShoppingSortAndFilterQuickFilter") {
            return quickAccessFilter;
          }
          var resultCountLabel = newQuickAccessFilter.resultCountLabel,
            applyAction = newQuickAccessFilter.applyAction;
          return _object_spread_props(_object_spread({}, quickAccessFilter), {
            resultCountLabel: resultCountLabel,
            applyAction: applyAction
          });
        })) !== null && _quickAccessFilters_map !== void 0 ? _quickAccessFilters_map : null
      })
    })
  });
  return newData;
};
// src/utils/query-params.ts
var SortAndFiltersParamsKeys = /* @__PURE__ */function (SortAndFiltersParamsKeys2) {
  SortAndFiltersParamsKeys2["SORT"] = "sort";
  SortAndFiltersParamsKeys2["HOTEL_NAME"] = "hotelName";
  SortAndFiltersParamsKeys2["REWARDS"] = "rewards";
  SortAndFiltersParamsKeys2["STAR"] = "star";
  SortAndFiltersParamsKeys2["GUEST_RATING"] = "guestRating";
  SortAndFiltersParamsKeys2["CLEANING_AND_SAFETY"] = "cleaningAndSafetyPractices";
  SortAndFiltersParamsKeys2["LODGING"] = "lodging";
  SortAndFiltersParamsKeys2["MEAL_PLAN"] = "mealPlan";
  SortAndFiltersParamsKeys2["AMENITIES"] = "amenities";
  SortAndFiltersParamsKeys2["TRAVELER_TYPE"] = "travelerType";
  SortAndFiltersParamsKeys2["PAYMENT_TYPE"] = "paymentType";
  SortAndFiltersParamsKeys2["DEALS"] = "deals";
  SortAndFiltersParamsKeys2["PROPERTY_STYLE"] = "propertyStyle";
  SortAndFiltersParamsKeys2["BEDROOM_FILTER"] = "bedroomFilter";
  SortAndFiltersParamsKeys2["NEIGHBORHOOD"] = "neighborhood";
  SortAndFiltersParamsKeys2["STAY_TYPE"] = "stayType";
  SortAndFiltersParamsKeys2["ACCESSIBILITY"] = "accessibility";
  SortAndFiltersParamsKeys2["POI"] = "poi";
  SortAndFiltersParamsKeys2["MIN_BEDROOMS"] = "bedroom_count_gt";
  SortAndFiltersParamsKeys2["MIN_BATHROOMS"] = "us_bathroom_count_gt";
  SortAndFiltersParamsKeys2["PROPERTY_TYPE"] = "property_type_group";
  SortAndFiltersParamsKeys2["LOCATION"] = "location_group";
  SortAndFiltersParamsKeys2["ACCESSIBILITY_FEATURES"] = "accessibility_features_group";
  SortAndFiltersParamsKeys2["BOOKING_OPTIONS"] = "booking_options_group";
  SortAndFiltersParamsKeys2["DISCOUNTS_GROUP"] = "discounts_group";
  SortAndFiltersParamsKeys2["AMENITIES_FACILITIES"] = "amenities_facilities_group";
  SortAndFiltersParamsKeys2["FREE_CANCELLATION_GROUP"] = "free_cancellation_group";
  SortAndFiltersParamsKeys2["HOUSE_RULES"] = "house_rules_group";
  SortAndFiltersParamsKeys2["NEARBY_ACTIVITIES"] = "nearby_activities_group";
  SortAndFiltersParamsKeys2["NEIGHBORHOOD_GROUP"] = "neighborhood_group";
  SortAndFiltersParamsKeys2["PREMIER_HOST"] = "premier_host_group";
  SortAndFiltersParamsKeys2["PROPERTIES_GOOD"] = "properties_good_for_group";
  SortAndFiltersParamsKeys2["PROPERTY_REVIEWS"] = "property_reviews_group";
  SortAndFiltersParamsKeys2["ROOMS_SPACES"] = "rooms_spaces_group";
  SortAndFiltersParamsKeys2["SAFETY"] = "safety_group";
  SortAndFiltersParamsKeys2["VIRTUAL_TOUR_GROUP"] = "virtual_tour_group";
  SortAndFiltersParamsKeys2["PRICING_GROUP"] = "pricing_group";
  SortAndFiltersParamsKeys2["PROPERTY_NAME"] = "propertyName";
  SortAndFiltersParamsKeys2["AVAILABLE_FILTER"] = "availableFilter";
  SortAndFiltersParamsKeys2["AGENCY_BUSINESS_MODELS"] = "agencyBusinessModels";
  SortAndFiltersParamsKeys2["COMMISSION_TIERS"] = "commissionTiers";
  SortAndFiltersParamsKeys2["BED_TYPE_GROUP"] = "bed_type_group";
  SortAndFiltersParamsKeys2["STAY_OPTIONS_GROUP"] = "stay_options_group";
  SortAndFiltersParamsKeys2["HOTEL_BRAND"] = "hotel_brand";
  SortAndFiltersParamsKeys2["MULTI_NEIGHBORHOOD_GROUP"] = "multi_neighborhood_group";
  SortAndFiltersParamsKeys2["SPECIAL_DISCOUNTS_GROUP"] = "special_discounts_group";
  return SortAndFiltersParamsKeys2;
}(SortAndFiltersParamsKeys || {});
var SortAndFiltersRangeParamKey = /* @__PURE__ */function (SortAndFiltersRangeParamKey2) {
  SortAndFiltersRangeParamKey2["PRICE"] = "price";
  SortAndFiltersRangeParamKey2["NIGHTLY_PRICE"] = "nightly_price";
  SortAndFiltersRangeParamKey2["TOTAL_PRICE"] = "total_price";
  return SortAndFiltersRangeParamKey2;
}(SortAndFiltersRangeParamKey || {});
// src/components/sort-filters/utils/sort-filters-utils.ts
var onSelectionChange = function (selectedData) {
  var _selectedData_data;
  return (selectedData === null || selectedData === void 0 ? void 0 : selectedData.term) ? {
    name: "propertyName" /* PROPERTY_NAME */,
    value: {
      selected: (_selectedData_data = selectedData.data) === null || _selectedData_data === void 0 ? void 0 : _selectedData_data.selected,
      hotelName: selectedData.term
    }
  } : {
    name: "propertyName" /* PROPERTY_NAME */,
    value: {}
  };
};
// src/components/sort-filters/utils/sort-filters-adapter-request-mapper.ts
import { ESSAdapter as ESSAdapter4 } from "uitk-react-typeahead";
var defaultMaxNumberOfResults = 10;
var defaultRegionType = 128;
var defaultLineOfBusiness = "hotels";
var getLodgingESSAdapters = function (data, expuserid, locale, guid, siteId, inputs) {
  var _data_propertySearch_universalSortAndFilter_filterSections;
  var adapters = /* @__PURE__ */new Map();
  (_data_propertySearch_universalSortAndFilter_filterSections = data.propertySearch.universalSortAndFilter.filterSections) === null || _data_propertySearch_universalSortAndFilter_filterSections === void 0 ? void 0 : _data_propertySearch_universalSortAndFilter_filterSections.map(function (filterSection) {
    return filterSection.fields.filter(function (field) {
      return field.__typename === "ShoppingTextInputField";
    });
  }).flat(2).forEach(function (shoppingTextInputField) {
    var _inputs_destination;
    var typeAheadInfo = shoppingTextInputField.typeaheadInfo;
    var _inputs_destination_regionId;
    var regionId = (_inputs_destination_regionId = (_inputs_destination = inputs.destination) === null || _inputs_destination === void 0 ? void 0 : _inputs_destination.regionId) !== null && _inputs_destination_regionId !== void 0 ? _inputs_destination_regionId : "";
    var _typeAheadInfo_client, _typeAheadInfo_isDestination, _typeAheadInfo_typeaheadFeatures, _typeAheadInfo_maxNumberOfResults, _typeAheadInfo_regionType, _typeAheadInfo_lineOfBusiness, _typeAheadInfo_domain;
    adapters.set(shoppingTextInputField.id, new ESSAdapter4({
      client: (_typeAheadInfo_client = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.client) !== null && _typeAheadInfo_client !== void 0 ? _typeAheadInfo_client : "",
      dest: (_typeAheadInfo_isDestination = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.isDestination) !== null && _typeAheadInfo_isDestination !== void 0 ? _typeAheadInfo_isDestination : false,
      expuserid: expuserid,
      features: (_typeAheadInfo_typeaheadFeatures = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.typeaheadFeatures) !== null && _typeAheadInfo_typeaheadFeatures !== void 0 ? _typeAheadInfo_typeaheadFeatures : "",
      guid: guid,
      locale: locale,
      maxResults: (_typeAheadInfo_maxNumberOfResults = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.maxNumberOfResults) !== null && _typeAheadInfo_maxNumberOfResults !== void 0 ? _typeAheadInfo_maxNumberOfResults : defaultMaxNumberOfResults,
      personalize: false,
      regionType: (_typeAheadInfo_regionType = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.regionType) !== null && _typeAheadInfo_regionType !== void 0 ? _typeAheadInfo_regionType : defaultRegionType,
      siteId: siteId,
      lob: (_typeAheadInfo_lineOfBusiness = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.lineOfBusiness) !== null && _typeAheadInfo_lineOfBusiness !== void 0 ? _typeAheadInfo_lineOfBusiness : defaultLineOfBusiness,
      domain: (_typeAheadInfo_domain = typeAheadInfo === null || typeAheadInfo === void 0 ? void 0 : typeAheadInfo.domain) !== null && _typeAheadInfo_domain !== void 0 ? _typeAheadInfo_domain : "",
      regionId: regionId
    }));
  });
  return adapters;
};
// src/components/sort-filters/sort-filters.tsx
var __Query = gql57(_templateObject62(), SearchToolsFilters.fragment, SearchToolsSort.fragment, SearchToolsSortAndFilter.fragment, SearchToolsFilterBar.fragment, SearchToolsAppliedFilters.fragment);
var __FilterSheetFooterQuery = gql57(_templateObject63(), AllFilterSheetFooter.fragment, QuickAccessFilterSheetFooter.fragment);
var LodgingSortAndFilters = function (props) {
  var _mockData_propertySearch, _filterSheetFooterInputs_criteria, _filterSheetFooterInputs_criteria_secondary, _filterSheetFooterInputs_criteria1, _inputs_criteria;
  var mockData = useMockData();
  var track = useClickTracker30();
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    view = props.view,
    onFieldChange = props.onFieldChange,
    onFieldClick = props.onFieldClick,
    onOpenDialog = props.onOpenDialog,
    isSearchResultsLoading = props.loading,
    filterSheetFooterInputs = props.filterSheetFooterInputs,
    onRemoveAppliedFilter = props.onRemoveAppliedFilter,
    onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters,
    isShoppingWithoutPackagePath = props.isShoppingWithoutPackagePath,
    fetchPolicy = props.fetchPolicy,
    filterBarSpacing = props.filterBarSpacing,
    carouselEdgeItemsPadding = props.carouselEdgeItemsPadding;
  var context = useBexApi4().context;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var _ref = identity || {},
    guid = _ref.duaid;
  var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
  var firstRender = React61.useRef(true);
  var _useExperiment5 = useExperiment5("Filter_Modal_Count_"),
    filterModalCountExposure = _useExperiment5.exposure;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: fetchPolicy,
      skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_propertySearch = mockData.propertySearch) === null || _mockData_propertySearch === void 0 ? void 0 : _mockData_propertySearch.universalSortAndFilter,
      onCompleted: function (result) {
        var _result_propertySearch;
        if (result === null || result === void 0 ? void 0 : (_result_propertySearch = result.propertySearch) === null || _result_propertySearch === void 0 ? void 0 : _result_propertySearch.universalSortAndFilter) {
          track("HOT.SR.FilterBar.Presented", "Filter bar presented");
        }
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    previousData = _useQuery.previousData;
  var universalSortAndFilterResponse = data || mockData;
  var footerLabel = universalSortAndFilterResponse === null || universalSortAndFilterResponse === void 0 ? void 0 : universalSortAndFilterResponse.propertySearch.universalSortAndFilter.footerLabel;
  var sortAndFilterEvents = useLoggerEvents(EVENTS);
  var cachedData = loading && previousData ? previousData : universalSortAndFilterResponse;
  var quickFiltersToUpdate = React61.useMemo(function () {
    var _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters;
    var _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters_reduce;
    return (_cachedData_propertySearch_universalSortAndFilter_quickAccessFilters_reduce = cachedData === null || cachedData === void 0 ? void 0 : (_cachedData_propertySearch_universalSortAndFilter_quickAccessFilters = cachedData.propertySearch.universalSortAndFilter.quickAccessFilters) === null || _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters === void 0 ? void 0 : _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters.reduce(function (result, quickAccessFilter) {
      var _quickAccessFilter_filterPill;
      if (quickAccessFilter.__typename !== "ShoppingSortAndFilterQuickFilter" || ((_quickAccessFilter_filterPill = quickAccessFilter.filterPill) === null || _quickAccessFilter_filterPill === void 0 ? void 0 : _quickAccessFilter_filterPill.__typename) !== "EGDSBasicTriggerPill" || !quickAccessFilter.filterPill.id) {
        return result;
      }
      return _to_consumable_array(result).concat([{
        id: "results_count_quick_filter_id",
        value: quickAccessFilter.filterPill.id
      }]);
    }, [])) !== null && _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters_reduce !== void 0 ? _cachedData_propertySearch_universalSortAndFilter_quickAccessFilters_reduce : [];
  }, [JSON.stringify(cachedData === null || cachedData === void 0 ? void 0 : cachedData.propertySearch.universalSortAndFilter.quickAccessFilters)]);
  var _filterSheetFooterInputs_criteria_secondary_selections;
  var filterSheetFooterVariables = _object_spread_props(_object_spread({
    context: context,
    destination: {}
  }, filterSheetFooterInputs), {
    criteria: _object_spread_props(_object_spread({
      primary: {
        destination: {},
        rooms: []
      }
    }, filterSheetFooterInputs === null || filterSheetFooterInputs === void 0 ? void 0 : filterSheetFooterInputs.criteria), {
      secondary: _object_spread_props(_object_spread({}, filterSheetFooterInputs === null || filterSheetFooterInputs === void 0 ? void 0 : (_filterSheetFooterInputs_criteria = filterSheetFooterInputs.criteria) === null || _filterSheetFooterInputs_criteria === void 0 ? void 0 : _filterSheetFooterInputs_criteria.secondary), {
        selections: _to_consumable_array((_filterSheetFooterInputs_criteria_secondary_selections = filterSheetFooterInputs === null || filterSheetFooterInputs === void 0 ? void 0 : (_filterSheetFooterInputs_criteria1 = filterSheetFooterInputs.criteria) === null || _filterSheetFooterInputs_criteria1 === void 0 ? void 0 : (_filterSheetFooterInputs_criteria_secondary = _filterSheetFooterInputs_criteria1.secondary) === null || _filterSheetFooterInputs_criteria_secondary === void 0 ? void 0 : _filterSheetFooterInputs_criteria_secondary.selections) !== null && _filterSheetFooterInputs_criteria_secondary_selections !== void 0 ? _filterSheetFooterInputs_criteria_secondary_selections : []).concat(_to_consumable_array(quickFiltersToUpdate))
      })
    })
  });
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__FilterSheetFooterQuery, {
      variables: filterSheetFooterVariables,
      ssr: !skipSsr,
      onError: function (filterSheetFooterError) {
        var name = filterSheetFooterError.name,
          message = filterSheetFooterError.message;
        sortAndFilterEvents.SEARCH_TOOLS_LODGING_FILTER_SHEET_FOOTER_QUERY_ERROR.log({
          name: name,
          message: "Error while fetching new filter sheet footer data. Error: ".concat(message)
        });
      },
      onCompleted: function (fetchedFilterSheetFooterData) {
        if (!fetchedFilterSheetFooterData) {
          sortAndFilterEvents.SEARCH_TOOLS_LODGING_FILTER_SHEET_FOOTER_QUERY_NO_DATA.log({
            message: "No data while fetching new filter sheet footer data"
          });
        }
      }
    }), 2),
    fetchFilterSheetFooterQuery = _useLazyQuery[0],
    _useLazyQuery_ = _useLazyQuery[1],
    filterSheetFooterData = _useLazyQuery_.data,
    previousFilterSheetFooterData = _useLazyQuery_.previousData,
    filterSheetFooterLoading = _useLazyQuery_.loading;
  React61.useEffect(function () {
    if (view !== "FILTER_BAR" /* FILTER_BAR */) {
      return;
    }
    if (loading) {
      track("HOT.SR.FilterBar.Initiated", "Filter bar initiated");
    }
  }, [loading, view]);
  var isClientSide = typeof window !== "undefined";
  React61.useEffect(function () {
    if (view !== "FILTER_BAR" /* FILTER_BAR */) {
      return;
    }
    if (isClientSide) {
      track("HOT.SR.FilterBar.Initiated", "Filter bar initiated");
    }
  }, []);
  React61.useEffect(function () {
    if (filterModalCountExposure.bucket === 1 && isShoppingWithoutPackagePath) {
      fetchFilterSheetFooterQuery();
      return;
    }
    if (firstRender.current || view !== "FILTER_BAR" /* FILTER_BAR */ || !filterSheetFooterInputs) {
      firstRender.current = false;
      return;
    }
    if (footerLabel) {
      fetchFilterSheetFooterQuery();
    }
  }, [JSON.stringify(filterSheetFooterInputs)]);
  var LoadingSkeleton = loadingSkeletonMap.get(view);
  if (loading && !universalSortAndFilterResponse && !previousData && LoadingSkeleton) {
    return /* @__PURE__ */React61.createElement(LoadingSkeleton, {
      filterBarSpacing: filterBarSpacing
    });
  }
  if (error) {
    sortAndFilterEvents.SEARCH_TOOLS_LODGING_SORT_AND_FILTER_QUERY_ERROR.log({
      name: error.name,
      message: "Error while loading Universal sort and filter module. Error: ".concat(error.message)
    });
    return null;
  }
  if (!cachedData || !cachedData.propertySearch.universalSortAndFilter) {
    if (!loading) {
      sortAndFilterEvents.SEARCH_TOOLS_LODGING_SORT_AND_FILTER_QUERY_NO_DATA.log({
        message: "No data while loading universal sort and filter module"
      });
    }
    return null;
  }
  var handleFieldChange = function (field, event) {
    onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
  };
  var handleSelectionChange = function (selectedData, event) {
    var selection = onSelectionChange(selectedData);
    handleFieldChange(selection, event);
  };
  var handleRangeSelectionChange = function (selected) {
    var field = {
      name: selected.id,
      value: {
        min: selected.min,
        max: selected.max
      }
    };
    handleFieldChange(field);
  };
  var handleStepInputChange = function (id, value) {
    var field = {
      name: id,
      value: value
    };
    handleFieldChange(field);
  };
  var View = sortAndFiltersViewMap[view];
  if (!View) {
    return null;
  }
  var typeaheadAdapters = getLodgingESSAdapters(cachedData, expuserid, locale, guid, siteId, inputs);
  var cachedFilterSheetFooterData = filterSheetFooterData !== null && filterSheetFooterData !== void 0 ? filterSheetFooterData : previousFilterSheetFooterData;
  var mergedData = cachedFilterSheetFooterData ? mergeFilterSheetFooterData(cachedData, cachedFilterSheetFooterData) : cachedData;
  var _inputs_criteria_primary;
  var dateRange = ((_inputs_criteria_primary = (_inputs_criteria = inputs.criteria) === null || _inputs_criteria === void 0 ? void 0 : _inputs_criteria.primary) !== null && _inputs_criteria_primary !== void 0 ? _inputs_criteria_primary : {}).dateRange;
  var _obj;
  return /* @__PURE__ */React61.createElement(UitkForm, {
    onFieldChange: handleFieldChange
  }, /* @__PURE__ */React61.createElement(View, _object_spread({
    data: mergedData.propertySearch.universalSortAndFilter,
    onClearFilters: handleFieldChange,
    typeaheadAdapters: typeaheadAdapters,
    onRangeSelectionChange: handleRangeSelectionChange,
    onRemoveAppliedFilter: onRemoveAppliedFilter,
    onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
    onSelectionChange: handleSelectionChange,
    onStepInputChange: handleStepInputChange,
    onClick: onFieldClick,
    onOpenDialog: onOpenDialog,
    loading: isSearchResultsLoading,
    footerDataLoading: filterSheetFooterLoading,
    withUpdatedNotification: true,
    isShoppingWithoutPackagePath: isShoppingWithoutPackagePath,
    isDatedSearch: Boolean(dateRange),
    stickyFilterBarByViewsize: (_obj = {}, _define_property(_obj, ViewSizes2.SMALL, true), _define_property(_obj, ViewSizes2.MEDIUM, true), _define_property(_obj, ViewSizes2.LARGE, false), _define_property(_obj, ViewSizes2.EXTRA_LARGE, false), _obj),
    filterBarSpacing: filterBarSpacing,
    carouselEdgeItemsPadding: carouselEdgeItemsPadding,
    currentView: view,
    regionId: inputs.destination.regionId,
    keepSectionExpanded: true
  }, props)));
};
LodgingSortAndFilters.displayName = "sharedui-LodgingSortAndFilters";
// test/fixtures/mock-cars-inputs.ts
var mockCarsSortAndFilterResponse = {
  propertySearch: {
    universalSortAndFilter: {
      scrollEndAnalytics: null,
      carousel: null,
      toggleButton: null,
      filterSections: [{
        __typename: "ShoppingSortAndFilterSection",
        id: null,
        title: "Filter by",
        subTitle: null,
        fields: [{
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-1",
          primary: "AARP Member Exclusive",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "AARP Member Exclusive",
            secondary: "$999",
            selected: false,
            value: "freeCancellation",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.freeCancellation",
              referrerId: "LX-GT.SR.filterCategories.freeCancellation.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.freeCancellation",
              referrerId: "LX-GT.SR.filterCategories.freeCancellation.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "freeCancellation-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "freeCancellation-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "freeCancellation-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Free cancellation",
                  id: "freeCancellation",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.freeCancellation",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Free cancellation",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "freeCancellation-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "freeCancellation",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-2",
          primary: "Exclusive offers",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Member Prices",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Seasonal Sale",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Mobile Exclusive",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-3",
          primary: "Car type",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Economy",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Compact",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Midsize",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Standard",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Full-size",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Premium",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Luxury",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Convertible",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Minivan",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "SUV",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Van",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Pickup",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Sports car",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Other",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-4",
          primary: "Capacity",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "2-5 passengers",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "6 or more passengers",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-5",
          primary: "Electric cars",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Electric",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Hybrid",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-5",
          primary: "Cancellation Policy",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Free cancellation",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-5",
          primary: "Save time during pick up",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Skip-the counter",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Online check-in",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingSelectionField",
          primary: "Traveler rating",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            primary: "Any",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            default: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            primary: "Excellent 80% & up",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            default: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            primary: "Good 60% & up",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            default: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-6",
          primary: "Payment option",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Pay now",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Pay later",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          numberFormat: "$#,##0.",
          fieldId: "price",
          minValueInput: {
            egdsElementId: null,
            label: "Min",
            readOnly: false,
            value: "$0",
            __typename: "EGDSTextInputField"
          },
          maxValueInput: {
            egdsElementId: null,
            label: "Max",
            readOnly: false,
            value: "$1,000+",
            __typename: "EGDSTextInputField"
          },
          rangeField: {
            characteristics: {
              max: 1e3,
              maxLabel: "$1,000+",
              min: 0,
              minLabel: "$0",
              step: 1,
              __typename: "ShoppingRangeCharacteristics"
            },
            id: "price",
            selected: {
              id: "price",
              max: 1e3,
              min: 0,
              __typename: "RangeValue"
            },
            analytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "price.",
              referrerId: "HOT.SR.price.",
              uisPrimeMessages: [],
              __typename: "ClientSideAnalytics"
            },
            receivers: null,
            emitters: null,
            __typename: "ShoppingRangeFilterOption"
          },
          primary: "Total price",
          secondary: null,
          lowerBoundAccessibility: "$0",
          upperBoundAccessibility: "$1,000 and above",
          minValueAccessibility: {
            models: [{
              key: "selectedValue",
              source: "range.selected.min",
              __typename: "TemplateModel"
            }],
            // eslint-disable-next-line no-template-curly-in-string
            template: "${selectedValue}",
            text: "Minimum",
            __typename: "EGDSBasicLocalizedText"
          },
          maxValueAccessibility: {
            models: [{
              key: "selectedValue",
              source: "range.selected.max",
              __typename: "TemplateModel"
            }],
            // eslint-disable-next-line no-template-curly-in-string
            template: "${selectedValue}",
            text: "Maximum",
            __typename: "EGDSBasicLocalizedText"
          },
          minValueAnalytics: {
            eventType: "CLICK" /* CLICK */,
            linkName: "price.MinimumInput",
            referrerId: "HOT.SR.price.MinimumInput",
            uisPrimeMessages: [],
            __typename: "ClientSideAnalytics"
          },
          maxValueAnalytics: {
            eventType: "CLICK" /* CLICK */,
            linkName: "price.MaximumInput",
            referrerId: "HOT.SR.price.MaximumInput",
            uisPrimeMessages: [],
            __typename: "ClientSideAnalytics"
          },
          __typename: "ShoppingRangeTextInputField"
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-7",
          primary: "Rental car company",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Ace",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Alamo",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Avis",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Budget",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Dollar",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Enterprise",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-8",
          primary: "Airport pick-up",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "At terminal",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Free shuttle",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }, {
          __typename: "ShoppingMultiSelectionField",
          fieldId: "sample-fieldId-9",
          primary: "Specification",
          secondary: "from",
          expando: {
            collapseLabel: "See less",
            collapseAccessibilityLabel: "See less options",
            expandAccessibilityLabel: "See more options",
            collapseAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.false",
              __typename: "ClientSideAnalytics"
            },
            expandAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.expand",
              referrerId: "LX-GT.SR.filterCategories.expand.true",
              __typename: "ClientSideAnalytics"
            },
            expandLabel: "See more",
            minimalHeight: 3,
            threshold: 3,
            visible: false,
            __typename: "ShoppingSelectionExpando"
          },
          options: [{
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Automatic",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Unlimited Mileage",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "Limited Mileage",
            secondary: "$999",
            selected: false,
            value: "privateTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.true:0",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.privateTransfer",
              referrerId: "LX-GT.SR.filterCategories.privateTransfer.false:0",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "privateTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "privateTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "privateTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Private transfer",
                  id: "privateTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.privateTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Private transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "privateTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "privateTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }, {
            __typename: "ShoppingSelectableFilterOption",
            accessibility: null,
            fieldId: "filterCategories",
            description: null,
            graphic: null,
            primary: "All-wheel drive/4X4",
            secondary: "$999",
            selected: false,
            value: "sharedTransfer",
            disabled: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.true:1",
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              uisPrimeMessages: [],
              linkName: "filterCategories.sharedTransfer",
              referrerId: "LX-GT.SR.filterCategories.sharedTransfer.false:1",
              __typename: "ClientSideAnalytics"
            },
            receivers: [{
              signalId: "sharedTransfer-deselected",
              __typename: "SortAndFilterSignalReceiver"
            }],
            emitters: [{
              signalId: "sharedTransfer-interacted",
              condition: "SELECTED" /* SELECTED */,
              payload: {
                deselectionSignalId: "sharedTransfer-deselected",
                filter: {
                  name: "filterCategories",
                  accessibility: "Shared transfer",
                  id: "sharedTransfer",
                  removeAnalytics: {
                    eventType: "CLICK" /* CLICK */,
                    uisPrimeMessages: [],
                    linkName: "RemoveFilter",
                    referrerId: "LX-GT.SR.RemoveFilter.filterCategories.sharedTransfer",
                    __typename: "ClientSideAnalytics"
                  },
                  __typename: "EGDSBasicRemovablePill"
                },
                filterName: {
                  text: "Shared transfer",
                  __typename: "EGDSPlainText"
                },
                __typename: "SortAndFilterSelectedFilterPillPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }, {
              signalId: "sharedTransfer-interacted",
              condition: "UNSELECTED" /* UNSELECTED */,
              payload: {
                filterId: "sharedTransfer",
                type: "REMOVE" /* REMOVE */,
                __typename: "SortAndFilterBasicFilterPayload"
              },
              __typename: "SortAndFilterSignalEmitter"
            }]
          }]
        }]
      }],
      __typename: "ShoppingSortAndFilters",
      sortSections: [{
        id: null,
        fields: [{
          __typename: "ShoppingDropdownField",
          primary: "Sort by",
          secondary: null,
          dropdownOptions: [{
            accessibility: "Sort by total price: low to high",
            id: "sort",
            primary: "Total Price",
            value: "",
            defaultOption: false,
            selected: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.PRICE_LOW_TO_HIGH",
              referrerId: "HOT.SR.sort.PRICE_LOW_TO_HIGH.true",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.PRICE_LOW_TO_HIGH",
              referrerId: "HOT.SR.sort.PRICE_LOW_TO_HIGH.false",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            __typename: "ShoppingSelectableFilterOption"
          }, {
            accessibility: "",
            id: "sort",
            primary: "Distance",
            value: "",
            defaultOption: false,
            selected: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.PRICE_HIGH_TO_LOW",
              referrerId: "HOT.SR.sort.PRICE_HIGH_TO_LOW.true",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.PRICE_HIGH_TO_LOW",
              referrerId: "HOT.SR.sort.PRICE_HIGH_TO_LOW.false",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            __typename: "ShoppingSelectableFilterOption"
          }, {
            accessibility: "",
            id: "sort",
            primary: "Traveler Ratings",
            value: "",
            defaultOption: false,
            selected: false,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.DISTANCE",
              referrerId: "HOT.SR.sort.DISTANCE.true",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.DISTANCE",
              referrerId: "HOT.SR.sort.DISTANCE.false",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            __typename: "ShoppingSelectableFilterOption"
          }, {
            accessibility: "Sort by recommended",
            id: "sort",
            primary: "Recommended",
            value: "RECOMMENDED",
            defaultOption: true,
            selected: true,
            selectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.RECOMMENDED",
              referrerId: "HOT.SR.sort.RECOMMENDED.true",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
              eventType: "CLICK" /* CLICK */,
              linkName: "sort.RECOMMENDED",
              referrerId: "HOT.SR.sort.RECOMMENDED.false",
              uisPrimeMessages: [{
                schemaName: "searchMetaGlobal",
                messageContent: '{"searchId":"7cacbc3b-af37-4f03-92db-15ea204ab1d5"}',
                __typename: "EGUisMicroMessage"
              }],
              __typename: "ClientSideAnalytics"
            },
            __typename: "ShoppingSelectableFilterOption"
          }]
        }],
        __typename: "ShoppingSortAndFilterSection",
        title: "Sort by",
        subTitle: null
      }],
      footerLabel: null,
      containers: [{
        view: "FILTER_DIALOG" /* FILTER_DIALOG */,
        applyAction: {
          __typename: "UIPrimaryFloatingActionButton",
          accessibility: "Apply and close Sort and Filter",
          primary: "Done",
          badge: null,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            uisPrimeMessages: [],
            linkName: "done search filters dialog",
            referrerId: "LX-GT.SR.FilterControlDone",
            __typename: "ClientSideAnalytics"
          },
          icon: null,
          egdsElementId: null,
          disabled: false
        },
        __typename: "ShoppingSortAndFilterDialogContainer",
        revealAction: {
          __typename: "UISecondaryFloatingActionButton",
          accessibility: "1 filter applied. Change sort or apply more filters.",
          primary: "Filter",
          badge: 1,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            linkName: "Launch filters takeover",
            referrerId: "LX-GT.SR:FilterControl",
            __typename: "ClientSideAnalytics",
            uisPrimeMessages: [{
              __typename: "EGUisMicroMessage",
              messageContent: "{}",
              schemaName: ""
            }]
          },
          icon: {
            id: "tune",
            title: "",
            token: "icon__tune",
            description: "reveals sort and filter window",
            size: null,
            __typename: "Icon"
          },
          egdsElementId: null
        },
        toolbar: {
          __typename: "UIToolbar",
          primary: "Filter",
          actions: {
            primary: {
              egdsElementId: null,
              primary: null,
              disabled: false,
              accessibility: "Close Sort and Filter",
              icon: {
                id: "close",
                description: "dismisses sort and filter window",
                token: "icon__close",
                title: "",
                __typename: "Icon"
              },
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "close search filters dialog",
                referrerId: "LX-GT.SR.CloseFilterDialog.Close",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: null,
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            },
            secondaries: [{
              egdsElementId: null,
              primary: "Clear",
              disabled: false,
              accessibility: "Clear all selections",
              icon: null,
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "clear all selections",
                referrerId: "LX-GT.SR.ClearFilters",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: "All selections now cleared",
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            }],
            __typename: "UIToolbarActions"
          }
        }
      }, {
        view: "FILTER_BAR" /* FILTER_BAR */,
        applyAction: {
          __typename: "UIPrimaryFloatingActionButton",
          accessibility: "Apply and close Sort and Filter",
          primary: "Done",
          badge: null,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            uisPrimeMessages: [],
            linkName: "done search filters dialog",
            referrerId: "LX-GT.SR.FilterControlDone",
            __typename: "ClientSideAnalytics"
          },
          icon: null,
          egdsElementId: null,
          disabled: false
        },
        __typename: "ShoppingSortAndFilterDialogContainer",
        revealAction: {
          __typename: "UISecondaryFloatingActionButton",
          accessibility: "1 filter applied. Change sort or apply more filters.",
          primary: "Filter",
          badge: 1,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            linkName: "Launch filters takeover",
            referrerId: "LX-GT.SR:FilterControl",
            __typename: "ClientSideAnalytics",
            uisPrimeMessages: [{
              __typename: "EGUisMicroMessage",
              messageContent: "{}",
              schemaName: ""
            }]
          },
          icon: {
            id: "tune",
            title: "",
            token: "icon__tune",
            description: "reveals sort and filter window",
            size: null,
            __typename: "Icon"
          },
          egdsElementId: null
        },
        toolbar: {
          __typename: "UIToolbar",
          primary: "Filter",
          actions: {
            primary: {
              egdsElementId: null,
              primary: null,
              disabled: false,
              accessibility: "Close Sort and Filter",
              icon: {
                id: "close",
                description: "dismisses sort and filter window",
                token: "icon__close",
                title: "",
                __typename: "Icon"
              },
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "close search filters dialog",
                referrerId: "LX-GT.SR.CloseFilterDialog.Close",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: null,
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            },
            secondaries: [{
              egdsElementId: null,
              primary: "Clear",
              disabled: false,
              accessibility: "Clear all selections",
              icon: null,
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "clear all selections",
                referrerId: "LX-GT.SR.ClearFilters",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: "All selections now cleared",
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            }],
            __typename: "UIToolbarActions"
          }
        }
      }, {
        view: "SORT_AND_FILTERS" /* SORT_AND_FILTERS */,
        applyAction: {
          __typename: "UIPrimaryFloatingActionButton",
          accessibility: "Apply and close Sort and Filter",
          primary: "Done",
          badge: null,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            uisPrimeMessages: [],
            linkName: "done search filters dialog",
            referrerId: "LX-GT.SR.FilterControlDone",
            __typename: "ClientSideAnalytics"
          },
          icon: null,
          egdsElementId: null,
          disabled: false
        },
        __typename: "ShoppingSortAndFilterDialogContainer",
        revealAction: {
          __typename: "UISecondaryFloatingActionButton",
          accessibility: "1 filter applied. Change sort or apply more filters.",
          primary: "Sort & Filter",
          badge: 1,
          action: {
            accessibility: null,
            __typename: "ShoppingSortAndFilterAction"
          },
          analytics: {
            eventType: "CLICK" /* CLICK */,
            linkName: "Launch filters takeover",
            referrerId: "LX-GT.SR:FilterControl",
            __typename: "ClientSideAnalytics",
            uisPrimeMessages: [{
              __typename: "EGUisMicroMessage",
              messageContent: "{}",
              schemaName: ""
            }]
          },
          icon: {
            id: "tune",
            title: "",
            token: "icon__tune",
            description: "reveals sort and filter window",
            size: null,
            __typename: "Icon"
          },
          egdsElementId: null
        },
        toolbar: {
          __typename: "UIToolbar",
          primary: "Sort & Filter",
          actions: {
            primary: {
              egdsElementId: null,
              primary: null,
              disabled: false,
              accessibility: "Close Sort and Filter",
              icon: {
                id: "close",
                description: "dismisses sort and filter window",
                token: "icon__close",
                title: "",
                __typename: "Icon"
              },
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "close search filters dialog",
                referrerId: "LX-GT.SR.CloseFilterDialog.Close",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: null,
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            },
            secondaries: [{
              egdsElementId: null,
              primary: "Clear",
              disabled: false,
              accessibility: "Clear all selections",
              icon: null,
              analytics: {
                eventType: "CLICK" /* CLICK */,
                uisPrimeMessages: [],
                linkName: "clear all selections",
                referrerId: "LX-GT.SR.ClearFilters",
                __typename: "ClientSideAnalytics"
              },
              action: {
                accessibility: "All selections now cleared",
                __typename: "ShoppingSortAndFilterAction"
              },
              __typename: "UITertiaryButton"
            }],
            __typename: "UIToolbarActions"
          }
        }
      }],
      sections: [],
      quickAccessFilters: null,
      appliedFilters: null,
      filtersApplied: [],
      clearAll: null
    },
    __typename: "PropertySearchResults"
  }
};
export { LodgingSortAndFilters, SortAndFiltersCustomEventTypes, SortAndFiltersParamsKeys, SortAndFiltersRangeParamKey, SortAndFiltersViewType, mockCarsSortAndFilterResponse }; /* istanbul ignore file -- @preserve */ /*! Bundled license information:
                                                                                                                                                                                                                        tslib/tslib.es6.js:
                                                                                                                                                                                                                        (*! *****************************************************************************
                                                                                                                                                                                                                        Copyright (c) Microsoft Corporation.
                                                                                                                                                                                                                        Permission to use, copy, modify, and/or distribute this software for any
                                                                                                                                                                                                                        purpose with or without fee is hereby granted.
                                                                                                                                                                                                                        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
                                                                                                                                                                                                                        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
                                                                                                                                                                                                                        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
                                                                                                                                                                                                                        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
                                                                                                                                                                                                                        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
                                                                                                                                                                                                                        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
                                                                                                                                                                                                                        PERFORMANCE OF THIS SOFTWARE.
                                                                                                                                                                                                                        ***************************************************************************** *)
                                                                                                                                                                                                                        */